module.exports = {
	"prostrate01": {
		"toe1-1.L": [
			-0.29499774533072065,
			-0.03172229732792842,
			0.01797936976071046,
			0.9548019524304702
		],
		"finger5-2.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger1-3.R": [
			-3.490658428972883e-8,
			5.551115123125783e-16,
			2.617994002055379e-8,
			0.9999999999999992
		],
		"toe5-2.R": [
			-0.03706738171818843,
			0.0031343045377925094,
			-0.0005620298652676036,
			0.9993076950919831
		],
		"toe4-2.R": [
			-0.1143178899910936,
			0.009666383274839485,
			-0.0017332869161141543,
			0.9933956798672088
		],
		"clavicle.R": [
			0.03204164465819385,
			-0.014961486478580643,
			-0.15595924837815248,
			0.9871302851069207
		],
		"neck03": [
			-0.11552073229011453,
			0,
			0,
			0.9933050691560754
		],
		"neck02": [
			0.044943657131892814,
			-2.220446049250313e-16,
			0,
			0.998989523310235
		],
		"neck01": [
			0.12930333356886187,
			0,
			0,
			0.9916050866791575
		],
		"clavicle.L": [
			0.032041719940525834,
			0.014961486475039698,
			0.1559592339899432,
			0.9871302849365835
		],
		"toe5-2.L": [
			-0.03706738171818843,
			-0.0031343045377925094,
			0.0005620298652676036,
			0.9993076950919831
		],
		"toe4-2.L": [
			-0.1143178899910936,
			-0.009666383274839485,
			0.0017332869161141543,
			0.9933956798672088
		],
		"finger5-2.L": [
			-1.7453292144864443e-8,
			-8.726645850387627e-9,
			2.6179939993653534e-8,
			0.9999999999999996
		],
		"finger1-3.L": [
			-3.490658428972883e-8,
			-2.6179939993653534e-8,
			1.0341496537059884e-15,
			0.9999999999999992
		],
		"toe1-1.R": [
			-0.2949977453401389,
			0.031722300205699994,
			-0.017979361158030855,
			0.9548019524939418
		],
		"oculi02.L": [
			6.108652428338209e-8,
			1.7453292144864463e-8,
			1.0899510809257394e-15,
			0.999999999999998
		],
		"oculi01.L": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"jaw": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger4-2.R": [
			0.015732285617544528,
			-0.00706724428977723,
			-0.006506433802424136,
			0.9998300933491507
		],
		"oculi01.R": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"oculi02.R": [
			6.108652428338209e-8,
			-1.7453292144864463e-8,
			-1.0899510809257394e-15,
			0.999999999999998
		],
		"wrist.R": [
			0.06400553839013624,
			-0.024220143408116068,
			-0.28765421138015235,
			0.9552862033882525
		],
		"finger1-1.L": [
			0.1349781321525207,
			0.10467216212537855,
			-0.006602531691843082,
			0.9852822178908299
		],
		"tongue07.R": [
			3.4906584289728866e-8,
			-5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"eye.R": [
			2.6179939993653527e-8,
			8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"finger2-1.R": [
			0.028308513634310594,
			-0.028187836457087,
			-0.015943138376584256,
			0.9990745168756883
		],
		"finger4-3.R": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"finger2-1.L": [
			0.028308506194191178,
			0.028187829016840138,
			0.015943146294900488,
			0.9990745171700611
		],
		"eye.L": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"tongue07.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"wrist.L": [
			0.0640055284288696,
			0.024220140092584774,
			0.2876540964116988,
			0.9552862387588374
		],
		"finger5-3.R": [
			-1.7453291256686047e-8,
			-1.7453291478730648e-8,
			2.6179939993653507e-8,
			0.9999999999999994
		],
		"lowerleg01.R": [
			0.7166949451773923,
			-0.06633687820718592,
			-0.0032580251527054354,
			0.694216939737863
		],
		"lowerarm02.L": [
			0.08508380075378742,
			-0.1357936179820335,
			0.17466177589096785,
			0.9715009543007422
		],
		"oris07.L": [
			3.490658428972884e-8,
			8.726646405499139e-9,
			-8.726645628342989e-9,
			0.9999999999999991
		],
		"oris07.R": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"tongue00": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"lowerarm02.R": [
			0.08508381706092867,
			0.13579363848663917,
			-0.17466184172752494,
			0.971500938170031
		],
		"lowerleg01.L": [
			0.7166949455805202,
			0.06633688347880518,
			0.003258019891344989,
			0.6942169388426374
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			0.13497814552597495,
			-0.10467222776788909,
			0.0066025373069097965,
			0.9852822090475328
		],
		"metacarpal4.L": [
			-0.04516756093027485,
			-0.0810048378732896,
			-0.057377884921852855,
			0.9940351533032552
		],
		"finger1-2.R": [
			-0.015187814265390795,
			-0.05356212701076479,
			-0.018012887788977777,
			0.9982865143441657
		],
		"pelvis.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-1.R": [
			-0.2949978399405706,
			0.0317223060518701,
			-0.017979365907488228,
			0.9548019229823083
		],
		"toe2-3.L": [
			-0.11599794025945076,
			-0.012473663755221964,
			0.007069780683113835,
			0.9931459629728048
		],
		"toe5-3.L": [
			-0.08292846884837331,
			-0.007012190115463834,
			0.0012573534748786391,
			0.9965300383362697
		],
		"levator05.L": [
			-1.5230870001493993e-16,
			-8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"finger4-1.L": [
			-0.10255970812727973,
			-0.059834654629546846,
			-0.03641743002350784,
			0.9922575729943778
		],
		"finger4-1.R": [
			-0.10255974824221942,
			0.059834622652964686,
			0.03641744180692374,
			0.9922575703438645
		],
		"levator05.R": [
			-1.5230870001493993e-16,
			8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe5-3.R": [
			-0.08292852256323847,
			0.007012189147140413,
			-0.0012573625983585794,
			0.9965300338615681
		],
		"toe2-3.R": [
			-0.11599794024247184,
			0.01247367310957026,
			-0.007069781606310259,
			0.9931459628507273
		],
		"finger4-2.L": [
			0.01573231168340105,
			0.007067218444694157,
			0.006506416337947747,
			0.9998300932353397
		],
		"toe2-1.L": [
			-0.2949978083746944,
			-0.03172230633684703,
			0.017979365092588667,
			0.9548019327408516
		],
		"finger1-2.L": [
			-0.015187823542814347,
			0.05356219148644703,
			0.01801288582711218,
			0.9982865107790353
		],
		"pelvis.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal4.R": [
			-0.04516760818921233,
			0.0810047703299348,
			0.057377890803834965,
			0.9940351563205219
		],
		"tongue04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			-0.11599787564913742,
			-0.012473657256240944,
			0.007069769912566891,
			0.9931459706774857
		],
		"levator03.R": [
			4.363322858580418e-8,
			-1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"upperleg02.R": [
			-0.10398265005424727,
			0.0071837524874875935,
			0.05562667827049113,
			0.9929963116006454
		],
		"upperleg02.L": [
			-0.10398262828971205,
			-0.007183751596019583,
			-0.05562667843175134,
			0.9929963138771571
		],
		"levator03.L": [
			4.363322858580418e-8,
			1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"toe3-2.R": [
			-0.1159979152508569,
			0.012473664723742561,
			-0.007069771386237191,
			0.9931459659477859
		],
		"metacarpal3.L": [
			-0.01756449570839344,
			-0.0790886585888555,
			-0.06137902079062131,
			0.9948211338627205
		],
		"tongue01": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"breast.L": [
			-0.026177208749308917,
			-1.74473110403639e-8,
			4.5687851198921377e-10,
			0.9996573181556244
		],
		"temporalis02.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"tongue02": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris04.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"oris04.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"temporalis02.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"breast.R": [
			-0.026177182716939085,
			8.495216974324649e-9,
			-8.952094564399027e-9,
			0.9996573188373126
		],
		"oris03.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"oris06.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"orbicularis04.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"toe1-2.R": [
			-0.11599790802544833,
			0.012473683482217779,
			-0.007069765506755096,
			0.9931459665979541
		],
		"toe1-2.L": [
			-0.11599790803975064,
			-0.012473675052520283,
			0.007069764583395732,
			0.9931459667087316
		],
		"orbicularis04.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"metacarpal3.R": [
			-0.017564502680441376,
			0.07908866602003228,
			0.0613789985255821,
			0.994821134522562
		],
		"oris06.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"levator04.L": [
			4.3633228585804185e-8,
			-3.3306690738754696e-16,
			8.726646077118623e-9,
			0.9999999999999991
		],
		"tongue06.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-2.L": [
			-0.11599783622458781,
			-0.012473655989525212,
			0.0070697781767240404,
			0.9931459752392902
		],
		"toe2-2.R": [
			-0.11599786844551845,
			0.012473655862139,
			-0.007069778641816437,
			0.9931459714742261
		],
		"tongue06.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"levator04.R": [
			4.3633228585804185e-8,
			4.440892098500626e-16,
			-8.72664605333848e-9,
			0.999999999999999
		],
		"toe4-1.L": [
			-2.6179939993653497e-8,
			8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"upperleg01.R": [
			0.21644123826846876,
			-4.742174541938482e-9,
			-1.8928379176903024e-8,
			0.9762956470131432
		],
		"metacarpal1.R": [
			0.019117941257869673,
			0.042926649284844576,
			0.05910105466832126,
			0.9971453617403678
		],
		"levator02.R": [
			-2.6179939993653507e-8,
			8.726645739365324e-9,
			-1.7453292144864397e-8,
			0.9999999999999994
		],
		"toe3-1.L": [
			-0.22198919496384387,
			-0.02655563350773371,
			0.01632307318983887,
			0.9745507441534005
		],
		"toe3-1.R": [
			-0.22198917523796635,
			0.026555642912187594,
			-0.016323074049041698,
			0.974550748376029
		],
		"levator02.L": [
			-2.6179939993653477e-8,
			-8.726645517320719e-9,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"finger5-1.R": [
			-0.14674661292921298,
			0.05520795829469494,
			0.025195095906469855,
			0.9873108528102985
		],
		"metacarpal1.L": [
			0.019117948769646283,
			-0.04292664189677309,
			-0.059101056533401336,
			0.9971453618038564
		],
		"toe4-1.R": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"upperleg01.L": [
			0.21644123826846876,
			4.742174541938482e-9,
			1.8928379176903024e-8,
			0.9762956470131432
		],
		"head": [
			-0.028178816161959566,
			1.1102230246251565e-16,
			2.465190328815662e-32,
			0.9996028983149812
		],
		"toe5-1.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"special01": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"temporalis01.L": [
			8.726646072432222e-9,
			2.220446049250313e-16,
			-3.490658426895706e-8,
			0.9999999999999992
		],
		"special04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal2.L": [
			0.006193448323233974,
			-0.05147844978485061,
			-0.05882182802416405,
			0.9969210615457533
		],
		"metacarpal2.R": [
			0.006193403896560818,
			0.05147846277642332,
			0.058821826151972255,
			0.9969210612613709
		],
		"temporalis01.R": [
			8.726646072432225e-9,
			-3.3306690738754696e-16,
			3.490658409227928e-8,
			0.9999999999999994
		],
		"toe5-1.L": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"risorius02.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"special05.L": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"finger2-2.L": [
			0.029563637937978834,
			0.02297340003376669,
			0.02392771428221667,
			0.9990123516213347
		],
		"foot.L": [
			-0.043428718569395314,
			-0.004077285413601972,
			-0.00006872775307644499,
			0.9990482057556446
		],
		"oris06": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"levator06.R": [
			-1.7453292144864446e-8,
			-3.490658440075123e-8,
			-8.726645628343005e-9,
			0.9999999999999993
		],
		"orbicularis03.R": [
			-3.490658428972884e-8,
			8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"levator06.L": [
			-4.363322858580408e-8,
			8.726646849588349e-9,
			1.745329214486511e-8,
			0.9999999999999989
		],
		"orbicularis03.L": [
			-3.490658428972884e-8,
			-8.726646405499139e-9,
			-8.726645628342989e-9,
			0.9999999999999991
		],
		"foot.R": [
			-0.043428725984940034,
			0.004077285412388054,
			0.00006872772032133509,
			0.9990482054332971
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			0.02956365653796329,
			-0.022973353461816948,
			-0.02392775804092456,
			0.9990123510937983
		],
		"risorius02.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"special05.R": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"lowerleg02.L": [
			0.04342875194535515,
			0.004077251150268024,
			0.00006871547424154348,
			0.999048204445466
		],
		"tongue05.L": [
			-3.4906584289728866e-8,
			5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"finger5-1.L": [
			-0.14674659883596308,
			-0.05520794725879763,
			-0.025195108903441083,
			0.9873108551904464
		],
		"toe4-3.R": [
			-0.06784601680709149,
			0.005736854848391815,
			-0.0010286641754143453,
			0.9976787801441278
		],
		"oris03.L": [
			-4.3633228585804185e-8,
			-4.440892098500626e-16,
			-8.72664605333848e-9,
			0.999999999999999
		],
		"toe4-3.L": [
			-0.0678460315374449,
			-0.005736854844715533,
			0.0010286642894839773,
			0.9976787791423101
		],
		"finger3-3.L": [
			4.363322858580416e-8,
			-2.617994021569814e-8,
			-1.1643607064032247e-15,
			0.9999999999999988
		],
		"tongue05.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerleg02.R": [
			0.04342875194535515,
			-0.004077251150268024,
			-0.00006871547424154348,
			0.999048204445466
		],
		"shoulder01.R": [
			-0.3664830863696703,
			0.26130929205821163,
			0.14912635356839082,
			0.8804367847610598
		],
		"finger3-1.L": [
			-0.07438011407141384,
			-0.04671589450711289,
			-0.03309538757878276,
			0.9955852144101648
		],
		"special06.R": [
			-2.6179939993653504e-8,
			1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"finger4-3.L": [
			-2.6179940881831887e-8,
			1.7453293255087488e-8,
			2.6179939105475074e-8,
			0.9999999999999993
		],
		"finger3-2.L": [
			0.03375351859805419,
			0.017898673966612044,
			0.017252437775142127,
			0.9991209590651688
		],
		"upperarm01.R": [
			-0.3845348745455427,
			0.011315452313193863,
			-0.03384392222636605,
			0.9224204462854931
		],
		"finger3-2.R": [
			0.033753516683231996,
			-0.01789873450667645,
			-0.017252439601719367,
			0.9991209580137751
		],
		"upperarm01.L": [
			-0.38453494253410936,
			-0.011315480727112637,
			0.0338439180551965,
			0.9224204177471775
		],
		"special06.L": [
			-2.6179939993653504e-8,
			-1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		],
		"finger3-1.R": [
			-0.07438009934589401,
			0.04671589634986861,
			0.03309539981187958,
			0.9955852150171852
		],
		"shoulder01.L": [
			-0.36648306408440123,
			-0.26130922634410014,
			-0.14912634615904422,
			0.8804368147959339
		],
		"lowerarm01.R": [
			-0.43068614338631345,
			0.4079350956870491,
			-0.14301349301063687,
			0.7922408373838844
		],
		"special03": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"upperarm02.L": [
			-0.10658079053352863,
			-0.023735194458893938,
			0.023732945868874412,
			0.9937373510710115
		],
		"spine02": [
			0.08718154396051105,
			0,
			0,
			0.9961924404414347
		],
		"spine03": [
			0.21875185244033352,
			0,
			0,
			0.9757805219689121
		],
		"spine01": [
			0.17306662070378664,
			-1.1102230246251565e-16,
			0,
			0.9849101201623283
		],
		"upperarm02.R": [
			-0.10658081225396246,
			0.023735202862642413,
			-0.023732947694942635,
			0.9937373484971089
		],
		"spine04": [
			0.04604637036261979,
			0,
			0,
			0.9989393033495221
		],
		"spine05": [
			0.6262940132675567,
			0,
			0,
			0.7795869476493417
		],
		"lowerarm01.L": [
			-0.43068612973593695,
			-0.40793511834480456,
			0.1430135251476026,
			0.792240827336578
		],
		"finger5-3.L": [
			9.138523059687561e-16,
			3.4906584289728926e-8,
			-2.6179939993653487e-8,
			0.999999999999999
		],
		"oris01": [
			0,
			0,
			0,
			1
		],
		"oris02": [
			0,
			0,
			0,
			1
		],
		"oris05": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"risorius03.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"finger2-3.L": [
			3.490658428972884e-8,
			-2.6179941325921163e-8,
			1.7453291256685967e-8,
			0.999999999999999
		],
		"toe3-3.R": [
			0.04290465742039351,
			0.003412745661475758,
			0.0013472097665151739,
			0.9990724340930106
		],
		"finger3-3.R": [
			2.6179939993653497e-8,
			8.72664507323151e-9,
			2.617993999365348e-8,
			0.9999999999999993
		],
		"finger2-3.R": [
			8.72664784878902e-9,
			4.363322858580432e-8,
			-4.3633228585804146e-8,
			0.999999999999998
		],
		"toe3-3.L": [
			0.042904694502099924,
			-0.0034127456555700375,
			-0.0013472098785195128,
			0.9990724325004244
		],
		"risorius03.L": [
			2.617993999365348e-8,
			-1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		]
	},
	"Harvey_StandingFashion1": {
		"toe1-1.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger5-2.R": [
			8.726645628343012e-9,
			-1.745329203384216e-8,
			-3.4906584289728866e-8,
			0.9999999999999993
		],
		"finger1-3.R": [
			-8.726645184253789e-9,
			-3.490658440075123e-8,
			2.6179939993653494e-8,
			0.999999999999999
		],
		"toe5-2.R": [
			-4.363322858580417e-8,
			8.726645628343022e-9,
			-8.726646516520993e-9,
			0.999999999999999
		],
		"toe4-2.R": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"clavicle.R": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"neck03": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"neck02": [
			0,
			0,
			0,
			1
		],
		"neck01": [
			0.09946983629352446,
			8.683366581330176e-9,
			8.680380769339109e-10,
			0.995040577900087
		],
		"clavicle.L": [
			0.06526797657843562,
			0.1255205022008652,
			0.19122878337764304,
			0.9712961686161985
		],
		"toe5-2.L": [
			-3.4906584289728866e-8,
			-8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"toe4-2.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger5-2.L": [
			1.745329214486444e-8,
			3.490658451177353e-8,
			4.799202690040438e-16,
			0.9999999999999992
		],
		"finger1-3.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"toe1-1.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oculi02.L": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"oculi01.L": [
			1.7453292144864453e-8,
			-2.6179939993653534e-8,
			-8.726646516521464e-9,
			0.9999999999999997
		],
		"jaw": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger4-2.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"oculi01.R": [
			-3.4906582513371954e-8,
			4.363322680944748e-8,
			-2.6179941770010287e-8,
			0.9999999999999979
		],
		"oculi02.R": [
			8.72664651652143e-9,
			4.363322880784892e-8,
			-8.726645628342965e-9,
			0.9999999999999992
		],
		"wrist.R": [
			0.05268757581180192,
			0.05794055323202163,
			0.06134941174429749,
			0.9950392762724853
		],
		"finger1-1.L": [
			7.615435000746988e-16,
			-4.363322858580432e-8,
			1.7453292144864436e-8,
			0.9999999999999989
		],
		"tongue07.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"eye.R": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"finger2-1.R": [
			0.07319614758140085,
			0.045995571627625464,
			0.049220150501468565,
			0.9950397520473753
		],
		"finger4-3.R": [
			8.726646072432225e-9,
			6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"finger2-1.L": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"eye.L": [
			-2.6179939993653504e-8,
			1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"tongue07.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"wrist.L": [
			-0.4000482643729639,
			0.18990065083536334,
			0.2992199616136811,
			0.8452020726171888
		],
		"finger5-3.R": [
			8.726646516521435e-9,
			-1.7453292366909068e-8,
			3.49065842897289e-8,
			0.9999999999999992
		],
		"lowerleg01.R": [
			0.8819526355185332,
			-0.0703827655611835,
			0.01871252525089698,
			0.46567763142823115
		],
		"lowerarm02.L": [
			2.617993999365347e-8,
			-2.6179940437742744e-8,
			8.726645184253845e-9,
			0.9999999999999996
		],
		"oris07.L": [
			3.490658251337198e-8,
			3.490658262439439e-8,
			4.3633230362160965e-8,
			0.9999999999999979
		],
		"oris07.R": [
			1.7453292144864443e-8,
			6.661338147750939e-16,
			-2.6179940059872455e-8,
			0.9999999999999999
		],
		"tongue00": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"lowerarm02.R": [
			2.617993910547503e-8,
			2.6179939216497417e-8,
			3.490658428972883e-8,
			0.9999999999999989
		],
		"lowerleg01.L": [
			0,
			0,
			0,
			1
		],
		"tongue03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			0.0694590922785238,
			-0.0006771940796062026,
			-0.071198513665488,
			0.9950405758359042
		],
		"metacarpal4.L": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"finger1-2.R": [
			-8.726646516521403e-9,
			-6.981316880150246e-8,
			-8.726645628343002e-9,
			0.9999999999999976
		],
		"pelvis.R": [
			-0.19431966054273475,
			-0.02305652529236668,
			-0.012095890810798832,
			0.9805926552822493
		],
		"toe2-1.R": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe2-3.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-3.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"levator05.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger4-1.L": [
			-8.72664474016463e-9,
			2.617993888343051e-8,
			-5.235987998730668e-8,
			0.9999999999999984
		],
		"finger4-1.R": [
			0.046745797981063125,
			0.02616865376105093,
			0.08381487877759494,
			0.995040249450717
		],
		"levator05.R": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"toe5-3.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe2-3.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger4-2.L": [
			-3.4906584289728906e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999994
		],
		"toe2-1.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger1-2.L": [
			-1.7453292144864436e-8,
			4.363322869682662e-8,
			-6.702088926697263e-16,
			0.9999999999999991
		],
		"pelvis.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal4.R": [
			-8.72664518425384e-9,
			-1.7453291367708346e-8,
			5.235987998730672e-8,
			0.9999999999999986
		],
		"tongue04": [
			-2.6179939993653497e-8,
			-8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"toe3-2.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"levator03.R": [
			-6.853892559463472e-16,
			2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"upperleg02.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperleg02.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"levator03.L": [
			1.745328948032921e-8,
			-6.108652406133785e-8,
			-4.3633230362160945e-8,
			0.9999999999999969
		],
		"toe3-2.R": [
			-2.6179939993653497e-8,
			-8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"metacarpal3.L": [
			-3.490658428972881e-8,
			-1.745329158975295e-8,
			1.7453293033042366e-8,
			0.9999999999999991
		],
		"tongue01": [
			-3.4906584289728866e-8,
			-8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"breast.L": [
			0,
			0,
			0,
			1
		],
		"temporalis02.R": [
			0,
			0,
			0,
			1
		],
		"tongue02": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"oris04.R": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"oris04.L": [
			-8.726646960610684e-9,
			-1.7453293255087488e-8,
			-6.108652428338172e-8,
			0.999999999999998
		],
		"temporalis02.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"breast.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"oris03.R": [
			3.807717500373487e-16,
			8.726646183454534e-9,
			-4.36332285858042e-8,
			0.999999999999999
		],
		"oris06.L": [
			-1.7453292144864443e-8,
			2.220446049250313e-16,
			2.6179940054284205e-8,
			0.9999999999999996
		],
		"orbicularis04.R": [
			8.726646516521438e-9,
			3.490658440075123e-8,
			-8.726645628343022e-9,
			0.9999999999999994
		],
		"toe1-2.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe1-2.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"orbicularis04.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal3.R": [
			8.72664607243222e-9,
			-2.220446049250313e-16,
			4.3633228492591465e-8,
			0.999999999999999
		],
		"oris06.R": [
			-3.490658428972882e-8,
			-2.6179939549564324e-8,
			2.617994088183189e-8,
			0.9999999999999989
		],
		"levator04.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"tongue06.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"toe2-2.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-2.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"tongue06.R": [
			-1.5230870001493993e-16,
			8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"levator04.R": [
			-3.8077175003734897e-16,
			4.363322858580432e-8,
			8.726646072432225e-9,
			0.999999999999999
		],
		"toe4-1.L": [
			0,
			0,
			0,
			1
		],
		"upperleg01.R": [
			-0.29549656079357217,
			-0.07474613298621469,
			0.12718807757046902,
			0.943884522114176
		],
		"metacarpal1.R": [
			8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"levator02.R": [
			2.617993999365347e-8,
			1.745329247793137e-8,
			-8.726645628343018e-9,
			0.9999999999999994
		],
		"toe3-1.L": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"toe3-1.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"levator02.L": [
			1.745329214486445e-8,
			-8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"finger5-1.R": [
			0.025827150095404733,
			0.023013963786825298,
			0.09326338910830287,
			0.9950403288514497
		],
		"metacarpal1.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe4-1.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"upperleg01.L": [
			0.0007085417664518905,
			-0.015130137271207378,
			-0.047568740554872216,
			0.9987531185617109
		],
		"head": [
			-0.0989816870399504,
			-0.005177688321898577,
			-0.09884712041556619,
			0.9901540607198037
		],
		"toe5-1.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"special01": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"temporalis01.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"special04": [
			-6.108652428338212e-8,
			1.7453293033042883e-8,
			8.726645184253815e-9,
			0.9999999999999981
		],
		"metacarpal2.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"metacarpal2.R": [
			2.617993910547522e-8,
			3.4906582846438994e-8,
			3.4906586066085765e-8,
			0.9999999999999987
		],
		"temporalis01.R": [
			1.7453291256686083e-8,
			2.617993899445281e-8,
			2.6179940881832245e-8,
			0.9999999999999991
		],
		"toe5-1.L": [
			3.4906584289728866e-8,
			-8.726645961409929e-9,
			-1.7169609607764797e-16,
			0.9999999999999993
		],
		"risorius02.R": [
			-1.745329214486445e-8,
			8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"special05.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger2-2.L": [
			8.726647404699818e-9,
			-3.490658451177353e-8,
			4.363322858580417e-8,
			0.9999999999999984
		],
		"foot.L": [
			0.005566696163229298,
			-0.046411994101164145,
			0.08781014718922477,
			0.9950398568640288
		],
		"oris06": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"levator06.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"orbicularis03.R": [
			3.4906584289728807e-8,
			2.6179939993653534e-8,
			8.72664696061079e-9,
			0.999999999999999
		],
		"levator06.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"orbicularis03.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"foot.R": [
			0.18856843282214222,
			-0.10149960783489631,
			-0.04165796314669926,
			0.9759120810087508
		],
		"root": [
			-2.2659934238242162e-8,
			0.0010514256631327656,
			-0.04990920797540352,
			0.9987532054833879
		],
		"finger2-2.R": [
			-9.138523059687563e-16,
			-5.235988009832937e-8,
			-1.745329214486443e-8,
			0.9999999999999987
		],
		"risorius02.L": [
			8.726644740164589e-9,
			-4.363322858580432e-8,
			-2.617993999365346e-8,
			0.9999999999999987
		],
		"special05.R": [
			2.2846307649218933e-16,
			2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"lowerleg02.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"tongue05.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"finger5-1.L": [
			-2.617993910547503e-8,
			-2.6179939216497417e-8,
			3.490658428972883e-8,
			0.9999999999999989
		],
		"toe4-3.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"oris03.L": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"toe4-3.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-3.L": [
			-2.6179939993653527e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"tongue05.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"lowerleg02.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"shoulder01.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-1.L": [
			-1.7453291256686053e-8,
			2.617993988263123e-8,
			-1.745329303304289e-8,
			0.9999999999999994
		],
		"special06.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"finger4-3.L": [
			2.617994088183186e-8,
			2.617994077080965e-8,
			-4.36332285858042e-8,
			0.9999999999999984
		],
		"finger3-2.L": [
			2.6179940881831864e-8,
			3.490658440075123e-8,
			-2.6179939105475068e-8,
			0.9999999999999987
		],
		"upperarm01.R": [
			0.13078026934452358,
			-0.13094065713870395,
			0.2841516512688637,
			0.9407491188087479
		],
		"finger3-2.R": [
			-8.726646516521441e-9,
			-2.6179940104675836e-8,
			-8.726645628343022e-9,
			0.9999999999999998
		],
		"upperarm01.L": [
			-0.12315193568484854,
			-0.36221466003996305,
			0.3440024944973228,
			0.8574942708664758
		],
		"special06.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-1.R": [
			0.05636776404166757,
			0.03739332095286663,
			0.07293740705659776,
			0.9950399737583002
		],
		"shoulder01.L": [
			0.0009138538331175106,
			0.0006807053436533872,
			0.09946337050761857,
			0.9950405717550774
		],
		"lowerarm01.R": [
			-0.03718516522850106,
			0.03331270496579042,
			-0.0005695829047822425,
			0.9987528236506295
		],
		"special03": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"upperarm02.L": [
			-0.2982366206581178,
			0.33283303358833705,
			-0.014740265256971388,
			0.8944606276583473
		],
		"spine02": [
			-0.07439566682484122,
			-0.0006322002740057897,
			0.09919312959601075,
			0.9922830282341067
		],
		"spine03": [
			-0.04967340825936633,
			-0.013253971367001238,
			0.09846044793972063,
			0.9938120672171424
		],
		"spine01": [
			-0.04985824400194388,
			-0.004897503290821947,
			-0.04961730380736518,
			0.9975110491264981
		],
		"upperarm02.R": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"spine04": [
			0.09946977228791996,
			8.683367136441689e-9,
			8.680375205221452e-10,
			0.9950405842984442
		],
		"spine05": [
			-1.202190454027754e-7,
			-0.05316754738988283,
			-0.08408041907216632,
			0.995039544456992
		],
		"lowerarm01.L": [
			-0.6209189191685367,
			-0.3229106295243097,
			0.21727477096404327,
			0.6804264067930587
		],
		"finger5-3.L": [
			1.745329214486444e-8,
			8.726646627543744e-9,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"oris01": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"risorius03.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"finger2-3.L": [
			2.6179939993653494e-8,
			-1.745329158975295e-8,
			-1.745329303304287e-8,
			0.9999999999999994
		],
		"toe3-3.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-3.R": [
			2.6179939993653494e-8,
			-8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"finger2-3.R": [
			1.5230870001493993e-16,
			8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe3-3.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.L": [
			6.981316857945728e-8,
			8.726644740164602e-9,
			2.617994088183179e-8,
			0.9999999999999974
		]
	},
	"Harvey_IDunno": {
		"toe1-1.L": [
			-0.19477091273664954,
			-0.01789474918210876,
			0.01349460581357169,
			0.9805926601384378
		],
		"finger5-2.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"finger1-3.R": [
			-5.235987998730676e-8,
			-1.7453290479529926e-8,
			2.6179940881831593e-8,
			0.9999999999999982
		],
		"toe5-2.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"toe4-2.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"clavicle.R": [
			0,
			0,
			-4.3633228585804205e-8,
			0.9999999999999991
		],
		"neck03": [
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"neck02": [
			0,
			0,
			0,
			1
		],
		"neck01": [
			0,
			0,
			0,
			1
		],
		"clavicle.L": [
			8.72664607243222e-9,
			-2.220446049250313e-16,
			4.3633228492591465e-8,
			0.999999999999999
		],
		"toe5-2.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"toe4-2.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger5-2.L": [
			0,
			0,
			0,
			1
		],
		"finger1-3.L": [
			-1.7453292144864433e-8,
			2.617994021569814e-8,
			-4.927555263958927e-16,
			0.9999999999999996
		],
		"toe1-1.R": [
			-0.36887769513511026,
			0.033883909484375696,
			-0.02555570842554417,
			0.9285084988715677
		],
		"oculi02.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oculi01.L": [
			1.7453292144864446e-8,
			-4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"jaw": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			1.7453291256686053e-8,
			2.617993988263123e-8,
			1.745329303304289e-8,
			0.9999999999999994
		],
		"oculi01.R": [
			-8.72664651652144e-9,
			-1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"oculi02.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"wrist.R": [
			-0.4358055228952712,
			-0.5221479726197721,
			-0.17233713315499624,
			0.7125552283430089
		],
		"finger1-1.L": [
			1.745328948032921e-8,
			-6.108652406133785e-8,
			-4.3633230362160945e-8,
			0.9999999999999969
		],
		"tongue07.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"eye.R": [
			-2.6179939993653497e-8,
			-8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"finger2-1.R": [
			1.7453291256686047e-8,
			1.7453291478730648e-8,
			2.6179939993653507e-8,
			0.9999999999999994
		],
		"finger4-3.R": [
			5.235987998730686e-8,
			2.617994110387656e-8,
			-8.726644740164896e-9,
			0.9999999999999984
		],
		"finger2-1.L": [
			-2.617993999365348e-8,
			1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		],
		"eye.L": [
			-2.6179939993653477e-8,
			2.6179940548765046e-8,
			-8.726646960610674e-9,
			0.9999999999999996
		],
		"tongue07.L": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"wrist.L": [
			-0.43580553954991025,
			0.5221479937396011,
			0.17233714273253778,
			0.7125552003642281
		],
		"finger5-3.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"lowerleg01.R": [
			0.09913226064798254,
			-0.007914647042239875,
			0.0021039917962976714,
			0.9950405652432154
		],
		"lowerarm02.L": [
			6.981316857945734e-8,
			-4.363322902989353e-8,
			-8.726649181055347e-9,
			0.9999999999999966
		],
		"oris07.L": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"oris07.R": [
			-8.726645184253779e-9,
			2.6179939993653534e-8,
			-3.490658428972884e-8,
			0.9999999999999991
		],
		"tongue00": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm02.R": [
			-8.726646960610704e-9,
			2.6179939993653534e-8,
			2.6179939993653468e-8,
			0.9999999999999992
		],
		"lowerleg01.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			1.7453292144864443e-8,
			2.6179940104675836e-8,
			-8.726645628343028e-9,
			0.9999999999999997
		],
		"metacarpal4.L": [
			1.7453293033042833e-8,
			1.745329292202058e-8,
			-5.235987998730684e-8,
			0.9999999999999982
		],
		"finger1-2.R": [
			-3.490658428972881e-8,
			-1.745329158975295e-8,
			1.7453293033042366e-8,
			0.9999999999999991
		],
		"pelvis.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe2-1.R": [
			-0.3680145346459284,
			0.03457334037301196,
			-0.03524205137474158,
			0.9285084728960168
		],
		"toe2-3.L": [
			-0.19561478308716831,
			-0.01239937163970839,
			-0.004363401389184473,
			0.9805927151213278
		],
		"toe5-3.L": [
			-0.0989084774727224,
			-0.009172591071700209,
			0.005227783135080551,
			0.9950405252755045
		],
		"levator05.L": [
			8.726645628343007e-9,
			-1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"finger4-1.L": [
			-2.6179939993653494e-8,
			-6.661338147750939e-16,
			-2.6179940052507944e-8,
			0.9999999999999993
		],
		"finger4-1.R": [
			-1.7453292144864436e-8,
			1.1102230246251565e-15,
			5.2359879927727643e-8,
			0.9999999999999986
		],
		"levator05.R": [
			-1.1423153030516055e-15,
			4.363322858580432e-8,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"toe5-3.R": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"toe2-3.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger4-2.L": [
			2.6179939105475025e-8,
			-2.617993899445281e-8,
			-4.36332285858042e-8,
			0.9999999999999987
		],
		"toe2-1.L": [
			-0.19431516309118926,
			-0.018258867148769342,
			0.01860901608421144,
			0.9805926451303139
		],
		"finger1-2.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"pelvis.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal4.R": [
			-3.490658428972882e-8,
			-2.6179939549564324e-8,
			2.617994088183189e-8,
			0.9999999999999989
		],
		"tongue04": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"toe3-2.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"levator03.R": [
			1.1423153030516055e-15,
			4.363322869682662e-8,
			-2.617993999365348e-8,
			0.9999999999999989
		],
		"upperleg02.R": [
			-1.745329214486445e-8,
			8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"upperleg02.L": [
			-0.09891963268173494,
			-0.010350616877011443,
			0.0014614907752934824,
			0.9950405192981286
		],
		"levator03.L": [
			-8.726646960610635e-9,
			-4.363322858580432e-8,
			-1.7453292144864436e-8,
			0.9999999999999989
		],
		"toe3-2.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"metacarpal3.L": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"tongue01": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"breast.L": [
			1.7453292144864443e-8,
			-1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"temporalis02.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue02": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris04.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oris04.L": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"temporalis02.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"breast.R": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"oris03.R": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"oris06.L": [
			-2.6179940881831897e-8,
			2.6179940992854256e-8,
			2.6179939105475064e-8,
			0.9999999999999988
		],
		"orbicularis04.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"toe1-2.R": [
			8.726645628343017e-9,
			1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"toe1-2.L": [
			-0.09794735077210281,
			-0.010073730386527147,
			0.014114040918977132,
			0.9950405169045953
		],
		"orbicularis04.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"metacarpal3.R": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"oris06.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator04.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"tongue06.L": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"toe2-2.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"toe2-2.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue06.R": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"levator04.R": [
			8.726646516521441e-9,
			2.6179940104675836e-8,
			-8.726645628343022e-9,
			0.9999999999999998
		],
		"toe4-1.L": [
			-0.19161650803661348,
			-0.025005940682967243,
			0.033107525255446996,
			0.9805925293157572
		],
		"upperleg01.R": [
			-0.08239542778720119,
			-0.047940095396744375,
			0.14559798805880683,
			0.9847405580183758
		],
		"metacarpal1.R": [
			-8.726646516521438e-9,
			-3.490658440075123e-8,
			-8.726645628343022e-9,
			0.9999999999999994
		],
		"levator02.R": [
			2.6179940881831897e-8,
			2.6179940992854256e-8,
			-2.6179939105475064e-8,
			0.9999999999999988
		],
		"toe3-1.L": [
			-0.1925986172423634,
			-0.020028384139154753,
			0.03070496497305703,
			0.9805925971529191
		],
		"toe3-1.R": [
			-0.3647635898064715,
			0.03792394856252501,
			-0.05815085427074557,
			0.9285083606648382
		],
		"levator02.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger5-1.R": [
			8.726646516521441e-9,
			8.726646516521441e-9,
			-3.490658428972886e-8,
			0.9999999999999994
		],
		"metacarpal1.L": [
			4.3633228585804185e-8,
			-3.3306690738754696e-16,
			8.726646077118623e-9,
			0.9999999999999991
		],
		"toe4-1.R": [
			-0.2807671826821984,
			0.0366372032402571,
			-0.04851073974082686,
			0.9578487420241416
		],
		"upperleg01.L": [
			0.13364798857668708,
			-0.13730339646860823,
			-0.1576349691030362,
			0.9687296882946631
		],
		"head": [
			-3.6935967985529696e-8,
			0.002614683092190928,
			0.049851830220885004,
			0.99875320197532
		],
		"toe5-1.R": [
			-0.1941639355554441,
			0.02028404042887233,
			-0.018083873264060246,
			0.9805926255898884
		],
		"special01": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"special04": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"metacarpal2.L": [
			8.726645628343012e-9,
			-8.726645406298417e-9,
			-4.363322858580416e-8,
			0.9999999999999992
		],
		"metacarpal2.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"temporalis01.R": [
			1.7453291256686083e-8,
			2.617993899445281e-8,
			2.6179940881832245e-8,
			0.9999999999999991
		],
		"toe5-1.L": [
			-0.19416391650626483,
			-0.020284031390138568,
			0.018083871387494746,
			0.9805926295833314
		],
		"risorius02.R": [
			-8.72664651652143e-9,
			2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"special05.L": [
			-1.745329214486445e-8,
			-1.7453292366909068e-8,
			-8.726645628343025e-9,
			0.9999999999999999
		],
		"finger2-2.L": [
			1.5230870001493993e-16,
			-8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"foot.L": [
			0.19991728338440207,
			-0.029982540921343448,
			0.08199995490855516,
			0.975915024189656
		],
		"oris06": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator06.R": [
			-6.092348000597591e-16,
			1.745329203384216e-8,
			3.490658428972889e-8,
			0.9999999999999993
		],
		"orbicularis03.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"levator06.L": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"orbicularis03.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"foot.R": [
			0.29171138366485816,
			0.06528157548575986,
			-0.16009090865891648,
			0.9407516598482264
		],
		"root": [
			-7.985037213990826e-10,
			-0.00042100894703200886,
			0.019984583642715915,
			0.9998001996239517
		],
		"finger2-2.R": [
			5.2359881763663516e-8,
			-5.235988198570851e-8,
			4.3633225033090454e-8,
			0.9999999999999967
		],
		"risorius02.L": [
			-3.490658428972882e-8,
			-2.6179939993653534e-8,
			-8.726645184253818e-9,
			0.9999999999999988
		],
		"special05.R": [
			0,
			0,
			0,
			1
		],
		"lowerleg02.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"tongue05.L": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger5-1.L": [
			0,
			0,
			3.490658428972887e-8,
			0.9999999999999996
		],
		"toe4-3.R": [
			-6.108652428338212e-8,
			-1.7453293033042883e-8,
			-8.726645184253815e-9,
			0.9999999999999981
		],
		"oris03.L": [
			1.5992415089755391e-15,
			-2.617994021569814e-8,
			6.108652428338218e-8,
			0.9999999999999978
		],
		"toe4-3.L": [
			-0.19448866038259202,
			-0.021415720057336052,
			0.012395428750391062,
			0.9805926173815018
		],
		"finger3-3.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"tongue05.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"lowerleg02.R": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"shoulder01.R": [
			0,
			0,
			2.617993999365351e-8,
			0.9999999999999998
		],
		"finger3-1.L": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"special06.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger4-3.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger3-2.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"upperarm01.R": [
			-0.2519707608611143,
			-0.2596662964741675,
			0.2627807259069823,
			0.8944442074485471
		],
		"finger3-2.R": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"upperarm01.L": [
			-0.2519707845354649,
			0.25966627724696834,
			-0.2627806811022032,
			0.8944442195244737
		],
		"special06.L": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"finger3-1.R": [
			1.3707785118926925e-15,
			5.235988009832937e-8,
			-2.617993999365348e-8,
			0.9999999999999982
		],
		"shoulder01.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"lowerarm01.R": [
			-0.5004042032522945,
			0.19068193471946648,
			0.15331507915692286,
			0.8305001623372414
		],
		"special03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperarm02.L": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"spine02": [
			-0.04985824813635371,
			0.0003169129790202563,
			-0.049857390480411795,
			0.9975110502011602
		],
		"spine03": [
			-1.6745380090753036e-8,
			0.006658132218425816,
			-0.049474543137123385,
			0.998753192163477
		],
		"spine01": [
			0,
			0,
			0,
			1
		],
		"upperarm02.R": [
			-8.726645628343018e-9,
			-8.726645628343022e-9,
			5.235987998730709e-8,
			0.9999999999999986
		],
		"spine04": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"spine05": [
			1.5696469901500368e-9,
			0.026682703488547066,
			0.04219694951368663,
			0.9987529478235754
		],
		"lowerarm01.L": [
			-0.500404208048105,
			-0.1906819226708466,
			-0.15331504291730755,
			0.830500168903994
		],
		"finger5-3.L": [
			-1.7453291256686083e-8,
			2.617993899445281e-8,
			-2.6179940881832245e-8,
			0.9999999999999991
		],
		"oris01": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"finger2-3.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"toe3-3.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger3-3.R": [
			2.617993999365347e-8,
			-2.6179940437742744e-8,
			8.726645184253845e-9,
			0.9999999999999996
		],
		"finger2-3.R": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"toe3-3.L": [
			-0.19534703188831612,
			-0.009006968320803055,
			-0.01401028930461432,
			0.9805927408703851
		],
		"risorius03.L": [
			3.490658428972884e-8,
			-8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		]
	},
	"sit_on_ground01": {
		"toe1-1.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"finger5-2.R": [
			-0.01068746535125665,
			-0.011824853008334912,
			-0.03584918418978137,
			0.9992300970890664
		],
		"finger1-3.R": [
			-4.3633228585804086e-8,
			-1.7453292144864463e-8,
			8.726646960611766e-9,
			0.9999999999999989
		],
		"toe5-2.R": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"toe4-2.R": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"clavicle.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"neck03": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"neck02": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"neck01": [
			-0.0168362379909243,
			-0.20018285686917614,
			-0.05653780273967207,
			0.9779810027640503
		],
		"clavicle.L": [
			0.00944746573112099,
			-0.03522476465370006,
			-0.009376964787492136,
			0.9992907654320258
		],
		"toe5-2.L": [
			4.363322858580422e-8,
			8.726646516521441e-9,
			-8.726645628343238e-9,
			0.999999999999999
		],
		"toe4-2.L": [
			-8.72664696061068e-9,
			1.745329292202058e-8,
			5.235987998730666e-8,
			0.9999999999999984
		],
		"finger5-2.L": [
			-0.0021396419367815936,
			0.0017146560309255765,
			0.004406675618416307,
			0.9999865314578351
		],
		"finger1-3.L": [
			4.3633228585804066e-8,
			1.7453290479529926e-8,
			3.490658428972878e-8,
			0.9999999999999984
		],
		"toe1-1.R": [
			-4.36332285858042e-8,
			1.4432899320127035e-15,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"oculi02.L": [
			2.617994088183188e-8,
			-5.2359880320373975e-8,
			8.7266447401646e-9,
			0.9999999999999986
		],
		"oculi01.L": [
			-1.7453292144864446e-8,
			3.490658440075123e-8,
			8.726645628343005e-9,
			0.9999999999999993
		],
		"jaw": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger4-2.R": [
			-0.014922083450345942,
			-0.016510077515314858,
			-0.050053456318451664,
			0.9984985729967348
		],
		"oculi01.R": [
			9.13852305968756e-16,
			-2.6179939993653534e-8,
			3.4906584289728846e-8,
			0.9999999999999991
		],
		"oculi02.R": [
			4.3633228585804185e-8,
			4.440892098500626e-16,
			-8.72664605333848e-9,
			0.999999999999999
		],
		"wrist.R": [
			-0.18435906919745407,
			-0.23429047675735437,
			-0.3716635995859098,
			0.8791961526578151
		],
		"finger1-1.L": [
			-0.1070679319467298,
			0.053443447983828496,
			-0.01036061493215629,
			0.9927602497453644
		],
		"tongue07.R": [
			-1.0661610059836916e-15,
			-6.108652417236016e-8,
			-1.745329214486441e-8,
			0.999999999999998
		],
		"eye.R": [
			1.7453291256686076e-8,
			6.981316835741325e-8,
			8.726647404699983e-9,
			0.9999999999999972
		],
		"finger2-1.R": [
			-0.013501956501324706,
			-0.015067005079017148,
			-0.040046310082846176,
			0.9989929807447767
		],
		"finger4-3.R": [
			-0.008606287698527039,
			-0.009522180018411541,
			-0.028868207320549972,
			0.9995008186619184
		],
		"finger2-1.L": [
			0.1342935760108229,
			-0.09520475777375881,
			-0.11364916079378427,
			0.9797883229505916
		],
		"eye.L": [
			-4.363322858580418e-8,
			-1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"tongue07.L": [
			8.72664607243222e-9,
			-4.3633228918871225e-8,
			-3.5626088403688626e-16,
			0.9999999999999991
		],
		"wrist.L": [
			0.14984370498830588,
			-0.1750099956422725,
			0.1996308293790151,
			0.9524000721661648
		],
		"finger5-3.R": [
			-0.006589716288242841,
			-0.0072909895453883156,
			-0.02210410580258597,
			0.9997073699925181
		],
		"lowerleg01.R": [
			0.5663156816656298,
			0.040647327319745075,
			0.10523781368634179,
			0.8164308580963079
		],
		"lowerarm02.L": [
			-2.6179941770010337e-8,
			-5.235988020935167e-8,
			-2.6179938217296668e-8,
			0.999999999999998
		],
		"oris07.L": [
			-8.726646960610626e-9,
			-3.490658440075123e-8,
			-2.61799399936535e-8,
			0.999999999999999
		],
		"oris07.R": [
			1.745329303304289e-8,
			-1.7453293144065185e-8,
			2.6179939993653494e-8,
			0.9999999999999993
		],
		"tongue00": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"lowerarm02.R": [
			4.36332285858042e-8,
			-1.4432899320127035e-15,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"lowerleg01.L": [
			0.5228745532729162,
			0.06721638776248606,
			0.11405596206592888,
			0.8420661472075859
		],
		"tongue03": [
			-3.046174000298796e-16,
			3.4906584178706623e-8,
			8.726646072432218e-9,
			0.9999999999999994
		],
		"finger1-1.R": [
			-0.13898128874189633,
			-0.12513660182478348,
			0.05932289226707655,
			0.9805640349902988
		],
		"metacarpal4.L": [
			-0.002723275724155266,
			0.0021824322186426715,
			0.005608802201461194,
			0.9999781808103646
		],
		"finger1-2.R": [
			-4.569261529843784e-16,
			-1.7453292255886765e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"pelvis.R": [
			-0.3025928717572053,
			0.1653953615116024,
			-0.04248721236719948,
			0.9376975872515824
		],
		"toe2-1.R": [
			-5.235987998730683e-8,
			-8.726646294476836e-9,
			4.4331856927593173e-16,
			0.9999999999999987
		],
		"toe2-3.L": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"toe5-3.L": [
			8.726646516521443e-9,
			1.7453291811797556e-8,
			-2.6179939993653554e-8,
			0.9999999999999993
		],
		"levator05.L": [
			-9.138523059687567e-16,
			3.4906584178706623e-8,
			2.6179939993653468e-8,
			0.9999999999999989
		],
		"finger4-1.L": [
			2.617993999365346e-8,
			5.235987998730707e-8,
			1.361416935280011e-15,
			0.9999999999999983
		],
		"finger4-1.R": [
			-0.014831506179981531,
			-0.016409905634565014,
			-0.04974958541582534,
			0.9985167600859042
		],
		"levator05.R": [
			-1.5230870001493993e-16,
			-8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe5-3.R": [
			3.490658428972883e-8,
			-5.551115123125783e-16,
			2.617994002055379e-8,
			0.9999999999999992
		],
		"toe2-3.R": [
			-8.726645628343061e-9,
			8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"finger4-2.L": [
			0.02195182439763686,
			-0.015562262181695874,
			-0.018577201218574646,
			0.9994652675287364
		],
		"toe2-1.L": [
			-8.726646516521426e-9,
			8.726646627543744e-9,
			5.2359879987307266e-8,
			0.9999999999999986
		],
		"finger1-2.L": [
			-2.617993999365348e-8,
			-1.1102230246251565e-15,
			-4.363322861862043e-8,
			0.9999999999999989
		],
		"pelvis.L": [
			5.2359879987306776e-8,
			-2.6179939549564324e-8,
			-1.7453293921221474e-8,
			0.9999999999999984
		],
		"metacarpal4.R": [
			0.007033650904995218,
			0.018535690430484864,
			0.03912061557017563,
			0.9990378037755242
		],
		"tongue04": [
			-2.6179939993653534e-8,
			-4.3633228474782015e-8,
			8.726647404699778e-9,
			0.9999999999999987
		],
		"toe3-2.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"levator03.R": [
			8.726645628343017e-9,
			-2.6179939993653534e-8,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"upperleg02.R": [
			-0.044796282525279674,
			-0.40502212325854203,
			0.012333452737831898,
			0.9131255437707467
		],
		"upperleg02.L": [
			0.013723314177283714,
			-0.12407892776332086,
			0.003778306589379267,
			0.9921702549121362
		],
		"levator03.L": [
			-1.745329214486445e-8,
			-1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"toe3-2.R": [
			-1.7453292144864446e-8,
			4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"metacarpal3.L": [
			-5.2359879987306876e-8,
			8.726647626744466e-9,
			2.6179939105475504e-8,
			0.9999999999999984
		],
		"tongue01": [
			-3.4906584289728793e-8,
			-1.7453292366909068e-8,
			8.7266465165216e-9,
			0.9999999999999996
		],
		"breast.L": [
			-8.726645628343017e-9,
			2.6179939993653534e-8,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"temporalis02.R": [
			-1.745329214486443e-8,
			-5.235987998730707e-8,
			8.662785736608193e-16,
			0.999999999999998
		],
		"tongue02": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"oris04.R": [
			-8.726645628343005e-9,
			-5.235987976526246e-8,
			8.726646516521441e-9,
			0.9999999999999984
		],
		"oris04.L": [
			8.726645628343012e-9,
			-4.3633228474782015e-8,
			-8.726646516521458e-9,
			0.9999999999999989
		],
		"temporalis02.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"breast.R": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"oris03.R": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"oris06.L": [
			-4.363322858580416e-8,
			2.617994021569814e-8,
			-1.1643607064032247e-15,
			0.9999999999999988
		],
		"orbicularis04.R": [
			-3.8077175003734897e-16,
			4.363322858580432e-8,
			8.726646072432225e-9,
			0.999999999999999
		],
		"toe1-2.R": [
			3.490658428972884e-8,
			-8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"toe1-2.L": [
			2.617993999365348e-8,
			-1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		],
		"orbicularis04.L": [
			6.092348000597589e-16,
			-3.4906584178706623e-8,
			1.745329214486445e-8,
			0.9999999999999991
		],
		"metacarpal3.R": [
			-0.000060270840156263466,
			0.030083305265528937,
			0.020822605168964704,
			0.9993304809849964
		],
		"oris06.R": [
			-7.853981998095982e-8,
			2.617993977160893e-8,
			-2.1033163520354776e-15,
			0.9999999999999964
		],
		"levator04.L": [
			-2.6179940881831887e-8,
			-1.7453293255087488e-8,
			-2.6179939105475074e-8,
			0.9999999999999993
		],
		"tongue06.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe2-2.L": [
			-8.72664562834299e-9,
			8.726645406298417e-9,
			-6.108652428338209e-8,
			0.9999999999999983
		],
		"toe2-2.R": [
			6.853892030067822e-16,
			-8.726645961409929e-9,
			7.853981998095987e-8,
			0.9999999999999968
		],
		"tongue06.R": [
			0,
			0,
			2.617993999365351e-8,
			0.9999999999999998
		],
		"levator04.R": [
			-8.726646072432225e-9,
			2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"toe4-1.L": [
			3.490658428972886e-8,
			8.881784197001252e-16,
			-2.6179940108230155e-8,
			0.9999999999999991
		],
		"upperleg01.R": [
			-0.2509388718710931,
			-0.29278186153435015,
			-0.0911022927439739,
			0.9181551265430777
		],
		"metacarpal1.R": [
			-0.006006919593092174,
			-0.006703177475822386,
			-0.017816284606693707,
			0.9998007623179447
		],
		"levator02.R": [
			-2.617993999365347e-8,
			-1.745329247793137e-8,
			-8.726645628343018e-9,
			0.9999999999999994
		],
		"toe3-1.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe3-1.R": [
			-4.363322858580409e-8,
			8.726647404699861e-9,
			2.6179939993652998e-8,
			0.9999999999999986
		],
		"levator02.L": [
			-1.745329303304284e-8,
			-5.235988009832937e-8,
			-8.726645184253813e-9,
			0.9999999999999986
		],
		"finger5-1.R": [
			-0.006321833273218274,
			-0.006994639499484201,
			-0.021205552192607915,
			0.9997306807328383
		],
		"metacarpal1.L": [
			-2.617993999365347e-8,
			-2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"toe4-1.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"upperleg01.L": [
			-0.2293538142283797,
			-0.23480106681168533,
			0.22372111447771634,
			0.9177222618307989
		],
		"head": [
			-0.0018575662371562497,
			-0.10063444514639219,
			0.06488943982549114,
			0.9928034138221355
		],
		"toe5-1.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			2.2846307649218957e-16,
			8.726646183454534e-9,
			-2.6179939993653534e-8,
			0.9999999999999994
		],
		"special04": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"metacarpal2.L": [
			-6.981316857945715e-8,
			-3.4906586066085765e-8,
			-2.617993732912073e-8,
			0.9999999999999968
		],
		"metacarpal2.R": [
			-8.726645628343023e-9,
			1.745329203384216e-8,
			-2.6179939993653547e-8,
			0.9999999999999994
		],
		"temporalis01.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"toe5-1.L": [
			1.745329214486445e-8,
			-8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"risorius02.R": [
			-8.726646516521428e-9,
			5.235987998730707e-8,
			8.726645628342985e-9,
			0.9999999999999987
		],
		"special05.L": [
			-2.6179939105475068e-8,
			3.4906584289728926e-8,
			-1.7453293033042906e-8,
			0.999999999999999
		],
		"finger2-2.L": [
			0.03547519967015399,
			-0.0185982356790797,
			-0.13790091899645612,
			0.9896357675316312
		],
		"foot.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"oris06": [
			8.726646072432225e-9,
			-2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"levator06.R": [
			-8.72664607243222e-9,
			4.3633228918871225e-8,
			-3.5626088403688626e-16,
			0.9999999999999991
		],
		"orbicularis03.R": [
			1.745329214486444e-8,
			3.490658451177353e-8,
			4.799202690040438e-16,
			0.9999999999999992
		],
		"levator06.L": [
			2.6179939993653484e-8,
			2.6179940104675836e-8,
			8.045503725131716e-16,
			0.9999999999999991
		],
		"orbicularis03.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"foot.R": [
			0.635353359487403,
			-0.2756965408811024,
			0.08962245524715878,
			0.7157411134270104
		],
		"root": [
			-0.20098981948297437,
			0.051511981456435985,
			0.2428637166189045,
			0.9476111140023032
		],
		"finger2-2.R": [
			-0.049398752017000426,
			-0.11112666182570285,
			-0.05447918072152588,
			0.9910815542620848
		],
		"risorius02.L": [
			8.726646072432215e-9,
			5.235988020935167e-8,
			4.624224031074066e-16,
			0.9999999999999982
		],
		"special05.R": [
			8.726646960610635e-9,
			4.363322858580432e-8,
			-1.7453292144864436e-8,
			0.9999999999999989
		],
		"lowerleg02.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"tongue05.L": [
			1.745329303304285e-8,
			4.3633228918871225e-8,
			-2.6179939105475048e-8,
			0.9999999999999986
		],
		"finger5-1.L": [
			-0.06374256168738383,
			0.054148447700526625,
			0.13742428309274282,
			0.9869748719484202
		],
		"toe4-3.R": [
			2.6179939993653487e-8,
			-7.771561172376096e-16,
			2.6179939958862843e-8,
			0.9999999999999994
		],
		"oris03.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe4-3.L": [
			8.726646072432225e-9,
			6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"finger3-3.L": [
			0.08833058586594267,
			-0.0482002978091719,
			-0.14540603579755995,
			0.984241598209162
		],
		"tongue05.R": [
			1.745329303304289e-8,
			2.6179940104675836e-8,
			-1.745329125668605e-8,
			0.9999999999999996
		],
		"lowerleg02.R": [
			-2.6179939993653527e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"shoulder01.R": [
			-0.022621746439657347,
			0.048423880041678635,
			-0.1464174167277496,
			0.9877779732857487
		],
		"finger3-1.L": [
			0.07154423734482153,
			-0.05071983070653152,
			-0.06054597474443867,
			0.9943053383232406
		],
		"special06.R": [
			-2.2846307649218933e-16,
			-2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"finger4-3.L": [
			0.14874946426441413,
			-0.10545303967802,
			-0.1258828286997729,
			0.9751444850596548
		],
		"finger3-2.L": [
			0.06261078169532443,
			-0.0326979435697583,
			-0.1360321097283607,
			0.9881831812091626
		],
		"upperarm01.R": [
			0.04486706465023275,
			0.162626040571765,
			0.24540413689954976,
			0.9546289996800904
		],
		"finger3-2.R": [
			-0.01763071858940222,
			-0.01967435049849986,
			-0.052292102398031864,
			0.9982823316683902
		],
		"upperarm01.L": [
			-0.15630077505965886,
			-0.42895800416262986,
			0.02776458134350627,
			0.8892661167521134
		],
		"special06.L": [
			-2.2846307649218933e-16,
			-2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"finger3-1.R": [
			-0.02541004230578719,
			-0.028065489841788804,
			-0.08176392930067182,
			0.9959323862066508
		],
		"shoulder01.L": [
			0.17382672567858484,
			-0.2019844122197918,
			0.14330463751553502,
			0.9531266167339093
		],
		"lowerarm01.R": [
			0.13213104170497741,
			-0.3042996221465467,
			0.019638673105609957,
			0.9431635331680703
		],
		"special03": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"upperarm02.L": [
			0.09961255532828352,
			-0.10899822016025484,
			0.006731316478035687,
			0.9890153771308804
		],
		"spine02": [
			0.06666772420902758,
			-0.0005020493216487676,
			0.0004989352100265534,
			0.9977749814256335
		],
		"spine03": [
			0.13965668631875283,
			-0.0012596761294343395,
			0.00035990437877195307,
			0.9901991181834853
		],
		"spine01": [
			0.04552672543571295,
			-0.08486828825678217,
			-0.15785778618993235,
			0.9827540945011011
		],
		"upperarm02.R": [
			2.2846307649218933e-16,
			2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"spine04": [
			-0.11001115518818354,
			-0.03444908508936606,
			-0.011016744371244523,
			0.9932720863963338
		],
		"spine05": [
			0.15853706436871096,
			0.005330308092790004,
			-0.02417207743551239,
			0.9870427030830216
		],
		"lowerarm01.L": [
			-0.21834962862956395,
			-0.03415552919826337,
			0.1409267469259243,
			0.9650370415188188
		],
		"finger5-3.L": [
			-2.6179939993653497e-8,
			5.551115123125783e-16,
			1.745329205570242e-8,
			0.9999999999999993
		],
		"oris01": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"oris02": [
			-1.7453292144864446e-8,
			1.7453292366909068e-8,
			-1.745329214486445e-8,
			0.9999999999999997
		],
		"oris05": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"risorius03.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger2-3.L": [
			0.03719634852347441,
			-0.02325019062250444,
			-0.07587292601884565,
			0.9961521768233387
		],
		"toe3-3.R": [
			1.745329214486444e-8,
			-8.726646183454534e-9,
			3.490658428972891e-8,
			0.9999999999999996
		],
		"finger3-3.R": [
			-0.010898364966812464,
			-0.01216166038240174,
			-0.03232411637585735,
			0.999344020424555
		],
		"finger2-3.R": [
			-2.6179939993653504e-8,
			-3.4906584733818136e-8,
			-8.726645184253808e-9,
			0.9999999999999991
		],
		"toe3-3.L": [
			2.617993999365347e-8,
			2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"risorius03.L": [
			2.7755575615628914e-16,
			1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		]
	},
	"Harvey_StandingFashion3": {
		"toe1-1.L": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger5-2.R": [
			0.10125852204955291,
			0.10554750765308174,
			0.34130865495223,
			0.9285013933189665
		],
		"finger1-3.R": [
			-1.7453291256686083e-8,
			2.617993899445281e-8,
			-2.6179940881832245e-8,
			0.9999999999999991
		],
		"toe5-2.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"toe4-2.R": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"clavicle.R": [
			0.0012380098247128052,
			0.0030851216974754347,
			0.09941443450143182,
			0.995040561770497
		],
		"neck03": [
			0,
			0,
			0,
			1
		],
		"neck02": [
			6.327142510034724e-9,
			-0.02641887815143429,
			0.095899800944629,
			0.9950403363964702
		],
		"neck01": [
			2.5417074547833076e-8,
			-0.045870389962814895,
			0.0882699981820641,
			0.9950398558578435
		],
		"clavicle.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"toe5-2.L": [
			2.6179939993653494e-8,
			-8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe4-2.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger5-2.L": [
			2.6179939993653504e-8,
			1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		],
		"finger1-3.L": [
			-3.4906584289728807e-8,
			-2.6179939993653534e-8,
			8.72664696061079e-9,
			0.999999999999999
		],
		"toe1-1.R": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"oculi02.L": [
			-2.6179939105475058e-8,
			-1.7453291256686043e-8,
			3.490658428972882e-8,
			0.9999999999999987
		],
		"oculi01.L": [
			8.726646516521436e-9,
			-1.7453292366909068e-8,
			2.6179939993653527e-8,
			0.9999999999999996
		],
		"jaw": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger4-2.R": [
			0.18221325673006925,
			0.12266935560308512,
			0.299396751269809,
			0.9284999427015759
		],
		"oculi01.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"oculi02.R": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"wrist.R": [
			0.1925607833378127,
			0.09747406846669127,
			-0.09995555902698523,
			0.9713022376770688
		],
		"finger1-1.L": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"tongue07.R": [
			-2.6179939993653494e-8,
			-1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"eye.R": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"finger2-1.R": [
			-2.6179939993653497e-8,
			-8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"finger4-3.R": [
			0.1393629680866851,
			0.08407556385857129,
			0.23673198078197757,
			0.9578450981045812
		],
		"finger2-1.L": [
			0.07319621197392415,
			-0.04599561843046307,
			-0.04922023527715266,
			0.9950397409536618
		],
		"eye.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"tongue07.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"wrist.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"finger5-3.R": [
			0.13855276206311773,
			0.13328654824437025,
			0.47718747413495144,
			0.8575138148802549
		],
		"lowerleg01.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"lowerarm02.L": [
			3.8077175003734897e-16,
			4.363322869682662e-8,
			-8.726646072432225e-9,
			0.9999999999999991
		],
		"oris07.L": [
			8.726646072432225e-9,
			-1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"oris07.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"tongue00": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"lowerarm02.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"lowerleg01.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"tongue03": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"finger1-1.R": [
			-0.022815779291223994,
			-0.09446268522699686,
			-0.02136585705294773,
			0.9950375578175086
		],
		"metacarpal4.L": [
			8.726646072432222e-9,
			3.3306690738754696e-16,
			-5.2359880055849324e-8,
			0.9999999999999984
		],
		"finger1-2.R": [
			0.10710304578641043,
			0.06111424520634867,
			-0.24254247971596643,
			0.9622718597929392
		],
		"pelvis.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe2-1.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-3.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-3.L": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"levator05.L": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"finger4-1.L": [
			1.745329303304289e-8,
			2.6179940104675836e-8,
			-1.745329125668605e-8,
			0.9999999999999996
		],
		"finger4-1.R": [
			0.09213394221563306,
			0.051584401326754015,
			0.16519973798005883,
			0.9805913689212682
		],
		"levator05.R": [
			8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"toe5-3.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"toe2-3.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger4-2.L": [
			-1.7453292144864443e-8,
			-8.726645850387627e-9,
			2.6179939993653534e-8,
			0.9999999999999996
		],
		"toe2-1.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger1-2.L": [
			-8.726645184253878e-9,
			2.6179939993653534e-8,
			-2.6179939993653474e-8,
			0.9999999999999992
		],
		"pelvis.L": [
			8.726646072432225e-9,
			6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"metacarpal4.R": [
			2.6179939993653438e-8,
			-1.6653345369377348e-15,
			6.108652420236881e-8,
			0.999999999999998
		],
		"tongue04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator03.R": [
			-8.726646516521428e-9,
			5.235987998730707e-8,
			8.726645628342985e-9,
			0.9999999999999987
		],
		"upperleg02.R": [
			-0.09891966174926611,
			0.010350628072996915,
			-0.0014614745965565593,
			0.9950405163157475
		],
		"upperleg02.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"levator03.L": [
			4.363322858580416e-8,
			-4.363322858580432e-8,
			-1.9472425866614827e-15,
			0.9999999999999979
		],
		"toe3-2.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"metacarpal3.L": [
			8.726646516521443e-9,
			1.7453291811797556e-8,
			-2.6179939993653554e-8,
			0.9999999999999993
		],
		"tongue01": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"breast.L": [
			0,
			0,
			0,
			1
		],
		"temporalis02.R": [
			-1.745329214486444e-8,
			-8.726646627543744e-9,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"tongue02": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"oris04.R": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"oris04.L": [
			-1.5230870001493993e-16,
			-8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"temporalis02.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"breast.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"oris03.R": [
			-1.5230870001493993e-16,
			-8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"oris06.L": [
			-2.6179940881831874e-8,
			4.363322880784892e-8,
			1.7453291256686013e-8,
			0.9999999999999986
		],
		"orbicularis04.R": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"toe1-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe1-2.L": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"orbicularis04.L": [
			2.6179939993653477e-8,
			-2.6179940548765046e-8,
			-8.726646960610674e-9,
			0.9999999999999996
		],
		"metacarpal3.R": [
			4.3633228585804185e-8,
			2.6179939660586626e-8,
			8.726647404700228e-9,
			0.9999999999999984
		],
		"oris06.R": [
			-6.108652428338209e-8,
			-3.490658462279583e-8,
			2.0145849534447307e-15,
			0.9999999999999976
		],
		"levator04.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"tongue06.L": [
			-1.5230870001493993e-16,
			8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe2-2.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-2.R": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"tongue06.R": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"levator04.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"toe4-1.L": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"upperleg01.R": [
			-0.1087239611690134,
			-0.16583973567646482,
			-0.24440754298859046,
			0.9491792429613911
		],
		"metacarpal1.R": [
			1.745329214486444e-8,
			4.440892098500626e-16,
			-1.7453292016352737e-8,
			0.9999999999999994
		],
		"levator02.R": [
			3.4906584289728827e-8,
			2.617994121489886e-8,
			-2.61799391054727e-8,
			0.9999999999999991
		],
		"toe3-1.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-1.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"levator02.L": [
			2.6179939993653484e-8,
			-2.6179940104675836e-8,
			-8.045503725131716e-16,
			0.9999999999999991
		],
		"finger5-1.R": [
			0.09639042169090366,
			0.08594233544630747,
			0.3481440587757758,
			0.9285033742121855
		],
		"metacarpal1.L": [
			2.6179939993653517e-8,
			3.4906584733818136e-8,
			8.72664696061073e-9,
			0.9999999999999996
		],
		"toe4-1.R": [
			3.4906584289728793e-8,
			-1.7453292366909068e-8,
			-8.7266465165216e-9,
			0.9999999999999996
		],
		"upperleg01.L": [
			0.09978287490845919,
			-0.019265867912301782,
			-0.09626830549766942,
			0.9901538353029782
		],
		"head": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-1.R": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			8.726645628343032e-9,
			-2.617993988263123e-8,
			-8.726646516521458e-9,
			0.9999999999999997
		],
		"special04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal2.L": [
			4.363322680944724e-8,
			-3.4906582846438994e-8,
			-3.490658606608551e-8,
			0.9999999999999978
		],
		"metacarpal2.R": [
			3.490658428972882e-8,
			5.235988009832937e-8,
			-8.726644296075283e-9,
			0.999999999999998
		],
		"temporalis01.R": [
			8.72664651652145e-9,
			-8.726646627543744e-9,
			2.6179939993653484e-8,
			0.9999999999999996
		],
		"toe5-1.L": [
			3.4906584289728866e-8,
			-8.726645961409929e-9,
			-1.7169609607764797e-16,
			0.9999999999999993
		],
		"risorius02.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"special05.L": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"finger2-2.L": [
			3.4906584289728793e-8,
			1.7453292366909068e-8,
			8.7266465165216e-9,
			0.9999999999999996
		],
		"foot.L": [
			-0.10418531991720381,
			0.0383132164088027,
			-0.08528671242948038,
			0.9901533685470818
		],
		"oris06": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.R": [
			-8.726646960610704e-9,
			2.6179939993653534e-8,
			2.6179939993653468e-8,
			0.9999999999999992
		],
		"orbicularis03.R": [
			1.7453292144864433e-8,
			2.617994021569814e-8,
			4.927555263958927e-16,
			0.9999999999999996
		],
		"levator06.L": [
			0,
			0,
			0,
			1
		],
		"orbicularis03.L": [
			-2.617993999365346e-8,
			-3.4906584733818136e-8,
			1.0095481158786604e-15,
			0.9999999999999991
		],
		"foot.R": [
			0.19396494494662234,
			0.024827266816278337,
			0.13539814140604153,
			0.9713025019313377
		],
		"root": [
			-1.4283491974796373e-7,
			-0.0031233913336558006,
			0.14825908030117155,
			0.9889436230315696
		],
		"finger2-2.R": [
			4.363322858580418e-8,
			1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"risorius02.L": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"special05.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"lowerleg02.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"tongue05.L": [
			-1.5230870001493993e-16,
			8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"finger5-1.L": [
			8.726647404699835e-9,
			-4.363322880784892e-8,
			3.490658428972884e-8,
			0.9999999999999982
		],
		"toe4-3.R": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"oris03.L": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"toe4-3.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"finger3-3.L": [
			8.726646516521433e-9,
			-8.726646405499139e-9,
			4.3633228585804245e-8,
			0.9999999999999992
		],
		"tongue05.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"lowerleg02.R": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"shoulder01.R": [
			-8.726645628343025e-9,
			-8.726645517320719e-9,
			2.6179939993653497e-8,
			0.9999999999999994
		],
		"finger3-1.L": [
			1.0661610059836916e-15,
			-6.108652428338246e-8,
			1.745329214486441e-8,
			0.9999999999999981
		],
		"special06.R": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger4-3.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger3-2.L": [
			4.363322858580412e-8,
			2.6179940992854256e-8,
			-2.617993910547514e-8,
			0.9999999999999986
		],
		"upperarm01.R": [
			0.12888288003077358,
			0.002099341733657667,
			0.28711261357941525,
			0.9491844621162189
		],
		"finger3-2.R": [
			0.16656546081689325,
			0.12411643639363645,
			0.19846656069903268,
			0.9578424096708693
		],
		"upperarm01.L": [
			0.0008710164123783456,
			0.26242015361113924,
			-0.2764263001566139,
			0.9245125228415464
		],
		"special06.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-1.R": [
			-0.022735373744812,
			0.08453947518909488,
			0.10925129434620263,
			0.9901516725225056
		],
		"shoulder01.L": [
			0.08861051354582129,
			-0.045218773029888415,
			0.09848356006023586,
			0.9901537395034569
		],
		"lowerarm01.R": [
			0.051627231511961955,
			0.05658021100329924,
			-0.06347765524076404,
			0.9950396454284459
		],
		"special03": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"upperarm02.L": [
			2.617993999365348e-8,
			-1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		],
		"spine02": [
			5.002467551034803e-7,
			0.09934966647659604,
			-0.14694667358631114,
			0.984142428153902
		],
		"spine03": [
			-1.6788981573913152e-8,
			0.006658132221168844,
			-0.04947453573197148,
			0.9987531925302823
		],
		"spine01": [
			-9.676599912928573e-8,
			-0.009774414008282606,
			-0.09898894995132054,
			0.99504052611857
		],
		"upperarm02.R": [
			0.06635084860280537,
			0.07405826688766004,
			-0.003281607420712516,
			0.9950387776604587
		],
		"spine04": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"spine05": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"lowerarm01.L": [
			-4.569261529843786e-16,
			1.745329203384216e-8,
			2.6179939993653514e-8,
			0.9999999999999997
		],
		"finger5-3.L": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"oris01": [
			-6.10865242833821e-8,
			-4.440892098500626e-16,
			-8.72664608214625e-9,
			0.9999999999999981
		],
		"oris02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			5.235987998730676e-8,
			-1.7453290479529926e-8,
			-2.6179940881831593e-8,
			0.9999999999999982
		],
		"finger2-3.L": [
			5.235987998730672e-8,
			-2.6179938550363602e-8,
			-2.617994177001015e-8,
			0.9999999999999981
		],
		"toe3-3.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger3-3.R": [
			0.21508490266172436,
			0.1564573365462576,
			0.2591352943003168,
			0.9284979729303322
		],
		"finger2-3.R": [
			-0.07333538599899797,
			-0.049504164188581834,
			-0.045463689443442125,
			0.9950398543930576
		],
		"toe3-3.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"risorius03.L": [
			5.235987998730684e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999987
		]
	},
	"run01": {
		"toe1-1.L": [
			4.3633225033090646e-8,
			-7.853981687233613e-8,
			-5.235988354001967e-8,
			0.9999999999999949
		],
		"finger5-2.R": [
			0.1689640642073576,
			0.2048792230367159,
			0.5613594068700722,
			0.7838056297915216
		],
		"finger1-3.R": [
			-0.11674540235647181,
			0.019808291632809394,
			0.04536502022962496,
			0.991927496115911
		],
		"toe5-2.R": [
			-6.108652428338212e-8,
			8.726647848789071e-9,
			2.6179939105475263e-8,
			0.9999999999999978
		],
		"toe4-2.R": [
			6.108652428338186e-8,
			2.617993710707367e-8,
			4.363323036216344e-8,
			0.9999999999999963
		],
		"clavicle.R": [
			0.01825920868793728,
			0.08460171021987017,
			-0.010705013071144812,
			0.9961900193342184
		],
		"neck03": [
			-6.498606571544075e-9,
			-0.11050784646017786,
			-0.004305819141036509,
			0.9938659244547313
		],
		"neck02": [
			-0.019848213624619693,
			-0.024069893253115593,
			-0.05798131758708717,
			0.997830073442147
		],
		"neck01": [
			0.002216466554085632,
			-0.15354090291435485,
			-0.05409893753726966,
			0.9866577843232166
		],
		"clavicle.L": [
			0.06619250955351944,
			0.1862703906390758,
			-0.0220905519463987,
			0.9800172961559794
		],
		"toe5-2.L": [
			1.3707784060135717e-15,
			1.7453292255886765e-8,
			-7.853981998096028e-8,
			0.9999999999999968
		],
		"toe4-2.L": [
			8.72664562834302e-9,
			-3.4906584289728926e-8,
			-8.726646516521445e-9,
			0.9999999999999994
		],
		"finger5-2.L": [
			-1.7453291256686003e-8,
			5.235987976526246e-8,
			-8.726646960611257e-9,
			0.9999999999999984
		],
		"finger1-3.L": [
			-1.2217304856676214e-7,
			8.72664285278546e-9,
			-2.617994088182809e-8,
			0.9999999999999921
		],
		"toe1-1.R": [
			1.7453291256686023e-8,
			2.617993932751972e-8,
			3.4906584289728926e-8,
			0.999999999999999
		],
		"oculi02.L": [
			7.85398199809595e-8,
			-6.108652461644937e-8,
			8.726641187459652e-9,
			0.9999999999999951
		],
		"oculi01.L": [
			3.490658428972883e-8,
			-2.6179939993653534e-8,
			-1.0341496537059884e-15,
			0.9999999999999992
		],
		"jaw": [
			-6.108652428338213e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"finger4-2.R": [
			0.318522823380126,
			0.24374473808450403,
			0.5100451523786065,
			0.7609110698216665
		],
		"oculi01.R": [
			3.490658784244258e-8,
			-6.981316846843555e-8,
			4.363322680944667e-8,
			0.9999999999999959
		],
		"oculi02.R": [
			-2.6179939993653487e-8,
			8.726645295276114e-9,
			-3.4906584289728926e-8,
			0.9999999999999988
		],
		"oris03.L": [
			-7.310818447749912e-15,
			-1.0471975997461413e-7,
			-6.98131685794569e-8,
			0.999999999999992
		],
		"finger1-1.L": [
			0.10354985599240853,
			0.044746778845505486,
			0.13696552233400394,
			0.9841319011182783
		],
		"tongue07.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"eye.R": [
			4.36332285858042e-8,
			-1.4432899320127035e-15,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"finger2-1.R": [
			0.24858515615714782,
			0.16125566315540296,
			0.15746206153910644,
			0.9420232111866951
		],
		"finger4-3.R": [
			0.2764935981261254,
			0.1871171466344561,
			0.4642130947599283,
			0.8203929950237615
		],
		"finger2-1.L": [
			-3.8077175003734897e-16,
			-4.363322869682662e-8,
			-8.726646072432225e-9,
			0.9999999999999991
		],
		"eye.L": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"tongue07.L": [
			7.85398199809599e-8,
			-8.726646627543744e-9,
			8.726645184253795e-9,
			0.9999999999999967
		],
		"wrist.L": [
			0.04203765973765045,
			-0.04865364789157456,
			-0.04621812643859133,
			0.9968598409501358
		],
		"finger5-3.R": [
			0.15020739498959854,
			0.16994108233969885,
			0.5110257703690446,
			0.8291021825097159
		],
		"lowerleg01.R": [
			0.468385102235004,
			-0.024706618306662653,
			-0.00691420106327792,
			0.8831518401949975
		],
		"lowerarm02.L": [
			-1.0471975642189872e-7,
			3.490657896065841e-8,
			-5.235988354000115e-8,
			0.9999999999999926
		],
		"oris07.L": [
			-6.981316857945685e-8,
			6.108652439440476e-8,
			1.7453287703973417e-8,
			0.9999999999999958
		],
		"oris07.R": [
			-2.6179939993653494e-8,
			-6.661338147750939e-16,
			-2.6179940052507944e-8,
			0.9999999999999993
		],
		"tongue00": [
			6.10865242833821e-8,
			-5.551115123125783e-16,
			8.726646064568477e-9,
			0.9999999999999981
		],
		"lowerarm02.R": [
			-8.726646072432222e-9,
			-3.3306690738754696e-16,
			-5.2359880055849324e-8,
			0.9999999999999984
		],
		"lowerleg01.L": [
			0.6567205136941227,
			0.06236236802677486,
			-0.00006984601342713512,
			0.751551127381867
		],
		"tongue03": [
			-7.853981998095985e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"finger1-1.R": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"metacarpal4.L": [
			-7.853981642824565e-8,
			3.490657551896703e-8,
			-1.1344640071794618e-7,
			0.9999999999999901
		],
		"finger1-2.R": [
			0.034837535679376044,
			-0.005036281208236293,
			-0.016311210393539183,
			0.9992471798283329
		],
		"pelvis.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe2-1.R": [
			-2.6179939993653527e-8,
			-8.726647404699861e-9,
			-4.363322858580379e-8,
			0.9999999999999987
		],
		"toe2-3.L": [
			-1.7453290368507614e-8,
			2.6179939216497417e-8,
			-6.981316857945846e-8,
			0.9999999999999971
		],
		"toe5-3.L": [
			8.726649625146034e-9,
			3.490658584404116e-8,
			-1.0471975997461114e-7,
			0.9999999999999939
		],
		"levator05.L": [
			-2.6179939993653504e-8,
			-3.4906584733818136e-8,
			-8.726645184253808e-9,
			0.9999999999999991
		],
		"finger4-1.L": [
			4.3633230362160965e-8,
			-6.108652450542706e-8,
			2.6179937329118278e-8,
			0.9999999999999969
		],
		"finger4-1.R": [
			0.2627267245440125,
			0.16771924706637098,
			0.46896697893226563,
			0.8263866498467944
		],
		"levator05.R": [
			-2.6179939993653517e-8,
			-3.4906584733818136e-8,
			8.72664696061073e-9,
			0.9999999999999996
		],
		"toe5-3.R": [
			1.745329214486436e-8,
			-2.3314683517128287e-15,
			1.0471975997979369e-7,
			0.9999999999999942
		],
		"toe2-3.R": [
			-5.235988176366347e-8,
			1.7453294809399722e-8,
			5.2359878210949805e-8,
			0.9999999999999972
		],
		"finger4-2.L": [
			-3.490658428972881e-8,
			8.726646738566046e-9,
			2.617993999365343e-8,
			0.9999999999999992
		],
		"toe2-1.L": [
			4.569261529843769e-16,
			-8.726645961409929e-9,
			5.235987998730683e-8,
			0.9999999999999987
		],
		"finger1-2.L": [
			-1.7453291256685957e-8,
			8.726644296075392e-9,
			-9.599310857310953e-8,
			0.9999999999999953
		],
		"pelvis.L": [
			0.0012242347757332103,
			0.022441766901693083,
			-0.007283257147378338,
			0.9997208723002983
		],
		"metacarpal4.R": [
			6.98131756848848e-8,
			9.599311590058335e-8,
			-7.853981287553142e-8,
			0.99999999999999
		],
		"tongue04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			-4.569261529843785e-16,
			2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"levator03.R": [
			7.853981998095985e-8,
			3.490658595506346e-8,
			-1.7453289480330276e-8,
			0.999999999999996
		],
		"upperleg02.R": [
			5.235987998730684e-8,
			8.726645739365324e-9,
			8.72664651652204e-9,
			0.9999999999999988
		],
		"upperleg02.L": [
			-0.17871053863283465,
			-0.0222005635533975,
			-0.0016303582430563807,
			0.9836498463841048
		],
		"levator03.L": [
			3.490658428972877e-8,
			1.7453293255087488e-8,
			-3.490658428972879e-8,
			0.9999999999999988
		],
		"toe3-2.R": [
			-8.726646072432222e-9,
			-3.3306690738754696e-16,
			-5.2359880055849324e-8,
			0.9999999999999984
		],
		"metacarpal3.L": [
			1.7453292144864446e-8,
			1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"tongue01": [
			0,
			0,
			0,
			1
		],
		"breast.L": [
			0.004637217825469179,
			-0.000016452224591234632,
			-0.001365723399657891,
			0.9999883153016139
		],
		"temporalis02.R": [
			-8.726646072432222e-9,
			-2.220446049250313e-16,
			-3.490658426895706e-8,
			0.9999999999999992
		],
		"tongue02": [
			0,
			0,
			0,
			1
		],
		"oris04.R": [
			4.3633230362160866e-8,
			-2.6179941881032676e-8,
			3.4906582513371795e-8,
			0.9999999999999981
		],
		"oris04.L": [
			6.981316857945727e-8,
			2.6179942214099583e-8,
			-2.6179938217296585e-8,
			0.9999999999999971
		],
		"temporalis02.L": [
			5.235987998730666e-8,
			-2.617993932751972e-8,
			-8.726647404699014e-9,
			0.9999999999999984
		],
		"breast.R": [
			6.853892559463472e-16,
			-2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"oris03.R": [
			-4.3633228585804086e-8,
			5.235987976526246e-8,
			8.72664385198646e-9,
			0.9999999999999973
		],
		"oris06.L": [
			-5.2359879987306756e-8,
			-2.617994121489886e-8,
			-1.7453290368507855e-8,
			0.9999999999999986
		],
		"orbicularis04.R": [
			5.235987998730684e-8,
			8.881784197001252e-16,
			-1.7453292120936186e-8,
			0.9999999999999983
		],
		"toe1-2.R": [
			4.363322858580418e-8,
			-1.7453291367708346e-8,
			-1.745329303304287e-8,
			0.999999999999999
		],
		"toe1-2.L": [
			-2.6179939993653497e-8,
			8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"orbicularis04.L": [
			4.569261529843786e-16,
			-1.745329203384216e-8,
			2.6179939993653514e-8,
			0.9999999999999997
		],
		"metacarpal3.R": [
			2.3455541708123308e-14,
			1.2217304856676492e-7,
			-1.9198621714621295e-7,
			0.999999999999974
		],
		"oris06.R": [
			-2.6179938217296555e-8,
			2.6179937884229787e-8,
			-6.98131685794569e-8,
			0.9999999999999972
		],
		"levator04.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"tongue06.L": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe2-2.L": [
			4.363322858580417e-8,
			-8.726646516521441e-9,
			-4.068768463957589e-16,
			0.999999999999999
		],
		"toe2-2.R": [
			-6.108652428338212e-8,
			8.726646405499139e-9,
			-4.661919405738096e-16,
			0.9999999999999984
		],
		"tongue06.R": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"levator04.R": [
			-8.726645184253789e-9,
			3.4906584178706623e-8,
			-2.617993999365348e-8,
			0.999999999999999
		],
		"toe4-1.L": [
			2.6179940881831828e-8,
			1.7453293699176697e-8,
			-6.981316857945666e-8,
			0.9999999999999969
		],
		"upperleg01.R": [
			0.17831041151268653,
			1.0748162138085604e-7,
			-3.9735519825006404e-7,
			0.9839742868317275
		],
		"metacarpal1.R": [
			5.23598817636635e-8,
			3.490658806448721e-8,
			-6.108652073066836e-8,
			0.9999999999999964
		],
		"levator02.R": [
			5.235987821094978e-8,
			-6.108652428338246e-8,
			-1.7453295697578545e-8,
			0.9999999999999963
		],
		"toe3-1.L": [
			3.490658606608565e-8,
			-3.4906586066085765e-8,
			4.363322680944711e-8,
			0.9999999999999977
		],
		"toe3-1.R": [
			-2.6179939993653464e-8,
			8.726645295276114e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"levator02.L": [
			7.853981998095975e-8,
			4.3633230695228065e-8,
			-2.6179936440939114e-8,
			0.9999999999999956
		],
		"finger5-1.R": [
			0.20161510819733572,
			0.11523566678916386,
			0.5199961114545502,
			0.821995214899929
		],
		"metacarpal1.L": [
			-2.6179937329118063e-8,
			2.6179937218095972e-8,
			-1.0471975997461235e-7,
			0.9999999999999937
		],
		"toe4-1.R": [
			2.61799391054751e-8,
			5.235987998730707e-8,
			1.7453293921221276e-8,
			0.9999999999999978
		],
		"upperleg01.L": [
			-0.18114441340591336,
			0.14629819883108142,
			0.06170298350780243,
			0.9705546251174351
		],
		"head": [
			-0.0870417478468922,
			-0.031383715697398396,
			0.10449312610182138,
			0.990212089967726
		],
		"toe5-1.R": [
			1.745329658575659e-8,
			3.490658617710807e-8,
			-1.3089969286284658e-7,
			0.9999999999999908
		],
		"special01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			-1.066161005983695e-15,
			-1.7453292144864463e-8,
			-6.108652428338229e-8,
			0.9999999999999979
		],
		"special04": [
			-7.853981998095985e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"metacarpal2.L": [
			-1.7453296585756558e-8,
			-7.853982031402751e-8,
			-5.235987821094999e-8,
			0.9999999999999956
		],
		"metacarpal2.R": [
			-2.6179932000047952e-8,
			8.726645372991726e-8,
			-8.726646072432758e-8,
			0.9999999999999917
		],
		"temporalis01.R": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"toe5-1.L": [
			3.4906584289728866e-8,
			-8.726645961409929e-9,
			-1.7169609607764797e-16,
			0.9999999999999993
		],
		"risorius02.R": [
			0,
			0,
			-3.490658428972887e-8,
			0.9999999999999996
		],
		"special05.L": [
			2.6179939105474995e-8,
			4.363322880784892e-8,
			2.617994088183188e-8,
			0.9999999999999984
		],
		"finger2-2.L": [
			-2.2846307649218957e-16,
			-8.726646183454534e-9,
			-2.6179939993653534e-8,
			0.9999999999999994
		],
		"foot.L": [
			-0.2734319097056278,
			-0.03457726563067942,
			-0.009911805918940707,
			0.9612185805318494
		],
		"toe3-3.R": [
			-6.108652783609577e-8,
			-2.617994609988017e-8,
			-9.599310857310678e-8,
			0.9999999999999928
		],
		"levator06.R": [
			-6.108652428338212e-8,
			8.726646405499139e-9,
			-4.661919405738096e-16,
			0.9999999999999984
		],
		"orbicularis03.R": [
			8.726646072432212e-9,
			6.661338147750939e-16,
			-4.363322873131176e-8,
			0.9999999999999994
		],
		"levator06.L": [
			-4.363322858580418e-8,
			1.7453291367708346e-8,
			-1.745329303304287e-8,
			0.999999999999999
		],
		"orbicularis03.L": [
			8.72664696061062e-9,
			-2.6179939993653534e-8,
			3.490658428972884e-8,
			0.9999999999999991
		],
		"foot.R": [
			0.24697500641840936,
			-0.022511803761614657,
			-0.001576548890844342,
			0.9687590409331001
		],
		"root": [
			0.0745775285412027,
			0,
			0,
			0.997215218614661
		],
		"finger2-2.R": [
			0.24841802680344846,
			0.16187565313994012,
			0.15234444905412733,
			0.9428021667995854
		],
		"risorius02.L": [
			-2.617993999365346e-8,
			-5.235987998730707e-8,
			1.361416935280011e-15,
			0.9999999999999983
		],
		"special05.R": [
			4.363322858580413e-8,
			3.490658440075123e-8,
			1.6405861018266948e-15,
			0.9999999999999987
		],
		"lowerleg02.L": [
			-0.009894719267259808,
			0.10826852903440243,
			0.003980636671479781,
			0.9940644720957683
		],
		"tongue05.L": [
			2.6179939993653494e-8,
			8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"finger5-1.L": [
			-3.4906578960658454e-8,
			7.853981653926922e-8,
			-6.981317213217043e-8,
			0.9999999999999942
		],
		"toe4-3.R": [
			4.363322858580417e-8,
			-8.726646516521441e-9,
			-4.068768463957589e-16,
			0.999999999999999
		],
		"wrist.R": [
			3.490658428972885e-8,
			1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"toe4-3.L": [
			8.726646072432218e-9,
			-6.661338147750939e-16,
			5.235988014207866e-8,
			0.9999999999999986
		],
		"finger3-3.L": [
			1.745329303304287e-8,
			-3.490658440075123e-8,
			1.7453291256686037e-8,
			0.999999999999999
		],
		"tongue05.R": [
			1.7453292144864446e-8,
			-4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"lowerleg02.R": [
			0.010713787091983427,
			0.11722732643044154,
			0.0043099459998787466,
			0.9930379615450742
		],
		"shoulder01.R": [
			0.1014450078731351,
			0.00772236030076956,
			0.031191992779291557,
			0.9943220479882069
		],
		"finger3-1.L": [
			8.726645184253878e-9,
			2.617993988263123e-8,
			2.6179939993653474e-8,
			0.9999999999999991
		],
		"special06.R": [
			3.4906584289728807e-8,
			-2.6179939993653534e-8,
			-8.72664696061079e-9,
			0.999999999999999
		],
		"finger4-3.L": [
			-5.2359879987306796e-8,
			4.363322858580432e-8,
			-8.7266482928784e-9,
			0.9999999999999978
		],
		"finger3-2.L": [
			7.853982353367289e-8,
			-6.108652805814074e-8,
			6.108652073067004e-8,
			0.9999999999999933
		],
		"upperarm01.R": [
			-0.29996791445329907,
			0.0720522834165006,
			0.0547027441492434,
			0.9496501084797225
		],
		"finger3-2.R": [
			0.4116888325632265,
			0.3287124044654298,
			0.4723829521020566,
			0.7066221103649596
		],
		"upperarm01.L": [
			0.15775814176215258,
			-0.006815183328870988,
			-0.047014214102588686,
			0.9863344187729952
		],
		"special06.L": [
			8.726645628343017e-9,
			1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"finger3-1.R": [
			0.27827437300400604,
			0.19853088062709923,
			0.35111995623423115,
			0.8717015768602966
		],
		"shoulder01.L": [
			0.006230998885875409,
			0.028452111295600546,
			-0.0038049481835740967,
			0.9995684940938403
		],
		"lowerarm01.R": [
			-0.34303250588229395,
			0.30394839461570666,
			-0.025734120310534726,
			0.8884153467666417
		],
		"special03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperarm02.L": [
			8.726650069235059e-9,
			8.726645717160864e-8,
			-4.363322858580405e-8,
			0.9999999999999953
		],
		"spine02": [
			0.0492390812901845,
			0.18685643195738533,
			0.05145951052340251,
			0.9798020746490308
		],
		"spine03": [
			0.13304735908412668,
			0.08937496359791208,
			-0.004405766708506822,
			0.9870618548714776
		],
		"spine01": [
			7.988914785982854e-8,
			-0.08390284663826642,
			-0.011347364919512945,
			0.9964093283562596
		],
		"upperarm02.R": [
			0.15234274390528582,
			0.17166199647192126,
			-0.0032508233414518394,
			0.9733002000895123
		],
		"spine04": [
			0.047041894247847625,
			0.11068988018850723,
			0.015208679217986677,
			0.9926245547465928
		],
		"spine05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			-0.18860207474251983,
			-0.1671146880955504,
			0.014149997963202592,
			0.9676268474898706
		],
		"finger5-3.L": [
			8.726646072432225e-9,
			-2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"oris01": [
			0,
			0,
			0,
			1
		],
		"oris02": [
			-7.853981998095985e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"oris05": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			-7.853981998095991e-8,
			8.72664829287828e-9,
			2.6179939105476246e-8,
			0.9999999999999963
		],
		"finger2-3.L": [
			9.599311567853686e-8,
			5.235989097851501e-8,
			-1.134463936125626e-7,
			0.9999999999999879
		],
		"oris06": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger3-3.R": [
			0.32816792226599706,
			0.25492508427737925,
			0.3823338437486953,
			0.8253119701822693
		],
		"finger2-3.R": [
			0.5240586003304084,
			0.36215886946637066,
			0.30449706319593034,
			0.7081561093372184
		],
		"toe3-3.L": [
			-8.726645628343005e-9,
			-5.235987976526246e-8,
			8.726646516521441e-9,
			0.9999999999999984
		],
		"risorius03.L": [
			-1.2217304856676193e-7,
			-3.4906587842442605e-8,
			-2.617993555275131e-8,
			0.9999999999999918
		]
	},
	"sit01": {
		"toe1-1.L": [
			3.49065842897289e-8,
			1.7453293699176697e-8,
			-4.363322858580413e-8,
			0.999999999999998
		],
		"finger5-2.R": [
			-0.032086184063162264,
			-0.03890347645653891,
			-0.10659840218371158,
			0.9930225460500582
		],
		"finger4-2.R": [
			-0.037703111046718196,
			-0.028850635757134202,
			-0.060372459119740596,
			0.9970462789728688
		],
		"toe5-2.R": [
			-1.5230870001493993e-16,
			8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe4-2.R": [
			-8.726646072432218e-9,
			6.661338147750939e-16,
			5.235988014207866e-8,
			0.9999999999999986
		],
		"clavicle.R": [
			1.7453290368507587e-8,
			5.235988020935167e-8,
			2.617994088183192e-8,
			0.9999999999999982
		],
		"neck03": [
			-8.726645717160755e-8,
			-3.4906584289728926e-8,
			3.1358776836655874e-15,
			0.9999999999999956
		],
		"neck02": [
			-1.5230870001493993e-16,
			-8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"neck01": [
			-1.7453293033042806e-8,
			-7.85398199809606e-8,
			-8.726644740164658e-9,
			0.9999999999999969
		],
		"clavicle.L": [
			-0.009078311961766667,
			0.14968274182842567,
			0.0006035776039970913,
			0.9886922153758092
		],
		"toe5-2.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe4-2.L": [
			0,
			0,
			0,
			1
		],
		"finger5-2.L": [
			0.16344572086369877,
			-0.009426041586660494,
			-0.13723657427865144,
			0.9769149240090523
		],
		"finger1-3.L": [
			-1.3089969286283663e-7,
			4.3633236135320885e-8,
			5.235987465823641e-8,
			0.9999999999999893
		],
		"toe1-1.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"oculi02.L": [
			2.6179939105474998e-8,
			-6.981316880150246e-8,
			-8.726647848788915e-9,
			0.9999999999999972
		],
		"oculi01.L": [
			6.108652783609577e-8,
			7.853982353367428e-8,
			-3.4906578960658394e-8,
			0.9999999999999944
		],
		"jaw": [
			2.617993999365346e-8,
			3.4906584733818136e-8,
			1.0095481158786604e-15,
			0.9999999999999991
		],
		"finger1-3.R": [
			-0.20162531978731754,
			0.034206814136812036,
			0.07834790773153325,
			0.9757247202163952
		],
		"oculi01.R": [
			3.490658251337198e-8,
			-3.490658262439439e-8,
			-4.3633230362160965e-8,
			0.9999999999999979
		],
		"oculi02.R": [
			2.617993821729663e-8,
			6.108652439440476e-8,
			2.6179941770010327e-8,
			0.9999999999999977
		],
		"wrist.R": [
			0.15514800690550562,
			-0.2139840428643096,
			-0.10570496341435166,
			0.958627344729048
		],
		"finger1-1.L": [
			-8.726646427703486e-8,
			1.2217305589423688e-7,
			5.235986932916384e-8,
			0.9999999999999876
		],
		"tongue07.R": [
			6.10865207306681e-8,
			-3.4906580625992945e-8,
			-6.108652783609546e-8,
			0.9999999999999957
		],
		"eye.R": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"finger2-1.R": [
			-0.09197880843659828,
			-0.05966445638765949,
			-0.0582631251791783,
			0.9922627976936879
		],
		"finger4-3.R": [
			-0.081800622805521,
			-0.055355308633561084,
			-0.1373338362018759,
			0.9855880809693205
		],
		"finger2-1.L": [
			2.617994088183185e-8,
			-8.726647293677559e-9,
			5.2359879987300185e-8,
			0.9999999999999984
		],
		"eye.L": [
			-8.72664651652143e-9,
			2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"tongue07.L": [
			2.61799391054751e-8,
			-5.235987998730707e-8,
			-1.7453293921221276e-8,
			0.9999999999999978
		],
		"wrist.L": [
			0.19224837426391442,
			-0.03965399068943731,
			-0.09661997682078091,
			0.9757728750556838
		],
		"finger5-3.R": [
			-0.022854715064886986,
			-0.025854480591192996,
			-0.0777506507586545,
			0.9963754534006082
		],
		"lowerleg01.R": [
			8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"lowerarm02.L": [
			-2.6179939105475104e-8,
			-6.981316891252476e-8,
			1.7453293921221593e-8,
			0.9999999999999972
		],
		"oris07.L": [
			-2.6179945322724075e-8,
			8.726645717160864e-8,
			6.108652073066822e-8,
			0.9999999999999938
		],
		"oris07.R": [
			4.36332268094472e-8,
			-6.981316857945785e-8,
			-3.4906587842442294e-8,
			0.9999999999999958
		],
		"tongue00": [
			6.10865242833821e-8,
			1.2212453270876722e-15,
			-2.6179939969202333e-8,
			0.9999999999999977
		],
		"lowerarm02.R": [
			-8.726645628343013e-9,
			3.4906584178706623e-8,
			-1.745329214486445e-8,
			0.9999999999999992
		],
		"lowerleg01.L": [
			0.7282192914954296,
			0.06638397177078481,
			0.004647266234752762,
			0.6821057357201842
		],
		"tongue03": [
			-1.745329303304287e-8,
			-3.490658440075123e-8,
			-1.7453291256686037e-8,
			0.999999999999999
		],
		"finger1-1.R": [
			-0.047259505825403315,
			0.0023724420637966093,
			0.049695945743139236,
			0.9976428336857271
		],
		"metacarpal4.L": [
			-1.134463794016909e-7,
			1.570796258620888e-7,
			-1.221730698830427e-7,
			0.9999999999999737
		],
		"finger1-2.R": [
			-0.036951782575106125,
			0.0053418443920469905,
			0.017301111997421105,
			0.9991529922822959
		],
		"pelvis.R": [
			4.363322858580417e-8,
			8.726646516521441e-9,
			4.068768463957589e-16,
			0.999999999999999
		],
		"toe2-1.R": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"toe2-3.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe5-3.L": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"levator05.L": [
			7.615435000746988e-16,
			4.363322858580432e-8,
			-1.7453292144864436e-8,
			0.9999999999999989
		],
		"finger4-1.L": [
			0.05054049573092968,
			-0.03226221567552412,
			-0.09021396962318033,
			0.9941158118729453
		],
		"finger4-1.R": [
			-0.1061360785418888,
			-0.06774972355096354,
			-0.18945045513451766,
			0.9737831549374032
		],
		"levator05.R": [
			8.376979030217172e-16,
			9.599310846208908e-8,
			-8.726646072432192e-9,
			0.9999999999999953
		],
		"toe5-3.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"toe2-3.R": [
			-3.4906584289728793e-8,
			-8.726647182655256e-9,
			-4.363322858580416e-8,
			0.9999999999999982
		],
		"finger4-2.L": [
			0.05761233589416657,
			-0.04408566577636208,
			-0.09225232053852968,
			0.9930895136799749
		],
		"toe2-1.L": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"finger1-2.L": [
			5.2359879987306704e-8,
			-1.745329336610979e-8,
			8.726645184253104e-9,
			0.9999999999999986
		],
		"pelvis.L": [
			-4.363322858580417e-8,
			8.726645628343022e-9,
			-8.726646516520993e-9,
			0.999999999999999
		],
		"metacarpal4.R": [
			-0.1098802529856072,
			-0.03288957852793861,
			-0.1871051947335423,
			0.9756209569970277
		],
		"tongue04": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"toe3-2.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator03.R": [
			-1.7453285039436844e-8,
			7.85398198699383e-8,
			-8.72664571716076e-8,
			0.999999999999993
		],
		"upperleg02.R": [
			-0.09770662988172334,
			0.0035566920941355606,
			0.0033866863296956934,
			0.995203142466003
		],
		"upperleg02.L": [
			-0.19663427992396587,
			0.02288891681077776,
			0.05372967947928978,
			0.9787360108778391
		],
		"levator03.L": [
			-4.3633230362161065e-8,
			7.85398202030052e-8,
			1.745328859215099e-8,
			0.9999999999999959
		],
		"toe3-2.R": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"metacarpal3.L": [
			-1.3089970707368857e-7,
			1.4835299599891272e-7,
			8.726643940803354e-8,
			0.9999999999999768
		],
		"tongue01": [
			-8.72664571716077e-8,
			4.363322725353669e-8,
			-1.74532956975764e-8,
			0.9999999999999953
		],
		"breast.L": [
			0,
			2.6179939993653504e-8,
			1.1102230246251565e-16,
			0.9999999999999998
		],
		"temporalis02.R": [
			6.10865242833821e-8,
			1.2212453270876722e-15,
			-2.6179939969202333e-8,
			0.9999999999999977
		],
		"tongue02": [
			4.363323036216087e-8,
			5.235988043139628e-8,
			-1.7453289480329435e-8,
			0.9999999999999978
		],
		"oris04.R": [
			6.108652428338185e-8,
			-3.490658218030518e-8,
			-2.6179941770008798e-8,
			0.9999999999999972
		],
		"oris04.L": [
			8.72664571716075e-8,
			-1.745329158975295e-8,
			-8.726647404697831e-9,
			0.9999999999999962
		],
		"temporalis02.L": [
			8.726645361889379e-8,
			6.108652061964648e-8,
			3.4906589618799e-8,
			0.9999999999999937
		],
		"breast.R": [
			2.6179940881831953e-8,
			-1.7453293810199e-8,
			5.235987998730656e-8,
			0.9999999999999983
		],
		"oris03.R": [
			4.363322680944749e-8,
			1.0471975975256953e-7,
			8.726650513321782e-9,
			0.9999999999999932
		],
		"oris06.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"orbicularis04.R": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"toe1-2.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"toe1-2.L": [
			-3.490658428972881e-8,
			-1.745329158975295e-8,
			1.7453293033042366e-8,
			0.9999999999999991
		],
		"orbicularis04.L": [
			1.7453292144864443e-8,
			-2.220446049250313e-16,
			2.6179940054284205e-8,
			0.9999999999999996
		],
		"metacarpal3.R": [
			-0.14387131775609757,
			-0.07892079277092612,
			-0.1457275141200134,
			0.9756208505479645
		],
		"oris06.R": [
			-2.6179947099081133e-8,
			6.981317235421614e-8,
			1.0471975642189525e-7,
			0.9999999999999917
		],
		"levator04.L": [
			-8.726646072432223e-9,
			3.490658451177353e-8,
			-3.180207328966892e-16,
			0.9999999999999998
		],
		"tongue06.L": [
			-3.490658428972876e-8,
			-6.108652472747167e-8,
			2.198084113085672e-15,
			0.9999999999999978
		],
		"toe2-2.L": [
			1.7453292144864407e-8,
			-6.108652472747167e-8,
			-1.0183439690065433e-15,
			0.9999999999999984
		],
		"toe2-2.R": [
			2.6179939993653474e-8,
			-8.726646627543744e-9,
			1.7453292144864476e-8,
			0.9999999999999994
		],
		"tongue06.R": [
			8.726645628343007e-9,
			-1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"levator04.R": [
			-8.726646960610704e-9,
			2.6179939993653534e-8,
			2.6179939993653468e-8,
			0.9999999999999992
		],
		"toe4-1.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"upperleg01.R": [
			-0.32709107938277965,
			0.01033499581587427,
			0.009898909285640526,
			0.9448844507370462
		],
		"metacarpal1.R": [
			-0.1708560167581953,
			-0.11041029315150974,
			-0.08235279178211048,
			0.9756207287616495
		],
		"levator02.R": [
			2.6179939105474998e-8,
			-6.981316880150246e-8,
			-8.726647848788915e-9,
			0.9999999999999972
		],
		"toe3-1.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"toe3-1.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"levator02.L": [
			5.235987998730658e-8,
			1.0471976008563644e-7,
			5.406259684038563e-15,
			0.9999999999999931
		],
		"finger5-1.R": [
			-0.05996250924798033,
			-0.06463370297098003,
			-0.21425699212376845,
			0.9727902771157928
		],
		"metacarpal1.L": [
			-6.108652073066813e-8,
			6.108652073066878e-8,
			-3.490658784244205e-8,
			0.9999999999999956
		],
		"toe4-1.R": [
			1.5230870001493993e-16,
			-8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"upperleg01.L": [
			-0.6269253115035869,
			0.06019574165008634,
			-0.017150301801370053,
			0.7765610044493921
		],
		"head": [
			0,
			0,
			0,
			1
		],
		"toe5-1.R": [
			3.490658428972881e-8,
			1.6653345369377348e-15,
			-4.363322861363843e-8,
			0.9999999999999984
		],
		"special01": [
			1.7453292144864436e-8,
			4.363322869682662e-8,
			6.702088926697263e-16,
			0.9999999999999991
		],
		"temporalis01.L": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"special04": [
			8.726646072432223e-9,
			-3.490658451177353e-8,
			-3.180207328966892e-16,
			0.9999999999999998
		],
		"metacarpal2.L": [
			-4.363322858580416e-8,
			-2.617994021569814e-8,
			1.1643607064032247e-15,
			0.9999999999999988
		],
		"metacarpal2.R": [
			-0.1421261994510505,
			-0.07722914200576725,
			-0.14832295957079553,
			0.9756208806287477
		],
		"temporalis01.R": [
			1.7453292144864436e-8,
			3.490658440075123e-8,
			8.726646516521445e-9,
			0.9999999999999993
		],
		"toe5-1.L": [
			9.13852305968756e-16,
			1.7453292255886765e-8,
			-5.235987998730695e-8,
			0.9999999999999986
		],
		"risorius02.R": [
			-6.108652428338209e-8,
			3.490658584404116e-8,
			1.7453290368507594e-8,
			0.9999999999999973
		],
		"special05.L": [
			1.7453291256686003e-8,
			5.235987976526246e-8,
			8.726646960611257e-9,
			0.9999999999999984
		],
		"finger2-2.L": [
			8.726646516521441e-9,
			2.6179940104675836e-8,
			-8.726645628343022e-9,
			0.9999999999999998
		],
		"foot.L": [
			0.33814198413222785,
			-0.06259162387951711,
			0.20235966460293953,
			0.9169475739261385
		],
		"toe3-3.R": [
			8.726645628343012e-9,
			-8.726645406298417e-9,
			-4.363322858580416e-8,
			0.9999999999999992
		],
		"levator06.R": [
			8.726646072432207e-9,
			-6.981316835741325e-8,
			-6.527107176072624e-16,
			0.9999999999999976
		],
		"orbicularis03.R": [
			1.7453292144864446e-8,
			5.551115123125783e-16,
			-3.490658429686185e-8,
			0.9999999999999992
		],
		"levator06.L": [
			8.72664740469985e-9,
			2.617993977160893e-8,
			-4.363322858580432e-8,
			0.9999999999999988
		],
		"orbicularis03.L": [
			-1.7453292144864473e-8,
			4.363322880784892e-8,
			-8.726646960610506e-9,
			0.9999999999999988
		],
		"foot.R": [
			0.14508641966092065,
			-0.013225390803066839,
			-0.000926013985110333,
			0.9893301584234563
		],
		"root": [
			-0.33361393895387637,
			-0.007009048421216968,
			-0.009344239935399788,
			0.9426374160598214
		],
		"finger2-2.R": [
			-0.17334570586489081,
			-0.11295483417977192,
			-0.10630754934994435,
			0.9725693685515865
		],
		"risorius02.L": [
			-6.108652428338214e-8,
			-8.726648625945188e-9,
			-4.363322858580311e-8,
			0.9999999999999971
		],
		"special05.R": [
			-4.363322858580409e-8,
			8.726647404699861e-9,
			2.6179939993652998e-8,
			0.9999999999999986
		],
		"lowerleg02.L": [
			-0.00643881988893256,
			0.07045068513805153,
			0.0025909659663232573,
			0.997491117482947
		],
		"tongue05.L": [
			3.490658428972878e-8,
			-1.7453290923619136e-8,
			-3.490658428972879e-8,
			0.9999999999999988
		],
		"finger5-1.L": [
			0.048298096730249825,
			-0.05206273642825199,
			-0.17258096308657922,
			0.9824319704223528
		],
		"toe4-3.R": [
			3.4906584289728793e-8,
			1.7453292366909068e-8,
			8.7266465165216e-9,
			0.9999999999999996
		],
		"oris03.L": [
			-7.853981998095985e-8,
			3.490658595506346e-8,
			1.7453289480330276e-8,
			0.999999999999996
		],
		"toe4-3.L": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"finger3-3.L": [
			4.3633233914874465e-8,
			-7.853982353367428e-8,
			7.853981642824957e-8,
			0.9999999999999928
		],
		"tongue05.R": [
			4.363322858580419e-8,
			2.6179939660586626e-8,
			-8.7266447401649e-9,
			0.9999999999999984
		],
		"lowerleg02.R": [
			-8.726646516521436e-9,
			1.7453292366909068e-8,
			2.6179939993653527e-8,
			0.9999999999999996
		],
		"shoulder01.R": [
			0.015830069791274774,
			-0.02913021186372522,
			0.0014921921513231064,
			0.9994491547896578
		],
		"finger3-1.L": [
			2.617994354636741e-8,
			-1.1344639705423987e-7,
			3.490658073701449e-8,
			0.9999999999999926
		],
		"special06.R": [
			1.745329303304286e-8,
			6.981316869048015e-8,
			-1.7453291256686017e-8,
			0.9999999999999971
		],
		"finger4-3.L": [
			-9.138523059687563e-16,
			-5.235988009832937e-8,
			-1.745329214486443e-8,
			0.9999999999999987
		],
		"finger3-2.L": [
			0.06279616985813974,
			-0.05013847108917446,
			-0.07205287848756886,
			0.9941585172746064
		],
		"upperarm01.R": [
			-0.06583831808778708,
			-0.08506508598564644,
			0.16430593752689562,
			0.9805268002002975
		],
		"finger3-2.R": [
			-0.09190304008139923,
			-0.07337823560286283,
			-0.10545056249376401,
			0.9874460211238668
		],
		"upperarm01.L": [
			-0.3084288227425467,
			-0.27945912509406245,
			0.023258455571157337,
			0.9089737636190347
		],
		"special06.L": [
			2.6179939105475045e-8,
			1.745329158975295e-8,
			2.6179940881831907e-8,
			0.9999999999999996
		],
		"finger3-1.R": [
			-0.13245746625167393,
			-0.0944950497687741,
			-0.1671304322410354,
			0.972416126883089
		],
		"shoulder01.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"lowerarm01.R": [
			0.17999386450697694,
			-0.15948659628535722,
			0.013503087096417923,
			0.9705585510333838
		],
		"special03": [
			2.6179939993653504e-8,
			-1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"upperarm02.L": [
			4.3633228585804106e-8,
			3.4906584289728926e-8,
			-8.726644740164946e-9,
			0.9999999999999984
		],
		"spine02": [
			0.056046654409118955,
			1.1102230246251565e-16,
			0,
			0.9984281509099914
		],
		"spine03": [
			0.1626577998616062,
			-1.4381943969077327e-8,
			-2.0059772967711365e-8,
			0.9866825427381294
		],
		"spine01": [
			0.12292652882773933,
			-0.16635008659134587,
			-0.0441718010054187,
			0.9773768818615226
		],
		"upperarm02.R": [
			-0.06091406693141478,
			-0.06863806603125155,
			0.0012982085086604607,
			0.9957793967521281
		],
		"spine04": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"spine05": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			-0.07840618496541713,
			-0.06947287570140892,
			0.005882041715258742,
			0.9944804629987486
		],
		"finger5-3.L": [
			0.0221690076348878,
			-0.0250790864975855,
			-0.07541804414306474,
			0.9965900326305523
		],
		"oris01": [
			1.0471975997461241e-7,
			1.7763568394002505e-15,
			-1.745329214486436e-8,
			0.9999999999999944
		],
		"oris02": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"oris05": [
			-1.7453292144864436e-8,
			-8.726646072432231e-9,
			1.7453292144864443e-8,
			0.9999999999999999
		],
		"risorius03.R": [
			4.363322858580412e-8,
			3.4906584178706623e-8,
			8.726647404700103e-9,
			0.9999999999999984
		],
		"finger2-3.L": [
			5.235988176366364e-8,
			1.745329558655584e-8,
			-6.981316857943709e-8,
			0.999999999999996
		],
		"oris06": [
			2.2846307649218933e-16,
			2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"finger3-3.R": [
			-0.058105668809720276,
			-0.04513578362296189,
			-0.06769499378292065,
			0.9949893869311606
		],
		"finger2-3.R": [
			-0.1255697117479206,
			-0.08677781730944423,
			-0.0729594997433235,
			0.9855854956886065
		],
		"toe3-3.L": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"risorius03.L": [
			-7.853981998095987e-8,
			8.72664329687467e-9,
			-3.4906584289727655e-8,
			0.9999999999999963
		]
	},
	"Harvey_FashionCloseup2": {
		"toe1-1.L": [
			-0.19477089363709968,
			-0.0178947388042624,
			0.01349462111570301,
			0.9805926639109007
		],
		"finger5-2.R": [
			0.027131498369240316,
			0.028265817834310147,
			0.09143241617891258,
			0.995040219594205
		],
		"finger1-3.R": [
			-1.7453291256686053e-8,
			-2.617993988263123e-8,
			1.745329303304289e-8,
			0.9999999999999994
		],
		"toe5-2.R": [
			0,
			0,
			0,
			1
		],
		"toe4-2.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"clavicle.R": [
			0.025157175612350362,
			0.0923048166452809,
			-0.10221157611166584,
			0.9901513677453865
		],
		"neck03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"neck02": [
			0,
			0,
			0,
			1
		],
		"neck01": [
			0,
			0,
			0,
			1
		],
		"clavicle.L": [
			0.025157177335938693,
			-0.09230480901555471,
			0.10221160530196301,
			0.9901513653995972
		],
		"toe5-2.L": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe4-2.L": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"finger5-2.L": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger1-3.L": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"toe1-1.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"oculi02.L": [
			-2.617993821729672e-8,
			-5.235987843299483e-8,
			3.490658606608563e-8,
			0.999999999999998
		],
		"oculi01.L": [
			-4.363322858580419e-8,
			-4.440892098500626e-16,
			-1.7453292253300258e-8,
			0.9999999999999987
		],
		"jaw": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			0.048818087271168535,
			0.032853866421261646,
			0.08020366764611236,
			0.9950400944245767
		],
		"oculi01.R": [
			-4.3633228585804e-8,
			3.490658451177353e-8,
			1.745329036850783e-8,
			0.9999999999999983
		],
		"oculi02.R": [
			-2.6179939105475045e-8,
			1.745329114566374e-8,
			-4.363322858580426e-8,
			0.9999999999999988
		],
		"wrist.R": [
			-0.12407856940282651,
			0.04066509053101819,
			-0.3775655060415342,
			0.9167306843749982
		],
		"finger1-1.L": [
			0.21610711026339194,
			0.4388054475140132,
			-0.0938809708643277,
			0.8671411992491213
		],
		"tongue07.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"eye.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger2-1.R": [
			0.06607323399523517,
			-0.06314392677409764,
			-0.03929784890917258,
			0.9950391205033448
		],
		"finger4-3.R": [
			0.09511522496060996,
			0.05737369981788487,
			0.16156257405613197,
			0.9805910907275553
		],
		"finger2-1.L": [
			0.21138664580907246,
			-0.1328358256876916,
			-0.14214898742587825,
			0.9578434082673727
		],
		"eye.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue07.L": [
			-8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"wrist.L": [
			0.0584160611279057,
			0.12806598510085077,
			-0.48927387809730793,
			0.8606960784586336
		],
		"finger5-3.R": [
			0.02680226502441698,
			0.02575810620706831,
			0.09226599764130804,
			0.9950402726691219
		],
		"lowerleg01.R": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"lowerarm02.L": [
			-1.7453294809399725e-8,
			-4.363323047318346e-8,
			-5.23598799873068e-8,
			0.9999999999999976
		],
		"oris07.L": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"oris07.R": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"tongue00": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.R": [
			8.726645184253878e-9,
			2.617993988263123e-8,
			2.6179939993653474e-8,
			0.9999999999999991
		],
		"lowerleg01.L": [
			0.09913224247401435,
			0.007914647993908841,
			-0.002104000845250509,
			0.9950405670271181
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"metacarpal4.L": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"finger1-2.R": [
			0.07254002862229095,
			0.10004372611964485,
			-0.31578703103248607,
			0.9407485041940074
		],
		"pelvis.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe2-1.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe2-3.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"toe5-3.L": [
			4.3633228585804185e-8,
			-3.3306690738754696e-16,
			8.726646077118623e-9,
			0.9999999999999991
		],
		"levator05.L": [
			-6.853892559463472e-16,
			2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"finger4-1.L": [
			-0.035240214538274264,
			-0.07234038720911518,
			-0.11455660968722402,
			0.9901524018224167
		],
		"finger4-1.R": [
			-0.08216014389854812,
			0.04653077090981805,
			0.03130707178720971,
			0.9950399315450704
		],
		"levator05.R": [
			-4.569261529843785e-16,
			-2.617993988263123e-8,
			-1.745329214486445e-8,
			0.9999999999999996
		],
		"toe5-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe2-3.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger4-2.L": [
			-8.726645628342998e-9,
			-6.108652406133785e-8,
			8.726646516521382e-9,
			0.9999999999999979
		],
		"toe2-1.L": [
			-0.19431514383631127,
			-0.018258889431111647,
			0.01860903836540772,
			0.9805926481081384
		],
		"finger1-2.L": [
			0.11609786245660755,
			-0.07785420537929111,
			0.007637698237273179,
			0.9901523491884477
		],
		"pelvis.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal4.R": [
			1.523087000149394e-15,
			-3.4906584178706623e-8,
			4.36332285858042e-8,
			0.9999999999999983
		],
		"tongue04": [
			0,
			0,
			0,
			1
		],
		"toe3-2.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"levator03.R": [
			3.490658428972883e-8,
			5.235987998730707e-8,
			1.6734015079435647e-15,
			0.9999999999999981
		],
		"upperleg02.R": [
			1.7453292144864446e-8,
			-4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"upperleg02.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"levator03.L": [
			4.363322858580412e-8,
			-2.6179940992854256e-8,
			2.617993910547514e-8,
			0.9999999999999986
		],
		"toe3-2.R": [
			-2.6179939993653497e-8,
			-8.726646405499139e-9,
			-1.7453292144864423e-8,
			0.9999999999999994
		],
		"metacarpal3.L": [
			-8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"tongue01": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"breast.L": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"temporalis02.R": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"tongue02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris04.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"oris04.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"temporalis02.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"breast.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"oris03.R": [
			-2.7755575615628914e-16,
			-1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"oris06.L": [
			-1.745329303304289e-8,
			3.490658440075123e-8,
			2.617993910547502e-8,
			0.9999999999999988
		],
		"orbicularis04.R": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"toe1-2.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"toe1-2.L": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"orbicularis04.L": [
			2.6179939993653504e-8,
			-1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"metacarpal3.R": [
			-8.726646516521448e-9,
			-8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"oris06.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"levator04.L": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"tongue06.L": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"toe2-2.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"toe2-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue06.R": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"levator04.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"toe4-1.L": [
			-0.19161650791730633,
			-0.025005944479711495,
			0.033107543275038225,
			0.980592528633859
		],
		"upperleg01.R": [
			0.0021043678364679108,
			0.04494640220826396,
			0.14130621202584984,
			0.9889428431448639
		],
		"metacarpal1.R": [
			2.6179939105474995e-8,
			-4.363322880784892e-8,
			-2.617994088183188e-8,
			0.9999999999999984
		],
		"levator02.R": [
			-8.726646072432225e-9,
			-6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"toe3-1.L": [
			-0.19259859254486292,
			-0.020028391903508025,
			0.03070497176105053,
			0.9805926016326302
		],
		"toe3-1.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator02.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"finger5-1.R": [
			-0.1110929008870997,
			0.07227265264344851,
			0.11787322963209061,
			0.9841447722710663
		],
		"metacarpal1.L": [
			-1.74532939212213e-8,
			2.6179940992854256e-8,
			6.981316857945851e-8,
			0.999999999999997
		],
		"toe4-1.R": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"upperleg01.L": [
			0.08755647904526909,
			0.10448474548427389,
			-0.031906567069626135,
			0.9901508834092472
		],
		"head": [
			-3.6514488676047054e-8,
			-0.002614674232801484,
			-0.04985183762639569,
			0.9987532016288739
		],
		"toe5-1.R": [
			3.490658428972885e-8,
			1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			2.2846307649218933e-16,
			-2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"special04": [
			0,
			0,
			0,
			1
		],
		"metacarpal2.L": [
			-8.726645184253779e-9,
			-2.6179939993653534e-8,
			3.490658428972884e-8,
			0.9999999999999991
		],
		"metacarpal2.R": [
			2.617993999365353e-8,
			-1.745329336610979e-8,
			1.7453291256686023e-8,
			0.9999999999999997
		],
		"temporalis01.R": [
			1.7453293033042873e-8,
			-1.7453293144065185e-8,
			4.363322858580396e-8,
			0.9999999999999986
		],
		"toe5-1.L": [
			-0.09851025659704502,
			-0.01029158464651625,
			0.009174964573503296,
			0.9950405180974905
		],
		"risorius02.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"special05.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"finger2-2.L": [
			2.6179939993653497e-8,
			-8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"foot.L": [
			-0.09310629138983717,
			-0.054065435577969834,
			0.0894735810897893,
			0.9901528293482597
		],
		"oris06": [
			0,
			0,
			0,
			1
		],
		"levator06.R": [
			-6.092348000597591e-16,
			1.745329203384216e-8,
			3.490658428972889e-8,
			0.9999999999999993
		],
		"orbicularis03.R": [
			-4.3633228585804185e-8,
			2.6179939660586626e-8,
			-8.726647404700228e-9,
			0.9999999999999984
		],
		"levator06.L": [
			8.726646516521441e-9,
			2.6179940104675836e-8,
			-8.726645628343022e-9,
			0.9999999999999998
		],
		"orbicularis03.L": [
			-8.72664562834302e-9,
			-3.4906584289728926e-8,
			8.726646516521445e-9,
			0.9999999999999994
		],
		"foot.R": [
			0.005566695707175361,
			0.04641199412111696,
			-0.08781013986910151,
			0.9950398575116343
		],
		"root": [
			-2.2659934238242162e-8,
			0.0010514256631327656,
			-0.04990920797540352,
			0.9987532054833879
		],
		"finger2-2.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"risorius02.L": [
			8.726645628343017e-9,
			-2.6179939993653534e-8,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"special05.R": [
			-1.745329214486445e-8,
			1.7453292366909068e-8,
			8.726645628343025e-9,
			0.9999999999999999
		],
		"lowerleg02.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue05.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger5-1.L": [
			-0.18152833687063924,
			-0.06578287432514274,
			-0.03405021043023549,
			0.9805919944238574
		],
		"toe4-3.R": [
			-5.235987998730684e-8,
			-8.881784197001252e-16,
			-1.7453292120936186e-8,
			0.9999999999999983
		],
		"oris03.L": [
			-2.7755575615628914e-16,
			-1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe4-3.L": [
			-5.235987998730683e-8,
			8.726646294476836e-9,
			-4.4331856927593173e-16,
			0.9999999999999987
		],
		"finger3-3.L": [
			0.11357365630725819,
			-0.08260619334754593,
			-0.13682428011148115,
			0.9805898009797999
		],
		"tongue05.R": [
			0,
			0,
			0,
			1
		],
		"lowerleg02.R": [
			0,
			0,
			0,
			1
		],
		"shoulder01.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"finger3-1.L": [
			0.07197872321820836,
			-0.09702888140202581,
			-0.16172441722601327,
			0.979412922342081
		],
		"special06.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"finger4-3.L": [
			0.09511525859062092,
			-0.057373684332268304,
			-0.1615625737856714,
			0.9805910884161299
		],
		"finger3-2.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"upperarm01.R": [
			-0.25635587583388886,
			0.35856640126936834,
			0.2547238472021329,
			0.8607134032142867
		],
		"finger3-2.R": [
			-1.7453291256686047e-8,
			-3.4906584289728926e-8,
			1.745329303304288e-8,
			0.999999999999999
		],
		"upperarm01.L": [
			-0.13822929178114154,
			-0.24780804724091143,
			-0.35464946329790903,
			0.8909026842471823
		],
		"special06.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"finger3-1.R": [
			-0.03975543194376223,
			0.02387140332070592,
			0.01849520600162055,
			0.9987530170614868
		],
		"shoulder01.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"lowerarm01.R": [
			-0.5742872218087306,
			0.545829739879329,
			-0.028461876191431184,
			0.6094702646841254
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"upperarm02.L": [
			8.726646516521431e-9,
			8.726646516521441e-9,
			-4.3633228585804225e-8,
			0.9999999999999991
		],
		"spine02": [
			-1.4536483068520866e-8,
			-0.0003155912194869881,
			0.049919285143824425,
			0.998753205438116
		],
		"spine03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"spine01": [
			-2.2832253786964226e-8,
			0.004905353104103227,
			0.04967889942284172,
			0.9987531949701381
		],
		"upperarm02.R": [
			-3.490658428972884e-8,
			-3.4906584289728926e-8,
			8.726647404699887e-9,
			0.9999999999999989
		],
		"spine04": [
			0,
			0,
			0,
			1
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			-0.04003523167270805,
			-0.5688156712092667,
			-0.09041627130980467,
			0.816499118367005
		],
		"finger5-3.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"oris01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			2.617993910547505e-8,
			-5.235987976526246e-8,
			-8.726647404699368e-9,
			0.999999999999998
		],
		"finger2-3.L": [
			4.3633228585804066e-8,
			8.726647404699861e-9,
			-3.4906584289728654e-8,
			0.9999999999999986
		],
		"toe3-3.R": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger3-3.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger2-3.R": [
			-0.07333540450882452,
			-0.0495041658734523,
			-0.04546368741752955,
			0.9950398530376068
		],
		"toe3-3.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"risorius03.L": [
			2.617993999365348e-8,
			4.363322869682662e-8,
			1.035761105051169e-15,
			0.9999999999999987
		]
	},
	"Harvey_sittingfashion1": {
		"toe1-1.L": [
			-0.3688777632440821,
			-0.03388391243606981,
			0.02555572109331234,
			0.9285084713568683
		],
		"finger5-2.R": [
			-1.7453292144864443e-8,
			-6.661338147750939e-16,
			-2.6179940059872455e-8,
			0.9999999999999999
		],
		"finger1-3.R": [
			8.72664696061062e-9,
			-2.6179939993653534e-8,
			3.490658428972884e-8,
			0.9999999999999991
		],
		"toe5-2.R": [
			-6.108652428338212e-8,
			8.726646405499139e-9,
			-4.661919405738096e-16,
			0.9999999999999984
		],
		"toe4-2.R": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"clavicle.R": [
			0.052268122623326745,
			0.18890450110424206,
			-0.006507602402987155,
			0.9805818598826694
		],
		"neck03": [
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"neck02": [
			4.363322858580417e-8,
			-8.726646516521441e-9,
			-4.068768463957589e-16,
			0.999999999999999
		],
		"neck01": [
			-0.09947011691017074,
			8.683366914397084e-9,
			-8.680404995952906e-10,
			0.9950405498480338
		],
		"clavicle.L": [
			0.05226811207502322,
			-0.1889045801025495,
			0.006507600583818274,
			0.9805818452383429
		],
		"toe5-2.L": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"toe4-2.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"finger5-2.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"finger1-3.L": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"toe1-1.R": [
			-0.36887769510186524,
			0.03388390671021768,
			-0.025555716800317672,
			0.92850849875551
		],
		"oculi02.L": [
			1.7453293033042916e-8,
			-2.617994110387656e-8,
			2.6179939105475286e-8,
			0.9999999999999992
		],
		"oculi01.L": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"jaw": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			-3.490658428972882e-8,
			-2.6179939549564324e-8,
			2.617994088183189e-8,
			0.9999999999999989
		],
		"oculi01.R": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"oculi02.R": [
			-2.6179939993653494e-8,
			-6.661338147750939e-16,
			-2.6179940052507944e-8,
			0.9999999999999993
		],
		"wrist.R": [
			-0.0030998415630411483,
			-0.281569723681115,
			-0.18905376703162216,
			0.9407271415557104
		],
		"finger1-1.L": [
			-0.09182210201856525,
			0.09333080603804478,
			-0.049587709303191535,
			0.9901510598445284
		],
		"tongue07.R": [
			-3.4906584289728906e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999994
		],
		"eye.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger2-1.R": [
			0.27374644482191945,
			0.07171824583118402,
			0.10384413319980831,
			0.9534861158728211
		],
		"finger4-3.R": [
			2.6179939993653527e-8,
			-4.3633228474782015e-8,
			8.7266447401645e-9,
			0.9999999999999987
		],
		"finger2-1.L": [
			-0.07877545995921408,
			0.1521416030247631,
			0.1350915755697336,
			0.9759086154693773
		],
		"eye.L": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"tongue07.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"wrist.L": [
			0.152541529471813,
			0.12219069306938157,
			0.01568437568637956,
			0.9805888622011537
		],
		"finger5-3.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"lowerleg01.R": [
			0.571467030316316,
			-0.04560603441721678,
			0.012136674099217619,
			0.8192668820524824
		],
		"lowerarm02.L": [
			1.7453291256686e-8,
			-4.363322836375971e-8,
			-2.617994088183192e-8,
			0.9999999999999984
		],
		"oris07.L": [
			8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"oris07.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"tongue00": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.R": [
			8.726646960610633e-9,
			-1.745329203384216e-8,
			4.3633228585804245e-8,
			0.9999999999999988
		],
		"lowerleg01.L": [
			0.5512499584130952,
			0.20599132807978582,
			-0.004439044628170344,
			0.8084994440247165
		],
		"tongue03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			-1.7453293033042863e-8,
			6.108652428338246e-8,
			1.7453291256686043e-8,
			0.9999999999999979
		],
		"metacarpal4.L": [
			8.726646072432225e-9,
			6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"finger1-2.R": [
			2.6179940881831874e-8,
			-4.363322880784892e-8,
			1.7453291256686013e-8,
			0.9999999999999986
		],
		"pelvis.R": [
			-0.5098789212338141,
			-0.06048139047510315,
			-0.03174614193753046,
			0.8575299817264248
		],
		"toe2-1.R": [
			-0.3680145450434492,
			0.03457332279521108,
			-0.03524204434155878,
			0.9285084696964206
		],
		"toe2-3.L": [
			1.745329214486445e-8,
			1.7453292366909068e-8,
			-8.726645628343025e-9,
			0.9999999999999999
		],
		"toe5-3.L": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"levator05.L": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger4-1.L": [
			-0.03524023360336993,
			-0.07234039825394556,
			-0.11455660588877492,
			0.990152400776408
		],
		"finger4-1.R": [
			0.055646290216031805,
			0.1198378245746674,
			0.2709568779278617,
			0.953480338806202
		],
		"levator05.R": [
			-3.8077175003734897e-16,
			4.363322858580432e-8,
			8.726646072432225e-9,
			0.999999999999999
		],
		"toe5-3.R": [
			6.108652428338212e-8,
			-8.726645739365324e-9,
			-8.72664651652142e-9,
			0.9999999999999983
		],
		"toe2-3.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger4-2.L": [
			1.745329214486448e-8,
			-8.72664507323151e-9,
			-4.36332285858036e-8,
			0.9999999999999989
		],
		"toe2-1.L": [
			-0.3680145345216278,
			-0.034573354851880844,
			0.03524204806783703,
			0.9285084725316723
		],
		"finger1-2.L": [
			8.726647404699846e-9,
			4.363322825273741e-8,
			-2.6179939993653474e-8,
			0.9999999999999982
		],
		"pelvis.L": [
			-0.5586071185469538,
			0.09274366677610679,
			0.11241371947914666,
			0.8165291513806812
		],
		"metacarpal4.R": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"tongue04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator03.R": [
			2.617993999365347e-8,
			2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"upperleg02.R": [
			-0.09891961815195333,
			0.010350611272886834,
			-0.001461463701479557,
			0.9950405208406331
		],
		"upperleg02.L": [
			-0.09891963266204795,
			-0.010350633710659807,
			0.001461501104046121,
			0.9950405191098077
		],
		"levator03.L": [
			6.853892559463472e-16,
			-2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"toe3-2.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal3.L": [
			8.726645628343032e-9,
			-2.617993988263123e-8,
			-8.726646516521458e-9,
			0.9999999999999997
		],
		"tongue01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"breast.L": [
			-2.6179939993653527e-8,
			4.3633228474782015e-8,
			8.7266447401645e-9,
			0.9999999999999987
		],
		"temporalis02.R": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"tongue02": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris04.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"oris04.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"temporalis02.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"breast.R": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"oris03.R": [
			-8.726646960610638e-9,
			-1.7453292144864463e-8,
			-4.3633228585804265e-8,
			0.9999999999999988
		],
		"oris06.L": [
			-2.617993999365348e-8,
			4.363322869682662e-8,
			-1.035761105051169e-15,
			0.9999999999999987
		],
		"orbicularis04.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"toe1-2.R": [
			-2.6179939993653527e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"toe1-2.L": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"orbicularis04.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"metacarpal3.R": [
			0,
			0,
			-3.490658428972887e-8,
			0.9999999999999996
		],
		"oris06.R": [
			-3.4906584289728866e-8,
			5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"levator04.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"tongue06.L": [
			-1.745329214486444e-8,
			8.726646183454534e-9,
			3.490658428972891e-8,
			0.9999999999999996
		],
		"toe2-2.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"toe2-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue06.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"levator04.R": [
			-8.726646516521441e-9,
			2.6179940104675836e-8,
			8.726645628343022e-9,
			0.9999999999999998
		],
		"toe4-1.L": [
			-0.36290348822417196,
			-0.04734935585492539,
			0.06270068988914382,
			0.9285083307231429
		],
		"upperleg01.R": [
			-0.0997335264518384,
			-0.04853939105144589,
			-0.1878509636633078,
			0.9759145283622959
		],
		"metacarpal1.R": [
			2.6179939993653474e-8,
			-8.726646627543744e-9,
			1.7453292144864476e-8,
			0.9999999999999994
		],
		"levator02.R": [
			2.6179940881831887e-8,
			2.617994110387656e-8,
			-1.745329125668601e-8,
			0.9999999999999994
		],
		"toe3-1.L": [
			-0.36476358950796595,
			-0.03792396197076109,
			0.05815085832175577,
			0.9285083599807525
		],
		"toe3-1.R": [
			-0.3647635295719905,
			0.03792396175312951,
			-0.05815087348956843,
			0.9285083825854944
		],
		"levator02.L": [
			8.72664651652143e-9,
			-2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"finger5-1.R": [
			-0.03966875555315904,
			0.0778773306331787,
			0.19988860105438958,
			0.9759129358579246
		],
		"metacarpal1.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe4-1.R": [
			-0.28076707948782087,
			0.03663722245721979,
			-0.04851071666390499,
			0.9578487727064505
		],
		"upperleg01.L": [
			-0.005281952841623246,
			0.11255507835524148,
			0.35381451669692127,
			0.9285034965389997
		],
		"head": [
			-0.09898132786068414,
			-0.09887762111275256,
			0.005181626927380632,
			0.9901510306616889
		],
		"toe5-1.R": [
			-0.1941639355377292,
			0.02028403850757876,
			-0.01808388138441984,
			0.9805926254833849
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			-9.13852305968756e-16,
			-1.7453292255886765e-8,
			-5.235987998730695e-8,
			0.9999999999999986
		],
		"special04": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"metacarpal2.L": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"metacarpal2.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"temporalis01.R": [
			1.7453291256686083e-8,
			2.617993899445281e-8,
			2.6179940881832245e-8,
			0.9999999999999991
		],
		"toe5-1.L": [
			-0.19416394910292253,
			-0.02028402050818401,
			0.018083887864201537,
			0.9805926230502127
		],
		"risorius02.R": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"special05.L": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger2-2.L": [
			0.14520588558988304,
			-0.09143754488682154,
			-0.09485901784746258,
			0.98058971690924
		],
		"foot.L": [
			0.44851353882589634,
			-0.04710035425574788,
			0.14612519078654543,
			0.8804911076986808
		],
		"oris06": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.R": [
			-8.726647404699835e-9,
			4.363322880784892e-8,
			3.490658428972884e-8,
			0.9999999999999982
		],
		"orbicularis03.R": [
			-2.617993999365348e-8,
			1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		],
		"levator06.L": [
			8.72664651652143e-9,
			-2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"orbicularis03.L": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"foot.R": [
			0.37617547397971896,
			0.24863719862908307,
			0.054295488801505726,
			0.8909116432788503
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			4.3633228585804185e-8,
			2.6179939660586626e-8,
			8.726647404700228e-9,
			0.9999999999999984
		],
		"risorius02.L": [
			-3.490658428972882e-8,
			-5.235988009832937e-8,
			8.726647848789038e-9,
			0.9999999999999978
		],
		"special05.R": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"lowerleg02.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue05.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"finger5-1.L": [
			-0.06594687837274012,
			-0.056110538277069355,
			-0.10999626168109736,
			0.9901532402327089
		],
		"toe4-3.R": [
			-5.2359879987306836e-8,
			-5.551115123125783e-16,
			-8.726646040608206e-9,
			0.9999999999999987
		],
		"oris03.L": [
			1.5230870001493993e-16,
			-8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe4-3.L": [
			-3.4906584289728754e-8,
			4.363322869682662e-8,
			8.7266447401648e-9,
			0.9999999999999986
		],
		"finger3-3.L": [
			2.6179939105475058e-8,
			2.617993943854202e-8,
			2.6179940881831917e-8,
			0.9999999999999991
		],
		"tongue05.R": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"lowerleg02.R": [
			-1.745329214486445e-8,
			-1.7453292366909068e-8,
			-8.726645628343025e-9,
			0.9999999999999999
		],
		"shoulder01.R": [
			-0.08679196714949336,
			-0.046573432315955454,
			-0.09946831750958149,
			0.9901535858908179
		],
		"finger3-1.L": [
			-0.05636800441118072,
			0.03738751919320893,
			0.07293744160890223,
			0.9950401756204755
		],
		"special06.R": [
			0,
			0,
			0,
			1
		],
		"finger4-3.L": [
			6.092348000597588e-16,
			3.490658440075123e-8,
			-1.7453292144864443e-8,
			0.9999999999999992
		],
		"finger3-2.L": [
			0.057677237226485024,
			-0.042972624239926316,
			-0.06872020068609425,
			0.9950398102033494
		],
		"upperarm01.R": [
			-0.007561987688990677,
			-0.001427970742302942,
			0.41021344240339586,
			0.9119570762449882
		],
		"finger3-2.R": [
			-3.490658428972885e-8,
			-1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"upperarm01.L": [
			-0.13539152509798122,
			-0.12010502094543496,
			-0.4381567405461725,
			0.8804899713167056
		],
		"special06.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"finger3-1.R": [
			0.1627836136637607,
			0.10800582579981433,
			0.2106465703316542,
			0.9578435462659749
		],
		"shoulder01.L": [
			0.0009138459305278808,
			0.0006806975322064535,
			0.09946339957665559,
			0.9950405688619636
		],
		"lowerarm01.R": [
			0.03718516972118889,
			-0.03331268166079182,
			0.0005695712163810805,
			0.998752824267347
		],
		"special03": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.L": [
			0.24766320146086424,
			-0.27639979725807307,
			0.012255534544081874,
			0.9285019615439107
		],
		"spine02": [
			-1.1075228067610266e-7,
			-0.0006288214727364627,
			0.09946796467441045,
			0.9950405663022355
		],
		"spine03": [
			-0.09898127046567713,
			0.09812820046047199,
			0.013197995015133357,
			0.9901511891115269
		],
		"spine01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.R": [
			0.3431105519934375,
			0.38289804869057653,
			-0.016987291796813308,
			0.8575404744600206
		],
		"spine04": [
			0.19511926116892728,
			0.03214962878534333,
			-0.09211246523510071,
			0.9759150419161334
		],
		"spine05": [
			1.5696469899576528e-9,
			-0.026682703488547177,
			-0.04219694951368662,
			0.9987529478235755
		],
		"lowerarm01.L": [
			0.1732791307621144,
			-0.11846355335176151,
			0.168421232700055,
			0.9631069606982363
		],
		"finger5-3.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris01": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			3.4906584289728807e-8,
			-2.6179939993653534e-8,
			-8.72664696061079e-9,
			0.999999999999999
		],
		"finger2-3.L": [
			6.981316857945735e-8,
			-2.6179940881831953e-8,
			8.726644296075377e-9,
			0.9999999999999971
		],
		"toe3-3.R": [
			3.4906584289728906e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"finger3-3.R": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger2-3.R": [
			6.108652428338209e-8,
			2.6179939993653534e-8,
			1.6135134219578416e-15,
			0.999999999999998
		],
		"toe3-3.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"risorius03.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		]
	},
	"Harvey_Fightpose2": {
		"toe1-1.L": [
			-0.0988181837289359,
			-0.009079396200767254,
			0.006846584898580093,
			0.9950405295285065
		],
		"finger5-2.R": [
			0.10125856492140294,
			0.10554747354788796,
			0.34130869435805467,
			0.9285013780352269
		],
		"finger1-3.R": [
			0.3415634022119529,
			-0.05176233421860876,
			-0.13611234314897222,
			0.9285087684390132
		],
		"toe5-2.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"toe4-2.R": [
			-3.4906584289728866e-8,
			-8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"clavicle.R": [
			-0.001238163271156722,
			-0.0030849405853943246,
			-0.09941444907246186,
			0.995040560685301
		],
		"neck03": [
			-0.09898124913638319,
			0.09186339500976948,
			0.036925552126855624,
			0.9901516715012944
		],
		"neck02": [
			0.04992026721873714,
			-9.151402191598379e-9,
			8.280129402642819e-9,
			0.9987532062130312
		],
		"neck01": [
			0.049920282027144026,
			2.5276025827913884e-8,
			1.873844148926821e-8,
			0.9987532054728686
		],
		"clavicle.L": [
			-0.0012381910974166954,
			0.0030849605786766876,
			0.09941448539855448,
			0.9950405569593506
		],
		"toe5-2.L": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe4-2.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"finger5-2.L": [
			0.1402555781369057,
			-0.14625330486255206,
			-0.4728755520352799,
			0.8575121316375606
		],
		"finger1-3.L": [
			0.2642574987285599,
			0.04005105369160322,
			0.10530613484539361,
			0.9578488948826115
		],
		"toe1-1.R": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"oculi02.L": [
			-3.4906582513371954e-8,
			-4.363322680944748e-8,
			2.6179941770010287e-8,
			0.9999999999999979
		],
		"oculi01.L": [
			-8.726646960610704e-9,
			-2.617993988263123e-8,
			-2.6179939993653468e-8,
			0.9999999999999991
		],
		"jaw": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"finger4-2.R": [
			0.21941443295875293,
			0.14772513600199078,
			0.36054388653354374,
			0.8944510588544631
		],
		"oculi01.R": [
			-8.726646072432225e-9,
			2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"oculi02.R": [
			2.6179939993653494e-8,
			8.726646960610651e-9,
			-3.490658428972892e-8,
			0.9999999999999989
		],
		"wrist.R": [
			-4.3633228585804086e-8,
			1.7453292144864463e-8,
			-8.726646960611766e-9,
			0.9999999999999989
		],
		"finger1-1.L": [
			4.363322858580413e-8,
			-3.490658440075123e-8,
			-1.6405861018266948e-15,
			0.9999999999999987
		],
		"tongue07.R": [
			-3.4906584289728866e-8,
			-8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"eye.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"finger2-1.R": [
			0.27322211565050614,
			0.1716904624683211,
			0.18373342734178255,
			0.9285009899262986
		],
		"finger4-3.R": [
			0.21689800971532405,
			0.13088059332199709,
			0.3684831009398326,
			0.8944527533609465
		],
		"finger2-1.L": [
			0.21138656515590448,
			-0.1328358379842577,
			-0.1421489811208074,
			0.9578434252971235
		],
		"eye.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue07.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"wrist.L": [
			-0.12537191878812484,
			0.194018804586216,
			-0.2907598209077913,
			0.9284919558035971
		],
		"finger5-3.R": [
			0.12044304768380772,
			0.1158434792037013,
			0.41476132746521066,
			0.8944533536355675
		],
		"lowerleg01.R": [
			0.28629484369294006,
			-0.02285338271631354,
			0.0060774801511181194,
			0.9578497009490945
		],
		"lowerarm02.L": [
			-0.1490937452492386,
			0.1634251261712052,
			-0.1833242252793957,
			0.9578389800426738
		],
		"oris07.L": [
			1.7453293033042876e-8,
			-2.6179940881831953e-8,
			3.4906584289728807e-8,
			0.9999999999999989
		],
		"oris07.R": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"tongue00": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"lowerarm02.R": [
			-0.10175567914710555,
			-0.11153166100336276,
			0.12511437452149776,
			0.9805880193247498
		],
		"lowerleg01.L": [
			0.2862948437720583,
			0.022853371991353955,
			-0.006077474953606121,
			0.9578497012143115
		],
		"tongue03": [
			2.6179939993653497e-8,
			8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"finger1-1.R": [
			8.726643407896924e-9,
			4.363322858580432e-8,
			6.108652428338221e-8,
			0.9999999999999971
		],
		"metacarpal4.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger1-2.R": [
			0.25819332945791157,
			-0.03178795209135077,
			-0.12186471525071703,
			0.9578490078828384
		],
		"pelvis.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe2-1.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"toe2-3.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-3.L": [
			0,
			0,
			0,
			1
		],
		"levator05.L": [
			2.7755575615628914e-16,
			1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"finger4-1.L": [
			0.1349946587224913,
			-0.07559317078767558,
			-0.24206141055999753,
			0.957845701647383
		],
		"finger4-1.R": [
			0.24170754922605844,
			0.13539013224204033,
			0.43348926211627276,
			0.8575161994787652
		],
		"levator05.R": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"toe5-3.R": [
			1.745329214486445e-8,
			-8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"toe2-3.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"finger4-2.L": [
			0.2524271471877905,
			-0.1699537420526228,
			-0.4148100326785939,
			0.857513205562531
		],
		"toe2-1.L": [
			-0.09858696802381252,
			-0.009264034478148608,
			0.009441376551353605,
			0.9950405257123321
		],
		"finger1-2.L": [
			0.3337250080368427,
			0.041083153316803234,
			0.1575157597802669,
			0.9285087931437175
		],
		"pelvis.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"metacarpal4.R": [
			2.4369392002390255e-15,
			-3.4906584178706623e-8,
			6.981316857945753e-8,
			0.9999999999999969
		],
		"tongue04": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"toe3-2.L": [
			-2.617993999365348e-8,
			-1.745329247793137e-8,
			8.726646516521431e-9,
			0.9999999999999996
		],
		"levator03.R": [
			0,
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0.9999999999999991
		],
		"upperleg02.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"upperleg02.L": [
			-0.09891962541234173,
			-0.010350615949596853,
			0.0014614993691655827,
			0.9950405200178227
		],
		"levator03.L": [
			-1.7453293921221266e-8,
			-5.235987998730707e-8,
			-2.617993910547512e-8,
			0.9999999999999981
		],
		"toe3-2.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"metacarpal3.L": [
			8.72664651652144e-9,
			1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"tongue01": [
			2.6179939993653504e-8,
			-1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"breast.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"temporalis02.R": [
			-1.7453292144864443e-8,
			-1.7453292255886765e-8,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"tongue02": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"oris04.R": [
			8.72664651652145e-9,
			-8.726646627543744e-9,
			2.6179939993653484e-8,
			0.9999999999999996
		],
		"oris04.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"temporalis02.L": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"breast.R": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"oris03.R": [
			0,
			0,
			0,
			1
		],
		"oris06.L": [
			-2.6179940881831874e-8,
			4.363322880784892e-8,
			1.7453291256686013e-8,
			0.9999999999999986
		],
		"orbicularis04.R": [
			3.490658428972882e-8,
			-8.726645850387627e-9,
			-1.7453292144864483e-8,
			0.9999999999999989
		],
		"toe1-2.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"toe1-2.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"orbicularis04.L": [
			3.4906584289728793e-8,
			-1.7453292366909068e-8,
			-8.7266465165216e-9,
			0.9999999999999996
		],
		"metacarpal3.R": [
			-2.284630764921893e-16,
			8.726645961409929e-9,
			2.61799399936535e-8,
			0.9999999999999996
		],
		"oris06.R": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"levator04.L": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"tongue06.L": [
			-2.220446049250313e-16,
			1.745329203384216e-8,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe2-2.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"toe2-2.R": [
			8.726646072432225e-9,
			-1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"tongue06.R": [
			-8.726646516521438e-9,
			1.7453292366909068e-8,
			1.7453292144864456e-8,
			0.9999999999999996
		],
		"levator04.R": [
			-8.726645628342998e-9,
			6.108652406133785e-8,
			-8.726646516521382e-9,
			0.9999999999999979
		],
		"toe4-1.L": [
			3.490658428972885e-8,
			-1.7453292144864463e-8,
			-6.052891516783062e-16,
			0.9999999999999991
		],
		"upperleg01.R": [
			-0.09978326679334232,
			-0.019252818314578146,
			-0.09626845250985629,
			0.9901540353431648
		],
		"metacarpal1.R": [
			6.092348000597591e-16,
			-1.745329203384216e-8,
			3.490658428972889e-8,
			0.9999999999999993
		],
		"levator02.R": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe3-1.L": [
			-0.0977160831259757,
			-0.010161571243265,
			0.015578263407221118,
			0.9950405153950266
		],
		"toe3-1.R": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"levator02.L": [
			3.4906584289728827e-8,
			-2.617994121489886e-8,
			2.61799391054727e-8,
			0.9999999999999991
		],
		"finger5-1.R": [
			0.13350943438065793,
			0.11909686008500353,
			0.4823463212172029,
			0.8575157113764628
		],
		"metacarpal1.L": [
			2.6179939993653517e-8,
			3.4906584733818136e-8,
			8.72664696061073e-9,
			0.9999999999999996
		],
		"toe4-1.R": [
			1.7453292144864446e-8,
			-4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"upperleg01.L": [
			-0.21930270318103673,
			0.4618684224391588,
			0.11785049933949074,
			0.8512902821813991
		],
		"head": [
			-0.09241872448416774,
			0.36929211317737476,
			-0.019352716519804625,
			0.9245039680136654
		],
		"toe5-1.R": [
			3.490658428972886e-8,
			-4.440892098500626e-16,
			1.745329202975935e-8,
			0.9999999999999992
		],
		"special01": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"temporalis01.L": [
			1.7453291256686083e-8,
			-2.617993899445281e-8,
			-2.6179940881832245e-8,
			0.9999999999999991
		],
		"special04": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"metacarpal2.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"metacarpal2.R": [
			8.72664474016458e-9,
			3.4906584289728926e-8,
			3.4906584289728827e-8,
			0.9999999999999988
		],
		"temporalis01.R": [
			8.726645184253878e-9,
			2.617993988263123e-8,
			2.6179939993653474e-8,
			0.9999999999999991
		],
		"toe5-1.L": [
			3.4906584289728906e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"risorius02.R": [
			-8.726645628343005e-9,
			5.235987976526246e-8,
			-8.726646516521441e-9,
			0.9999999999999984
		],
		"special05.L": [
			-2.617993999365347e-8,
			-1.745329247793137e-8,
			-8.726645628343018e-9,
			0.9999999999999994
		],
		"finger2-2.L": [
			0.42466985809223434,
			-0.26738574598693676,
			-0.27744028682449234,
			0.8192601917081497
		],
		"foot.L": [
			0.08670754259140624,
			0.14059769730124794,
			-0.042811002751123754,
			0.985333094752627
		],
		"oris06": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"levator06.R": [
			-1.7453292144864453e-8,
			2.6179939993653534e-8,
			-8.726646516521464e-9,
			0.9999999999999997
		],
		"orbicularis03.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"levator06.L": [
			2.6179939993653494e-8,
			1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"orbicularis03.L": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"foot.R": [
			-0.10418526145302957,
			-0.0383132197662589,
			0.08528673163194447,
			0.9901533729148466
		],
		"root": [
			6.388289864437867e-10,
			-0.5143816881189687,
			-0.010832496386350754,
			0.8574929363848544
		],
		"finger2-2.R": [
			0.2749983138275158,
			0.17316525701372776,
			0.17965361814415337,
			0.9285011031997259
		],
		"risorius02.L": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"special05.R": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"lowerleg02.L": [
			0,
			0,
			0,
			1
		],
		"tongue05.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger5-1.L": [
			0.07458179847370738,
			-0.06648102386499255,
			-0.2693470051880015,
			0.9578465532633834
		],
		"toe4-3.R": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"oris03.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"toe4-3.L": [
			-4.363322858580418e-8,
			1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"finger3-3.L": [
			0.21508492569674215,
			-0.15645736254032605,
			-0.25913531861775235,
			0.9284979564273836
		],
		"tongue05.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"lowerleg02.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"shoulder01.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-1.L": [
			0.16278359615480056,
			-0.10800588363915509,
			-0.21064658986510137,
			0.9578435384239115
		],
		"special06.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"finger4-3.L": [
			0.1801239449376904,
			-0.1086802580741334,
			-0.3059893083944132,
			0.9285012165384237
		],
		"finger3-2.L": [
			0.2982537370901559,
			-0.22225597288853738,
			-0.35541394059674886,
			0.8575126364413626
		],
		"upperarm01.R": [
			-0.41202794577291046,
			0.39031197434028597,
			0.15549500515705894,
			0.8085238635686337
		],
		"finger3-2.R": [
			0.21528604293592604,
			0.16042842136083535,
			0.2565282134823667,
			0.9284976666767699
		],
		"upperarm01.L": [
			-0.06869835845257503,
			0.07194353708718759,
			0.0015167264055145758,
			0.9950388748980197
		],
		"special06.L": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"finger3-1.R": [
			0.21039747050766608,
			0.13960669479227794,
			0.2722720742125925,
			0.9284992152808336
		],
		"shoulder01.L": [
			-0.2545297542680855,
			0.13319776376453485,
			0.0014327127178280852,
			0.957847016623544
		],
		"lowerarm01.R": [
			-0.4270922265281577,
			0.3825170065942174,
			-0.0065169407166782165,
			0.8192865794025408
		],
		"special03": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.L": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"spine02": [
			-2.807958466831775e-7,
			-0.09838928688599469,
			-0.09960544031572825,
			0.9901506473691247
		],
		"spine03": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"spine01": [
			0.09898124698716554,
			-0.009732875555091836,
			-0.0985041144713917,
			0.9901539896957956
		],
		"upperarm02.R": [
			4.569261529843772e-16,
			8.726646072432231e-9,
			-5.235987998730683e-8,
			0.9999999999999986
		],
		"spine04": [
			-4.363322858580419e-8,
			-2.6179939660586626e-8,
			-8.7266447401649e-9,
			0.9999999999999984
		],
		"spine05": [
			-1.2091407220498728e-7,
			0.053167547315714714,
			0.08408043372638022,
			0.9950395432226804
		],
		"lowerarm01.L": [
			-0.49824311493672774,
			-0.4462313050979404,
			0.007600996005190383,
			0.7433529751258581
		],
		"finger5-3.L": [
			0.15442710338555424,
			-0.1485620510841873,
			-0.5319024547614095,
			0.8192443868201927
		],
		"oris01": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"oris05": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"risorius03.R": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger2-3.L": [
			0.32964018186311045,
			-0.22253117467697314,
			-0.2043666691087311,
			0.8944559750795704
		],
		"toe3-3.R": [
			1.7453292144864443e-8,
			-2.6179940104675836e-8,
			8.726645628343028e-9,
			0.9999999999999997
		],
		"finger3-3.R": [
			0.2590016741531312,
			0.18840750945056262,
			0.3120586664330018,
			0.8944496251173503
		],
		"finger2-3.R": [
			0.27374095283122385,
			0.18480053859776424,
			0.1697093141744706,
			0.9285006194717699
		],
		"toe3-3.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"risorius03.L": [
			8.726645628343061e-9,
			-8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		]
	},
	"tpose": {
		"toe1-1.L": [
			0,
			0,
			0,
			1
		],
		"finger5-2.R": [
			-0.02713930766239003,
			-0.033389816022924346,
			-0.07120280473252773,
			0.9965333605874831
		],
		"finger1-3.R": [
			6.108652428338194e-8,
			-1.7453293699176697e-8,
			3.490658251338867e-8,
			0.9999999999999969
		],
		"toe5-2.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"toe4-2.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"clavicle.R": [
			-3.482940341091577e-8,
			-2.3199824283892667e-9,
			-0.06646260431291842,
			0.9977889166692236
		],
		"neck03": [
			0,
			0,
			0,
			1
		],
		"neck02": [
			0,
			0,
			0,
			1
		],
		"neck01": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"metatarsal1.R": [
			-6.108652428338213e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"clavicle.L": [
			-3.48294034109158e-8,
			2.3199823173669643e-9,
			0.06646260431291873,
			0.9977889166692238
		],
		"toe5-2.L": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"toe4-2.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			-8.726646072432226e-9,
			1
		],
		"finger5-2.L": [
			-0.02713934503693339,
			0.03338979359824257,
			0.07120280473347775,
			0.9965333603209278
		],
		"finger1-3.L": [
			-8.726645184253878e-9,
			2.6179939993653534e-8,
			2.6179939993653474e-8,
			0.9999999999999992
		],
		"toe1-1.R": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"oculi02.L": [
			-8.726645628343012e-9,
			1.745329203384216e-8,
			3.4906584289728866e-8,
			0.9999999999999993
		],
		"oculi01.L": [
			-2.6179939993653497e-8,
			-8.726646405499139e-9,
			-1.7453292144864423e-8,
			0.9999999999999994
		],
		"jaw": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			-0.036578538089969394,
			-0.03335144611310992,
			-0.06087861763130583,
			0.9969169902798661
		],
		"oculi01.R": [
			-2.6179939993653474e-8,
			8.726646627543744e-9,
			1.7453292144864476e-8,
			0.9999999999999994
		],
		"oculi02.R": [
			-8.726645628343013e-9,
			-1.7453292144864463e-8,
			-3.490658428972889e-8,
			0.9999999999999992
		],
		"wrist.R": [
			6.108652428338212e-8,
			-8.726645739365324e-9,
			-8.72664651652142e-9,
			0.9999999999999983
		],
		"finger1-1.L": [
			0.01073116757239942,
			-0.0315525650666183,
			0.09017133623771119,
			0.9953684784045332
		],
		"tongue07.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"eye.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger2-1.R": [
			0.07630599690180848,
			-0.09729201584011626,
			-0.03573171690092074,
			0.9916828640739437
		],
		"finger5-3.R": [
			2.6179939993653504e-8,
			-1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"metatarsal4.L": [
			-6.981316857945734e-8,
			-8.72664507323151e-9,
			1.745329303304303e-8,
			0.9999999999999974
		],
		"metatarsal4.R": [
			-4.363322858580419e-8,
			-4.440892098500626e-16,
			-1.7453292253300258e-8,
			0.9999999999999987
		],
		"finger2-1.L": [
			0.07630600078176969,
			0.09729199761315344,
			0.035731733315461076,
			0.9916828649721681
		],
		"metatarsal1.L": [
			-6.10865242833821e-8,
			-8.726645295276114e-9,
			1.7453293033041314e-8,
			0.9999999999999981
		],
		"eye.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"tongue07.L": [
			-3.4906584289728866e-8,
			-8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"wrist.L": [
			4.3633228585804185e-8,
			2.6179939660586626e-8,
			8.726647404700228e-9,
			0.9999999999999984
		],
		"finger3-1.R": [
			-0.020460158072647467,
			-0.0186551464707152,
			-0.03405237498712201,
			0.9990364373732991
		],
		"lowerleg01.R": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.L": [
			-4.3633228585804066e-8,
			-3.490658462279583e-8,
			1.745329392122137e-8,
			0.9999999999999983
		],
		"oris07.L": [
			-2.617994088183188e-8,
			8.7266446291423e-9,
			-5.2359879987306836e-8,
			0.9999999999999981
		],
		"oris07.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue00": [
			-6.108652428338213e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"lowerarm02.R": [
			-3.490658606608567e-8,
			3.4906582513372086e-8,
			-3.4906586066085725e-8,
			0.9999999999999981
		],
		"lowerleg01.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"tongue03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			0.010742188310171775,
			0.03161825077122027,
			-0.09014698876853186,
			0.9953684805259021
		],
		"metacarpal4.L": [
			-0.050724790471702925,
			0.016990521235243694,
			0.030603471888286153,
			0.9980990658888218
		],
		"finger1-2.R": [
			0.12977228817076256,
			-0.22097139816656164,
			-0.2327332443651365,
			0.9381716428151714
		],
		"pelvis.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-1.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe2-3.L": [
			0,
			0,
			0,
			1
		],
		"toe5-3.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			-8.726646072432226e-9,
			1
		],
		"temporalis02.R": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			8.726646072432235e-9,
			0.9999999999999999
		],
		"finger4-1.L": [
			-0.07838154040625106,
			-0.03403698242195119,
			0.0161202951784409,
			0.9962118017944327
		],
		"finger4-1.R": [
			-0.07838161016482753,
			0.034037000853460064,
			-0.01612023706762942,
			0.9962117966164393
		],
		"levator05.R": [
			3.046174000298796e-16,
			-3.4906584178706623e-8,
			-8.726646072432218e-9,
			0.9999999999999994
		],
		"toe5-3.R": [
			-1.7453292144864443e-8,
			-1.7453292255886765e-8,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"toe2-3.R": [
			0,
			0,
			0,
			1
		],
		"finger4-2.L": [
			-0.03657855682915362,
			0.033351471503019536,
			0.060878530717580315,
			0.9969169940504318
		],
		"toe2-1.L": [
			3.4906584289728866e-8,
			-5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"finger1-2.L": [
			0.12977240688888406,
			0.22097145624237802,
			0.23273321081398676,
			0.9381716210377509
		],
		"pelvis.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal4.R": [
			-0.05072482925929742,
			-0.016990481930034718,
			-0.030603536911566434,
			0.9980990625929383
		],
		"tongue04": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"toe3-2.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator03.R": [
			-1.7453292144864446e-8,
			8.726646294476836e-9,
			2.6179939993653537e-8,
			0.9999999999999994
		],
		"upperleg02.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperleg02.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator03.L": [
			-1.745329214486445e-8,
			-8.726646627543744e-9,
			-2.6179939993653573e-8,
			0.9999999999999997
		],
		"toe3-2.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"metacarpal3.L": [
			-0.035101815039748414,
			0.030822872227328046,
			0.0320065040244292,
			0.9983954110615227
		],
		"tongue01": [
			0.0000014486232657827584,
			1.1102230246251565e-16,
			0,
			0.9999999999989508
		],
		"breast.L": [
			0,
			0,
			0,
			1
		],
		"metatarsal3.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"tongue02": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"metatarsal5.L": [
			-2.6179939993653487e-8,
			8.726647182655256e-9,
			2.617993999365346e-8,
			0.9999999999999989
		],
		"oris04.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oris04.L": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			-8.726646072432222e-9,
			0.9999999999999999
		],
		"metatarsal5.R": [
			-5.235987998730682e-8,
			8.726645295276114e-9,
			-1.745329303304291e-8,
			0.9999999999999988
		],
		"metatarsal3.L": [
			-7.853981998095989e-8,
			-1.7453290368507623e-8,
			1.745329392122154e-8,
			0.9999999999999964
		],
		"breast.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris03.R": [
			-8.726645628343023e-9,
			1.745329203384216e-8,
			2.6179939993653547e-8,
			0.9999999999999994
		],
		"oris06.L": [
			4.363322858580419e-8,
			4.440892098500626e-16,
			-1.7453292253300258e-8,
			0.9999999999999987
		],
		"orbicularis04.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"toe1-2.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"toe1-2.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"orbicularis04.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"metacarpal3.R": [
			-0.035101814172184824,
			-0.030822858213560345,
			-0.032006583108552186,
			0.9983954089893862
		],
		"oris06.R": [
			5.235987998730684e-8,
			-3.3306690738754696e-16,
			8.726646049588092e-9,
			0.9999999999999987
		],
		"levator04.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue06.L": [
			0,
			0,
			0,
			1
		],
		"metatarsal2.L": [
			-6.981316857945734e-8,
			-8.72664507323151e-9,
			1.745329303304303e-8,
			0.9999999999999974
		],
		"toe2-2.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"toe2-2.R": [
			0,
			0,
			0,
			1
		],
		"tongue06.R": [
			0,
			0,
			0,
			1
		],
		"levator04.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"toe4-1.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperleg01.R": [
			6.104962607328282e-8,
			-2.1229044078197035e-9,
			0.034752418059352905,
			0.9993959522826896
		],
		"metacarpal1.R": [
			-0.02476261587853631,
			-0.03996223626862083,
			-0.03292668716984705,
			0.9983514740807878
		],
		"levator02.R": [
			3.490658428972884e-8,
			-8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"temporalis02.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			-8.726646072432226e-9,
			1
		],
		"toe3-1.L": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe3-1.R": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"levator02.L": [
			3.490658428972884e-8,
			8.726646405499139e-9,
			-8.726645628342989e-9,
			0.9999999999999991
		],
		"finger5-1.R": [
			-0.13649704297650153,
			0.019436284279485516,
			-0.09107401620831188,
			0.9862536751180024
		],
		"metacarpal1.L": [
			-0.024762589815145168,
			0.03996226983022322,
			0.032926609025111915,
			0.9983514759611318
		],
		"toe4-1.R": [
			-3.490658428972882e-8,
			2.6179939993653534e-8,
			8.726645184253818e-9,
			0.9999999999999988
		],
		"upperleg01.L": [
			6.104962601259199e-8,
			2.1229048519089133e-9,
			-0.03475242548744739,
			0.9993959520243894
		],
		"head": [
			0,
			0,
			0,
			1
		],
		"toe5-1.R": [
			4.363322858580418e-8,
			1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"special04": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"metacarpal2.L": [
			-0.03510182243035363,
			0.03082290099862861,
			0.032006528109337636,
			0.9983954091413296
		],
		"metacarpal2.R": [
			-0.03510185876170931,
			-0.030822904637991866,
			-0.03200657277443542,
			0.9983954063197531
		],
		"temporalis01.R": [
			-1.745329125668606e-8,
			-2.617993988263123e-8,
			-1.7453291256686063e-8,
			0.9999999999999994
		],
		"toe5-1.L": [
			8.726646516521441e-9,
			-2.6179940104675836e-8,
			-8.726646516521445e-9,
			0.9999999999999998
		],
		"finger3-3.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"risorius02.R": [
			-3.490658428972878e-8,
			-2.6179939549564324e-8,
			1.7453293033042585e-8,
			0.9999999999999991
		],
		"special05.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger2-2.L": [
			-0.05360775923169337,
			0.04577200459549724,
			0.0853460212639502,
			0.9938547119171293
		],
		"foot.L": [
			0,
			0,
			0.022712292941328455,
			0.9997420426036645
		],
		"oris06": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"levator06.R": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"orbicularis03.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"levator06.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"orbicularis03.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"foot.R": [
			1.7448789730442967e-8,
			3.9640413174169e-10,
			-0.022712285500354534,
			0.9997420427727095
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			-0.05360773872657106,
			-0.0457720345239222,
			-0.08534599921532181,
			0.9938547135382029
		],
		"risorius02.L": [
			-3.490658428972878e-8,
			2.6179939549564324e-8,
			-1.7453293033042585e-8,
			0.9999999999999991
		],
		"special05.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"lowerleg02.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"tongue05.L": [
			0,
			0,
			0,
			1
		],
		"finger5-1.L": [
			-0.1364969995161761,
			-0.019436254976223033,
			0.09107407112259157,
			0.9862536766394017
		],
		"toe4-3.R": [
			0,
			0,
			0,
			1
		],
		"oris03.L": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"toe4-3.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-3.L": [
			1.745329214486445e-8,
			-8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"tongue05.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"lowerleg02.R": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"shoulder01.R": [
			0,
			0,
			-0.0914326454743988,
			0.9958112629115785
		],
		"finger3-1.L": [
			-0.020460122705238976,
			0.018655138115546088,
			0.03405238616722545,
			0.9990364378725607
		],
		"special06.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger4-3.L": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			-8.726645628343035e-9,
			0.9999999999999997
		],
		"finger3-2.L": [
			-0.02921526064934317,
			0.026637875343599293,
			0.048623691452506626,
			0.9980343825599906
		],
		"upperarm01.R": [
			0.009641250090009986,
			-0.0151044780196683,
			-0.24779149943979642,
			0.9686476520623133
		],
		"finger3-2.R": [
			-0.029215296016548785,
			-0.026637825908497836,
			-0.048623728515501605,
			0.9980343810384413
		],
		"upperarm01.L": [
			0.009641250090009986,
			0.0151044780196683,
			0.24779149943979642,
			0.9686476520623133
		],
		"special06.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"metatarsal2.R": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"shoulder01.L": [
			0,
			0,
			0.09143262358843446,
			0.9958112649210872
		],
		"lowerarm01.R": [
			0.23848787210455522,
			-0.2375925809334143,
			-0.0021825725269267325,
			0.9416307857762535
		],
		"temporalis01.L": [
			-1.745329125668606e-8,
			2.617993988263123e-8,
			1.7453291256686063e-8,
			0.9999999999999994
		],
		"upperarm02.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"spine02": [
			0,
			0,
			0,
			1
		],
		"spine03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"spine01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"spine04": [
			5.235987998730684e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999987
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			0.23848785500358924,
			0.2375925357545552,
			0.0021825690884329767,
			0.9416308015149469
		],
		"finger5-3.L": [
			5.235987998730683e-8,
			8.726646294476836e-9,
			4.4331856927593173e-16,
			0.9999999999999987
		],
		"oris01": [
			0,
			0,
			0,
			1
		],
		"oris02": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"risorius03.R": [
			4.3633228585804245e-8,
			1.7453293255087488e-8,
			-1.745329125668602e-8,
			0.999999999999999
		],
		"finger2-3.L": [
			-6.108652428338216e-8,
			8.726643518919275e-9,
			-4.363322858580252e-8,
			0.999999999999997
		],
		"toe3-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-3.R": [
			-1.7453293033042886e-8,
			4.363322880784892e-8,
			-1.745329303304289e-8,
			0.9999999999999986
		],
		"finger2-3.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe3-3.L": [
			0,
			0,
			0,
			1
		],
		"risorius03.L": [
			4.3633228585804245e-8,
			-1.7453293255087488e-8,
			1.745329125668602e-8,
			0.999999999999999
		],
		"levator05.L": [
			3.046174000298792e-16,
			3.490658440075123e-8,
			8.726646072432198e-9,
			0.9999999999999992
		]
	},
	"Harvey_FashionCloseup1": {
		"toe1-1.L": [
			-0.19477089363709968,
			-0.0178947388042624,
			0.01349462111570301,
			0.9805926639109007
		],
		"finger5-2.R": [
			0.027131498369240316,
			0.028265817834310147,
			0.09143241617891258,
			0.995040219594205
		],
		"finger1-3.R": [
			-1.7453291256686053e-8,
			-2.617993988263123e-8,
			1.745329303304289e-8,
			0.9999999999999994
		],
		"toe5-2.R": [
			0,
			0,
			0,
			1
		],
		"toe4-2.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"clavicle.R": [
			0.025157175612350362,
			0.0923048166452809,
			-0.10221157611166584,
			0.9901513677453865
		],
		"neck03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"neck02": [
			0,
			0,
			0,
			1
		],
		"neck01": [
			0,
			0,
			0,
			1
		],
		"clavicle.L": [
			0.025157177335938693,
			-0.09230480901555471,
			0.10221160530196301,
			0.9901513653995972
		],
		"toe5-2.L": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe4-2.L": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"finger5-2.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"finger1-3.L": [
			-1.7453291256686083e-8,
			2.617993899445281e-8,
			-2.6179940881832245e-8,
			0.9999999999999991
		],
		"toe1-1.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"oculi02.L": [
			-2.617993821729672e-8,
			-5.235987843299483e-8,
			3.490658606608563e-8,
			0.999999999999998
		],
		"oculi01.L": [
			-4.363322858580419e-8,
			-4.440892098500626e-16,
			-1.7453292253300258e-8,
			0.9999999999999987
		],
		"jaw": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			0.048818087271168535,
			0.032853866421261646,
			0.08020366764611236,
			0.9950400944245767
		],
		"oculi01.R": [
			-4.3633228585804e-8,
			3.490658451177353e-8,
			1.745329036850783e-8,
			0.9999999999999983
		],
		"oculi02.R": [
			-2.6179939105475045e-8,
			1.745329114566374e-8,
			-4.363322858580426e-8,
			0.9999999999999988
		],
		"wrist.R": [
			-0.12407856940282651,
			0.04066509053101819,
			-0.3775655060415342,
			0.9167306843749982
		],
		"finger1-1.L": [
			0.13690229888893182,
			0.0013408227009354956,
			0.14033366238572953,
			0.9805928951174476
		],
		"tongue07.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"eye.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger2-1.R": [
			0.06607323399523517,
			-0.06314392677409764,
			-0.03929784890917258,
			0.9950391205033448
		],
		"finger4-3.R": [
			0.09511522496060996,
			0.05737369981788487,
			0.16156257405613197,
			0.9805910907275553
		],
		"finger2-1.L": [
			3.4906586066085626e-8,
			5.235988176366391e-8,
			-3.490658251337196e-8,
			0.9999999999999974
		],
		"eye.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue07.L": [
			-8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"wrist.L": [
			-0.08592652771956157,
			0.06605824986498376,
			0.3213144801632558,
			0.9407496714303184
		],
		"finger5-3.R": [
			0.02680226502441698,
			0.02575810620706831,
			0.09226599764130804,
			0.9950402726691219
		],
		"lowerleg01.R": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"lowerarm02.L": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"oris07.L": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"oris07.R": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"tongue00": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.R": [
			8.726645184253878e-9,
			2.617993988263123e-8,
			2.6179939993653474e-8,
			0.9999999999999991
		],
		"lowerleg01.L": [
			0.09913224247401435,
			0.007914647993908841,
			-0.002104000845250509,
			0.9950405670271181
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"metacarpal4.L": [
			-3.490658251337201e-8,
			1.745329025748532e-8,
			-5.23598799873061e-8,
			0.999999999999998
		],
		"finger1-2.R": [
			0.07254002862229095,
			0.10004372611964485,
			-0.31578703103248607,
			0.9407485041940074
		],
		"pelvis.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe2-1.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe2-3.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"toe5-3.L": [
			4.3633228585804185e-8,
			-3.3306690738754696e-16,
			8.726646077118623e-9,
			0.9999999999999991
		],
		"levator05.L": [
			-6.853892559463472e-16,
			2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"finger4-1.L": [
			-0.12827433962300377,
			-0.02027119962835855,
			0.0522509268180011,
			0.9901538329505011
		],
		"finger4-1.R": [
			-0.08216014389854812,
			0.04653077090981805,
			0.03130707178720971,
			0.9950399315450704
		],
		"levator05.R": [
			-4.569261529843785e-16,
			-2.617993988263123e-8,
			-1.745329214486445e-8,
			0.9999999999999996
		],
		"toe5-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe2-3.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger4-2.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"toe2-1.L": [
			-0.19431514383631127,
			-0.018258889431111647,
			0.01860903836540772,
			0.9805926481081384
		],
		"finger1-2.L": [
			-5.235987998730686e-8,
			-2.617994110387656e-8,
			-8.726644740164896e-9,
			0.9999999999999984
		],
		"pelvis.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal4.R": [
			1.523087000149394e-15,
			-3.4906584178706623e-8,
			4.36332285858042e-8,
			0.9999999999999983
		],
		"tongue04": [
			0,
			0,
			0,
			1
		],
		"toe3-2.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"levator03.R": [
			3.490658428972883e-8,
			5.235987998730707e-8,
			1.6734015079435647e-15,
			0.9999999999999981
		],
		"upperleg02.R": [
			1.7453292144864446e-8,
			-4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"upperleg02.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"levator03.L": [
			4.363322858580412e-8,
			-2.6179940992854256e-8,
			2.617993910547514e-8,
			0.9999999999999986
		],
		"toe3-2.R": [
			-2.6179939993653497e-8,
			-8.726646405499139e-9,
			-1.7453292144864423e-8,
			0.9999999999999994
		],
		"metacarpal3.L": [
			-8.72664607243222e-9,
			-4.3633228918871225e-8,
			3.5626088403688626e-16,
			0.9999999999999991
		],
		"tongue01": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"breast.L": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"temporalis02.R": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"tongue02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris04.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"oris04.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"temporalis02.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"breast.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"oris03.R": [
			-2.7755575615628914e-16,
			-1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"oris06.L": [
			-1.745329303304289e-8,
			3.490658440075123e-8,
			2.617993910547502e-8,
			0.9999999999999988
		],
		"orbicularis04.R": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"toe1-2.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"toe1-2.L": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"orbicularis04.L": [
			2.6179939993653504e-8,
			-1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"metacarpal3.R": [
			-8.726646516521448e-9,
			-8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"oris06.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"levator04.L": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"tongue06.L": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"toe2-2.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"toe2-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue06.R": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"levator04.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"toe4-1.L": [
			-0.19161650791730633,
			-0.025005944479711495,
			0.033107543275038225,
			0.980592528633859
		],
		"upperleg01.R": [
			0.0021043678364679108,
			0.04494640220826396,
			0.14130621202584984,
			0.9889428431448639
		],
		"metacarpal1.R": [
			2.6179939105474995e-8,
			-4.363322880784892e-8,
			-2.617994088183188e-8,
			0.9999999999999984
		],
		"levator02.R": [
			-8.726646072432225e-9,
			-6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"toe3-1.L": [
			-0.19259859254486292,
			-0.020028391903508025,
			0.03070497176105053,
			0.9805926016326302
		],
		"toe3-1.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator02.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"finger5-1.R": [
			-0.1110929008870997,
			0.07227265264344851,
			0.11787322963209061,
			0.9841447722710663
		],
		"metacarpal1.L": [
			1.7453292144864433e-8,
			2.617994021569814e-8,
			4.927555263958927e-16,
			0.9999999999999996
		],
		"toe4-1.R": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"upperleg01.L": [
			0.08755647904526909,
			0.10448474548427389,
			-0.031906567069626135,
			0.9901508834092472
		],
		"head": [
			-3.6514488676047054e-8,
			-0.002614674232801484,
			-0.04985183762639569,
			0.9987532016288739
		],
		"toe5-1.R": [
			3.490658428972885e-8,
			1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			2.2846307649218933e-16,
			-2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"special04": [
			0,
			0,
			0,
			1
		],
		"metacarpal2.L": [
			1.7453292144864443e-8,
			-2.6179940104675836e-8,
			8.726645628343028e-9,
			0.9999999999999997
		],
		"metacarpal2.R": [
			2.617993999365353e-8,
			-1.745329336610979e-8,
			1.7453291256686023e-8,
			0.9999999999999997
		],
		"temporalis01.R": [
			1.7453293033042873e-8,
			-1.7453293144065185e-8,
			4.363322858580396e-8,
			0.9999999999999986
		],
		"toe5-1.L": [
			-0.09851025659704502,
			-0.01029158464651625,
			0.009174964573503296,
			0.9950405180974905
		],
		"risorius02.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"special05.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"finger2-2.L": [
			2.617994088183186e-8,
			2.617994077080965e-8,
			-4.36332285858042e-8,
			0.9999999999999984
		],
		"foot.L": [
			-0.09310629138983717,
			-0.054065435577969834,
			0.0894735810897893,
			0.9901528293482597
		],
		"oris06": [
			0,
			0,
			0,
			1
		],
		"levator06.R": [
			-6.092348000597591e-16,
			1.745329203384216e-8,
			3.490658428972889e-8,
			0.9999999999999993
		],
		"orbicularis03.R": [
			-4.3633228585804185e-8,
			2.6179939660586626e-8,
			-8.726647404700228e-9,
			0.9999999999999984
		],
		"levator06.L": [
			8.726646516521441e-9,
			2.6179940104675836e-8,
			-8.726645628343022e-9,
			0.9999999999999998
		],
		"orbicularis03.L": [
			-8.72664562834302e-9,
			-3.4906584289728926e-8,
			8.726646516521445e-9,
			0.9999999999999994
		],
		"foot.R": [
			0.005566695707175361,
			0.04641199412111696,
			-0.08781013986910151,
			0.9950398575116343
		],
		"root": [
			-2.2659934238242162e-8,
			0.0010514256631327656,
			-0.04990920797540352,
			0.9987532054833879
		],
		"finger2-2.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"risorius02.L": [
			8.726645628343017e-9,
			-2.6179939993653534e-8,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"special05.R": [
			-1.745329214486445e-8,
			1.7453292366909068e-8,
			8.726645628343025e-9,
			0.9999999999999999
		],
		"lowerleg02.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue05.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger5-1.L": [
			-0.1815283247597666,
			-0.06578287963621476,
			-0.034050202747631715,
			0.9805919965763162
		],
		"toe4-3.R": [
			-5.235987998730684e-8,
			-8.881784197001252e-16,
			-1.7453292120936186e-8,
			0.9999999999999983
		],
		"oris03.L": [
			-2.7755575615628914e-16,
			-1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe4-3.L": [
			-5.235987998730683e-8,
			8.726646294476836e-9,
			-4.4331856927593173e-16,
			0.9999999999999987
		],
		"finger3-3.L": [
			0.11357363470833771,
			-0.08260620318882428,
			-0.1368242331551763,
			0.9805898092043188
		],
		"tongue05.R": [
			0,
			0,
			0,
			1
		],
		"lowerleg02.R": [
			0,
			0,
			0,
			1
		],
		"shoulder01.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"finger3-1.L": [
			-0.13491908323862603,
			-0.010128950379407309,
			0.03590765437530552,
			0.9901539707033058
		],
		"special06.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"finger4-3.L": [
			0.09511521027456242,
			-0.05737367476613031,
			-0.16156252764020762,
			0.9805911012653352
		],
		"finger3-2.L": [
			-8.726644296075356e-9,
			5.235987998730707e-8,
			-3.4906584289728846e-8,
			0.9999999999999983
		],
		"upperarm01.R": [
			-0.25635587583388886,
			0.35856640126936834,
			0.2547238472021329,
			0.8607134032142867
		],
		"finger3-2.R": [
			-1.7453291256686047e-8,
			-3.4906584289728926e-8,
			1.745329303304288e-8,
			0.999999999999999
		],
		"upperarm01.L": [
			-0.3490472869457665,
			-0.32522574922058145,
			-0.38881030399143374,
			0.7881755838833122
		],
		"special06.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"finger3-1.R": [
			-0.03975543194376223,
			0.02387140332070592,
			0.01849520600162055,
			0.9987530170614868
		],
		"shoulder01.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"lowerarm01.R": [
			-0.5742872218087306,
			0.545829739879329,
			-0.028461876191431184,
			0.6094702646841254
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"upperarm02.L": [
			-2.6179939993653484e-8,
			2.6179940104675836e-8,
			-8.045503725131716e-16,
			0.9999999999999991
		],
		"spine02": [
			-1.4536483068520866e-8,
			-0.0003155912194869881,
			0.049919285143824425,
			0.998753205438116
		],
		"spine03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"spine01": [
			-2.2832253786964226e-8,
			0.004905353104103227,
			0.04967889942284172,
			0.9987531949701381
		],
		"upperarm02.R": [
			-3.490658428972884e-8,
			-3.4906584289728926e-8,
			8.726647404699887e-9,
			0.9999999999999989
		],
		"spine04": [
			0,
			0,
			0,
			1
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			-0.5231985603109663,
			-0.5937041663781466,
			0.08620183605289672,
			0.6052667781853481
		],
		"finger5-3.L": [
			-1.745329214486444e-8,
			3.490658451177353e-8,
			-4.799202690040438e-16,
			0.9999999999999992
		],
		"oris01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			2.617993910547505e-8,
			-5.235987976526246e-8,
			-8.726647404699368e-9,
			0.999999999999998
		],
		"finger2-3.L": [
			1.5230870001493917e-15,
			4.363322858580432e-8,
			-3.490658428972882e-8,
			0.9999999999999987
		],
		"toe3-3.R": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger3-3.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger2-3.R": [
			-0.07333540450882452,
			-0.0495041658734523,
			-0.04546368741752955,
			0.9950398530376068
		],
		"toe3-3.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"risorius03.L": [
			2.617993999365348e-8,
			4.363322869682662e-8,
			1.035761105051169e-15,
			0.9999999999999987
		]
	},
	"mh-rigging351-benchmark1": {
		"toe1-1.L": [
			0.1746287231708288,
			3.0478463086680563e-9,
			-1.7185110777099316e-8,
			0.9846343529674993
		],
		"finger5-2.R": [
			5.235987998730683e-8,
			1.7453293255087488e-8,
			-1.7453291256686007e-8,
			0.9999999999999984
		],
		"finger1-3.R": [
			8.72664607243222e-9,
			-4.3633228918871225e-8,
			-3.5626088403688626e-16,
			0.9999999999999991
		],
		"toe5-2.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"toe4-2.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"clavicle.R": [
			-0.08428028886523192,
			-0.05428695460807176,
			-0.3529348163187047,
			0.9302616701220452
		],
		"neck03": [
			0,
			0,
			0,
			1
		],
		"neck02": [
			0.024077281987792097,
			1.1102230246251565e-16,
			1.5777218104420236e-30,
			0.9997101002251004
		],
		"neck01": [
			0.039637263022145264,
			-2.220446049250313e-16,
			-4.930380657631324e-32,
			0.9992141348980772
		],
		"clavicle.L": [
			-0.08428028886523192,
			0.05428695460807176,
			0.3529348163187047,
			0.9302616701220452
		],
		"toe5-2.L": [
			0.14556015882694057,
			-8.63370253068041e-9,
			-1.2702519617082881e-9,
			0.9893494024672355
		],
		"toe4-2.L": [
			0.21036333474771718,
			-6.695605958562112e-9,
			-1.036713878897304e-8,
			0.9776232747811501
		],
		"finger5-2.L": [
			-8.726645184253779e-9,
			-2.6179939993653534e-8,
			-3.490658428972884e-8,
			0.9999999999999991
		],
		"finger1-3.L": [
			-2.617993999365347e-8,
			2.6179940437742744e-8,
			8.726645184253845e-9,
			0.9999999999999996
		],
		"toe1-1.R": [
			0.15361393122190664,
			2.681069255494606e-9,
			-1.724613836063182e-8,
			0.9881309428079617
		],
		"oculi02.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"oculi01.L": [
			-6.108652428338189e-8,
			-3.490658595506346e-8,
			-2.617993821729565e-8,
			0.999999999999997
		],
		"jaw": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			1.745329214486445e-8,
			1.7453291922819858e-8,
			-1.745329214486445e-8,
			0.9999999999999993
		],
		"oculi01.R": [
			-6.108652428338189e-8,
			3.490658595506346e-8,
			2.617993821729565e-8,
			0.999999999999997
		],
		"oculi02.R": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"wrist.R": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"finger1-1.L": [
			-1.1423153030516057e-15,
			-2.617993988263123e-8,
			4.3633228585804225e-8,
			0.9999999999999984
		],
		"tongue07.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"eye.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger2-1.R": [
			7.853981998095989e-8,
			-2.617994165898807e-8,
			2.6179938217300896e-8,
			0.9999999999999961
		],
		"finger4-3.R": [
			-6.981316857945706e-8,
			2.6179936774006762e-8,
			-5.235988176364014e-8,
			0.9999999999999962
		],
		"finger2-1.L": [
			6.981316502674292e-8,
			2.617994787623701e-8,
			-1.1344639361255275e-7,
			0.9999999999999909
		],
		"eye.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue07.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"wrist.L": [
			2.617993999365347e-8,
			1.745329247793137e-8,
			-8.726645628343018e-9,
			0.9999999999999994
		],
		"finger5-3.R": [
			8.726646960610638e-9,
			1.7453292144864463e-8,
			4.3633228585804265e-8,
			0.9999999999999988
		],
		"lowerleg01.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"lowerarm02.L": [
			6.108652428338192e-8,
			5.235987998730707e-8,
			-8.726642963808368e-9,
			0.9999999999999966
		],
		"oris07.L": [
			-8.726646516521426e-9,
			8.726645739365324e-9,
			-5.2359879987306e-8,
			0.9999999999999986
		],
		"oris07.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"tongue00": [
			-6.108652428338213e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"lowerarm02.R": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"lowerleg01.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			4.569261529843786e-16,
			-1.745329203384216e-8,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"metacarpal4.L": [
			-3.490658428972881e-8,
			8.726646738566046e-9,
			2.617993999365343e-8,
			0.9999999999999992
		],
		"finger1-2.R": [
			-1.745329480939975e-8,
			-6.981316846843555e-8,
			3.490658606608566e-8,
			0.9999999999999967
		],
		"pelvis.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-1.R": [
			0.1419900654359043,
			1.1116423115353768e-8,
			-1.603735959740477e-8,
			0.9898680827855331
		],
		"toe2-3.L": [
			0.363451573853804,
			-4.958144672606579e-9,
			-1.1301571034779955e-8,
			0.9316130921488772
		],
		"toe5-3.L": [
			0.29620858342190615,
			-1.667004623229218e-8,
			-5.169814950717569e-9,
			0.9551232774397177
		],
		"levator05.L": [
			8.726645628343e-9,
			6.108652417236016e-8,
			-8.726645628343018e-9,
			0.9999999999999979
		],
		"finger4-1.L": [
			-4.363322680944738e-8,
			-2.6179943546367213e-8,
			-7.853981998094747e-8,
			0.9999999999999956
		],
		"finger4-1.R": [
			2.5130938149442876e-15,
			2.6179939993653534e-8,
			9.599310857311078e-8,
			0.9999999999999951
		],
		"levator05.R": [
			8.726645628343e-9,
			-6.108652417236016e-8,
			8.726645628343018e-9,
			0.9999999999999979
		],
		"toe5-3.R": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"toe2-3.R": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"finger4-2.L": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"toe2-1.L": [
			0.25062763706911506,
			-1.8867061246652383e-9,
			-2.7531508265222735e-8,
			0.968083564335823
		],
		"finger1-2.L": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"pelvis.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal4.R": [
			8.726646516521435e-9,
			-4.363322880784892e-8,
			-8.726646516521451e-9,
			0.999999999999999
		],
		"tongue04": [
			8.726645717160763e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999962
		],
		"toe3-2.L": [
			0.10659972915095733,
			-8.676921958716832e-9,
			-9.302580847147922e-10,
			0.9943020153579809
		],
		"levator03.R": [
			-4.363322858580418e-8,
			1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"upperleg02.R": [
			0.04415688386170277,
			-3.8534153645741753e-10,
			8.71813426528171e-9,
			0.9990246091101184
		],
		"upperleg02.L": [
			-0.10680700562031312,
			-9.320669791534897e-10,
			-8.676727431278989e-9,
			0.9942797712668313
		],
		"levator03.L": [
			-4.363322858580418e-8,
			-1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"toe3-2.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal3.L": [
			3.0461740002987937e-16,
			8.726646183454534e-9,
			3.490658428972886e-8,
			0.9999999999999994
		],
		"tongue01": [
			0.0000013962633147416553,
			1.1102230246251565e-16,
			0,
			0.9999999999990252
		],
		"breast.L": [
			1.0530043090085886e-9,
			8.662882300392027e-9,
			0.12066540864769236,
			0.9926932351718153
		],
		"temporalis02.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"tongue02": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"oris04.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oris04.L": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"temporalis02.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"breast.R": [
			-2.7041653320086717e-8,
			5.503869249245952e-9,
			-0.12066540864769233,
			0.9926932351718151
		],
		"oris03.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"oris06.L": [
			6.108652428338212e-8,
			8.881784197001252e-16,
			-1.745329220342391e-8,
			0.999999999999998
		],
		"orbicularis04.R": [
			0,
			0,
			0,
			1
		],
		"toe1-2.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"toe1-2.L": [
			0.11317590666893834,
			-8.6705770341311e-9,
			-9.876460429826736e-10,
			0.9935749665473982
		],
		"orbicularis04.L": [
			0,
			0,
			0,
			1
		],
		"metacarpal3.R": [
			3.490658428972884e-8,
			-3.4906584289728926e-8,
			-8.726647404699887e-9,
			0.9999999999999989
		],
		"oris06.R": [
			7.853981998095987e-8,
			-6.661338147750939e-16,
			8.726646066520822e-9,
			0.9999999999999972
		],
		"levator04.L": [
			0,
			0,
			2.617993999365351e-8,
			0.9999999999999998
		],
		"tongue06.L": [
			0,
			0,
			0,
			1
		],
		"toe2-2.L": [
			0.14807598086293394,
			9.922649923943538e-9,
			-7.338236622257846e-9,
			0.9889759875201624
		],
		"toe2-2.R": [
			0,
			0,
			0,
			1
		],
		"tongue06.R": [
			0,
			0,
			0,
			1
		],
		"levator04.R": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"toe4-1.L": [
			0.3192667395020603,
			-1.9326000133546017e-8,
			2.6976802723215377e-9,
			0.9476648928011012
		],
		"upperleg01.R": [
			0.4727881987967042,
			0.00904604581856061,
			-0.011653033858134128,
			0.881052606224803
		],
		"metacarpal1.R": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"levator02.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"toe3-1.L": [
			0.2732033549788354,
			4.768298089707912e-9,
			-1.6789304424472502e-8,
			0.9619563019328417
		],
		"toe3-1.R": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"levator02.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"finger5-1.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"metacarpal1.L": [
			-5.235988176366344e-8,
			-3.490658262439439e-8,
			4.363323036216129e-8,
			0.9999999999999969
		],
		"toe4-1.R": [
			-1.745329214486444e-8,
			-4.440892098500626e-16,
			-1.7453292016352737e-8,
			0.9999999999999994
		],
		"upperleg01.L": [
			-0.7312045113345239,
			0.026966148439717785,
			0.011476573449029392,
			0.6815284863483232
		],
		"head": [
			0,
			0,
			0,
			1
		],
		"toe5-1.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"special04": [
			-8.726645717160763e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999962
		],
		"metacarpal2.L": [
			8.726646960610635e-9,
			8.726645295276114e-9,
			7.853981998095989e-8,
			0.999999999999997
		],
		"metacarpal2.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"temporalis01.R": [
			-1.745329125668606e-8,
			-2.617993988263123e-8,
			-1.7453291256686063e-8,
			0.9999999999999994
		],
		"toe5-1.L": [
			0.36313749575474463,
			-1.7929818740824999e-9,
			-1.9430825126368433e-8,
			0.9317355629023573
		],
		"risorius02.R": [
			-4.569261529843784e-16,
			-1.7453292255886765e-8,
			2.6179939993653494e-8,
			0.9999999999999994
		],
		"special05.L": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"finger2-2.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"foot.L": [
			0.3541363470111519,
			3.0904226955286163e-9,
			-8.161105338401296e-9,
			0.9351938022279644
		],
		"oris06": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator06.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"orbicularis03.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"orbicularis03.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"foot.R": [
			0.3466445698006267,
			5.160519345182024e-9,
			1.1210608373139362e-8,
			0.9379965576843758
		],
		"root": [
			0.2075671232939164,
			0,
			0,
			0.9782207773951074
		],
		"finger2-2.R": [
			-2.6179939993653497e-8,
			5.551115123125783e-16,
			1.745329205570242e-8,
			0.9999999999999993
		],
		"risorius02.L": [
			-4.569261529843786e-16,
			1.745329203384216e-8,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"special05.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"lowerleg02.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"tongue05.L": [
			0,
			0,
			0,
			1
		],
		"finger5-1.L": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			8.726646072432235e-9,
			0.9999999999999999
		],
		"toe4-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris03.L": [
			8.726645628343007e-9,
			-1.745329203384216e-8,
			1.7453292144864443e-8,
			0.9999999999999998
		],
		"toe4-3.L": [
			0.2485022017906498,
			-6.284311848681057e-9,
			-1.0621493533300538e-8,
			0.9686313311602093
		],
		"finger3-3.L": [
			1.7453292144864427e-8,
			8.881784197001252e-16,
			-5.235988012452949e-8,
			0.9999999999999986
		],
		"tongue05.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"lowerleg02.R": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"shoulder01.R": [
			-0.10095647975571247,
			0.03236224075991989,
			-0.041972400778026234,
			0.993478128667793
		],
		"finger3-1.L": [
			2.6179939105475e-8,
			8.726647626744466e-9,
			-6.981316857945817e-8,
			0.9999999999999971
		],
		"special06.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger4-3.L": [
			-3.490658428972879e-8,
			-8.726645406298417e-9,
			2.6179939993653504e-8,
			0.9999999999999992
		],
		"finger3-2.L": [
			-1.7453292144864443e-8,
			-2.6179940104675836e-8,
			-8.726645628343028e-9,
			0.9999999999999997
		],
		"upperarm01.R": [
			-0.12289177229614603,
			0.2974315781332817,
			-0.5182753398405564,
			0.7923526618521664
		],
		"finger3-2.R": [
			-2.6179939993653487e-8,
			8.726647071632954e-9,
			3.490658428972886e-8,
			0.9999999999999988
		],
		"upperarm01.L": [
			-0.12289169940220541,
			-0.2974316483165885,
			0.5182752683490149,
			0.792352693574946
		],
		"special06.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-1.R": [
			8.726644740164615e-9,
			2.6179940992854256e-8,
			-5.235987998730674e-8,
			0.9999999999999982
		],
		"shoulder01.L": [
			-0.10095645062726494,
			-0.0323622137314431,
			0.04197242701223486,
			0.9934781313999053
		],
		"lowerarm01.R": [
			2.6179939105475048e-8,
			2.6179940881831953e-8,
			-3.4906584289728846e-8,
			0.9999999999999988
		],
		"temporalis01.L": [
			-1.745329125668606e-8,
			2.617993988263123e-8,
			1.7453291256686063e-8,
			0.9999999999999994
		],
		"upperarm02.L": [
			-0.2931824722506077,
			0.3181296651728217,
			0.010147276400465923,
			0.9015179348652489
		],
		"spine02": [
			-0.10297134374678983,
			0,
			0,
			0.9946843229723592
		],
		"spine03": [
			-0.055238475072293625,
			-1.1102230246251565e-16,
			0,
			0.998473189861244
		],
		"spine01": [
			-0.10026645467278891,
			-1.1102230246251565e-16,
			-2.465190328815662e-32,
			0.994960621365162
		],
		"upperarm02.R": [
			-0.2931825265487914,
			-0.3181297107738873,
			-0.010147290152976067,
			0.9015179009603422
		],
		"spine04": [
			-0.05446430232166322,
			1.1102230246251565e-16,
			0,
			0.9985157183402845
		],
		"spine05": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			8.726647404699846e-9,
			-4.363322880784892e-8,
			-2.617993999365346e-8,
			0.9999999999999984
		],
		"finger5-3.L": [
			1.7453293033042856e-8,
			-2.6179939216497417e-8,
			-4.363322858580415e-8,
			0.9999999999999984
		],
		"oris01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"oris05": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"risorius03.R": [
			3.49065842897288e-8,
			-8.726644962209207e-9,
			-2.61799399936534e-8,
			0.9999999999999991
		],
		"finger2-3.L": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"toe3-3.R": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"finger3-3.R": [
			3.4906584289728793e-8,
			1.7453291478730648e-8,
			2.617994088183205e-8,
			0.9999999999999991
		],
		"finger2-3.R": [
			-8.726645184253878e-9,
			2.6179939993653534e-8,
			2.6179939993653474e-8,
			0.9999999999999992
		],
		"toe3-3.L": [
			0.49839385129411773,
			-2.0832229274958536e-9,
			-3.139533132187128e-8,
			0.8669507304294841
		],
		"risorius03.L": [
			3.490658428972879e-8,
			8.726645406298417e-9,
			2.6179939993653504e-8,
			0.9999999999999992
		]
	},
	"sitting": {
		"toe1-1.L": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"finger5-2.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"finger1-3.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"toe5-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe4-2.R": [
			4.363322858580417e-8,
			8.726645628343022e-9,
			8.726646516520993e-9,
			0.999999999999999
		],
		"clavicle.R": [
			0,
			0,
			0,
			1
		],
		"neck03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"neck02": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"neck01": [
			0,
			0,
			0,
			1
		],
		"clavicle.L": [
			0,
			0,
			0,
			1
		],
		"toe5-2.L": [
			0,
			0,
			0,
			1
		],
		"toe4-2.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"finger5-2.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"finger1-3.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"toe1-1.R": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"oculi02.L": [
			2.6179939993653484e-8,
			-2.6179940104675836e-8,
			-8.045503725131716e-16,
			0.9999999999999991
		],
		"oculi01.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"jaw": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			1.745329214486443e-8,
			5.235987998730707e-8,
			8.662785736608193e-16,
			0.999999999999998
		],
		"oculi01.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"oculi02.R": [
			2.6179939993653484e-8,
			2.6179940104675836e-8,
			8.045503725131716e-16,
			0.9999999999999991
		],
		"wrist.R": [
			-0.13132828115603468,
			0.0019188538439727232,
			-0.19219843147251214,
			0.97252710168305
		],
		"finger1-1.L": [
			-0.09162784592817355,
			0.10539001838473239,
			0.23753152877338027,
			0.9612887467946397
		],
		"tongue07.R": [
			3.490658428972884e-8,
			8.726646405499139e-9,
			-8.726645628342989e-9,
			0.9999999999999991
		],
		"eye.R": [
			0,
			0,
			0,
			1
		],
		"finger2-1.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger4-3.R": [
			1.745329303304285e-8,
			-4.3633228918871225e-8,
			2.6179939105475048e-8,
			0.9999999999999986
		],
		"finger2-1.L": [
			-8.726646960610635e-9,
			4.363322858580432e-8,
			1.7453292144864436e-8,
			0.9999999999999989
		],
		"eye.L": [
			0,
			0,
			0,
			1
		],
		"tongue07.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"wrist.L": [
			0.03524605665082867,
			0.030438490974100008,
			0.3089085130461423,
			0.9499509167980247
		],
		"finger5-3.R": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"lowerleg01.R": [
			0.7517142774573309,
			2.884397402036498e-7,
			2.22916708486131e-7,
			0.6594889271751803
		],
		"lowerarm02.L": [
			-0.03823083215203702,
			0.00642292967442093,
			0.08152858883294609,
			0.9959167829945776
		],
		"oris07.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris07.R": [
			-2.617993999365347e-8,
			1.745329247793137e-8,
			8.726645628343018e-9,
			0.9999999999999994
		],
		"tongue00": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.R": [
			-2.6179939993653474e-8,
			8.726646627543744e-9,
			1.7453292144864476e-8,
			0.9999999999999994
		],
		"lowerleg01.L": [
			0.7945212298097296,
			3.3033157420536696e-7,
			-1.426304132620891e-7,
			0.6072363752127383
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			8.726646072432223e-9,
			-3.490658451177353e-8,
			-3.180207328966892e-16,
			0.9999999999999998
		],
		"metacarpal4.L": [
			8.726645628343013e-9,
			1.7453292255886765e-8,
			2.61799399936535e-8,
			0.9999999999999997
		],
		"finger1-2.R": [
			-8.726646072432215e-9,
			-5.235988020935167e-8,
			4.624224031074066e-16,
			0.9999999999999982
		],
		"pelvis.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-1.R": [
			5.235987998730683e-8,
			8.726646294476836e-9,
			4.4331856927593173e-16,
			0.9999999999999987
		],
		"toe2-3.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe5-3.L": [
			0,
			0,
			0,
			1
		],
		"levator05.L": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"finger4-1.L": [
			-8.726645184253878e-9,
			-2.617993988263123e-8,
			2.6179939993653474e-8,
			0.9999999999999991
		],
		"finger4-1.R": [
			-2.6179940881831897e-8,
			-2.6179940992854256e-8,
			-2.6179939105475064e-8,
			0.9999999999999988
		],
		"levator05.R": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"toe5-3.R": [
			6.981316857945735e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999974
		],
		"toe2-3.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.L": [
			-2.617993821729663e-8,
			-6.108652439440476e-8,
			2.6179941770010327e-8,
			0.9999999999999977
		],
		"toe2-1.L": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"finger1-2.L": [
			6.108652428338193e-8,
			3.490658440075123e-8,
			-8.726643851989352e-9,
			0.9999999999999974
		],
		"pelvis.L": [
			-0.5449585876448417,
			-1.7303118127198758e-7,
			-3.1426273252957873e-7,
			0.8384629614669991
		],
		"metacarpal4.R": [
			4.569261529843786e-16,
			-1.745329203384216e-8,
			2.6179939993653514e-8,
			0.9999999999999997
		],
		"tongue04": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe3-2.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator03.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"upperleg02.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperleg02.L": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"levator03.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"toe3-2.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal3.L": [
			-8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"tongue01": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"breast.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"temporalis02.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue02": [
			0,
			0,
			0,
			1
		],
		"oris04.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"oris04.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"temporalis02.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"breast.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"oris03.R": [
			1.5230870001493993e-16,
			8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"oris06.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"orbicularis04.R": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe1-2.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe1-2.L": [
			3.4906584289728866e-8,
			-5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"orbicularis04.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"metacarpal3.R": [
			8.726646072432225e-9,
			6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"oris06.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"levator04.L": [
			-8.726646072432225e-9,
			2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"tongue06.L": [
			0,
			0,
			0,
			1
		],
		"toe2-2.L": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"toe2-2.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"tongue06.R": [
			0,
			0,
			0,
			1
		],
		"levator04.R": [
			-8.726646072432225e-9,
			-2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"toe4-1.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperleg01.R": [
			-0.5319114890539569,
			-8.429568598700143e-9,
			-4.623222369148173e-8,
			0.8467999573762389
		],
		"metacarpal1.R": [
			-8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"levator02.R": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"toe3-1.L": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"toe3-1.R": [
			0,
			0,
			0,
			1
		],
		"levator02.L": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger5-1.R": [
			1.7453290368507637e-8,
			-5.235988020935167e-8,
			-3.490658606608566e-8,
			0.9999999999999979
		],
		"metacarpal1.L": [
			-2.6179939993653497e-8,
			8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"toe4-1.R": [
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"upperleg01.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"head": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-1.R": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"special04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal2.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"metacarpal2.R": [
			8.726645628343025e-9,
			8.726645517320719e-9,
			2.6179939993653497e-8,
			0.9999999999999994
		],
		"temporalis01.R": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"toe5-1.L": [
			-3.4906584289728866e-8,
			5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"risorius02.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"special05.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger2-2.L": [
			-4.363322858580419e-8,
			-4.440892098500626e-16,
			-1.7453292253300258e-8,
			0.9999999999999987
		],
		"foot.L": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"oris06": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.R": [
			2.6179939993653517e-8,
			-3.4906584733818136e-8,
			-8.72664696061073e-9,
			0.9999999999999996
		],
		"orbicularis03.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"levator06.L": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"orbicularis03.L": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"foot.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			-8.726645628343032e-9,
			8.726645295276114e-9,
			-3.490658428972877e-8,
			0.9999999999999992
		],
		"risorius02.L": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"special05.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"lowerleg02.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue05.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger5-1.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"toe4-3.R": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"oris03.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe4-3.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-3.L": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"tongue05.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"lowerleg02.R": [
			-6.108652428338213e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"shoulder01.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"finger3-1.L": [
			-2.6179939993653497e-8,
			8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"special06.R": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"finger4-3.L": [
			3.490658428972884e-8,
			2.6179941325921163e-8,
			-1.7453291256685967e-8,
			0.999999999999999
		],
		"finger3-2.L": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"upperarm01.R": [
			0.16237526440228778,
			0.4580098299413413,
			0.09029176860513961,
			0.8693150554945812
		],
		"finger3-2.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"upperarm01.L": [
			-8.173464696571948e-8,
			-0.4158963481752428,
			-0.004153292274476903,
			0.9094025388890081
		],
		"special06.L": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"finger3-1.R": [
			-8.726646516521438e-9,
			-3.490658440075123e-8,
			-8.726645628343022e-9,
			0.9999999999999994
		],
		"shoulder01.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"lowerarm01.R": [
			2.617993999365347e-8,
			2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"upperarm02.L": [
			0.06760502886821218,
			-0.1399945668678544,
			-0.10682146931337391,
			0.9820490084577969
		],
		"spine02": [
			0,
			0,
			0,
			1
		],
		"spine03": [
			-0.08447263673550874,
			0,
			0,
			0.9964257993663908
		],
		"spine01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.R": [
			0,
			0,
			-5.2359879987306856e-8,
			0.9999999999999987
		],
		"spine04": [
			0.07949650041154765,
			0,
			0,
			0.9968351450577558
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			0.09411667957018222,
			0.0010871880621227126,
			-0.10885362102757479,
			0.9895917126966992
		],
		"finger5-3.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"oris01": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris02": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris05": [
			0,
			0,
			0,
			1
		],
		"risorius03.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"finger2-3.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"toe3-3.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger3-3.R": [
			2.6179939993653504e-8,
			1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		],
		"finger2-3.R": [
			-3.49065842897288e-8,
			1.7453293477132092e-8,
			1.7453291256685666e-8,
			0.9999999999999992
		],
		"toe3-3.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"risorius03.L": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		]
	},
	"lie_pensive_01": {
		"toe1-1.L": [
			0.18770293459446358,
			-0.0013939646159141228,
			0.035244434807293765,
			0.9815923262854034
		],
		"finger5-2.R": [
			0.07834837459096124,
			0.08164905617957074,
			0.264058825990358,
			0.957845446948793
		],
		"finger1-3.R": [
			0.09150195977324703,
			-0.013867554293006679,
			-0.03646251126961454,
			0.9950404853911717
		],
		"toe5-2.R": [
			-2.617993999365347e-8,
			-2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"toe4-2.R": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"clavicle.R": [
			0.01518617986112712,
			-0.03491768778011295,
			-0.06028597645361177,
			0.997454628574328
		],
		"neck03": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"neck02": [
			0.09461843832906305,
			-0.02671210074988506,
			-0.007708559739376448,
			0.9951253151781646
		],
		"neck01": [
			-0.30799669831046,
			-0.16406208965539748,
			-0.03243699074760315,
			0.9365732786061108
		],
		"clavicle.L": [
			0.00009079537078201584,
			0.026105253009038543,
			0.006984379019548689,
			0.9996347962987514
		],
		"toe5-2.L": [
			-3.4906584289728866e-8,
			-8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"toe4-2.L": [
			-1.5230870001493986e-16,
			1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"finger5-2.L": [
			1.745329214486444e-8,
			8.726646627543744e-9,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"finger1-3.L": [
			-0.016330253352456914,
			-0.000188197070964069,
			-0.032691295303116756,
			0.9993320602375926
		],
		"toe1-1.R": [
			-2.617993999365353e-8,
			-1.745329336610979e-8,
			-1.7453291256686023e-8,
			0.9999999999999997
		],
		"oculi02.L": [
			8.72664651652143e-9,
			-2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"oculi01.L": [
			1.745329214486445e-8,
			1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"jaw": [
			0,
			0,
			0,
			1
		],
		"finger4-2.R": [
			0.2194142470258992,
			0.14772524391154662,
			0.3605437952058424,
			0.8944511234561111
		],
		"oculi01.R": [
			1.745329303304289e-8,
			-3.490658440075123e-8,
			2.617993910547502e-8,
			0.9999999999999988
		],
		"oculi02.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"wrist.R": [
			-0.033434430869876706,
			0.13635488193305612,
			0.03245466172786765,
			0.9895636310705639
		],
		"finger1-1.L": [
			-0.09050600635958311,
			0.11148470095109664,
			-0.04961239776848711,
			0.9883918424665112
		],
		"tongue07.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"eye.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"finger2-1.R": [
			0.27322215053297083,
			0.1716903950870523,
			0.1837334191729565,
			0.9285009937377583
		],
		"finger4-3.R": [
			0.09511476201387004,
			0.05737388809785182,
			0.16156272435702723,
			0.9805910998524896
		],
		"finger2-1.L": [
			0.021907320630865156,
			-0.023671634525848417,
			0.0018449020357572488,
			0.9994780234493053
		],
		"eye.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue07.L": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"wrist.L": [
			-0.05032136448004301,
			0.06136567910129176,
			0.0695867372627229,
			0.9944142495471555
		],
		"finger5-3.R": [
			0.052825546377354815,
			0.0507743797072594,
			0.1818563385820078,
			0.9805915031922433
		],
		"lowerleg01.R": [
			0.6382431321487948,
			-0.06401381318857091,
			0.019388300199233932,
			0.7669237444500848
		],
		"lowerarm02.L": [
			4.3633228585804086e-8,
			1.7453292144864463e-8,
			8.726646960611766e-9,
			0.9999999999999989
		],
		"oris07.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"oris07.R": [
			1.7453292144864443e-8,
			6.661338147750939e-16,
			-2.6179940059872455e-8,
			0.9999999999999999
		],
		"tongue00": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm02.R": [
			-8.726646516521438e-9,
			3.490658440075123e-8,
			8.726645628343022e-9,
			0.9999999999999994
		],
		"lowerleg01.L": [
			-0.0899164474806794,
			-0.006201326298637899,
			0.00669371416539831,
			0.9959075108740086
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			0.06945905521716052,
			-0.0006772386094984206,
			-0.07119854174354662,
			0.9950405763835959
		],
		"metacarpal4.L": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger1-2.R": [
			0.08940236187448215,
			-0.011005483921777026,
			-0.04219581748867453,
			0.9950405067138595
		],
		"pelvis.R": [
			-1.745329214486445e-8,
			3.3306690738754696e-16,
			4.3633228449276404e-8,
			0.9999999999999991
		],
		"toe2-1.R": [
			-6.981316857945738e-8,
			-4.363322914091583e-8,
			-8.726642963806366e-9,
			0.9999999999999968
		],
		"toe2-3.L": [
			1.745329214486445e-8,
			-8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"toe5-3.L": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"levator05.L": [
			2.6179939993653477e-8,
			-2.6179940548765046e-8,
			-8.726646960610674e-9,
			0.9999999999999996
		],
		"finger4-1.L": [
			-3.490658073701534e-8,
			7.85398202030052e-8,
			-4.36332321385178e-8,
			0.9999999999999952
		],
		"finger4-1.R": [
			0.1349947935792021,
			0.07559294591492793,
			0.24206141065616943,
			0.9578457003638723
		],
		"levator05.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"toe5-3.R": [
			-8.726646516521438e-9,
			3.490658440075123e-8,
			8.726645628343022e-9,
			0.9999999999999994
		],
		"toe2-3.R": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"finger4-2.L": [
			1.7453291256686053e-8,
			-2.617993988263123e-8,
			-1.745329303304289e-8,
			0.9999999999999994
		],
		"toe2-1.L": [
			0.1418290272767858,
			-0.015298553742688292,
			0.036354249905917534,
			0.9891050752012552
		],
		"finger1-2.L": [
			0.17719514552061763,
			0.22472150147031122,
			-0.43775941208434876,
			0.8523314052130314
		],
		"pelvis.L": [
			-8.726646072432225e-9,
			3.3306690738754696e-16,
			3.490658409227928e-8,
			0.9999999999999994
		],
		"metacarpal4.R": [
			-5.235987998730683e-8,
			8.726646627543744e-9,
			8.726645628343008e-9,
			0.9999999999999987
		],
		"tongue04": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe3-2.L": [
			1.7453291256686047e-8,
			1.7453291478730648e-8,
			2.6179939993653507e-8,
			0.9999999999999994
		],
		"levator03.R": [
			8.726646072432215e-9,
			5.235988020935167e-8,
			4.624224031074066e-16,
			0.9999999999999982
		],
		"upperleg02.R": [
			-0.07732783780796275,
			-0.0012917372968179741,
			0.0032194854744184848,
			0.9969996849688477
		],
		"upperleg02.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"levator03.L": [
			8.726646072432215e-9,
			-5.235988020935167e-8,
			-4.624224031074066e-16,
			0.9999999999999982
		],
		"toe3-2.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"metacarpal3.L": [
			-2.6179939993653487e-8,
			7.771561172376096e-16,
			2.6179939958862843e-8,
			0.9999999999999994
		],
		"tongue01": [
			0,
			0,
			0,
			1
		],
		"breast.L": [
			-1.7453292144864446e-8,
			1.7453292366909068e-8,
			-1.745329214486445e-8,
			0.9999999999999997
		],
		"temporalis02.R": [
			-3.490658428972886e-8,
			-1.1102230246251565e-16,
			-8.726646072432225e-9,
			0.9999999999999993
		],
		"tongue02": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris04.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"oris04.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"temporalis02.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"breast.R": [
			8.726646516521448e-9,
			8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"oris03.R": [
			8.726645628343061e-9,
			-8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"oris06.L": [
			8.726644740164625e-9,
			5.235987998730707e-8,
			2.617994088183188e-8,
			0.9999999999999984
		],
		"orbicularis04.R": [
			3.4906584289728866e-8,
			-5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"toe1-2.R": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"toe1-2.L": [
			0.06401895297568982,
			0.016113968416834212,
			-0.004773554068549069,
			0.9978071591561729
		],
		"orbicularis04.L": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"metacarpal3.R": [
			-8.726645628343032e-9,
			2.617993988263123e-8,
			-8.726646516521458e-9,
			0.9999999999999997
		],
		"oris06.R": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"levator04.L": [
			9.138523059687561e-16,
			3.4906584289728926e-8,
			-2.6179939993653487e-8,
			0.999999999999999
		],
		"tongue06.L": [
			8.726646072432225e-9,
			-3.3306690738754696e-16,
			3.490658409227928e-8,
			0.9999999999999994
		],
		"toe2-2.L": [
			8.726645628343032e-9,
			-2.617993988263123e-8,
			-8.726646516521458e-9,
			0.9999999999999997
		],
		"toe2-2.R": [
			-8.72664651652143e-9,
			2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"tongue06.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"levator04.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe4-1.L": [
			0.14182848201416973,
			-0.015298060392591184,
			0.036353586674377235,
			0.9891051853941972
		],
		"upperleg01.R": [
			0.08870203576580188,
			-0.08736210891156115,
			0.06865729028999383,
			0.9898413950060698
		],
		"metacarpal1.R": [
			2.6179940881831904e-8,
			-1.7453293255087488e-8,
			4.363322858580429e-8,
			0.9999999999999984
		],
		"levator02.R": [
			0,
			2.6179939993653504e-8,
			1.1102230246251565e-16,
			0.9999999999999998
		],
		"toe3-1.L": [
			0.14182881972000128,
			-0.015298563391817788,
			0.03635419055526502,
			0.9891051069952319
		],
		"toe3-1.R": [
			-4.3633228585804086e-8,
			-1.7453292144864463e-8,
			8.726646960611766e-9,
			0.9999999999999989
		],
		"levator02.L": [
			1.7453292144864446e-8,
			-3.490658440075123e-8,
			8.726645628343005e-9,
			0.9999999999999993
		],
		"finger5-1.R": [
			0.07458257648329654,
			0.06648359070081633,
			0.2693462180378738,
			0.957846535871657
		],
		"metacarpal1.L": [
			-8.726646072432212e-9,
			-6.661338147750939e-16,
			-4.363322873131176e-8,
			0.9999999999999994
		],
		"toe4-1.R": [
			-6.981316857945734e-8,
			-4.363322902989353e-8,
			8.726649181055347e-9,
			0.9999999999999966
		],
		"upperleg01.L": [
			0.07514372668830213,
			0.07233121665558706,
			-0.13006891926420183,
			0.986003900437498
		],
		"head": [
			-0.1461149013715308,
			-0.21769957625585856,
			0.21097768034867712,
			0.9416717838450395
		],
		"toe5-1.R": [
			-2.6179939993653527e-8,
			-4.3633228474782015e-8,
			-8.7266447401645e-9,
			0.9999999999999987
		],
		"special01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			-6.853892559463472e-16,
			-2.617993988263123e-8,
			-2.6179939993653514e-8,
			0.9999999999999993
		],
		"special04": [
			0,
			0,
			0,
			1
		],
		"metacarpal2.L": [
			-1.7453292144864443e-8,
			-8.726645850387627e-9,
			2.6179939993653534e-8,
			0.9999999999999996
		],
		"metacarpal2.R": [
			-4.3633228585804185e-8,
			-7.771561172376096e-16,
			-2.6179939951169008e-8,
			0.9999999999999984
		],
		"temporalis01.R": [
			-9.13852305968756e-16,
			2.6179939993653534e-8,
			3.4906584289728846e-8,
			0.9999999999999991
		],
		"toe5-1.L": [
			0.14182890409614815,
			-0.01529809386559633,
			0.036353708999524746,
			0.989105119857815
		],
		"risorius02.R": [
			-8.726646516521441e-9,
			2.6179940104675836e-8,
			8.726645628343022e-9,
			0.9999999999999998
		],
		"special05.L": [
			1.745329214486444e-8,
			4.440892098500626e-16,
			-1.7453292016352737e-8,
			0.9999999999999994
		],
		"finger2-2.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"foot.L": [
			0.44819366351237416,
			0.10193234431486065,
			0.10356431891527078,
			0.8820468632773715
		],
		"oris06": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"orbicularis03.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"levator06.L": [
			-1.7453291256686007e-8,
			8.72664507323151e-9,
			-5.235987998730687e-8,
			0.9999999999999984
		],
		"orbicularis03.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"foot.R": [
			0.34787153874637966,
			-0.09440048949346369,
			-0.06129481508121524,
			0.9307614548087925
		],
		"root": [
			0.6285553439251521,
			0.26866443281068775,
			-0.2308272280196306,
			0.6924278973080289
		],
		"finger2-2.R": [
			0.21276080355661556,
			0.13397708172923717,
			0.13899273686468747,
			0.9578434115971799
		],
		"risorius02.L": [
			-1.7453292144864453e-8,
			-2.6179939993653534e-8,
			8.726646516521464e-9,
			0.9999999999999997
		],
		"special05.R": [
			-1.5230870001493986e-16,
			1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"lowerleg02.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue05.L": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"finger5-1.L": [
			-0.042445782549622516,
			0.03038056754174845,
			0.04449589587781333,
			0.9976449728784396
		],
		"toe4-3.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris03.L": [
			-1.745329214486445e-8,
			-1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"toe4-3.L": [
			8.726645628343025e-9,
			8.726645517320719e-9,
			2.6179939993653497e-8,
			0.9999999999999994
		],
		"finger3-3.L": [
			2.617994265818873e-8,
			5.235988198570851e-8,
			-5.235987821094996e-8,
			0.9999999999999971
		],
		"tongue05.R": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"lowerleg02.R": [
			-4.569261529843785e-16,
			-2.617993988263123e-8,
			-1.745329214486445e-8,
			0.9999999999999996
		],
		"shoulder01.R": [
			-0.14735869358174727,
			-0.014896234630995209,
			-0.31146022756368774,
			0.9386458566816749
		],
		"finger3-1.L": [
			1.745329303304289e-8,
			-3.490658440075123e-8,
			2.617993910547502e-8,
			0.9999999999999988
		],
		"special06.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger4-3.L": [
			-8.72664562834302e-9,
			3.4906584289728926e-8,
			-8.726646516521445e-9,
			0.9999999999999994
		],
		"finger3-2.L": [
			3.8077175003734897e-16,
			4.363322869682662e-8,
			-8.726646072432225e-9,
			0.9999999999999991
		],
		"upperarm01.R": [
			-0.6249063817863207,
			-0.16600743954749475,
			0.22377060356333106,
			0.7292875022914603
		],
		"finger3-2.R": [
			0.21528604211966498,
			0.16042848963019074,
			0.2565282776376394,
			0.9284976373452396
		],
		"upperarm01.L": [
			-0.3798945123935055,
			-0.3243261272816831,
			0.015582530904405785,
			0.8661696758409284
		],
		"special06.L": [
			0,
			0,
			0,
			1
		],
		"finger3-1.R": [
			0.210397332416203,
			0.13960675524920452,
			0.27227217802003656,
			0.9284992070417505
		],
		"shoulder01.L": [
			0.00020927347567105284,
			0.060193007767500806,
			0.016104676785817406,
			0.9980568107107625
		],
		"lowerarm01.R": [
			-0.5956567028761134,
			0.45493316500805303,
			-0.12801753791059492,
			0.6494924308118011
		],
		"special03": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.L": [
			1.745329214486445e-8,
			-8.726645406298417e-9,
			-2.6179939993653613e-8,
			0.9999999999999994
		],
		"spine02": [
			-0.05253893459460895,
			0.06209050553299089,
			-0.00421122785239928,
			0.9966778291074283
		],
		"spine03": [
			0.03694450788668977,
			0.0006152443229289206,
			0.000974416417129576,
			0.999316654181286
		],
		"spine01": [
			-0.10228983072233229,
			0.000998690641026534,
			-0.0055481404101974195,
			0.994738664818951
		],
		"upperarm02.R": [
			0.22388873163256684,
			0.24996304021436777,
			-0.01108511892847643,
			0.9419498046674744
		],
		"spine04": [
			-0.02123512929742559,
			-0.00038529393392838784,
			0.00006062513435758212,
			0.9997744331382448
		],
		"spine05": [
			4.3633228585804066e-8,
			1.7453290479529926e-8,
			3.490658428972878e-8,
			0.9999999999999984
		],
		"lowerarm01.L": [
			-0.3130439060314853,
			-0.3992435410958357,
			0.4159986013009385,
			0.7546875323638726
		],
		"finger5-3.L": [
			-2.617994088183191e-8,
			1.7453293144065185e-8,
			3.490658428972874e-8,
			0.9999999999999989
		],
		"oris01": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris02": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger2-3.L": [
			1.7453292144864443e-8,
			8.726646738566046e-9,
			-3.490658428972891e-8,
			0.9999999999999996
		],
		"toe3-3.R": [
			-4.363322858580416e-8,
			-2.617994021569814e-8,
			1.1643607064032247e-15,
			0.9999999999999988
		],
		"finger3-3.R": [
			0.11357367015656608,
			0.08260617814427695,
			0.13682432735514205,
			0.9805897940644583
		],
		"finger2-3.R": [
			0.14454222174842085,
			0.09758220481784474,
			0.08960878416526713,
			0.980589376464655
		],
		"toe3-3.L": [
			1.7453292144864453e-8,
			-2.6179939993653534e-8,
			-8.726646516521464e-9,
			0.9999999999999997
		],
		"risorius03.L": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		]
	},
	"Harvey_Super1": {
		"toe1-1.L": [
			-0.28472205953004526,
			-0.03619614016300654,
			0.013867092354055819,
			0.9578261282737665
		],
		"finger5-2.R": [
			-8.726645184253789e-9,
			3.4906584178706623e-8,
			-2.617993999365348e-8,
			0.999999999999999
		],
		"finger1-3.R": [
			-0.09224075544836863,
			0.01447497376696738,
			0.03439714515097951,
			0.9950371624086322
		],
		"toe5-2.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"toe4-2.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"clavicle.R": [
			-0.28376385841548113,
			0.04524280726719787,
			-0.0005525697213470711,
			0.9578261093301047
		],
		"neck03": [
			-0.1961165689959565,
			-1.7114398787043683e-9,
			-8.557179777234364e-9,
			0.9805805889192658
		],
		"neck02": [
			-0.09938100069537172,
			-0.014300363758561252,
			0.04758828693729748,
			0.9938079649728782
		],
		"neck01": [
			-0.09841380052497846,
			0.014175630208589252,
			-0.14693848890295985,
			0.9841355881449132
		],
		"clavicle.L": [
			0,
			0,
			0,
			1
		],
		"toe5-2.L": [
			-8.726646516521438e-9,
			-3.490658440075123e-8,
			-8.726645628343022e-9,
			0.9999999999999994
		],
		"toe4-2.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger5-2.L": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"finger1-3.L": [
			0.09224074183185865,
			0.014474970314522717,
			0.03439712088531806,
			0.9950371645599486
		],
		"toe1-1.R": [
			-0.2847221624777066,
			0.03619614113886749,
			-0.013867114440513518,
			0.9578260973150439
		],
		"oculi02.L": [
			4.569261529843784e-16,
			1.7453292255886765e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"oculi01.L": [
			-1.7453291256686083e-8,
			-2.617993899445281e-8,
			2.6179940881832245e-8,
			0.9999999999999991
		],
		"jaw": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"finger4-2.R": [
			3.4906584289728793e-8,
			1.7453291478730648e-8,
			2.617994088183205e-8,
			0.9999999999999991
		],
		"oculi01.R": [
			-8.726646960610626e-9,
			3.4906584178706623e-8,
			2.6179939993653494e-8,
			0.999999999999999
		],
		"oculi02.R": [
			2.6179939993653494e-8,
			1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"wrist.R": [
			-0.18885610454623955,
			-0.20332288692814038,
			-0.5629681136581708,
			0.7784986052851907
		],
		"finger1-1.L": [
			8.726645628343025e-9,
			8.726645517320719e-9,
			2.6179939993653497e-8,
			0.9999999999999994
		],
		"tongue07.R": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"eye.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger2-1.R": [
			1.7453292144864443e-8,
			-2.220446049250313e-16,
			2.6179940054284205e-8,
			0.9999999999999996
		],
		"finger4-3.R": [
			0.04836989736620531,
			0.03545515055188575,
			0.07939966537703926,
			0.9950371744141725
		],
		"finger2-1.L": [
			1.745329214486445e-8,
			-8.726645406298417e-9,
			-2.6179939993653613e-8,
			0.9999999999999994
		],
		"eye.L": [
			2.617993999365346e-8,
			-3.4906584733818136e-8,
			-1.0095481158786604e-15,
			0.9999999999999991
		],
		"tongue07.L": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"wrist.L": [
			-0.054060315622325175,
			0.30179628214441456,
			0.4846189790960576,
			0.8192319155517064
		],
		"finger5-3.R": [
			0.1019677186824649,
			0.1259476721900361,
			0.3341722714519192,
			0.9284765270103867
		],
		"lowerleg01.R": [
			0.9597147360646074,
			-0.10227437164645953,
			-0.02034049110901851,
			0.26090964471672307
		],
		"lowerarm02.L": [
			-3.490658428972885e-8,
			1.7453292144864463e-8,
			-6.052891516783062e-16,
			0.9999999999999991
		],
		"oris07.L": [
			5.235987998730684e-8,
			8.881784197001252e-16,
			-1.7453292120936186e-8,
			0.9999999999999983
		],
		"oris07.R": [
			-2.6179940881831887e-8,
			1.7453293255087488e-8,
			2.6179939105475074e-8,
			0.9999999999999993
		],
		"tongue00": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"lowerarm02.R": [
			-1.745329214486445e-8,
			-1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"lowerleg01.L": [
			0.808971768727801,
			0.08621008147553921,
			0.017145726644551426,
			0.5812387833853009
		],
		"tongue03": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"finger1-1.R": [
			-0.1386206721186621,
			0.00818659125259813,
			0.13848830094511072,
			0.9805805828621991
		],
		"metacarpal4.L": [
			8.72664696061062e-9,
			-2.6179939993653534e-8,
			3.490658428972884e-8,
			0.9999999999999991
		],
		"finger1-2.R": [
			0.3025418348494524,
			0.14011984527970223,
			-0.0622852168555875,
			0.9407206912181593
		],
		"pelvis.R": [
			-0.44459842800598154,
			-0.020434210097922567,
			-0.04376399673431242,
			0.8944268519348705
		],
		"toe2-1.R": [
			-0.28507233482999744,
			0.03330747983284987,
			-0.013911244558334748,
			0.9578261079009053
		],
		"toe2-3.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"toe5-3.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"levator05.L": [
			1.1423153030516055e-15,
			-4.363322858580432e-8,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"finger4-1.L": [
			-2.6179940881831887e-8,
			1.7453293255087488e-8,
			2.6179939105475074e-8,
			0.9999999999999993
		],
		"finger4-1.R": [
			8.726645184253789e-9,
			-3.4906584178706623e-8,
			-2.617993999365348e-8,
			0.999999999999999
		],
		"levator05.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"toe5-3.R": [
			2.6179939993653477e-8,
			8.726645517320719e-9,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"toe2-3.R": [
			-8.72664696061065e-9,
			-6.108652461644937e-8,
			-1.7453291256685984e-8,
			0.9999999999999982
		],
		"finger4-2.L": [
			1.7453292144864443e-8,
			-2.6179940104675836e-8,
			8.726645628343028e-9,
			0.9999999999999997
		],
		"toe2-1.L": [
			-0.2850722837246352,
			-0.03330743059286112,
			0.013911254440149195,
			0.9578261246798523
		],
		"finger1-2.L": [
			0.07133404539584681,
			-0.2669152574760656,
			-0.0789714419974424,
			0.9578262946081573
		],
		"pelvis.L": [
			-0.5114869239732156,
			0.023508469431530066,
			0.05034815810390419,
			0.8574925897317996
		],
		"metacarpal4.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue04": [
			0,
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0.9999999999999992
		],
		"toe3-2.L": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"levator03.R": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"upperleg02.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"upperleg02.L": [
			-0.09840253986475171,
			-0.01463494027833856,
			-0.0019491878383837973,
			0.9950371648023941
		],
		"levator03.L": [
			-9.138523059687567e-16,
			3.4906584178706623e-8,
			2.6179939993653468e-8,
			0.9999999999999989
		],
		"toe3-2.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"metacarpal3.L": [
			-8.726644740164569e-9,
			3.4906584178706623e-8,
			-3.490658428972887e-8,
			0.9999999999999988
		],
		"tongue01": [
			-2.617993999365348e-8,
			1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		],
		"breast.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis02.R": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"tongue02": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"oris04.R": [
			-8.726646516521428e-9,
			5.235987998730707e-8,
			8.726645628342985e-9,
			0.9999999999999987
		],
		"oris04.L": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"temporalis02.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"breast.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris03.R": [
			-1.7453292144864446e-8,
			1.7453292366909068e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"oris06.L": [
			-6.10865242833821e-8,
			-1.7453293144065185e-8,
			-1.7453291256684746e-8,
			0.9999999999999979
		],
		"orbicularis04.R": [
			-1.7453292144864453e-8,
			-2.6179939993653534e-8,
			8.726646516521464e-9,
			0.9999999999999997
		],
		"toe1-2.R": [
			-1.7453292144864436e-8,
			4.363322869682662e-8,
			-6.702088926697263e-16,
			0.9999999999999991
		],
		"toe1-2.L": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"orbicularis04.L": [
			-2.617993910547506e-8,
			-4.3633228918871225e-8,
			1.745329303304283e-8,
			0.9999999999999987
		],
		"metacarpal3.R": [
			2.7415568120271375e-15,
			-3.4906584178706623e-8,
			7.853981998096016e-8,
			0.9999999999999962
		],
		"oris06.R": [
			-2.6179940881831887e-8,
			-2.617994110387656e-8,
			-1.745329125668601e-8,
			0.9999999999999994
		],
		"levator04.L": [
			8.726646072432223e-9,
			-3.490658451177353e-8,
			-3.180207328966892e-16,
			0.9999999999999998
		],
		"tongue06.L": [
			1.5230870001493993e-16,
			8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe2-2.L": [
			-8.726645628343032e-9,
			2.617993988263123e-8,
			-8.726646516521458e-9,
			0.9999999999999997
		],
		"toe2-2.R": [
			2.6179939993653504e-8,
			1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		],
		"tongue06.R": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"levator04.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"toe4-1.L": [
			-0.28564398716790723,
			-0.03124963258298441,
			-0.00032892669535267686,
			0.9578261141070846
		],
		"upperleg01.R": [
			-0.44348101405379886,
			-0.10430872563997651,
			-0.21488669656925022,
			0.8638680382828927
		],
		"metacarpal1.R": [
			8.726645628343013e-9,
			1.7453292255886765e-8,
			2.61799399936535e-8,
			0.9999999999999997
		],
		"levator02.R": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe3-1.L": [
			-0.28560721065832534,
			-0.03147816422856986,
			0.0026025241695640743,
			0.9578261184916168
		],
		"toe3-1.R": [
			-0.1949282228346003,
			0.02148400395187633,
			-0.0017762279946036768,
			0.9805805782957622
		],
		"levator02.L": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"finger5-1.R": [
			1.745329214486444e-8,
			4.440892098500626e-16,
			-1.7453292016352737e-8,
			0.9999999999999994
		],
		"metacarpal1.L": [
			2.6179939993653507e-8,
			4.440892098500626e-16,
			-1.745329219192525e-8,
			0.9999999999999997
		],
		"toe4-1.R": [
			-0.19495330397616534,
			0.021328016321343735,
			0.00022448536855645935,
			0.9805805803680253
		],
		"upperleg01.L": [
			-0.617373677128124,
			0.10533548897496336,
			0.17239451706001513,
			0.7602856752822247
		],
		"head": [
			8.183351662378088e-9,
			0.2897765213286029,
			0.08329858407218788,
			0.9534625915987802
		],
		"toe5-1.R": [
			-0.19496440328254527,
			0.02030031925666087,
			0.006205292938323589,
			0.9805805794682599
		],
		"special01": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"temporalis01.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"special04": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"metacarpal2.L": [
			2.6179939105475045e-8,
			2.617993977160893e-8,
			1.745329303304287e-8,
			0.9999999999999997
		],
		"metacarpal2.R": [
			-1.7453292144864446e-8,
			4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"temporalis01.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-1.L": [
			-0.2856602593141116,
			-0.029743826206886204,
			-0.009091961534019947,
			0.9578261101508109
		],
		"risorius02.R": [
			-1.745329214486444e-8,
			-3.490658451177353e-8,
			4.799202690040438e-16,
			0.9999999999999992
		],
		"special05.L": [
			8.726646072432223e-9,
			-3.490658451177353e-8,
			-3.180207328966892e-16,
			0.9999999999999998
		],
		"finger2-2.L": [
			2.6179939993653507e-8,
			-8.726645739365324e-9,
			-1.7453292144864397e-8,
			0.9999999999999994
		],
		"foot.L": [
			0.4445974045258838,
			0.0473786550770704,
			0.009422578235484645,
			0.8944269819003293
		],
		"oris06": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"levator06.R": [
			8.726646516521443e-9,
			1.7453291811797556e-8,
			-2.6179939993653554e-8,
			0.9999999999999993
		],
		"orbicularis03.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"levator06.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"orbicularis03.L": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"foot.R": [
			-0.3692183409169675,
			0.039345812001092106,
			0.007824985358701162,
			0.9284764366491125
		],
		"root": [
			0.19611655550815552,
			1.1102230246251565e-16,
			0,
			0.9805805916168322
		],
		"finger2-2.R": [
			-5.23598799873068e-8,
			-3.4906584733818136e-8,
			8.726647848788919e-9,
			0.9999999999999982
		],
		"risorius02.L": [
			-8.72664651652143e-9,
			4.363322880784892e-8,
			8.726645628342965e-9,
			0.9999999999999992
		],
		"special05.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"lowerleg02.L": [
			-1.745329303304284e-8,
			5.235988009832937e-8,
			8.726645184253813e-9,
			0.9999999999999986
		],
		"tongue05.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"finger5-1.L": [
			2.6179939993653487e-8,
			-8.726645295276114e-9,
			-3.4906584289728926e-8,
			0.9999999999999988
		],
		"toe4-3.R": [
			-3.490658428972885e-8,
			-1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"oris03.L": [
			2.6179939993653477e-8,
			8.726645517320719e-9,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"toe4-3.L": [
			-8.72664651652143e-9,
			-4.363322880784892e-8,
			-8.726645628342965e-9,
			0.9999999999999992
		],
		"finger3-3.L": [
			0.11544471103059957,
			-0.09275129856397923,
			-0.12857444927153416,
			0.9805806067347437
		],
		"tongue05.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"lowerleg02.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"shoulder01.R": [
			-0.0068544769291048495,
			0.002304067198113824,
			0.099240864705738,
			0.9950371642269611
		],
		"finger3-1.L": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"special06.R": [
			0,
			-5.235987998730684e-8,
			-1.1102230246251565e-16,
			0.9999999999999987
		],
		"finger4-3.L": [
			0.1396830950015074,
			-0.1023876898222491,
			-0.22929121960190893,
			0.9578261483991402
		],
		"finger3-2.L": [
			1.7453291256686043e-8,
			1.745329114566374e-8,
			4.363322858580395e-8,
			0.9999999999999986
		],
		"upperarm01.R": [
			-0.032186631088589386,
			0.13943423363997864,
			0.19006857643477107,
			0.9712857723247357
		],
		"finger3-2.R": [
			1.7453293033042873e-8,
			-1.7453293144065185e-8,
			4.363322858580396e-8,
			0.9999999999999986
		],
		"upperarm01.L": [
			-0.042031385220862146,
			-0.270174258897692,
			-0.08836327071924588,
			0.9578262707157782
		],
		"special06.L": [
			8.726646516521441e-9,
			-2.6179940104675836e-8,
			8.726645628343022e-9,
			0.9999999999999998
		],
		"finger3-1.R": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"shoulder01.L": [
			-0.14038238582746942,
			-0.25024239334302556,
			0.015505879553936845,
			0.95782623581869
		],
		"lowerarm01.R": [
			0.14460574245551305,
			-0.13183551863750032,
			0.013047582715260707,
			0.9805806116071026
		],
		"special03": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"upperarm02.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"spine02": [
			0.09950396300933954,
			-1.1102230246251565e-16,
			0,
			0.995037165811125
		],
		"spine03": [
			0.09950396300933954,
			-1.1102230246251565e-16,
			0,
			0.995037165811125
		],
		"spine01": [
			0,
			0,
			0,
			1
		],
		"upperarm02.R": [
			0.1935841215039203,
			0.2123537972014773,
			0.00020964177181881437,
			0.9578261892253712
		],
		"spine04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"spine05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			0.07336883363088934,
			0.06688955517551409,
			-0.006620001434296494,
			0.9950371737985848
		],
		"finger5-3.L": [
			0.07889324983872682,
			-0.09744668518629618,
			-0.2585517793158341,
			0.9578261721673211
		],
		"oris01": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"oris02": [
			-2.617993999365348e-8,
			-1.745329247793137e-8,
			8.726646516521431e-9,
			0.9999999999999996
		],
		"oris05": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"risorius03.R": [
			-3.490658428972882e-8,
			-2.6179939993653534e-8,
			-8.726645184253818e-9,
			0.9999999999999988
		],
		"finger2-3.L": [
			0.21502932206529177,
			-0.1499366268185508,
			-0.11768775668584971,
			0.9578261796989407
		],
		"toe3-3.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger3-3.R": [
			-4.363323036216088e-8,
			-1.7453295031444327e-8,
			-5.2359879987306935e-8,
			0.999999999999998
		],
		"finger2-3.R": [
			0.1467584958725643,
			0.10233237344770918,
			0.08032244477769342,
			0.9805806107091428
		],
		"toe3-3.L": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"risorius03.L": [
			-3.490658428972882e-8,
			2.6179939993653534e-8,
			8.726645184253818e-9,
			0.9999999999999988
		]
	},
	"Harvey_Super2": {
		"toe1-1.L": [
			-4.36332285858041e-8,
			-8.726647071632954e-9,
			-1.7453292144865118e-8,
			0.9999999999999989
		],
		"finger5-2.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger1-3.R": [
			0.3442816905487777,
			-0.05402679209366523,
			-0.12838474793509397,
			0.928476483162921
		],
		"toe5-2.R": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"toe4-2.R": [
			-2.6179939993653527e-8,
			-4.3633228474782015e-8,
			-8.7266447401645e-9,
			0.9999999999999987
		],
		"clavicle.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"neck03": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"neck02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"neck01": [
			0,
			0,
			0,
			1
		],
		"clavicle.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-2.L": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"toe4-2.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger5-2.L": [
			0.027543657249595,
			-0.035470812392371154,
			-0.08879303813725895,
			0.9950371675429499
		],
		"finger1-3.L": [
			0.26637352599450564,
			0.04180091245291884,
			0.09933227687941253,
			0.9578261466139405
		],
		"toe1-1.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"oculi02.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oculi01.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"jaw": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			0.049095758852794935,
			0.040134873637545754,
			0.07668003549351317,
			0.9950371704300699
		],
		"oculi01.R": [
			-8.726645628343007e-9,
			1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"oculi02.R": [
			5.235987998730683e-8,
			1.7453293255087488e-8,
			-1.7453291256686007e-8,
			0.9999999999999984
		],
		"wrist.R": [
			-0.0940462943054617,
			-0.13102762743898666,
			0.2378151275739997,
			0.957826195336128
		],
		"finger1-1.L": [
			-3.490658428972881e-8,
			8.726646738566046e-9,
			2.617993999365343e-8,
			0.9999999999999992
		],
		"tongue07.R": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"eye.R": [
			8.726646072432225e-9,
			-2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"finger2-1.R": [
			-0.06495926585799534,
			0.06685169323625928,
			0.03481617239304356,
			0.9950371746977761
		],
		"finger4-3.R": [
			0.21739556835656637,
			0.15935075254249853,
			0.3568567432169261,
			0.8944270620591
		],
		"finger2-1.L": [
			-0.06495930485941365,
			-0.06685165616204258,
			-0.03481618729642259,
			0.9950371741210045
		],
		"eye.L": [
			-2.6179939993653484e-8,
			-2.6179940104675836e-8,
			8.045503725131716e-16,
			0.9999999999999991
		],
		"tongue07.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"wrist.L": [
			-0.0940463350170057,
			0.13102759813730847,
			-0.23781508850289337,
			0.9578262050479714
		],
		"finger5-3.R": [
			0.05384493975180548,
			0.06650792187414811,
			0.17646279040810894,
			0.9805805945420758
		],
		"lowerleg01.R": [
			0.09892173373854492,
			-0.010541795257721587,
			-0.0020965921656999776,
			0.995037167872736
		],
		"lowerarm02.L": [
			-0.2251133344360241,
			0.21514894271031548,
			-0.3209908400667941,
			0.8944270790304498
		],
		"oris07.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"oris07.R": [
			-2.6179939993653527e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"tongue00": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm02.R": [
			-0.1446419441656835,
			-0.13823962693828384,
			0.20624619821891482,
			0.9578261946993198
		],
		"lowerleg01.L": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"tongue03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			-1.745329303304289e-8,
			1.7453293144065185e-8,
			2.6179939993653494e-8,
			0.9999999999999993
		],
		"metacarpal4.L": [
			-2.6179939993653524e-8,
			-8.72664507323151e-9,
			3.4906584289729124e-8,
			0.999999999999999
		],
		"finger1-2.R": [
			2.617994088183186e-8,
			-4.363322880784892e-8,
			2.617993910547505e-8,
			0.9999999999999986
		],
		"pelvis.R": [
			-2.6179939993653527e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"toe2-1.R": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"toe2-3.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"toe5-3.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"levator05.L": [
			-1.745329214486445e-8,
			-1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"finger4-1.L": [
			1.7453290368507637e-8,
			5.235988020935167e-8,
			3.490658606608566e-8,
			0.9999999999999979
		],
		"finger4-1.R": [
			1.745329125668605e-8,
			-2.617993899445281e-8,
			-4.3633228585803e-8,
			0.9999999999999988
		],
		"levator05.R": [
			8.726645628343017e-9,
			1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"toe5-3.R": [
			2.6179939105474995e-8,
			-4.363322880784892e-8,
			-2.617994088183188e-8,
			0.9999999999999984
		],
		"toe2-3.R": [
			-3.046174000298792e-16,
			-3.490658440075123e-8,
			-8.726646072432198e-9,
			0.9999999999999992
		],
		"finger4-2.L": [
			0.0967649199255904,
			-0.07910345789903461,
			-0.15113199298145738,
			0.9805806004187838
		],
		"toe2-1.L": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"finger1-2.L": [
			0.3446576116424203,
			0.13040147514583666,
			-0.12941928902464644,
			0.9205744041874548
		],
		"pelvis.L": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"metacarpal4.R": [
			-1.7453292144864433e-8,
			2.617994021569814e-8,
			-4.927555263958927e-16,
			0.9999999999999996
		],
		"tongue04": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"toe3-2.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator03.R": [
			-2.6179939105475045e-8,
			-1.745329158975295e-8,
			2.6179940881831907e-8,
			0.9999999999999996
		],
		"upperleg02.R": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"upperleg02.L": [
			0.0023299147470715407,
			-0.0024205840790513244,
			-0.0994472276247368,
			0.9950371657318843
		],
		"levator03.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"toe3-2.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"metacarpal3.L": [
			-2.6179936440939776e-8,
			5.235987821095023e-8,
			-6.108652428338168e-8,
			0.9999999999999962
		],
		"tongue01": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"breast.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis02.R": [
			1.7453292144864443e-8,
			-2.6179940104675836e-8,
			8.726645628343028e-9,
			0.9999999999999997
		],
		"tongue02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris04.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"oris04.L": [
			6.092348000597591e-16,
			-1.745329203384216e-8,
			3.490658428972889e-8,
			0.9999999999999993
		],
		"temporalis02.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"breast.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris03.R": [
			3.490658428972883e-8,
			-1.3322676295501878e-15,
			3.4906584292733954e-8,
			0.999999999999999
		],
		"oris06.L": [
			-2.617993999365347e-8,
			-1.745329247793137e-8,
			-8.726645628343018e-9,
			0.9999999999999994
		],
		"orbicularis04.R": [
			-2.6179939993653504e-8,
			-1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		],
		"toe1-2.R": [
			-8.726645628343007e-9,
			1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"toe1-2.L": [
			-6.853892559463472e-16,
			2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"orbicularis04.L": [
			-6.108652428338209e-8,
			-2.6179939993653534e-8,
			1.6135134219578416e-15,
			0.999999999999998
		],
		"metacarpal3.R": [
			-3.0461740002987947e-16,
			8.726645961409929e-9,
			3.490658428972888e-8,
			0.9999999999999993
		],
		"oris06.R": [
			-2.617993999365347e-8,
			-2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"levator04.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue06.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"toe2-2.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe2-2.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"tongue06.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"levator04.R": [
			3.4906584289728906e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"toe4-1.L": [
			-3.490658428972885e-8,
			-1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"upperleg01.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"metacarpal1.R": [
			-8.726646072432225e-9,
			2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"levator02.R": [
			2.6179939105475025e-8,
			3.4906584289728926e-8,
			2.6179940881831904e-8,
			0.9999999999999988
		],
		"toe3-1.L": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe3-1.R": [
			0,
			0,
			0,
			1
		],
		"levator02.L": [
			8.726645628343023e-9,
			-1.745329203384216e-8,
			-2.6179939993653547e-8,
			0.9999999999999994
		],
		"finger5-1.R": [
			0.09181765745977075,
			-0.03550282700365959,
			-0.014494915982841966,
			0.9950371673781833
		],
		"metacarpal1.L": [
			-2.6179940881831877e-8,
			2.6179940992854256e-8,
			3.4906584289728846e-8,
			0.9999999999999988
		],
		"toe4-1.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"upperleg01.L": [
			-0.005172658129396219,
			0.03020824715972903,
			0.09466648041663935,
			0.995037166590746
		],
		"head": [
			-0.09950397754293931,
			1.1102230246251565e-16,
			2.465190328815662e-32,
			0.9950371643577614
		],
		"toe5-1.R": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			1.745329303304289e-8,
			1.745329292202058e-8,
			-2.6179939993653487e-8,
			0.9999999999999993
		],
		"special04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal2.L": [
			-3.490658428972884e-8,
			2.6179941325921163e-8,
			1.7453291256685967e-8,
			0.999999999999999
		],
		"metacarpal2.R": [
			-4.569261529843786e-16,
			1.745329203384216e-8,
			2.6179939993653514e-8,
			0.9999999999999997
		],
		"temporalis01.R": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"toe5-1.L": [
			-1.7453292144864443e-8,
			-2.6179940104675836e-8,
			-8.726645628343028e-9,
			0.9999999999999997
		],
		"risorius02.R": [
			-6.092348000597588e-16,
			-3.490658440075123e-8,
			-1.7453292144864443e-8,
			0.9999999999999992
		],
		"special05.L": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"finger2-2.L": [
			0.21575955557236845,
			-0.14295594790411537,
			-0.1248215038774184,
			0.9578261863761242
		],
		"foot.L": [
			0.011926399578702335,
			0.3395065037422612,
			-0.0398854003199802,
			0.9396819939485433
		],
		"oris06": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"levator06.R": [
			-1.7453291256686053e-8,
			3.4906584178706623e-8,
			-2.6179940881831874e-8,
			0.9999999999999988
		],
		"orbicularis03.R": [
			1.7453292144864443e-8,
			-2.6179940104675836e-8,
			8.726645628343028e-9,
			0.9999999999999997
		],
		"levator06.L": [
			-1.745329214486444e-8,
			-3.490658451177353e-8,
			4.799202690040438e-16,
			0.9999999999999992
		],
		"orbicularis03.L": [
			-4.363322858580416e-8,
			-2.617994021569814e-8,
			1.1643607064032247e-15,
			0.9999999999999988
		],
		"foot.R": [
			-0.11959006365575982,
			-0.20567050246367435,
			0.0013105803185993917,
			0.9712858196588579
		],
		"root": [
			2.2830923974207256e-10,
			-0.19406467619590484,
			0.0282917861425222,
			0.980580683212679
		],
		"finger2-2.R": [
			0.21575955544541667,
			0.14295594394372702,
			0.12482151861145321,
			0.9578261850757078
		],
		"risorius02.L": [
			-2.6179939993653504e-8,
			1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"special05.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"lowerleg02.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue05.L": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger5-1.L": [
			0.09181763910465479,
			0.03550285692670352,
			0.014494917986303629,
			0.9950371679750764
		],
		"toe4-3.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"oris03.L": [
			8.726646516521438e-9,
			-1.7453292366909068e-8,
			1.7453292144864456e-8,
			0.9999999999999996
		],
		"toe4-3.L": [
			2.6179939993653527e-8,
			8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"finger3-3.L": [
			0.11544467456718463,
			-0.09275129115531167,
			-0.12857449286558534,
			0.9805806060123038
		],
		"tongue05.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"lowerleg02.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"shoulder01.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger3-1.L": [
			-0.07855548635785824,
			-0.05106928208929895,
			-0.03349617397458428,
			0.9950371703202995
		],
		"special06.R": [
			4.3633228585804086e-8,
			-1.7453292144864463e-8,
			-8.726646960611766e-9,
			0.9999999999999989
		],
		"finger4-3.L": [
			0.09533433705211242,
			-0.06988010759775287,
			-0.15649221029461557,
			0.9805806049775133
		],
		"finger3-2.L": [
			0.1155452057661438,
			-0.09448866757097629,
			-0.12721183496820476,
			0.9805806168638778
		],
		"upperarm01.R": [
			0.14696134030904134,
			-0.11718668081881956,
			0.11085516359935314,
			0.9758999841154824
		],
		"finger3-2.R": [
			0.11554520522411611,
			0.09448866373240594,
			0.12721186787750088,
			0.9805806130282703
		],
		"upperarm01.L": [
			0.1469613302457562,
			0.11718667296811602,
			-0.11085521107580973,
			0.9758999811806532
		],
		"special06.L": [
			6.108652428338212e-8,
			-8.726646405499139e-9,
			-4.661919405738096e-16,
			0.9999999999999984
		],
		"finger3-1.R": [
			-0.07855548641336192,
			0.051069295263113546,
			0.03349611709008376,
			0.9950371715546994
		],
		"shoulder01.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"lowerarm01.R": [
			-0.2543135000082755,
			-0.11575856195352818,
			0.2592760329291823,
			0.9245001556497966
		],
		"special03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperarm02.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"spine02": [
			-2.652102812434577e-9,
			0.09826320984822778,
			-0.01566292701421515,
			0.9950371924243184
		],
		"spine03": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"spine01": [
			-0.09901503015597428,
			0.09490278198583568,
			0.028238050731874888,
			0.9901475133864771
		],
		"upperarm02.R": [
			-0.06703494796850316,
			-0.07353451000679245,
			-0.00007259870532833877,
			0.9950371783598586
		],
		"spine04": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"spine05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			-0.28078638331543554,
			0.009294439432009471,
			-0.19004555801706868,
			0.9407206313344381
		],
		"finger5-3.L": [
			0.1019677173960623,
			-0.12594763399562037,
			-0.33417235312852167,
			0.9284765029361212
		],
		"oris01": [
			0,
			0,
			0,
			1
		],
		"oris02": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris05": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"risorius03.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger2-3.L": [
			0.21502935445807725,
			-0.14993660789232344,
			-0.11768780236537812,
			0.9578261697769039
		],
		"toe3-3.R": [
			3.490658428972885e-8,
			1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"finger3-3.R": [
			0.21862071673343825,
			0.17564562276088358,
			0.24348484703501125,
			0.928476562269741
		],
		"finger2-3.R": [
			0.2150293296527586,
			0.149936584671438,
			0.11768778246567847,
			0.9578261814256596
		],
		"toe3-3.L": [
			3.4906584289728793e-8,
			-1.7453292366909068e-8,
			-8.7266465165216e-9,
			0.9999999999999996
		],
		"risorius03.L": [
			-3.490658428972882e-8,
			2.6179939993653534e-8,
			8.726645184253818e-9,
			0.9999999999999988
		]
	},
	"Harvey_selfie1": {
		"toe1-1.L": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"finger5-2.R": [
			0.05347440894361295,
			0.055717123066460816,
			0.1802132790418955,
			0.9805912827688689
		],
		"finger1-3.R": [
			-0.09150222892471851,
			0.013863054057034474,
			0.03646260556115456,
			0.995040519893392
		],
		"toe5-2.R": [
			1.745329214486445e-8,
			1.7453292366909068e-8,
			-8.726645628343025e-9,
			0.9999999999999999
		],
		"toe4-2.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"clavicle.R": [
			-0.002440629598071123,
			-0.006080514727683006,
			-0.19594589661259545,
			0.9805928187930493
		],
		"neck03": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"neck02": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"neck01": [
			1.7453292144864453e-8,
			2.6179939993653534e-8,
			8.726646516521464e-9,
			0.9999999999999997
		],
		"clavicle.L": [
			-8.726646516521433e-9,
			8.726646405499139e-9,
			4.3633228585804245e-8,
			0.9999999999999992
		],
		"toe5-2.L": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe4-2.L": [
			3.8077175003734897e-16,
			4.363322869682662e-8,
			-8.726646072432225e-9,
			0.9999999999999991
		],
		"finger5-2.L": [
			0.10125851936345999,
			-0.10554750565296933,
			-0.3413086858591591,
			0.9285013824781577
		],
		"finger1-3.L": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"toe1-1.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oculi02.L": [
			4.569261529843771e-16,
			-5.235987998730707e-8,
			8.726646072432165e-9,
			0.9999999999999986
		],
		"oculi01.L": [
			-1.7453291256686047e-8,
			-1.7453291478730648e-8,
			2.6179939993653507e-8,
			0.9999999999999994
		],
		"jaw": [
			0,
			0,
			0,
			1
		],
		"finger4-2.R": [
			0.09621844051419556,
			0.06476075726287733,
			0.15808188983115906,
			0.9805907261090961
		],
		"oculi01.R": [
			-8.726645184253792e-9,
			1.745329203384216e-8,
			-4.363322858580425e-8,
			0.9999999999999988
		],
		"oculi02.R": [
			-2.6179939993653494e-8,
			-6.661338147750939e-16,
			-2.6179940052507944e-8,
			0.9999999999999993
		],
		"wrist.R": [
			0.08109751592559929,
			0.28817071641794934,
			-0.34159996798229425,
			0.8908929750449034
		],
		"finger1-1.L": [
			0.13690227682875242,
			0.0013408272405897037,
			0.14033364435349213,
			0.980592900771713
		],
		"tongue07.R": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"eye.R": [
			0,
			0,
			0,
			1
		],
		"finger2-1.R": [
			0.0660732061850054,
			-0.06314400103989892,
			-0.03929778365716578,
			0.9950391202142459
		],
		"finger4-3.R": [
			0.13936293556851395,
			0.08407557072851324,
			0.2367319420507227,
			0.9578451118052926
		],
		"finger2-1.L": [
			0.06607326365645345,
			0.06314396375365139,
			0.03929784641473428,
			0.9950391162855993
		],
		"eye.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"tongue07.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"wrist.L": [
			0.066799823235439,
			-0.020949035421874762,
			-0.48729763849593105,
			0.8704251449992106
		],
		"finger5-3.R": [
			0.052825560658227584,
			0.05077434521497737,
			0.18185627330142606,
			0.9805915163155612
		],
		"lowerleg01.R": [
			0,
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0.9999999999999991
		],
		"lowerarm02.L": [
			-0.05162734916198186,
			0.05658476875995655,
			-0.06347775943299495,
			0.9950393735025044
		],
		"oris07.L": [
			2.6179940881831877e-8,
			-2.6179940992854256e-8,
			3.4906584289728846e-8,
			0.9999999999999988
		],
		"oris07.R": [
			-8.726644740164625e-9,
			5.235987998730707e-8,
			-2.617994088183188e-8,
			0.9999999999999984
		],
		"tongue00": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.R": [
			1.7453292144864436e-8,
			4.363322869682662e-8,
			6.702088926697263e-16,
			0.9999999999999991
		],
		"lowerleg01.L": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"tongue03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			0.06945905517671212,
			-0.000677238145428527,
			-0.07119854911407529,
			0.9950405758593484
		],
		"metacarpal4.L": [
			-5.2359879987306876e-8,
			-8.726647626744466e-9,
			-2.6179939105475504e-8,
			0.9999999999999984
		],
		"finger1-2.R": [
			-2.6179940881831907e-8,
			-3.490658451177353e-8,
			-1.7453291256686053e-8,
			0.9999999999999991
		],
		"pelvis.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"toe2-1.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-3.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe5-3.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator05.L": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"finger4-1.L": [
			-1.74532930330429e-8,
			-1.7453292810998278e-8,
			-4.3633228585803696e-8,
			0.9999999999999984
		],
		"finger4-1.R": [
			-0.08216018067506127,
			0.046530748437738634,
			0.03130708676497091,
			0.9950399290880517
		],
		"levator05.R": [
			6.092348000597589e-16,
			-3.4906584178706623e-8,
			1.745329214486445e-8,
			0.9999999999999991
		],
		"toe5-3.R": [
			1.7453292144864443e-8,
			-1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"toe2-3.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger4-2.L": [
			0.14097945226445127,
			-0.09489904324948606,
			-0.23163177973720847,
			0.9578442901877742
		],
		"toe2-1.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger1-2.L": [
			0.2581933292348276,
			0.03178795025180614,
			0.12186472265573986,
			0.957849007061898
		],
		"pelvis.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"metacarpal4.R": [
			-3.490658428972881e-8,
			2.1094237467877974e-15,
			5.235987984666416e-8,
			0.9999999999999981
		],
		"tongue04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			-1.7453292144864436e-8,
			-3.490658440075123e-8,
			8.726646516521445e-9,
			0.9999999999999993
		],
		"levator03.R": [
			8.72664207562928e-9,
			8.726645717160864e-8,
			4.363322858580404e-8,
			0.9999999999999953
		],
		"upperleg02.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"upperleg02.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator03.L": [
			4.363323036216087e-8,
			-5.235988043139628e-8,
			1.7453289480329435e-8,
			0.9999999999999978
		],
		"toe3-2.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal3.L": [
			-8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"tongue01": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"breast.L": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"temporalis02.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue02": [
			0,
			0,
			0,
			1
		],
		"oris04.R": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"oris04.L": [
			-8.726646072432222e-9,
			-2.220446049250313e-16,
			-3.490658426895706e-8,
			0.9999999999999992
		],
		"temporalis02.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"breast.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oris03.R": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"oris06.L": [
			-2.6179940881831897e-8,
			2.6179940992854256e-8,
			2.6179939105475064e-8,
			0.9999999999999988
		],
		"orbicularis04.R": [
			3.490658428972885e-8,
			1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"toe1-2.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"toe1-2.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"orbicularis04.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"metacarpal3.R": [
			-1.7453293033042916e-8,
			2.617994110387656e-8,
			2.6179939105475286e-8,
			0.9999999999999992
		],
		"oris06.R": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"levator04.L": [
			8.7266478487891e-9,
			6.108652428338246e-8,
			-2.6179939105475074e-8,
			0.9999999999999977
		],
		"tongue06.L": [
			0,
			0,
			0,
			1
		],
		"toe2-2.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe2-2.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue06.R": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"levator04.R": [
			3.046174000298796e-16,
			-3.4906584178706623e-8,
			8.726646072432218e-9,
			0.9999999999999994
		],
		"toe4-1.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"upperleg01.R": [
			0.0011314569016430164,
			0.02416149386283961,
			0.07596263196268249,
			0.9968172453187685
		],
		"metacarpal1.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"levator02.R": [
			1.1423153030516055e-15,
			4.363322869682662e-8,
			-2.617993999365348e-8,
			0.9999999999999989
		],
		"toe3-1.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"toe3-1.R": [
			-3.490658428972885e-8,
			1.7453292144864463e-8,
			-6.052891516783062e-16,
			0.9999999999999991
		],
		"levator02.L": [
			1.7453293033042916e-8,
			-2.617994110387656e-8,
			2.6179939105475286e-8,
			0.9999999999999992
		],
		"finger5-1.R": [
			-0.18152831801842226,
			0.06578285919982763,
			0.034050227210988326,
			0.9805919983457839
		],
		"metacarpal1.L": [
			-2.284630764921893e-16,
			8.726645961409929e-9,
			2.61799399936535e-8,
			0.9999999999999996
		],
		"toe4-1.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"upperleg01.L": [
			0.0011314384360046788,
			-0.024161504111685606,
			-0.07596263929210616,
			0.9968172445327698
		],
		"head": [
			-2.862764174864814e-7,
			-0.20002502879575712,
			-0.08720843733579267,
			0.9759019808938928
		],
		"toe5-1.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			1.5230870001493993e-16,
			-8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"special04": [
			0,
			0,
			0,
			1
		],
		"metacarpal2.L": [
			2.617993910547502e-8,
			-2.617993899445281e-8,
			-3.490658428972884e-8,
			0.9999999999999989
		],
		"metacarpal2.R": [
			-3.807717500373487e-16,
			8.726645961409929e-9,
			4.3633228585804185e-8,
			0.999999999999999
		],
		"temporalis01.R": [
			8.726645628343025e-9,
			8.726645517320719e-9,
			2.6179939993653497e-8,
			0.9999999999999994
		],
		"toe5-1.L": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"risorius02.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"special05.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger2-2.L": [
			0.07367196005803121,
			-0.046391043715055647,
			-0.04812727859840493,
			0.9950397371054824
		],
		"foot.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"oris06": [
			0,
			0,
			0,
			1
		],
		"levator06.R": [
			2.2846307649218933e-16,
			2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"orbicularis03.R": [
			0,
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0.9999999999999992
		],
		"levator06.L": [
			0,
			0,
			0,
			1
		],
		"orbicularis03.L": [
			-2.6179939993653527e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"foot.R": [
			-0.006003527334728779,
			-0.08766046433708796,
			-0.04668137467381342,
			0.9950379138054538
		],
		"root": [
			8.161953728257245e-10,
			0.19607266175857052,
			0.004129148089005899,
			0.9805806756442677
		],
		"finger2-2.R": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"risorius02.L": [
			-3.490658428972884e-8,
			-2.6179941325921163e-8,
			-1.7453291256685967e-8,
			0.999999999999999
		],
		"special05.R": [
			-1.7453292144864443e-8,
			-1.7453292255886765e-8,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"lowerleg02.L": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"tongue05.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"finger5-1.L": [
			8.726647404699876e-9,
			-2.617994065978735e-8,
			5.2359879987306756e-8,
			0.9999999999999984
		],
		"toe4-3.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"oris03.L": [
			-8.726645628343e-9,
			-8.726645628343022e-9,
			6.108652428338217e-8,
			0.9999999999999979
		],
		"toe4-3.L": [
			-4.363322858580417e-8,
			-8.726645628343022e-9,
			8.726646516520993e-9,
			0.999999999999999
		],
		"finger3-3.L": [
			0.05762340104994045,
			-0.04190858121362362,
			-0.06941854469614872,
			0.9950398384609375
		],
		"tongue05.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"lowerleg02.R": [
			-1.5230870001493986e-16,
			1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"shoulder01.R": [
			-0.08464807867032573,
			-0.046567616572908754,
			-0.19559412998415351,
			0.9759144922481077
		],
		"finger3-1.L": [
			-7.615435000746988e-16,
			-4.363322858580432e-8,
			-1.7453292144864436e-8,
			0.9999999999999989
		],
		"special06.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger4-3.L": [
			0.32449131140106796,
			-0.19572703260643176,
			-0.5512760834602424,
			0.7432973814948041
		],
		"finger3-2.L": [
			0.21528601841894612,
			-0.1604284529201775,
			-0.2565282455097758,
			0.928497658059853
		],
		"upperarm01.R": [
			-0.19138635583607966,
			-0.2033745499741918,
			-0.19236680206778423,
			0.9407470800830554
		],
		"finger3-2.R": [
			-2.617993999365348e-8,
			-1.745329247793137e-8,
			8.726646516521431e-9,
			0.9999999999999996
		],
		"upperarm01.L": [
			-0.003613698362847342,
			0.0006814808269470785,
			-0.19602077054540834,
			0.980592848374293
		],
		"special06.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger3-1.R": [
			-0.03975543376032456,
			0.02387141355031075,
			0.018495230238930176,
			0.9987530162958447
		],
		"shoulder01.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"lowerarm01.R": [
			-0.7346562300401578,
			0.45469440980243403,
			0.1770128796664698,
			0.4713805869886704
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"upperarm02.L": [
			-1.5230870001493993e-16,
			8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"spine02": [
			8.726646072432225e-9,
			-2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"spine03": [
			-0.09947006743840667,
			-1.6498693189426206e-8,
			1.0419447015416116e-8,
			0.995040554793521
		],
		"spine01": [
			-1.0269086853830795e-7,
			0.009774389224756597,
			0.09898893251558964,
			0.9950405280965676
		],
		"upperarm02.R": [
			-0.13077580456568452,
			-0.14596269793061556,
			0.006467242766250558,
			0.9805869438882086
		],
		"spine04": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"spine05": [
			0.09946981449274779,
			-1.1102230246251565e-16,
			0,
			0.9950405800794149
		],
		"lowerarm01.L": [
			-0.42466280447906024,
			-0.4040506989744399,
			-0.3566268878370226,
			0.7274763212792056
		],
		"finger5-3.L": [
			0.07739786016641188,
			-0.07440650385529324,
			-0.2664664012394104,
			0.9578459690556778
		],
		"oris01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			2.6179939993653477e-8,
			-2.6179940548765046e-8,
			-8.726646960610674e-9,
			0.9999999999999996
		],
		"finger2-3.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe3-3.R": [
			3.490658428972885e-8,
			-1.7453292144864463e-8,
			-6.052891516783062e-16,
			0.9999999999999991
		],
		"finger3-3.R": [
			5.235987998730673e-8,
			8.726647182655256e-9,
			-1.745329125668265e-8,
			0.9999999999999986
		],
		"finger2-3.R": [
			-2.6179939993653534e-8,
			4.3633228474782015e-8,
			-8.726647404699778e-9,
			0.9999999999999987
		],
		"toe3-3.L": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"risorius03.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		]
	},
	"fight04": {
		"toe1-1.L": [
			2.6179939993653497e-8,
			-8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"finger5-2.R": [
			0.1689669651484682,
			0.20487582702888152,
			0.5613630558548579,
			0.7838032787052138
		],
		"finger1-3.R": [
			0.4936019574117956,
			-0.08374239410132733,
			-0.19180165282125486,
			0.8441305853032792
		],
		"toe5-2.R": [
			-5.2359879987306836e-8,
			-5.551115123125783e-16,
			-8.726646040608206e-9,
			0.9999999999999987
		],
		"toe4-2.R": [
			-1.7453293033042893e-8,
			6.108652428338246e-8,
			8.72664518425366e-9,
			0.9999999999999979
		],
		"clavicle.R": [
			0.025814077350230648,
			0.11960358217468126,
			-0.015134422829174902,
			0.9923706796289218
		],
		"neck03": [
			0.060099967199610506,
			-0.10176379468025798,
			-0.01014849680269655,
			0.992939641694059
		],
		"neck02": [
			2.0681443091957663e-8,
			-0.0062735184987661174,
			0.00008119418359453802,
			0.9999803179928841
		],
		"neck01": [
			3.849329376952332e-7,
			-0.31703454930356345,
			-0.021134643401411756,
			0.9481784754971153
		],
		"clavicle.L": [
			0.06619367487410965,
			0.18627035241729284,
			-0.02209125892496715,
			0.980017208775493
		],
		"toe5-2.L": [
			8.72664784878909e-9,
			2.6179940992854256e-8,
			-6.108652428338182e-8,
			0.9999999999999977
		],
		"toe4-2.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger5-2.L": [
			0.1689667920442725,
			-0.20487604615936972,
			-0.5613629019336416,
			0.7838033689829432
		],
		"finger1-3.L": [
			0.4936019640693959,
			0.08374246797097451,
			0.19180161169550838,
			0.8441305834265037
		],
		"toe1-1.R": [
			1.745329303304288e-8,
			-1.7453293144065185e-8,
			3.490658428972881e-8,
			0.9999999999999989
		],
		"oculi02.L": [
			-2.6179940881831947e-8,
			-6.981316869048015e-8,
			-1.745329036850794e-8,
			0.9999999999999971
		],
		"oculi01.L": [
			6.108652428338185e-8,
			4.363322680944748e-8,
			1.7453294809398597e-8,
			0.999999999999997
		],
		"jaw": [
			-1.7453293921221236e-8,
			-4.363322869682662e-8,
			-3.490658428972883e-8,
			0.9999999999999984
		],
		"finger4-2.R": [
			0.3185265433748312,
			0.2437418832334869,
			0.5100489183049004,
			0.7609079027447907
		],
		"oculi01.R": [
			4.363322680944721e-8,
			4.3633227031492083e-8,
			2.6179941770010135e-8,
			0.999999999999998
		],
		"oculi02.R": [
			8.726644296075359e-9,
			-3.4906584178706623e-8,
			-5.235987998730692e-8,
			0.999999999999998
		],
		"oris03.L": [
			5.235987998730666e-8,
			-2.617993932751972e-8,
			-8.726647404699014e-9,
			0.9999999999999984
		],
		"finger1-1.L": [
			0.1035506008566901,
			0.044748500688594484,
			0.13696630243922653,
			0.9841316358823489
		],
		"tongue07.R": [
			-3.4906584289728793e-8,
			-8.726647293677559e-9,
			-2.61799399936534e-8,
			0.999999999999999
		],
		"eye.R": [
			8.726645628343032e-9,
			2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"finger2-1.R": [
			0.4750260107279647,
			0.3081395623492844,
			0.30090298332166054,
			0.7673706365734823
		],
		"finger4-3.R": [
			0.27649618032354384,
			0.18711479545400778,
			0.46421701199882137,
			0.8203904444589667
		],
		"finger2-1.L": [
			0.4750260269187364,
			-0.3081395422162153,
			-0.3009029492533118,
			0.7673706479943316
		],
		"eye.L": [
			-3.490658606608563e-8,
			4.363323047318346e-8,
			4.363322680944733e-8,
			0.9999999999999974
		],
		"tongue07.L": [
			6.108652428338212e-8,
			-8.726646405499139e-9,
			8.726645628342997e-9,
			0.999999999999998
		],
		"wrist.L": [
			-0.08402270422250514,
			0.08378765155653989,
			-0.282134060681984,
			0.9520085012356094
		],
		"finger5-3.R": [
			0.15021023969572847,
			0.16993748852200818,
			0.5110302433629668,
			0.8290996467577173
		],
		"lowerleg01.R": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"lowerarm02.L": [
			8.726645184253797e-9,
			8.726645295276114e-9,
			7.853981998095983e-8,
			0.999999999999997
		],
		"oris07.L": [
			-4.363322858580419e-8,
			8.881784197001252e-16,
			1.74532921206064e-8,
			0.9999999999999988
		],
		"oris07.R": [
			1.745329125668599e-8,
			-8.726644962209207e-9,
			-6.108652428338222e-8,
			0.999999999999998
		],
		"tongue00": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"lowerarm02.R": [
			-0.08159354650296714,
			-0.08289835819732227,
			0.10850478216254178,
			0.9872674752189072
		],
		"lowerleg01.L": [
			0.10817390452914655,
			0.009861083159827366,
			0.000690437727925925,
			0.9940828379534465
		],
		"tongue03": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"finger1-1.R": [
			0.16403675090320552,
			-0.008237834527527133,
			-0.1724952557020196,
			0.9712206078928266
		],
		"metacarpal4.L": [
			0.041487579110946686,
			-0.05657600126000528,
			-0.08453665731398519,
			0.9939474284040973
		],
		"finger1-2.R": [
			0.14371613598103394,
			-0.020777198062504665,
			-0.0672891454488338,
			0.9871099995462097
		],
		"pelvis.R": [
			-0.010299525424906069,
			0.18879937455689688,
			-0.06127381699510971,
			0.9800480780521924
		],
		"toe2-1.R": [
			8.72664562834302e-9,
			-3.4906584289728926e-8,
			-8.726646516521445e-9,
			0.9999999999999994
		],
		"toe2-3.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe5-3.L": [
			1.74532930330429e-8,
			1.7453292810998278e-8,
			-4.3633228585803696e-8,
			0.9999999999999984
		],
		"levator05.L": [
			-4.569261529843784e-16,
			-1.7453292255886765e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"finger4-1.L": [
			0.2627311442404995,
			-0.1677164205975692,
			-0.46897212247406583,
			0.8263828994178107
		],
		"finger4-1.R": [
			0.2627310871941135,
			0.16771640003893395,
			0.4689721035858232,
			0.8263829324460108
		],
		"levator05.R": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"toe5-3.R": [
			-8.726645628343005e-9,
			-5.235987976526246e-8,
			8.726646516521441e-9,
			0.9999999999999984
		],
		"toe2-3.R": [
			-2.617994265818873e-8,
			5.235988198570851e-8,
			5.235987821094996e-8,
			0.9999999999999971
		],
		"finger4-2.L": [
			0.31852635649387606,
			-0.24374215979170155,
			-0.51004888921137,
			0.7609079118875426
		],
		"toe2-1.L": [
			-1.745329214486445e-8,
			3.3306690738754696e-16,
			4.3633228449276404e-8,
			0.9999999999999991
		],
		"finger1-2.L": [
			0.1437162289784594,
			0.020777183739128402,
			0.06728919876575168,
			0.9871099826734329
		],
		"pelvis.L": [
			0.0012242725086083002,
			0.0224417771127412,
			-0.007283378697971838,
			0.9997208711393339
		],
		"metacarpal4.R": [
			-8.726645184253779e-9,
			-2.6179939993653534e-8,
			3.490658428972884e-8,
			0.9999999999999991
		],
		"tongue04": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"toe3-2.L": [
			3.807717500373487e-16,
			-8.726645961409929e-9,
			4.3633228585804185e-8,
			0.999999999999999
		],
		"levator03.R": [
			2.6179941770010353e-8,
			-7.853982031402751e-8,
			1.7453290368507392e-8,
			0.9999999999999966
		],
		"upperleg02.R": [
			-0.014734756295560808,
			0.15736773841626062,
			-0.023959851533556,
			0.9871394062528104
		],
		"upperleg02.L": [
			-0.08580927533159496,
			-0.010659860481850414,
			-0.000782482459128195,
			0.99625424634617
		],
		"levator03.L": [
			-3.49065842897289e-8,
			-1.7453293699176697e-8,
			-4.363322858580413e-8,
			0.999999999999998
		],
		"toe3-2.R": [
			-1.7453291256686033e-8,
			2.6179938772408207e-8,
			-3.49065842897288e-8,
			0.999999999999999
		],
		"metacarpal3.L": [
			0.03246531246072145,
			-0.044272620050717526,
			-0.06615261928972561,
			0.9962980324992022
		],
		"tongue01": [
			3.490658428972884e-8,
			3.4906584289728926e-8,
			8.726647404699887e-9,
			0.9999999999999989
		],
		"breast.L": [
			0.004637296285085243,
			-0.000016469449700573513,
			-0.0013657495927716678,
			0.9999883149017151
		],
		"temporalis02.R": [
			3.490657896065849e-8,
			-7.853981631722462e-8,
			-6.10865278360958e-8,
			0.9999999999999942
		],
		"tongue02": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"oris04.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"oris04.L": [
			3.4906584289728793e-8,
			-1.7453291478730648e-8,
			-2.617994088183205e-8,
			0.9999999999999991
		],
		"temporalis02.L": [
			3.490658251337198e-8,
			-3.490658262439439e-8,
			-4.3633230362160965e-8,
			0.9999999999999979
		],
		"breast.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"oris03.R": [
			0,
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0.9999999999999992
		],
		"oris06.L": [
			2.617994177001025e-8,
			2.6179941770010373e-8,
			-6.98131685794569e-8,
			0.9999999999999969
		],
		"orbicularis04.R": [
			8.726646960610633e-9,
			7.853982053607211e-8,
			-8.726645184253805e-9,
			0.9999999999999972
		],
		"toe1-2.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe1-2.L": [
			0,
			0,
			2.617993999365351e-8,
			0.9999999999999998
		],
		"orbicularis04.L": [
			-2.617994088183186e-8,
			4.363322880784892e-8,
			2.617993910547505e-8,
			0.9999999999999986
		],
		"metacarpal3.R": [
			-4.363322858580416e-8,
			2.617994021569814e-8,
			-1.1643607064032247e-15,
			0.9999999999999988
		],
		"oris06.R": [
			2.6179939993653517e-8,
			-3.4906584733818136e-8,
			-8.72664696061073e-9,
			0.9999999999999996
		],
		"levator04.L": [
			2.6179939993653477e-8,
			-2.6179940548765046e-8,
			-8.726646960610674e-9,
			0.9999999999999996
		],
		"tongue06.L": [
			-2.617994177001034e-8,
			-2.6179941770010373e-8,
			-5.235987998730672e-8,
			0.999999999999998
		],
		"toe2-2.L": [
			0,
			0,
			2.617993999365351e-8,
			0.9999999999999998
		],
		"toe2-2.R": [
			3.4906580737015366e-8,
			5.235987843299483e-8,
			6.108652783609697e-8,
			0.9999999999999962
		],
		"tongue06.R": [
			8.726646516521448e-9,
			8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"levator04.R": [
			8.726645184253837e-9,
			5.235988020935167e-8,
			1.7453293033042836e-8,
			0.9999999999999986
		],
		"toe4-1.L": [
			8.726645184253779e-9,
			2.6179939993653534e-8,
			3.490658428972884e-8,
			0.9999999999999991
		],
		"upperleg01.R": [
			-0.3592529992211797,
			-0.2257908110792849,
			-0.4008434783898935,
			0.8119607736923236
		],
		"metacarpal1.R": [
			-2.6179938217296784e-8,
			-3.490658262439439e-8,
			4.363323036216037e-8,
			0.9999999999999981
		],
		"levator02.R": [
			5.2359874658236285e-8,
			-1.2217304878880952e-7,
			-4.363323569123113e-8,
			0.9999999999999903
		],
		"toe3-1.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"toe3-1.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"levator02.L": [
			6.108652428338173e-8,
			-6.108652417236016e-8,
			-8.726649625147647e-9,
			0.9999999999999963
		],
		"finger5-1.R": [
			0.2016194092378028,
			0.11523257991138058,
			0.5200010287861276,
			0.8219914819552182
		],
		"metacarpal1.L": [
			2.6179940881831864e-8,
			-3.490658440075123e-8,
			2.6179939105475068e-8,
			0.9999999999999987
		],
		"toe4-1.R": [
			8.72664607243222e-9,
			4.3633228918871225e-8,
			3.5626088403688626e-16,
			0.9999999999999991
		],
		"upperleg01.L": [
			0.2541141632917496,
			0.012762848870451093,
			0.12260586388747655,
			0.9592866640601494
		],
		"head": [
			0.029323273018797308,
			0.016497215389845832,
			-0.00016462579436125606,
			0.9994338199411673
		],
		"toe5-1.R": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"special01": [
			1.7453290368507604e-8,
			-6.981316869048015e-8,
			-2.6179940881831867e-8,
			0.9999999999999971
		],
		"temporalis01.L": [
			1.7453287703972192e-8,
			-7.85398198699383e-8,
			-6.1086524283382e-8,
			0.9999999999999949
		],
		"special04": [
			-2.617993999365348e-8,
			-8.726646738566046e-9,
			-2.6179939993653468e-8,
			0.9999999999999991
		],
		"metacarpal2.L": [
			0.03056453364685719,
			-0.028688065983717648,
			-0.05181150358821513,
			0.9977767146255678
		],
		"metacarpal2.R": [
			-4.363322858580419e-8,
			2.6179939660586626e-8,
			8.7266447401649e-9,
			0.9999999999999984
		],
		"temporalis01.R": [
			1.7453289480329277e-8,
			-2.6179938217296694e-8,
			-8.726645717160371e-8,
			0.9999999999999958
		],
		"toe5-1.L": [
			1.745329303304289e-8,
			1.745329292202058e-8,
			-2.6179939993653487e-8,
			0.9999999999999993
		],
		"risorius02.R": [
			-6.108652073066812e-8,
			5.2359876323571086e-8,
			-6.98131721321708e-8,
			0.9999999999999943
		],
		"special05.L": [
			8.726647404699816e-9,
			4.363322836375971e-8,
			-3.4906584289728793e-8,
			0.9999999999999982
		],
		"finger2-2.L": [
			0.24841927894605006,
			-0.16187545897222788,
			-0.1523474671503729,
			0.9428013825209004
		],
		"foot.L": [
			-0.05051893131505516,
			-0.004604920159564818,
			-0.0003223751527741848,
			0.9987124352702181
		],
		"toe3-3.R": [
			4.363322858580411e-8,
			8.726647404699861e-9,
			-2.617993999365284e-8,
			0.9999999999999986
		],
		"levator06.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"orbicularis03.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"levator06.L": [
			8.726645184253779e-9,
			-2.6179939993653534e-8,
			-3.490658428972884e-8,
			0.9999999999999991
		],
		"orbicularis03.L": [
			-5.2359879987306664e-8,
			3.4906586510174975e-8,
			1.7453290368507233e-8,
			0.9999999999999982
		],
		"foot.R": [
			0.2168949152995223,
			-0.01977083295582327,
			-0.0013848782431127625,
			0.9759937458783726
		],
		"root": [
			-0.2254028088112018,
			-0.05526111497960584,
			-0.18863250391992384,
			0.9542313982552298
		],
		"finger2-2.R": [
			0.2484192720409324,
			0.1618754937621959,
			0.1523474562061324,
			0.9428013801355082
		],
		"risorius02.L": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"special05.R": [
			-1.218469600119515e-15,
			-3.4906584289728926e-8,
			-3.4906584289728807e-8,
			0.9999999999999988
		],
		"lowerleg02.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue05.L": [
			2.617993910547509e-8,
			1.745329014646302e-8,
			6.108652428338099e-8,
			0.9999999999999972
		],
		"finger5-1.L": [
			0.2016192666647375,
			-0.11523279748105164,
			-0.5200010826844206,
			0.8219914523286088
		],
		"toe4-3.R": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"wrist.R": [
			-0.07707374502834992,
			-0.06459801883317873,
			0.29546268858412617,
			0.950046595407179
		],
		"toe4-3.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"finger3-3.L": [
			0.32817018093462436,
			-0.2549243547942416,
			-0.38233698580686554,
			0.8253098417940965
		],
		"tongue05.R": [
			-8.726645628343018e-9,
			-8.726645628343022e-9,
			5.235987998730709e-8,
			0.9999999999999986
		],
		"lowerleg02.R": [
			0.004124191788219714,
			0.04512529449657776,
			0.0016592184030021842,
			0.9989714439527195
		],
		"shoulder01.R": [
			2.831068712794149e-15,
			5.235987998730707e-8,
			-5.235987998730679e-8,
			0.9999999999999973
		],
		"finger3-1.L": [
			0.3470154729429924,
			-0.24756645460985072,
			-0.4378581423045335,
			0.791562606056958
		],
		"special06.R": [
			4.3633226809447214e-8,
			-5.2359878544017135e-8,
			-3.4906586066085587e-8,
			0.9999999999999972
		],
		"finger4-3.L": [
			0.2764961908482319,
			-0.1871149553061301,
			-0.46421700987860276,
			0.8203904056524385
		],
		"finger3-2.L": [
			0.411691870954773,
			-0.3287105842499861,
			-0.4723852200158518,
			0.7066196707581573
		],
		"upperarm01.R": [
			-0.14278854704816785,
			0.12937928206862181,
			-0.01076680254697405,
			0.9812015634752097
		],
		"finger3-2.R": [
			0.4116917597822982,
			0.3287106129517291,
			0.4723852142004407,
			0.7066197260656238
		],
		"upperarm01.L": [
			0.28128854559197497,
			0.0981064133411439,
			-0.03716881252620934,
			0.9538712518759959
		],
		"special06.L": [
			6.092348000597549e-16,
			8.726646183454534e-9,
			-6.98131685794573e-8,
			0.9999999999999977
		],
		"finger3-1.R": [
			0.3470154371385883,
			0.2475664152865853,
			0.43785812375398603,
			0.7915626443133249
		],
		"shoulder01.L": [
			-0.09567976692494379,
			-0.15834122142607532,
			0.007556481081980932,
			0.9827086747312982
		],
		"lowerarm01.R": [
			-0.36930508129152845,
			0.3272285818416154,
			-0.02770610973852044,
			0.86934894239387
		],
		"special03": [
			1.7453291256686053e-8,
			-3.4906584178706623e-8,
			-2.6179940881831874e-8,
			0.9999999999999988
		],
		"upperarm02.L": [
			-3.4906584289728886e-8,
			4.363322880784892e-8,
			1.7453290368507557e-8,
			0.9999999999999981
		],
		"spine02": [
			0.05861533528281898,
			0.0007705623825414731,
			0.07360622692947402,
			0.9955630427353678
		],
		"spine03": [
			0.004588367100609382,
			0.00006030099365306185,
			0.005761907892741074,
			0.999972871466309
		],
		"spine01": [
			0.022589797638827843,
			0.0002969231593088484,
			0.02836722931366113,
			0.9993422402662366
		],
		"upperarm02.R": [
			-2.6179939105474995e-8,
			-4.363322880784892e-8,
			2.617994088183188e-8,
			0.9999999999999984
		],
		"spine04": [
			0.018731766048831207,
			0.00024625392155641634,
			0.023522450252062125,
			0.9995477750632216
		],
		"spine05": [
			-5.539933174547033e-7,
			0.18031664600239006,
			-0.08718241413316133,
			0.9797372779679538
		],
		"lowerarm01.L": [
			0.002761054080917106,
			0.0024468747979826677,
			-0.00020679521216906288,
			0.9999931732866104
		],
		"finger5-3.L": [
			0.15021018132407765,
			-0.1699377109916651,
			-0.5110301756797296,
			0.8290996534520113
		],
		"oris01": [
			2.6179939105475104e-8,
			-6.981316891252476e-8,
			-1.7453293921221593e-8,
			0.9999999999999972
		],
		"oris02": [
			2.6179939993653494e-8,
			1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"oris05": [
			1.2184696001195153e-15,
			-6.981316846843555e-8,
			1.745329214486441e-8,
			0.9999999999999974
		],
		"risorius03.R": [
			-8.72664696061062e-9,
			-2.6179939993653534e-8,
			-3.490658428972884e-8,
			0.9999999999999991
		],
		"finger2-3.L": [
			0.5240617160590134,
			-0.36216393233589006,
			-0.30449772432916855,
			0.7081509300669205
		],
		"oris06": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger3-3.R": [
			0.32817018179118923,
			0.25492436356058457,
			0.38233691820074717,
			0.825309870065252
		],
		"finger2-3.R": [
			0.5240617802005326,
			0.3621637819085014,
			0.304497615118926,
			0.7081510064906117
		],
		"toe3-3.L": [
			-1.5230870001493993e-16,
			-8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"risorius03.L": [
			-5.235988176366349e-8,
			-4.363323058420576e-8,
			-3.490658251337249e-8,
			0.9999999999999972
		]
	},
	"fight01": {
		"toe1-1.L": [
			-0.1806916323614074,
			-0.0938800716641196,
			0.012327438239918009,
			0.9789714502503895
		],
		"finger5-2.R": [
			0.19240642960145452,
			0.17670671177456376,
			0.65715055780262,
			0.7070414756162101
		],
		"finger4-2.R": [
			0.31027399497056213,
			0.19322217614710646,
			0.5156438600106831,
			0.7749236403177202
		],
		"toe5-2.R": [
			1.745329214486444e-8,
			-8.726646183454534e-9,
			3.490658428972891e-8,
			0.9999999999999996
		],
		"toe4-2.R": [
			-1.7453293033042846e-8,
			8.726647071632954e-9,
			5.235987998730684e-8,
			0.9999999999999984
		],
		"clavicle.R": [
			-0.036690584722506726,
			-0.13940798833831836,
			-0.03419932382992552,
			0.9889639124001235
		],
		"neck03": [
			-3.305775110617611e-8,
			-0.04598501208401895,
			-0.005834088454131522,
			0.9989250933255913
		],
		"neck02": [
			3.526592839468444e-8,
			-0.048806817444597805,
			-0.0036334657932585975,
			0.9988016282011448
		],
		"neck01": [
			-1.5278212639359194e-7,
			-0.10519902580968754,
			-0.016309733233742428,
			0.9943174330014101
		],
		"clavicle.L": [
			-0.03669058295547231,
			0.13940795564563535,
			0.03419937259603916,
			0.9889639153877812
		],
		"toe5-2.L": [
			-9.599310857311006e-8,
			8.72664329687467e-9,
			-2.6179940881831818e-8,
			0.9999999999999949
		],
		"toe4-2.L": [
			8.726645184253845e-9,
			-1.745329114566374e-8,
			-6.108652428338177e-8,
			0.999999999999998
		],
		"finger5-2.L": [
			8.726644296075423e-9,
			-6.108652406133785e-8,
			-2.6179940881831907e-8,
			0.9999999999999978
		],
		"finger1-3.L": [
			3.490658428972885e-8,
			1.7453292144864463e-8,
			6.052891516783062e-16,
			0.9999999999999991
		],
		"toe1-1.R": [
			0.008001828275617726,
			0.08591788405762979,
			0.017060276109169714,
			0.9961240057956571
		],
		"oculi02.L": [
			-4.3633228585804126e-8,
			-2.6179940992854256e-8,
			-1.7453291256686043e-8,
			0.9999999999999988
		],
		"oculi01.L": [
			2.6179940881831897e-8,
			2.6179940992854256e-8,
			-2.6179939105475064e-8,
			0.9999999999999988
		],
		"jaw": [
			2.6179939993653477e-8,
			2.6179940548765046e-8,
			8.726646960610674e-9,
			0.9999999999999996
		],
		"finger1-3.R": [
			0.4190486889594918,
			-0.0566362488958112,
			-0.16840226680765144,
			0.8904106963229872
		],
		"oculi01.R": [
			1.7453296585756585e-8,
			-9.599310868413369e-8,
			4.3633226809447545e-8,
			0.9999999999999943
		],
		"oculi02.R": [
			-2.617993821729672e-8,
			5.235987843299483e-8,
			-3.490658606608563e-8,
			0.999999999999998
		],
		"wrist.R": [
			-0.04304392318259212,
			-0.06630776491618351,
			0.09458986369000298,
			0.9923725402669997
		],
		"finger1-1.L": [
			-3.4906582513372e-8,
			5.2359878099927926e-8,
			-4.3633230362160436e-8,
			0.9999999999999968
		],
		"tongue07.R": [
			-8.726648292878226e-9,
			-6.981316857945785e-8,
			-3.4906584289728793e-8,
			0.9999999999999968
		],
		"eye.R": [
			3.490658251337195e-8,
			6.108652406133785e-8,
			2.617994177001026e-8,
			0.999999999999997
		],
		"finger2-1.R": [
			0.4342394484239336,
			0.25662796039145797,
			0.2985762929782932,
			0.8102039179423522
		],
		"finger4-3.R": [
			0.29935508172487174,
			0.15800380463397556,
			0.5183434570546657,
			0.7853288440489764
		],
		"finger2-1.L": [
			0.01048126416283342,
			0.009755914451560543,
			0.006858969401112567,
			0.9998739519427021
		],
		"eye.L": [
			4.36332285858041e-8,
			8.726647071632954e-9,
			-1.7453292144865118e-8,
			0.9999999999999989
		],
		"tongue07.L": [
			-8.726645628343012e-9,
			8.726645406298417e-9,
			-4.363322858580416e-8,
			0.9999999999999992
		],
		"wrist.L": [
			4.363323213851784e-8,
			8.726646072432231e-8,
			-4.363322503309051e-8,
			0.9999999999999942
		],
		"finger5-3.R": [
			0.126492231223394,
			0.10504930781546584,
			0.4411614183011992,
			0.8822363409937798
		],
		"lowerleg01.R": [
			0.48275047049515074,
			-0.0790949826704388,
			-0.002647763659880091,
			0.8721748427354887
		],
		"lowerarm02.L": [
			-4.363321970402056e-8,
			-5.2359872659835105e-8,
			1.5707963996182726e-7,
			0.9999999999999851
		],
		"oris07.L": [
			1.7453291256686076e-8,
			6.981316835741325e-8,
			8.726647404699983e-9,
			0.9999999999999972
		],
		"oris07.R": [
			-1.903858591368061e-15,
			-4.363322869682662e-8,
			-4.363322858580416e-8,
			0.9999999999999984
		],
		"tongue00": [
			-1.745329214486445e-8,
			3.3306690738754696e-16,
			3.490658449484121e-8,
			0.9999999999999994
		],
		"lowerarm02.R": [
			-0.1631016529475511,
			-0.18397798463421444,
			0.20163049776269207,
			0.9481007828008995
		],
		"lowerleg01.L": [
			0.22141395520288512,
			0.0019183013410367655,
			0.014444524118674452,
			0.9750710416602292
		],
		"tongue03": [
			-2.617993999365351e-8,
			8.726644518119997e-9,
			-4.363322858580391e-8,
			0.9999999999999987
		],
		"finger1-1.R": [
			0.15396746995867988,
			0.006402903760764134,
			-0.16196457901027028,
			0.9746899487344574
		],
		"metacarpal4.L": [
			2.6179941770010294e-8,
			6.108652428338246e-8,
			-3.490658251337185e-8,
			0.9999999999999971
		],
		"finger1-2.R": [
			0.16317388184472187,
			-0.01684616809333317,
			-0.07816454924063583,
			0.9833518160588833
		],
		"pelvis.R": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe2-1.R": [
			-2.6179939993653434e-8,
			-6.108652450542706e-8,
			1.5739905687674017e-15,
			0.999999999999998
		],
		"toe2-3.L": [
			-0.12731548252221372,
			-0.011683776433997206,
			0.0029957740892462194,
			0.9917889304766322
		],
		"toe5-3.L": [
			1.7453292144864476e-8,
			-8.726646960610651e-9,
			4.363322858580359e-8,
			0.9999999999999989
		],
		"levator05.L": [
			8.726646516521438e-9,
			-1.7453292366909068e-8,
			1.7453292144864456e-8,
			0.9999999999999996
		],
		"finger4-1.L": [
			8.726649625145859e-9,
			-4.363322858580432e-8,
			7.85398199809603e-8,
			0.999999999999996
		],
		"finger4-1.R": [
			0.2328833003989757,
			0.1118666356272433,
			0.42708143344776694,
			0.8665175551787295
		],
		"levator05.R": [
			-8.726647404699853e-9,
			6.981316857945785e-8,
			1.745329125668601e-8,
			0.9999999999999976
		],
		"toe5-3.R": [
			-1.7453292144864453e-8,
			-2.6179939993653534e-8,
			8.726646516521464e-9,
			0.9999999999999997
		],
		"toe2-3.R": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"finger4-2.L": [
			1.7453292144864436e-8,
			8.726646072432231e-9,
			1.7453292144864443e-8,
			0.9999999999999999
		],
		"toe2-1.L": [
			-5.235987998730673e-8,
			8.726647182655256e-9,
			1.745329125668265e-8,
			0.9999999999999986
		],
		"finger1-2.L": [
			-4.3633232138517825e-8,
			4.3633232138517997e-8,
			9.599310502039953e-8,
			0.9999999999999936
		],
		"pelvis.L": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"metacarpal4.R": [
			0.014976137513481366,
			0.08076939576747821,
			0.14641252700299137,
			0.9858069749951721
		],
		"tongue04": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"toe3-2.L": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"levator03.R": [
			-2.6179939993653434e-8,
			6.108652450542706e-8,
			-1.5739905687674017e-15,
			0.999999999999998
		],
		"upperleg02.R": [
			-0.2011544029895345,
			0.024734499121259024,
			0.004004956269343653,
			0.9792390265080461
		],
		"upperleg02.L": [
			0.14868813247942905,
			0.01828318001812068,
			0.0029604631288892777,
			0.9887106757015761
		],
		"levator03.L": [
			1.745329214486444e-8,
			3.490658451177353e-8,
			4.799202690040438e-16,
			0.9999999999999992
		],
		"toe3-2.R": [
			-8.726644740164569e-9,
			3.4906584178706623e-8,
			-3.490658428972887e-8,
			0.9999999999999988
		],
		"metacarpal3.L": [
			-5.23598799873068e-8,
			-3.4906584733818136e-8,
			8.726647848788919e-9,
			0.9999999999999982
		],
		"tongue01": [
			3.4906584289728654e-8,
			1.0471976019665874e-7,
			3.711412361251355e-15,
			0.9999999999999942
		],
		"breast.L": [
			-8.72664651652144e-9,
			-1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"temporalis02.R": [
			6.108652428338202e-8,
			-5.235987998730707e-8,
			-3.1505396764713425e-15,
			0.9999999999999967
		],
		"tongue02": [
			-3.4906584289728774e-8,
			-3.490658451177353e-8,
			-1.7453291256686083e-8,
			0.9999999999999987
		],
		"oris04.R": [
			5.2359879987306604e-8,
			1.745328981339611e-8,
			4.3633230362161356e-8,
			0.9999999999999977
		],
		"oris04.L": [
			2.6179939105475068e-8,
			-3.4906584289728926e-8,
			-1.7453293033042906e-8,
			0.999999999999999
		],
		"temporalis02.L": [
			2.617993910547522e-8,
			3.4906582846438994e-8,
			3.4906586066085765e-8,
			0.9999999999999987
		],
		"breast.R": [
			-2.6179941770010446e-8,
			5.235988231877542e-8,
			3.4906582513371954e-8,
			0.9999999999999979
		],
		"oris03.R": [
			-8.726648736967438e-9,
			5.235987998730707e-8,
			5.2359879987306776e-8,
			0.9999999999999973
		],
		"oris06.L": [
			-9.599310857311006e-8,
			8.726647959811373e-9,
			1.7453291256685964e-8,
			0.9999999999999952
		],
		"orbicularis04.R": [
			-2.617993999365348e-8,
			4.363322869682662e-8,
			-1.035761105051169e-15,
			0.9999999999999987
		],
		"toe1-2.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"toe1-2.L": [
			-0.21604776369668255,
			-0.022073288590636064,
			0.03028903285933257,
			0.9756632145473678
		],
		"orbicularis04.L": [
			2.2846306061032016e-15,
			-8.726645717160864e-8,
			2.6179939993653388e-8,
			0.9999999999999959
		],
		"metacarpal3.R": [
			0.0316473201378685,
			0.04696020340647267,
			0.12390552165259322,
			0.9906768434399343
		],
		"oris06.R": [
			-4.363322858580407e-8,
			-8.726644740164602e-9,
			3.490658428972865e-8,
			0.9999999999999986
		],
		"levator04.L": [
			-7.61543500074698e-16,
			1.745329203384216e-8,
			4.363322858580423e-8,
			0.9999999999999989
		],
		"tongue06.L": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"toe2-2.L": [
			-0.18949753644947182,
			-0.01794251276252279,
			0.008504122151818236,
			0.9816804112448076
		],
		"toe2-2.R": [
			4.3633228585804e-8,
			-3.490658451177353e-8,
			1.745329036850783e-8,
			0.9999999999999983
		],
		"tongue06.R": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"levator04.R": [
			-3.490658428972883e-8,
			8.726647515722163e-9,
			3.490658428972884e-8,
			0.9999999999999987
		],
		"toe4-1.L": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"upperleg01.R": [
			-0.23184096774989754,
			-0.043060235013184456,
			-0.17525859362481735,
			0.9558661031724325
		],
		"metacarpal1.R": [
			0.01514697067906443,
			-0.02021583166136065,
			-0.0055590480995991644,
			0.9996654372407366
		],
		"levator02.R": [
			7.853981998095916e-8,
			-8.726639966205596e-9,
			-7.853981998095929e-8,
			0.9999999999999937
		],
		"toe3-1.L": [
			-2.6179939993653464e-8,
			8.726645295276114e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"toe3-1.R": [
			-1.7453291256686023e-8,
			-2.617993932751972e-8,
			3.4906584289728926e-8,
			0.999999999999999
		],
		"levator02.L": [
			2.6179939105475058e-8,
			-2.617993943854202e-8,
			-2.6179940881831917e-8,
			0.9999999999999991
		],
		"finger5-1.R": [
			0.10328156021008579,
			0.07874676783328882,
			0.3773580871576182,
			0.9169147942601451
		],
		"metacarpal1.L": [
			-1.7453290368507584e-8,
			2.6179939216497417e-8,
			-5.235987998730692e-8,
			0.9999999999999979
		],
		"toe4-1.R": [
			-2.6179941770010476e-8,
			-4.363323080625037e-8,
			-3.490658251337224e-8,
			0.9999999999999982
		],
		"upperleg01.L": [
			0.13473315109434408,
			-0.002713069598049178,
			0.16511252473429794,
			0.9770248059416969
		],
		"head": [
			1.7108222887788627e-8,
			-0.016268886114594316,
			-0.0007804838354428759,
			0.9998673482965492
		],
		"toe5-1.R": [
			-8.72664918105665e-9,
			-3.490658395666202e-8,
			-8.726645717160828e-8,
			0.9999999999999951
		],
		"special01": [
			1.7453292144864473e-8,
			4.363322880784892e-8,
			8.726646960610506e-9,
			0.9999999999999988
		],
		"temporalis01.L": [
			5.235988176366352e-8,
			4.363323036216116e-8,
			-2.6179937329117888e-8,
			0.9999999999999971
		],
		"special04": [
			-2.6179939105475058e-8,
			-2.617993943854202e-8,
			2.6179940881831917e-8,
			0.9999999999999991
		],
		"metacarpal2.L": [
			8.72664562834302e-9,
			3.4906584289728926e-8,
			8.726646516521445e-9,
			0.9999999999999994
		],
		"metacarpal2.R": [
			0.018219092892088885,
			0.016411374618529817,
			0.05340072452227403,
			0.9982720541304438
		],
		"temporalis01.R": [
			6.981316857945738e-8,
			2.617993899445281e-8,
			8.726647848791145e-9,
			0.9999999999999969
		],
		"toe5-1.L": [
			3.49065842897288e-8,
			-1.7453293477132092e-8,
			1.7453291256685666e-8,
			0.9999999999999992
		],
		"risorius02.R": [
			8.726645628343013e-9,
			-3.4906584178706623e-8,
			-1.745329214486445e-8,
			0.9999999999999992
		],
		"special05.L": [
			1.7453292144864436e-8,
			-3.490658440075123e-8,
			-8.726646516521445e-9,
			0.9999999999999993
		],
		"finger2-2.L": [
			-0.06649609733064105,
			0.039609810896472974,
			0.04440077575452282,
			0.9960109954377689
		],
		"foot.L": [
			-6.108652428338218e-8,
			-8.72664329687467e-9,
			4.363322858580178e-8,
			0.9999999999999969
		],
		"toe3-3.R": [
			-1.7453293033042916e-8,
			-2.617994110387656e-8,
			-2.6179939105475286e-8,
			0.9999999999999992
		],
		"levator06.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"orbicularis03.R": [
			8.726646516521416e-9,
			6.108652428338246e-8,
			-8.726645628342962e-9,
			0.9999999999999981
		],
		"levator06.L": [
			1.7453292144864446e-8,
			3.490658440075123e-8,
			-8.726645628343005e-9,
			0.9999999999999993
		],
		"orbicularis03.L": [
			-1.7453292144864433e-8,
			-2.617994021569814e-8,
			4.927555263958927e-16,
			0.9999999999999996
		],
		"foot.R": [
			-0.006771811424681662,
			-0.10027025885025476,
			0.1593071816210326,
			0.982100422382607
		],
		"root": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger2-2.R": [
			0.39525131244609824,
			0.23543979892656453,
			0.26392894749896706,
			0.847753508847438
		],
		"risorius02.L": [
			-3.490658428972883e-8,
			-2.6179939993653534e-8,
			1.0341496537059884e-15,
			0.9999999999999992
		],
		"special05.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"lowerleg02.L": [
			8.72664651652143e-9,
			-2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"tongue05.L": [
			-3.49065860660857e-8,
			4.363323047318346e-8,
			2.6179938217296602e-8,
			0.999999999999998
		],
		"finger5-1.L": [
			0.10772339503318805,
			0.03895935706928,
			0.021355931244352665,
			0.9931876775614761
		],
		"toe4-3.R": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"oris03.L": [
			-1.7453293033042833e-8,
			-8.726646960610651e-9,
			-5.2359879987304315e-8,
			0.9999999999999987
		],
		"toe4-3.L": [
			-1.7453292144864443e-8,
			-2.6179940104675836e-8,
			-8.726645628343028e-9,
			0.9999999999999997
		],
		"finger3-3.L": [
			2.6179934664583032e-8,
			-6.108652061964648e-8,
			-8.726645717160668e-8,
			0.9999999999999941
		],
		"tongue05.R": [
			-5.23598799873067e-8,
			6.108652450542706e-8,
			-3.384421543835748e-15,
			0.999999999999997
		],
		"lowerleg02.R": [
			1.745329214486445e-8,
			-1.7453292366909068e-8,
			8.726645628343025e-9,
			0.9999999999999999
		],
		"shoulder01.R": [
			0.003011084095781141,
			0.003534231955725109,
			-0.0525718886693281,
			0.9986063484170278
		],
		"finger3-1.L": [
			-6.108652428338159e-8,
			-1.3089969297386261e-7,
			8.726654066037814e-9,
			0.9999999999999897
		],
		"special06.R": [
			-5.33080502991848e-16,
			6.108652428338246e-8,
			8.726646072432205e-9,
			0.9999999999999981
		],
		"finger4-3.L": [
			2.6179939105475025e-8,
			3.4906584289728926e-8,
			2.6179940881831904e-8,
			0.9999999999999988
		],
		"finger3-2.L": [
			1.3089969286283674e-7,
			3.490658073701525e-8,
			2.6179944434535852e-8,
			0.9999999999999903
		],
		"upperarm01.R": [
			0.03865232160642999,
			-0.24278480830386062,
			-0.11438039902497557,
			0.9625376144391333
		],
		"finger3-2.R": [
			0.36228090331403473,
			0.25192983665441504,
			0.439328826828135,
			0.7824794479186408
		],
		"upperarm01.L": [
			-0.08029587342307272,
			0.102398891797984,
			0.1404499814983453,
			0.9814992829171529
		],
		"special06.L": [
			8.726646072432223e-9,
			3.490658451177353e-8,
			3.180207328966892e-16,
			0.9999999999999998
		],
		"finger3-1.R": [
			0.2811925784078561,
			0.1689201366254709,
			0.37094580280343126,
			0.8687899243622087
		],
		"shoulder01.L": [
			0.0030110522944590355,
			-0.0035341257694023742,
			0.05257181100239185,
			0.9986063529775157
		],
		"lowerarm01.R": [
			-0.3450067827061318,
			0.3067924138289966,
			0.0008451454787317625,
			0.8870445425303406
		],
		"special03": [
			1.7453292144864436e-8,
			4.363322869682662e-8,
			6.702088926697263e-16,
			0.9999999999999991
		],
		"upperarm02.L": [
			8.726646960610626e-9,
			3.490658440075123e-8,
			-2.61799399936535e-8,
			0.999999999999999
		],
		"spine02": [
			-4.363322858580404e-8,
			8.726645761569785e-8,
			-3.731731566931179e-15,
			0.9999999999999956
		],
		"spine03": [
			-3.663343454044385e-8,
			-0.04881294551014104,
			-0.005532496257095891,
			0.9987926150286597
		],
		"spine01": [
			-1.7453292144864466e-8,
			4.3633228918871225e-8,
			8.726645184253712e-9,
			0.9999999999999988
		],
		"upperarm02.R": [
			-1.7453293921221352e-8,
			-2.6179941881032676e-8,
			-7.853981998095827e-8,
			0.9999999999999964
		],
		"spine04": [
			-1.2313162931767883e-7,
			-0.06718717871300595,
			-0.022161838229760072,
			0.9974942285260848
		],
		"spine05": [
			1.2992109620783485e-7,
			-0.10484570386865211,
			0.03983784223674873,
			0.9936902559179043
		],
		"lowerarm01.L": [
			-4.363322858580412e-8,
			-2.6179940992854256e-8,
			-2.617993910547514e-8,
			0.9999999999999986
		],
		"finger5-3.L": [
			-6.1086531388809e-8,
			6.981317557386291e-8,
			1.2217304146133756e-7,
			0.9999999999999883
		],
		"oris01": [
			-1.745329214486445e-8,
			8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"oris02": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"oris05": [
			-6.108652428338188e-8,
			6.981316857945785e-8,
			-1.745329658575686e-8,
			0.9999999999999953
		],
		"risorius03.R": [
			5.235988354002032e-8,
			6.981317246523844e-8,
			-6.108652073066799e-8,
			0.9999999999999947
		],
		"finger2-3.L": [
			-0.052428146174776744,
			0.03343853805605834,
			0.03350446698572314,
			0.9975021826308719
		],
		"oris06": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"finger3-3.R": [
			0.3814443860033192,
			0.25644615189128206,
			0.4685576433033641,
			0.7544463443272171
		],
		"finger2-3.R": [
			0.4672994523729038,
			0.29804410433238215,
			0.2986513542236882,
			0.7769223270733367
		],
		"toe3-3.L": [
			-0.1896852912096258,
			-0.01680446903194499,
			-0.006364633172186997,
			0.9816804936250172
		],
		"risorius03.L": [
			-4.3633228585804047e-8,
			-8.726647848789071e-9,
			-4.363322858580405e-8,
			0.9999999999999981
		]
	},
	"Harvey_Fightpose1": {
		"toe1-1.L": [
			3.4906584289728906e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"finger5-2.R": [
			0.14241782955548354,
			0.18340544020920524,
			0.45911395779997516,
			0.8574928454976263
		],
		"finger1-3.R": [
			0.5316028907775064,
			-0.08342266536831022,
			-0.19823809682775143,
			0.8192317635357879
		],
		"toe5-2.R": [
			0,
			0,
			0,
			1
		],
		"toe4-2.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"clavicle.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"neck03": [
			-0.09950394847573953,
			1.1102230246251565e-16,
			1.232595164407831e-32,
			0.9950371672644883
		],
		"neck02": [
			0,
			0,
			0,
			1
		],
		"neck01": [
			0.09950394847573953,
			-1.1102230246251565e-16,
			-1.232595164407831e-32,
			0.9950371672644883
		],
		"clavicle.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe5-2.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"toe4-2.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"finger5-2.L": [
			0.1424178957289729,
			-0.18340538644708682,
			-0.4591139764840006,
			0.8574928360023625
		],
		"finger1-3.L": [
			0.5316028971939397,
			0.08342262743251783,
			0.19823809705645273,
			0.8192317631798105
		],
		"toe1-1.R": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			8.726646072432228e-9,
			0.9999999999999996
		],
		"oculi02.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oculi01.L": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"jaw": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger4-2.R": [
			0.2538552479904895,
			0.20752151480501102,
			0.39648253975421466,
			0.8574928160811429
		],
		"oculi01.R": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"oculi02.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"wrist.R": [
			2.617993999365347e-8,
			-1.745329247793137e-8,
			8.726645628343018e-9,
			0.9999999999999994
		],
		"finger1-1.L": [
			0.06727668256976232,
			0.02523718702190969,
			-0.0688329076350225,
			0.9950371667431006
		],
		"tongue07.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"eye.R": [
			2.6179939993653504e-8,
			-1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"finger2-1.R": [
			0.38413999627109935,
			0.2535084809263868,
			0.22994809643317377,
			0.8574927325114747
		],
		"finger4-3.R": [
			0.13968306519104362,
			0.10238768090274242,
			0.22929118715018942,
			0.9578261614684838
		],
		"finger2-1.L": [
			0.38414001695452443,
			-0.2535084215924658,
			-0.2299480675694721,
			0.8574927485273214
		],
		"eye.L": [
			2.6179939993653504e-8,
			1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		],
		"tongue07.L": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"wrist.L": [
			5.2359879987306816e-8,
			1.745329158975295e-8,
			1.745329303304285e-8,
			0.9999999999999987
		],
		"finger5-3.R": [
			0.07889320618512169,
			0.09744674232356088,
			0.25855176504544797,
			0.9578261738020324
		],
		"lowerleg01.R": [
			0.57010704198927,
			-0.06075485286477156,
			-0.012083210537689695,
			0.8192318380963515
		],
		"lowerarm02.L": [
			-0.09871876237002737,
			0.09434920683940806,
			-0.14076395121851812,
			0.9805806153306595
		],
		"oris07.L": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"oris07.R": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"tongue00": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm02.R": [
			-0.09871875147672626,
			-0.09434923665001405,
			0.14076393705166262,
			0.9805806155926966
		],
		"lowerleg01.L": [
			0.44459728462848763,
			0.04737955381287451,
			0.009423018962957018,
			0.8944269892479165
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			0.06727666807614134,
			-0.02523717656073443,
			0.0688328559077247,
			0.9950371715666715
		],
		"metacarpal4.L": [
			1.3707785118926925e-15,
			-5.235987998730707e-8,
			2.617993999365348e-8,
			0.9999999999999981
		],
		"finger1-2.R": [
			0.4054084463921671,
			-0.05490189796321043,
			-0.1806381183160112,
			0.8944269916573275
		],
		"pelvis.R": [
			0.09892195296917071,
			0.0045465334803233,
			0.00973737517127495,
			0.9950371650239256
		],
		"toe2-1.R": [
			-1.7453292144864443e-8,
			-1.7453292255886765e-8,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"toe2-3.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"toe5-3.L": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"levator05.L": [
			8.72664651652143e-9,
			-2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"finger4-1.L": [
			0.2414498566057147,
			-0.16941412350054463,
			-0.42155293564458085,
			0.8574928244324014
		],
		"finger4-1.R": [
			0.24144982308514215,
			0.1694141668867729,
			0.42155294359399453,
			0.857492821391207
		],
		"levator05.R": [
			8.726646516521438e-9,
			2.6179939660586626e-8,
			-1.7453292144864443e-8,
			0.9999999999999991
		],
		"toe5-3.R": [
			2.6179939993653494e-8,
			8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe2-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.L": [
			0.25385524458961406,
			-0.2075215113979445,
			-0.3964825806160927,
			0.8574927990190143
		],
		"toe2-1.L": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"finger1-2.L": [
			0.4054084166956616,
			0.054901880965227856,
			0.18063812152646022,
			0.894427005512573
		],
		"pelvis.L": [
			0.09892195296917071,
			-0.0045465334803233,
			-0.00973737517127495,
			0.9950371650239256
		],
		"metacarpal4.R": [
			2.6179940881831864e-8,
			2.617994077080965e-8,
			-3.490658428972883e-8,
			0.9999999999999988
		],
		"tongue04": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe3-2.L": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"levator03.R": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"upperleg02.R": [
			-6.108652428338212e-8,
			-8.726645739365324e-9,
			8.72664651652142e-9,
			0.9999999999999983
		],
		"upperleg02.L": [
			-3.490658428972881e-8,
			8.726646738566046e-9,
			1.7453292144864403e-8,
			0.9999999999999988
		],
		"levator03.L": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"toe3-2.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"metacarpal3.L": [
			-2.617994177001032e-8,
			-2.6179941547965768e-8,
			-7.853981998096171e-8,
			0.9999999999999959
		],
		"tongue01": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"breast.L": [
			0,
			0,
			0,
			1
		],
		"temporalis02.R": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"tongue02": [
			0,
			0,
			0,
			1
		],
		"oris04.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"oris04.L": [
			-1.7453292144864436e-8,
			-8.726646072432231e-9,
			1.7453292144864443e-8,
			0.9999999999999999
		],
		"temporalis02.L": [
			0,
			2.6179939993653504e-8,
			1.1102230246251565e-16,
			0.9999999999999998
		],
		"breast.R": [
			0,
			0,
			0,
			1
		],
		"oris03.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"oris06.L": [
			-2.6179939993653497e-8,
			-8.726646405499139e-9,
			-1.7453292144864423e-8,
			0.9999999999999994
		],
		"orbicularis04.R": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"toe1-2.R": [
			2.6179939993653507e-8,
			-8.726645739365324e-9,
			-1.7453292144864397e-8,
			0.9999999999999994
		],
		"toe1-2.L": [
			2.6179939993653504e-8,
			-3.4906584733818136e-8,
			8.726645184253808e-9,
			0.9999999999999991
		],
		"orbicularis04.L": [
			1.7453292144864446e-8,
			1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"metacarpal3.R": [
			-8.726644740164582e-9,
			-2.617993988263123e-8,
			4.363322858580427e-8,
			0.9999999999999987
		],
		"oris06.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"levator04.L": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"tongue06.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe2-2.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe2-2.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"tongue06.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"levator04.R": [
			4.569261529843785e-16,
			2.617993988263123e-8,
			-1.745329214486445e-8,
			0.9999999999999996
		],
		"toe4-1.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"upperleg01.R": [
			-0.3786204082966277,
			0.0377446476883021,
			-0.0881181360844047,
			0.9205743435949056
		],
		"metacarpal1.R": [
			1.7453291256686083e-8,
			2.617993899445281e-8,
			2.6179940881832245e-8,
			0.9999999999999991
		],
		"levator02.R": [
			2.6179939993653494e-8,
			1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"toe3-1.L": [
			2.6179939993653527e-8,
			8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"toe3-1.R": [
			-3.4906584289728906e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999994
		],
		"levator02.L": [
			2.6179939993653494e-8,
			-1.745329158975295e-8,
			-1.745329303304287e-8,
			0.9999999999999994
		],
		"finger5-1.R": [
			0.13717588779953419,
			0.16365465026728132,
			0.46808758172767745,
			0.8574928262584112
		],
		"metacarpal1.L": [
			-1.599241508975541e-15,
			-6.108652395031555e-8,
			-2.617993999365344e-8,
			0.9999999999999974
		],
		"toe4-1.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"upperleg01.L": [
			-0.2019764742586079,
			0.09684215788982642,
			0.2546995298261025,
			0.9407206013517861
		],
		"head": [
			-0.099504013876938,
			1.1102230246251565e-16,
			-1.9721522630525295e-31,
			0.9950371607243511
		],
		"toe5-1.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"special01": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			4.569261529843784e-16,
			1.7453292255886765e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"special04": [
			0,
			0,
			0,
			1
		],
		"metacarpal2.L": [
			-1.745329303304289e-8,
			-1.745329292202058e-8,
			-2.6179939993653487e-8,
			0.9999999999999993
		],
		"metacarpal2.R": [
			-8.72664651652143e-9,
			2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"temporalis01.R": [
			4.569261529843786e-16,
			-1.745329203384216e-8,
			2.6179939993653514e-8,
			0.9999999999999997
		],
		"toe5-1.L": [
			3.4906584289728866e-8,
			-8.726645961409929e-9,
			-1.7169609607764797e-16,
			0.9999999999999993
		],
		"risorius02.R": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"special05.L": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"finger2-2.L": [
			0.3863167447900535,
			-0.2559623024796346,
			-0.22349243612522018,
			0.8574927424759674
		],
		"foot.L": [
			-0.1860346324829889,
			-0.01909511057163593,
			-0.21816426819824955,
			0.9578261033980534
		],
		"oris06": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.R": [
			8.72664651652144e-9,
			1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"orbicularis03.R": [
			8.726646072432225e-9,
			-1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"levator06.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"orbicularis03.L": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"foot.R": [
			-0.1968689146966622,
			-0.023208488092820057,
			0.09123196148715478,
			0.9758999568141247
		],
		"root": [
			-0.09950399934333867,
			1.1102230246251565e-16,
			0,
			0.9950371621777151
		],
		"finger2-2.R": [
			0.38631675656547004,
			0.2559622771926857,
			0.2234924192452392,
			0.8574927491186034
		],
		"risorius02.L": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"special05.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"lowerleg02.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue05.L": [
			0,
			0,
			0,
			1
		],
		"finger5-1.L": [
			0.13717589170095976,
			-0.16365469272688404,
			-0.4680875634130955,
			0.8574928275283165
		],
		"toe4-3.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"oris03.L": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"toe4-3.L": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"finger3-3.L": [
			0.1691485801311556,
			-0.1358984298338637,
			-0.18838622918088052,
			0.9578261863528862
		],
		"tongue05.R": [
			0,
			0,
			0,
			1
		],
		"lowerleg02.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"shoulder01.R": [
			0.006854448394909679,
			-0.0023040771204697608,
			-0.09924084655330952,
			0.9950371662109945
		],
		"finger3-1.L": [
			0.2959342249031023,
			-0.21980123741669622,
			-0.35891000874751133,
			0.857492831563011
		],
		"special06.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger4-3.L": [
			0.13968304761365694,
			-0.10238769622279875,
			-0.22929118796417758,
			0.9578261621993446
		],
		"finger3-2.L": [
			0.3031238599962644,
			-0.2478834822567214,
			-0.33373001938923064,
			0.8574928448002996
		],
		"upperarm01.R": [
			-0.3606930188323886,
			0.2673209727589675,
			0.2284123370334418,
			0.8638679574910153
		],
		"finger3-2.R": [
			0.30312387542013863,
			0.24788350358072786,
			0.3337300354122568,
			0.8574928269475803
		],
		"upperarm01.L": [
			-0.3606930188323886,
			-0.2673209727589675,
			-0.2284123370334418,
			0.8638679574910153
		],
		"special06.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-1.R": [
			0.29593417060963534,
			0.2198012533421837,
			0.35891003230427054,
			0.8574928363584967
		],
		"shoulder01.L": [
			0.006854448394909679,
			0.0023040771204697608,
			0.09924084655330952,
			0.9950371662109945
		],
		"lowerarm01.R": [
			-0.31330907264996977,
			0.2087646995210154,
			0.2882040260643986,
			0.8804505463621382
		],
		"special03": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.L": [
			-0.13212203237919212,
			0.14493230543799496,
			0.0001429908785507868,
			0.9805806315413474
		],
		"spine02": [
			0.09950396300933954,
			-1.1102230246251565e-16,
			0,
			0.995037165811125
		],
		"spine03": [
			0.09950396300933954,
			-1.1102230246251565e-16,
			0,
			0.995037165811125
		],
		"spine01": [
			0,
			0,
			0,
			1
		],
		"upperarm02.R": [
			-0.13212203237919212,
			-0.14493230543799496,
			-0.0001429908785507868,
			0.9805806315413474
		],
		"spine04": [
			0.09950394120893946,
			-1.1102230246251565e-16,
			-1.232595164407831e-32,
			0.99503716799117
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			-0.3133091484326263,
			-0.2087647551102786,
			-0.2882040403079693,
			0.8804505015515239
		],
		"finger5-3.L": [
			0.0788931630259041,
			-0.09744678082510738,
			-0.2585517647737032,
			0.9578261735132295
		],
		"oris01": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris02": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris05": [
			0,
			0,
			0,
			1
		],
		"risorius03.R": [
			-5.235987998730683e-8,
			8.726646294476836e-9,
			-4.4331856927593173e-16,
			0.9999999999999987
		],
		"finger2-3.L": [
			0.21502933386430498,
			-0.14993661492018118,
			-0.11768779017346565,
			0.9578261747980356
		],
		"toe3-3.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger3-3.R": [
			0.16914859424497738,
			0.13589841731013863,
			0.18838625709490525,
			0.9578261801471708
		],
		"finger2-3.R": [
			0.21502929665667458,
			0.14993660153207422,
			0.11768774923997595,
			0.9578261902762822
		],
		"toe3-3.L": [
			3.4906584289728866e-8,
			-5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"risorius03.L": [
			-5.235987998730683e-8,
			-8.726646294476836e-9,
			4.4331856927593173e-16,
			0.9999999999999987
		]
	},
	"fight03": {
		"toe1-1.L": [
			-0.3287341489196925,
			-0.03292560639521336,
			0.024965349688246673,
			0.9435181477282227
		],
		"finger5-2.R": [
			0.1689684251456601,
			0.20487105973169428,
			0.561364146348411,
			0.7838034290450178
		],
		"finger4-2.R": [
			0.3185267158250233,
			0.24373831170872506,
			0.5100503650923528,
			0.7609080048075869
		],
		"toe5-2.R": [
			-4.569261529843785e-16,
			-2.617993988263123e-8,
			-1.745329214486445e-8,
			0.9999999999999996
		],
		"toe4-2.R": [
			-8.72664696061062e-9,
			2.6179939993653534e-8,
			3.490658428972884e-8,
			0.9999999999999991
		],
		"clavicle.R": [
			0.025814432742465993,
			0.11960362388571799,
			-0.015134511209715845,
			0.9923706640091853
		],
		"neck03": [
			-0.10614413683834974,
			-2.5105761247701253e-8,
			1.1456194298766163e-8,
			0.9943507541179023
		],
		"neck02": [
			-0.1041008634220172,
			-0.08134265110750849,
			-0.007479905812721718,
			0.9912065548384076
		],
		"neck01": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"clavicle.L": [
			0.0661948205239435,
			0.1862704904035597,
			-0.022091288522006033,
			0.9800171044997419
		],
		"toe5-2.L": [
			1.7453293033042916e-8,
			2.617994110387656e-8,
			-2.6179939105475286e-8,
			0.9999999999999992
		],
		"toe4-2.L": [
			4.363322858580413e-8,
			2.617993943854202e-8,
			2.6179940881831894e-8,
			0.9999999999999987
		],
		"finger5-2.L": [
			0.16896839594832594,
			-0.204871189804551,
			-0.5613639889021624,
			0.7838035141045042
		],
		"finger1-3.L": [
			0.4936039605268198,
			0.08374276328373753,
			0.19180329461816223,
			0.8441290043135942
		],
		"toe1-1.R": [
			3.4906584289728906e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"oculi02.L": [
			-8.72664571716076e-8,
			-8.72664374096388e-9,
			2.6179940881844394e-8,
			0.9999999999999957
		],
		"oculi01.L": [
			7.853981998095924e-8,
			2.6179944989657145e-8,
			-6.108652073066871e-8,
			0.9999999999999951
		],
		"jaw": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"finger1-3.R": [
			0.4936038837491474,
			-0.08374284844841595,
			-0.19180320361708972,
			0.8441290614377193
		],
		"oculi01.R": [
			6.108652428338193e-8,
			8.726641187450923e-9,
			7.853981998096142e-8,
			0.9999999999999951
		],
		"oculi02.R": [
			-7.853981998095932e-8,
			4.3633227142514386e-8,
			-1.7453295697572024e-8,
			0.9999999999999958
		],
		"wrist.R": [
			-0.07707480320279791,
			-0.06459579610526978,
			0.2954659075182466,
			0.9500456596033664
		],
		"finger1-1.L": [
			0.10355202271420628,
			0.04474809621326059,
			0.13696844411339565,
			0.9841312065950563
		],
		"tongue07.R": [
			3.4906584289728807e-8,
			-8.726644851186904e-9,
			-3.49065842897288e-8,
			0.9999999999999984
		],
		"eye.R": [
			3.046174000298796e-16,
			-3.4906584178706623e-8,
			8.726646072432218e-9,
			0.9999999999999994
		],
		"finger2-1.R": [
			0.47502667208915844,
			0.3081380203390437,
			0.300906408515946,
			0.7673695032638895
		],
		"finger4-3.R": [
			0.27649768979836126,
			0.18711064391812204,
			0.46421876249334065,
			0.820389892074413
		],
		"finger2-1.L": [
			0.47502681262573454,
			-0.30813811863373575,
			-0.3009064515860322,
			0.767369359907861
		],
		"eye.L": [
			8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"tongue07.L": [
			5.2359879987306816e-8,
			6.108652428338246e-8,
			8.726649181056767e-9,
			0.9999999999999966
		],
		"wrist.L": [
			-0.08402383706907846,
			0.0837852980322219,
			-0.2821371239209142,
			0.9520077005694201
		],
		"finger5-3.R": [
			0.15021229473733416,
			0.16993248782924053,
			0.5110320392854649,
			0.8290991924454206
		],
		"lowerleg01.R": [
			0.34057217162496617,
			-0.03786837199544746,
			0.03726459867063385,
			0.9387161083112323
		],
		"lowerarm02.L": [
			-1.7453292144864446e-8,
			8.726646294476836e-9,
			2.6179939993653537e-8,
			0.9999999999999994
		],
		"oris07.L": [
			3.1984830179510653e-15,
			1.2217304834472031e-7,
			-2.6179939993653322e-8,
			0.999999999999992
		],
		"oris07.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"tongue00": [
			7.853981998095983e-8,
			-8.726647293677559e-9,
			1.745329125668274e-8,
			0.9999999999999964
		],
		"lowerarm02.R": [
			-0.08159467601609957,
			-0.08289792764679538,
			0.10850646405906819,
			0.9872672331719978
		],
		"lowerleg01.L": [
			0.0713884389006525,
			0.006508192842409666,
			0.00045797766783342456,
			0.9974272527225784
		],
		"tongue03": [
			-4.363322858580417e-8,
			1.7453292255886765e-8,
			8.726645184253984e-9,
			0.9999999999999989
		],
		"finger1-1.R": [
			0.16403883928541543,
			-0.008237122908441363,
			-0.17249762218881812,
			0.9712198408966369
		],
		"metacarpal4.L": [
			0.0497614873622736,
			-0.03490221879034883,
			-0.11055854647151937,
			0.9920092929509833
		],
		"finger1-2.R": [
			0.14371826875504912,
			-0.020776972258058413,
			-0.06729017011745642,
			0.9871096239300893
		],
		"pelvis.R": [
			-0.010299662918314453,
			0.18879926139456915,
			-0.061274629800462554,
			0.9800480475892241
		],
		"toe2-1.R": [
			1.745329214486445e-8,
			8.726646627543744e-9,
			-2.6179939993653573e-8,
			0.9999999999999997
		],
		"toe2-3.L": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"toe5-3.L": [
			-2.6179945322723953e-8,
			5.235988176366391e-8,
			9.599310857311274e-8,
			0.9999999999999938
		],
		"levator05.L": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"finger4-1.L": [
			0.26273290289395856,
			-0.16771208853714725,
			-0.4689737783198676,
			0.826382279785699
		],
		"finger4-1.R": [
			0.26273273820723914,
			0.16771192083896236,
			0.4689736973514927,
			0.8263824121283694
		],
		"levator05.R": [
			8.726646960610676e-9,
			5.235988043139628e-8,
			-1.745329125668601e-8,
			0.9999999999999988
		],
		"toe5-3.R": [
			-3.4906584289728807e-8,
			2.6179939993653534e-8,
			-8.72664696061079e-9,
			0.999999999999999
		],
		"toe2-3.R": [
			-8.726646072432222e-9,
			-2.220446049250313e-16,
			-3.490658426895706e-8,
			0.9999999999999992
		],
		"finger4-2.L": [
			0.3185266725437417,
			-0.24373851011358483,
			-0.5100503277813523,
			0.7609079843817893
		],
		"toe2-1.L": [
			-0.30554922764295867,
			-0.03048904825501597,
			0.022730047013808295,
			0.9514165398951423
		],
		"finger1-2.L": [
			0.14371832250350058,
			0.020776995483665184,
			0.06729016798579478,
			0.9871096157610334
		],
		"pelvis.L": [
			0.0012242489243162844,
			0.02244175848964447,
			-0.007283501417739646,
			0.9997208706921955
		],
		"metacarpal4.R": [
			0.05222230808198131,
			0.006767337516339733,
			0.06552894700917417,
			0.9964602304083191
		],
		"tongue04": [
			1.5230870001493993e-16,
			8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe3-2.L": [
			-0.1890156093214088,
			-0.017643111399870404,
			0.003033561146039223,
			0.981810886861498
		],
		"levator03.R": [
			8.726645628343061e-9,
			-8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"upperleg02.R": [
			-0.14243525146901612,
			-0.12218914722159557,
			-0.013364896609111856,
			0.9821422457968322
		],
		"upperleg02.L": [
			2.6179940881831824e-8,
			8.726647626744466e-9,
			-6.981316857945608e-8,
			0.9999999999999973
		],
		"levator03.L": [
			8.726644296075356e-9,
			5.235988009832937e-8,
			3.4906584289728846e-8,
			0.9999999999999984
		],
		"toe3-2.R": [
			2.617993910547522e-8,
			-3.4906582846438994e-8,
			-3.4906586066085765e-8,
			0.9999999999999987
		],
		"metacarpal3.L": [
			0.04085343327346028,
			-0.03602789341446799,
			-0.08334085245418814,
			0.9950313011147419
		],
		"tongue01": [
			-7.85398199809599e-8,
			8.726646627543744e-9,
			8.726645184253795e-9,
			0.9999999999999967
		],
		"breast.L": [
			0.004637401286048681,
			-0.000016451771638115176,
			-0.001365767054507339,
			0.999988314391225
		],
		"temporalis02.R": [
			1.745329303304287e-8,
			-3.490658440075123e-8,
			1.7453291256686037e-8,
			0.999999999999999
		],
		"tongue02": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"oris04.R": [
			3.490658428972882e-8,
			-8.726645850387627e-9,
			-1.7453292144864483e-8,
			0.9999999999999989
		],
		"oris04.L": [
			2.6179939993653497e-8,
			8.726646405499139e-9,
			-1.7453292144864423e-8,
			0.9999999999999994
		],
		"temporalis02.L": [
			2.617993999365353e-8,
			-1.745329336610979e-8,
			1.7453291256686023e-8,
			0.9999999999999997
		],
		"breast.R": [
			-6.981316857945727e-8,
			-3.4906584733818136e-8,
			2.663987862210689e-15,
			0.9999999999999971
		],
		"oris03.R": [
			-4.264644023934739e-15,
			6.108652428338246e-8,
			6.98131685794572e-8,
			0.9999999999999958
		],
		"oris06.L": [
			-4.3633228585804066e-8,
			-1.7453290479529926e-8,
			3.490658428972878e-8,
			0.9999999999999984
		],
		"orbicularis04.R": [
			4.363322858580413e-8,
			-2.617993943854202e-8,
			-2.6179940881831894e-8,
			0.9999999999999987
		],
		"toe1-2.R": [
			1.599241508975541e-15,
			6.108652395031555e-8,
			-2.617993999365344e-8,
			0.9999999999999974
		],
		"toe1-2.L": [
			3.490658251337199e-8,
			2.6179938217296694e-8,
			5.2359881763663814e-8,
			0.9999999999999973
		],
		"orbicularis04.L": [
			2.6179939993653494e-8,
			-8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"metacarpal3.R": [
			0.017336996744552035,
			0.01840822395742725,
			0.04692694815901462,
			0.9985782029320959
		],
		"oris06.R": [
			-2.6179939105475035e-8,
			-8.7266446291423e-9,
			5.235987998730851e-8,
			0.9999999999999981
		],
		"levator04.L": [
			1.7453293033042797e-8,
			-9.599310868413369e-8,
			8.72664429607514e-9,
			0.9999999999999954
		],
		"tongue06.L": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"toe2-2.L": [
			5.235988176366363e-8,
			3.490658617710807e-8,
			-3.490658251337178e-8,
			0.9999999999999977
		],
		"toe2-2.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"tongue06.R": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"levator04.R": [
			3.490658428972879e-8,
			6.108652439440476e-8,
			8.72664829287832e-9,
			0.9999999999999977
		],
		"toe4-1.L": [
			-0.11794206599106447,
			-0.01203138968509998,
			0.01674706755875956,
			0.9928063509366704
		],
		"upperleg01.R": [
			-0.13738431664516343,
			-0.239674775118488,
			-0.12897985969428527,
			0.9523894935923469
		],
		"metacarpal1.R": [
			2.6179940881831887e-8,
			-1.7453293255087488e-8,
			2.6179939105475074e-8,
			0.9999999999999993
		],
		"levator02.R": [
			2.6179941770010237e-8,
			-6.981316891252476e-8,
			2.6179938217296602e-8,
			0.9999999999999973
		],
		"toe3-1.L": [
			-0.1716063671693906,
			-0.025302271118799236,
			0.034955970920133084,
			0.9842200617342575
		],
		"toe3-1.R": [
			-1.5230870001493993e-16,
			8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"levator02.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger5-1.R": [
			0.20162215703387604,
			0.1152279618448887,
			0.5200017402593871,
			0.8219910052605739
		],
		"metacarpal1.L": [
			-5.2359881763663464e-8,
			-3.4906586066085765e-8,
			-2.617993821729546e-8,
			0.9999999999999978
		],
		"toe4-1.R": [
			-8.72664651652143e-9,
			2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"upperleg01.L": [
			0.07542632910885946,
			0.039045876384464884,
			0.16445391391262343,
			0.9827213229666643
		],
		"head": [
			-3.474126602281191e-8,
			-0.12849695865580446,
			0.005054191786538284,
			0.9916970236728514
		],
		"toe5-1.R": [
			1.7453291256685974e-8,
			-8.726644518119997e-9,
			-7.853981998096083e-8,
			0.9999999999999969
		],
		"special01": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"temporalis01.L": [
			-5.2359878210949824e-8,
			-6.108652106373569e-8,
			3.490658784244232e-8,
			0.9999999999999964
		],
		"special04": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"metacarpal2.L": [
			0.016693425022190653,
			-0.01026685240025027,
			-0.03163449398794686,
			0.9993073501645762
		],
		"metacarpal2.R": [
			0.01237524733543857,
			0.0016761050192627414,
			0.011353890898684387,
			0.9998575563983163
		],
		"temporalis01.R": [
			-8.72664696061064e-9,
			-8.726647071632954e-9,
			-7.853981998095982e-8,
			0.9999999999999969
		],
		"toe5-1.L": [
			-0.11912385616786286,
			-0.011364161094473801,
			0.003981771763929712,
			0.9928063800298309
		],
		"risorius02.R": [
			-2.6179940881831864e-8,
			-3.490658440075123e-8,
			-2.6179939105475068e-8,
			0.9999999999999987
		],
		"special05.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger2-2.L": [
			0.3797033084589266,
			-0.2848825679975219,
			-0.18361127644621358,
			0.8607869766430453
		],
		"foot.L": [
			8.726643851986146e-9,
			-6.108652428338246e-8,
			-3.4906584289728807e-8,
			0.9999999999999976
		],
		"toe3-3.R": [
			7.615435000746974e-16,
			1.7453292255886765e-8,
			-4.363322858580417e-8,
			0.999999999999999
		],
		"levator06.R": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"orbicularis03.R": [
			-1.745329214486444e-8,
			-8.726646627543744e-9,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"levator06.L": [
			0,
			2.6179939993653504e-8,
			1.1102230246251565e-16,
			0.9999999999999998
		],
		"orbicularis03.L": [
			-1.7453291256686023e-8,
			-2.6179939105475114e-8,
			4.3633228585804576e-8,
			0.9999999999999986
		],
		"foot.R": [
			-0.009526925136499395,
			0.0024195170909099284,
			0.06512691285942157,
			0.9978285768887819
		],
		"root": [
			0.07333480799236669,
			0.18194342168628252,
			0.003938387608576652,
			0.9805626376447631
		],
		"finger2-2.R": [
			0.24842196826982338,
			0.16187491555690692,
			0.15234985586973038,
			0.9428003812106057
		],
		"risorius02.L": [
			-3.49065825133719e-8,
			-3.490658262439439e-8,
			6.108652428338225e-8,
			0.999999999999997
		],
		"special05.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"lowerleg02.L": [
			-8.72664651652143e-9,
			-4.363322880784892e-8,
			-8.726645628342965e-9,
			0.9999999999999992
		],
		"tongue05.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger5-1.L": [
			0.20162203389324287,
			-0.11522815894092198,
			-0.5200017878315145,
			0.8219909777411591
		],
		"toe4-3.R": [
			8.726646072432225e-9,
			-3.3306690738754696e-16,
			3.490658409227928e-8,
			0.9999999999999994
		],
		"oris03.L": [
			-7.853981998095983e-8,
			-8.726647293677559e-9,
			-1.745329125668274e-8,
			0.9999999999999964
		],
		"toe4-3.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"finger3-3.L": [
			0.3281712882862707,
			-0.25492115310224783,
			-0.3823398000481368,
			0.825309086672806
		],
		"tongue05.R": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"lowerleg02.R": [
			-0.014237375424519272,
			-0.15578151817193742,
			-0.005728194094040574,
			0.9876723158666993
		],
		"shoulder01.R": [
			-1.745329214486445e-8,
			-8.726645850387627e-9,
			3.490658428972894e-8,
			0.9999999999999992
		],
		"finger3-1.L": [
			0.34701623734159326,
			-0.24756314373724142,
			-0.43786038332622523,
			0.7915620668005935
		],
		"special06.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger4-3.L": [
			0.27649780140067715,
			-0.18711060050102946,
			-0.4642185618300935,
			0.82038997790876
		],
		"finger3-2.L": [
			0.41169025854102553,
			-0.3287085588485198,
			-0.47238835084158715,
			0.7066194593636089
		],
		"upperarm01.R": [
			-0.14279082204983817,
			0.129379244493522,
			-0.01076718112800857,
			0.9812012332050817
		],
		"finger3-2.R": [
			0.4116900525347049,
			0.32870847770335865,
			0.47238844214488945,
			0.7066195560963746
		],
		"upperarm01.L": [
			0.28129172150468607,
			0.09810721101394038,
			-0.037168288351041204,
			0.9538702537038514
		],
		"special06.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"finger3-1.R": [
			0.3470162243874104,
			0.24756320528891607,
			0.43786038782570463,
			0.7915620507402484
		],
		"shoulder01.L": [
			-0.0956812677550553,
			-0.1583413053952063,
			0.0075566704039705624,
			0.9827085136188314
		],
		"lowerarm01.R": [
			-0.3693087166582038,
			0.3272298177437448,
			-0.02770923051886616,
			0.8693468333891362
		],
		"special03": [
			-1.7453291256686003e-8,
			-5.235987976526246e-8,
			8.726646960611257e-9,
			0.9999999999999984
		],
		"upperarm02.L": [
			-6.98131685794573e-8,
			8.726647626744466e-9,
			1.7453291256686354e-8,
			0.9999999999999976
		],
		"spine02": [
			0.1424804159049506,
			0.05203117410145597,
			0.0924599672251845,
			0.9840951389301208
		],
		"spine03": [
			0.05571894414146325,
			-0.09308537394666094,
			-0.007612715143797389,
			0.9940686892710733
		],
		"spine01": [
			-0.05250173719585274,
			-0.08318854949422605,
			-0.01575275845769405,
			0.9950251672321851
		],
		"upperarm02.R": [
			2.6179939993653487e-8,
			-8.726647182655256e-9,
			2.617993999365346e-8,
			0.9999999999999989
		],
		"spine04": [
			4.363322858580418e-8,
			-1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"spine05": [
			-2.6179939993653527e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"lowerarm01.L": [
			-0.18860430685727536,
			-0.16711478701437632,
			0.014151291046959589,
			0.9676263764272505
		],
		"finger5-3.L": [
			0.15021228475881065,
			-0.1699324778515343,
			-0.5110320293064311,
			0.8290992024490954
		],
		"oris01": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"oris02": [
			-4.36332285858042e-8,
			-8.726645184253812e-9,
			1.7453292144864443e-8,
			0.9999999999999989
		],
		"oris05": [
			-4.363322858580418e-8,
			-1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"risorius03.R": [
			1.7453292144864436e-8,
			-4.363322869682662e-8,
			-6.702088926697263e-16,
			0.9999999999999991
		],
		"finger2-3.L": [
			0.524061475941336,
			-0.3621626894095873,
			-0.30450217552013586,
			0.7081498294409933
		],
		"oris06": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-3.R": [
			0.3281712880685237,
			0.25492108122915624,
			0.3823398950969484,
			0.8253090649263813
		],
		"finger2-3.R": [
			0.5240615023259878,
			0.3621626370025245,
			0.30450212460648773,
			0.7081498586099845
		],
		"toe3-3.L": [
			6.108652428338189e-8,
			-3.490658595506346e-8,
			2.617993821729565e-8,
			0.999999999999997
		],
		"risorius03.L": [
			-6.981316857945724e-8,
			1.745328970237381e-8,
			-3.4906586066085924e-8,
			0.999999999999997
		]
	},
	"fight02": {
		"toe1-1.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger5-2.R": [
			0.07851829615118079,
			0.09520326704697901,
			0.26086133005222956,
			0.9574563079307997
		],
		"finger1-3.R": [
			0.3275044159157543,
			-0.05556254147578643,
			-0.12726164246795052,
			0.9345898222732751
		],
		"toe5-2.R": [
			-1.745329214486445e-8,
			1.7453292366909068e-8,
			8.726645628343025e-9,
			0.9999999999999999
		],
		"toe4-2.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"clavicle.R": [
			0.15350277780497978,
			0.053686414226380874,
			-0.16396089897679758,
			0.9729704464886838
		],
		"neck03": [
			-0.21164821103129924,
			1.2309928831832906e-7,
			-8.799803801732553e-9,
			0.9773459135675736
		],
		"neck02": [
			-0.10688504015760658,
			5.1127183042787294e-8,
			-1.4273142401611037e-8,
			0.9942713855836863
		],
		"neck01": [
			-0.0536294203032614,
			2.6142264908379786e-8,
			-1.404014995812575e-9,
			0.9985609071448449
		],
		"clavicle.L": [
			-0.00836468239304899,
			0.03218952680067966,
			0.26865681319600015,
			0.962661614055625
		],
		"toe5-2.L": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"toe4-2.L": [
			-4.363322858580413e-8,
			3.490658440075123e-8,
			-1.6405861018266948e-15,
			0.9999999999999987
		],
		"finger5-2.L": [
			0.07851830713985868,
			-0.09520327574117882,
			-0.2608612782384046,
			0.9574563202819569
		],
		"finger1-3.L": [
			0.3275044160456745,
			0.05556248756015536,
			0.12726166214138102,
			0.9345898227541976
		],
		"toe1-1.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"oculi02.L": [
			1.7453291256686056e-8,
			-1.745329114566374e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"oculi01.L": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"jaw": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger4-2.R": [
			0.13037049933216624,
			0.0997602270692114,
			0.20875758987564624,
			0.9640911257076755
		],
		"oculi01.R": [
			2.617993999365353e-8,
			-1.745329336610979e-8,
			1.7453291256686023e-8,
			0.9999999999999997
		],
		"oculi02.R": [
			-2.6179939105475054e-8,
			-1.7453291367708346e-8,
			4.363322858580434e-8,
			0.9999999999999986
		],
		"oris03.L": [
			1.7453293033042826e-8,
			-1.7453293144065185e-8,
			5.2359879987306406e-8,
			0.9999999999999981
		],
		"finger1-1.L": [
			5.235987998730683e-8,
			8.726646627543744e-9,
			-8.726645628343008e-9,
			0.9999999999999987
		],
		"tongue07.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"eye.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger2-1.R": [
			-0.07685893760329661,
			-0.049855881633725674,
			-0.048686071618465804,
			0.9946038212310353
		],
		"finger4-3.R": [
			0.18512764190457323,
			0.12527947824356656,
			0.3108130049652387,
			0.9238117148414768
		],
		"finger2-1.L": [
			0,
			-6.981316857945734e-8,
			2.220446049250313e-16,
			0.9999999999999974
		],
		"eye.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue07.L": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"wrist.L": [
			-4.363322858580418e-8,
			1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"finger5-3.R": [
			0.0919080567862738,
			0.10397390707045484,
			0.3126727358849581,
			0.9396691417624029
		],
		"lowerleg01.R": [
			0.9076701038439612,
			-0.0827424670716711,
			-0.005790717335463701,
			0.41140628862904743
		],
		"lowerarm02.L": [
			-0.24140000925248406,
			0.24526007670116345,
			-0.3210174841607727,
			0.8823385434018667
		],
		"oris07.L": [
			4.569261529843784e-16,
			1.7453292255886765e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"oris07.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"tongue00": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm02.R": [
			-0.24139998938737392,
			-0.24526016757655644,
			0.32101753228786983,
			0.8823385060666354
		],
		"lowerleg01.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"metacarpal4.L": [
			4.3633230362160886e-8,
			6.981316857945785e-8,
			-3.490658073701492e-8,
			0.9999999999999958
		],
		"finger1-2.R": [
			-3.490658428972882e-8,
			-2.6179939993653534e-8,
			-8.726645184253818e-9,
			0.9999999999999988
		],
		"pelvis.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-1.R": [
			-2.7755575615628914e-16,
			-1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe2-3.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"toe5-3.L": [
			8.726647404699846e-9,
			-4.363322880784892e-8,
			2.617993999365346e-8,
			0.9999999999999984
		],
		"levator05.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"finger4-1.L": [
			-0.16403328994881308,
			0.10470614081965579,
			0.2927958129941264,
			0.9361625477214587
		],
		"finger4-1.R": [
			-0.16403335726307733,
			-0.1047061131565038,
			-0.29279574666988756,
			0.9361625597644267
		],
		"levator05.R": [
			-8.72664562834302e-9,
			-3.4906584289728926e-8,
			8.726646516521445e-9,
			0.9999999999999994
		],
		"toe5-3.R": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"toe2-3.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"finger4-2.L": [
			0.130370447899922,
			-0.09976024812403084,
			-0.20875755771918103,
			0.9640911374469368
		],
		"toe2-1.L": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"finger1-2.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"pelvis.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"metacarpal4.R": [
			4.363322858580412e-8,
			1.7453291367708346e-8,
			2.6179940881832073e-8,
			0.9999999999999987
		],
		"tongue04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"levator03.R": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"upperleg02.R": [
			-0.310735448132048,
			0.09236769095214947,
			0.14702068217692027,
			0.9345034028587464
		],
		"upperleg02.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator03.L": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"toe3-2.R": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"metacarpal3.L": [
			6.108652428338193e-8,
			8.726648959012095e-9,
			-5.235987998730657e-8,
			0.9999999999999964
		],
		"tongue01": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"breast.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis02.R": [
			-8.72664607243222e-9,
			-4.3633228918871225e-8,
			3.5626088403688626e-16,
			0.9999999999999991
		],
		"tongue02": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris04.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"oris04.L": [
			8.72664651652144e-9,
			1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"temporalis02.L": [
			1.745329303304289e-8,
			-2.6179940104675836e-8,
			1.745329125668605e-8,
			0.9999999999999996
		],
		"breast.R": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"oris03.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"oris06.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"orbicularis04.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"toe1-2.R": [
			2.6179939993653494e-8,
			1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"toe1-2.L": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"orbicularis04.L": [
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"metacarpal3.R": [
			-4.363322680944723e-8,
			-3.4906582846438994e-8,
			2.617994177001014e-8,
			0.9999999999999983
		],
		"oris06.R": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"levator04.L": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"tongue06.L": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"toe2-2.L": [
			-8.726645628343013e-9,
			-1.7453292255886765e-8,
			2.61799399936535e-8,
			0.9999999999999997
		],
		"toe2-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue06.R": [
			1.7453292144864446e-8,
			5.551115123125783e-16,
			-3.490658429686185e-8,
			0.9999999999999992
		],
		"levator04.R": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"toe4-1.L": [
			4.363322858580418e-8,
			-1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"upperleg01.R": [
			-0.2904674097148861,
			0.008839637106639708,
			0.008981846094545814,
			0.9568018975472831
		],
		"metacarpal1.R": [
			-0.020561713650384724,
			-0.013287527191345405,
			-0.009910953411082992,
			0.9996511544310756
		],
		"levator02.R": [
			1.7453292144864443e-8,
			6.661338147750939e-16,
			-2.6179940059872455e-8,
			0.9999999999999999
		],
		"toe3-1.L": [
			8.72664562834302e-9,
			-3.4906584289728926e-8,
			-8.726646516521445e-9,
			0.9999999999999994
		],
		"toe3-1.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator02.L": [
			-3.490658428972881e-8,
			1.745329158975295e-8,
			-1.7453293033042366e-8,
			0.9999999999999991
		],
		"finger5-1.R": [
			-0.08866231325291075,
			-0.09556987826221008,
			-0.3168085299550578,
			0.9394880243650282
		],
		"metacarpal1.L": [
			4.3633228585804126e-8,
			-8.726644740164602e-9,
			-2.6179939993652468e-8,
			0.9999999999999986
		],
		"toe4-1.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperleg01.L": [
			0.11394181188987144,
			0.0034675574649342122,
			0.003523306364490036,
			0.9934751259396194
		],
		"head": [
			0,
			0,
			0,
			1
		],
		"toe5-1.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			2.6179939993653517e-8,
			-3.4906584733818136e-8,
			-8.72664696061073e-9,
			0.9999999999999996
		],
		"special04": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"metacarpal2.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"metacarpal2.R": [
			8.726646516521443e-9,
			1.7453291811797556e-8,
			-2.6179939993653554e-8,
			0.9999999999999993
		],
		"temporalis01.R": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"toe5-1.L": [
			1.7453292144864433e-8,
			-2.617994021569814e-8,
			-4.927555263958927e-16,
			0.9999999999999996
		],
		"risorius02.R": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"special05.L": [
			-8.726646072432225e-9,
			2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"finger2-2.L": [
			0.19389144005260672,
			-0.1263416828672682,
			-0.11890847125467305,
			0.9655592494034064
		],
		"foot.L": [
			0.427954305096812,
			0.10027661553856981,
			-0.04300700261851777,
			0.897190119679773
		],
		"toe3-3.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"levator06.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"orbicularis03.R": [
			0,
			0,
			0,
			1
		],
		"levator06.L": [
			-8.726645628343007e-9,
			1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"orbicularis03.L": [
			8.726646072432225e-9,
			-1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"foot.R": [
			0.3903075973546969,
			-0.035580013589074144,
			-0.0024900460839893408,
			0.919993392232088
		],
		"root": [
			0.47299554174135316,
			0,
			0,
			0.8810648202560375
		],
		"finger2-2.R": [
			0.1938914314054644,
			0.12634178348374026,
			0.11890861357588553,
			0.965559220447482
		],
		"risorius02.L": [
			-8.72664607243222e-9,
			-4.3633228918871225e-8,
			3.5626088403688626e-16,
			0.9999999999999991
		],
		"special05.R": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"lowerleg02.L": [
			-0.012899254241355315,
			0.14114131862822943,
			0.005189888050805495,
			0.9898918135220237
		],
		"tongue05.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger5-1.L": [
			-0.0886622729173451,
			0.09556988468820848,
			0.3168085309199277,
			0.9394880271925611
		],
		"toe4-3.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"wrist.R": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"toe4-3.L": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"finger3-3.L": [
			0.2629496555578068,
			-0.20425806230769306,
			-0.3063506504550313,
			0.8917877559095083
		],
		"tongue05.R": [
			0,
			0,
			0,
			1
		],
		"lowerleg02.R": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"shoulder01.R": [
			0.01043169182929633,
			-0.0036786579226980587,
			-0.18248662815033997,
			0.9831461121459952
		],
		"finger3-1.L": [
			-0.16674505847981197,
			0.11895419071652724,
			0.2103943674901465,
			0.9559185091376571
		],
		"special06.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"finger4-3.L": [
			0.18512762196821628,
			-0.12527940764673673,
			-0.3108129484627892,
			0.9238117474204061
		],
		"finger3-2.L": [
			0.165359020678409,
			-0.132027772709563,
			-0.1897356635052421,
			0.9587624520744722
		],
		"upperarm01.R": [
			-0.5071569411403553,
			0.028422403164259702,
			-0.4158679020374829,
			0.754346002910116
		],
		"finger3-2.R": [
			0.16535890155155525,
			0.1320277926634862,
			0.18973571416276389,
			0.9587624598477024
		],
		"upperarm01.L": [
			-0.3774463095927163,
			-0.07269057098791964,
			0.4682468638784787,
			0.7956099790300893
		],
		"special06.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger3-1.R": [
			-0.16674502966339194,
			-0.11895414498648127,
			-0.21039432991466395,
			0.9559185281250957
		],
		"shoulder01.L": [
			0.01043166201686389,
			0.0036786885770112576,
			0.18248660241342077,
			0.9831461171247772
		],
		"lowerarm01.R": [
			0.15894022850867348,
			-0.14083050228749583,
			0.01192512778972106,
			0.9771195242723694
		],
		"special03": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperarm02.L": [
			-0.1703725533171651,
			0.059349552166194086,
			0.01696521847517597,
			0.9834444595888223
		],
		"spine02": [
			-0.07506347750975062,
			-1.1102230246251565e-16,
			0,
			0.9971787574673577
		],
		"spine03": [
			-0.03701543126561384,
			0,
			0,
			0.9993146941020236
		],
		"spine01": [
			1.3129175373677086e-8,
			0.006076075995877228,
			-0.04492208406337224,
			0.9989720154558362
		],
		"upperarm02.R": [
			-0.170372501934747,
			-0.05934953203450277,
			-0.01696525279738434,
			0.9834444691131781
		],
		"spine04": [
			-0.0829432391053487,
			0,
			0,
			0.9965542730261674
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			0.15894020536743536,
			0.14083047990131214,
			-0.011925140864981967,
			0.9771195311034744
		],
		"finger5-3.L": [
			0.09190805066947225,
			-0.10397389858027528,
			-0.31267269651491186,
			0.9396691564004058
		],
		"oris01": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			6.108652428338212e-8,
			8.726646405499139e-9,
			4.661919405738096e-16,
			0.9999999999999984
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			-4.569261529843784e-16,
			-1.7453292255886765e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"finger2-3.L": [
			0.3569549966341872,
			-0.246681612661786,
			-0.20740371385303857,
			0.8767639430499152
		],
		"oris06": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-3.R": [
			0.2629496212277165,
			0.20425791824779782,
			0.3063507477865867,
			0.8917877655921695
		],
		"finger2-3.R": [
			0.3569550183565636,
			0.24668165275760445,
			0.20740366213443823,
			0.8767639351593256
		],
		"toe3-3.L": [
			-1.7453291256686053e-8,
			-3.4906584178706623e-8,
			2.6179940881831874e-8,
			0.9999999999999988
		],
		"risorius03.L": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		]
	},
	"standing02": {
		"toe1-1.L": [
			-5.235987998730683e-8,
			-8.726646627543744e-9,
			-8.726645628343008e-9,
			0.9999999999999987
		],
		"finger5-2.R": [
			0.02384329531309948,
			0.02891022246714925,
			0.07921388855481354,
			0.9961530284878615
		],
		"finger1-3.R": [
			-1.4835298145498702e-7,
			1.134463939456154e-7,
			-2.6179956868924937e-8,
			0.9999999999999826
		],
		"toe5-2.R": [
			-4.3633230362161e-8,
			1.745329469837742e-8,
			6.108652428338094e-8,
			0.9999999999999971
		],
		"toe4-2.R": [
			-1.745329214486445e-8,
			8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"clavicle.R": [
			-0.02909325588335801,
			-0.13479779021387162,
			0.017056505830961615,
			0.9902990527231664
		],
		"neck03": [
			0,
			0,
			0,
			1
		],
		"neck02": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"neck01": [
			0.034581879095405985,
			1.1102230246251565e-16,
			1.1832913578315177e-30,
			0.9994018679381336
		],
		"clavicle.L": [
			-0.02909326227666523,
			0.13479781155378434,
			-0.01705650747485495,
			0.9902990496022762
		],
		"toe5-2.L": [
			-1.745329214486441e-8,
			-1.1102230246251565e-15,
			-7.853981998115686e-8,
			0.9999999999999968
		],
		"toe4-2.L": [
			-2.617993910547522e-8,
			-3.4906582846438994e-8,
			3.4906586066085765e-8,
			0.9999999999999987
		],
		"finger5-2.L": [
			0.05284908273228402,
			-0.06408284786898466,
			-0.17557864961047145,
			0.9809548923698376
		],
		"finger1-3.L": [
			-2.5307275564043565e-7,
			-6.5503158452884236e-15,
			-2.617993999376353e-8,
			0.9999999999999676
		],
		"toe1-1.R": [
			4.363322858580412e-8,
			-1.5543122344752192e-15,
			4.3633228586164466e-8,
			0.999999999999998
		],
		"oculi02.L": [
			-8.72663941109397e-9,
			6.981316880150246e-8,
			-9.599310857311047e-8,
			0.9999999999999928
		],
		"oculi01.L": [
			-3.490658251337201e-8,
			1.745329014646302e-8,
			-6.108652428338315e-8,
			0.9999999999999973
		],
		"jaw": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			5.235987821094984e-8,
			5.235987787788332e-8,
			2.617994265818816e-8,
			0.9999999999999968
		],
		"oculi01.R": [
			-1.7453293033042846e-8,
			8.726647071632954e-9,
			5.235987998730684e-8,
			0.9999999999999984
		],
		"oculi02.R": [
			7.853981998095975e-8,
			-4.218847493575595e-15,
			5.235987992701905e-8,
			0.9999999999999957
		],
		"oris03.L": [
			1.745329303304277e-8,
			-8.726645728263094e-8,
			8.726644740164559e-9,
			0.9999999999999961
		],
		"finger1-1.L": [
			-0.06419655183268605,
			-0.028313471028957427,
			0.2493314745260067,
			0.9658731624296087
		],
		"tongue07.R": [
			-8.726648292878309e-9,
			-2.6179940992854256e-8,
			-7.853981998095838e-8,
			0.9999999999999964
		],
		"eye.R": [
			-1.7453292144864436e-8,
			1.1102230246251565e-15,
			5.2359879927727643e-8,
			0.9999999999999986
		],
		"finger2-1.R": [
			0.08148109060759169,
			-0.08019722128147666,
			-0.04650590391446794,
			0.9923539884906124
		],
		"finger4-3.R": [
			-8.72664296380771e-9,
			3.4906584178706623e-8,
			-8.726645717160819e-8,
			0.9999999999999956
		],
		"finger2-1.L": [
			-8.726645361889314e-8,
			-5.2359873103924315e-8,
			7.853982353367216e-8,
			0.9999999999999917
		],
		"eye.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"tongue07.L": [
			5.235987998730684e-8,
			-3.3306690738754696e-16,
			8.726646049588092e-9,
			0.9999999999999987
		],
		"wrist.L": [
			0.082251445160241,
			0.040045359574991446,
			0.000921018854220521,
			0.9958063168457166
		],
		"finger5-3.R": [
			-4.363323036216091e-8,
			-4.363323047318346e-8,
			-2.6179938217296526e-8,
			0.9999999999999981
		],
		"lowerleg01.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"lowerarm02.L": [
			0.0457151205718622,
			-0.04644671673281009,
			0.060793533603965076,
			0.9960205703336581
		],
		"oris07.L": [
			-5.235987110552229e-8,
			9.599310524244231e-8,
			-8.726646072432102e-8,
			0.9999999999999903
		],
		"oris07.R": [
			6.108652073066812e-8,
			-6.108652095271339e-8,
			-4.363323213851738e-8,
			0.9999999999999954
		],
		"tongue00": [
			1.7453291434320933e-7,
			1.1102230246251565e-16,
			0,
			0.9999999999999849
		],
		"lowerarm02.R": [
			1.0471975286918616e-7,
			-3.4906563084469155e-8,
			-2.094395270548307e-7,
			0.9999999999999719
		],
		"lowerleg01.L": [
			0,
			0,
			0,
			1
		],
		"tongue03": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger1-1.R": [
			-7.853981998095938e-8,
			-9.599310879515599e-8,
			-1.7453285039437966e-8,
			0.9999999999999925
		],
		"metacarpal4.L": [
			6.108653849423774e-8,
			1.9198622447369473e-7,
			-6.98131579213134e-8,
			0.9999999999999775
		],
		"finger1-2.R": [
			-0.027607659000188252,
			-0.09452725882365731,
			-0.02977874166801362,
			0.9946937423390603
		],
		"pelvis.R": [
			6.981316857945728e-8,
			-8.726644740164602e-9,
			-2.617994088183179e-8,
			0.9999999999999974
		],
		"toe2-1.R": [
			1.5230870001493993e-16,
			8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe2-3.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"toe5-3.L": [
			0,
			0,
			4.3633228585804205e-8,
			0.9999999999999991
		],
		"levator05.L": [
			3.426946015033916e-15,
			7.85398199809606e-8,
			-4.363322858580405e-8,
			0.9999999999999959
		],
		"finger4-1.L": [
			0.07391533050624739,
			-0.04718584427322314,
			-0.13193761691425732,
			0.9873715031635061
		],
		"finger4-1.R": [
			0.02988312363494569,
			0.08183193628945329,
			0.1447720490167017,
			0.9856224363053241
		],
		"levator05.R": [
			-1.7453292144864443e-8,
			-1.7453292255886765e-8,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"toe5-3.R": [
			-3.4906584289728674e-8,
			3.1086244689504383e-15,
			9.5993108598738e-8,
			0.9999999999999946
		],
		"toe2-3.R": [
			8.726646072432225e-9,
			6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"finger4-2.L": [
			0.1445792797556628,
			-0.11064071791946717,
			-0.23150625695142812,
			0.955646543653007
		],
		"toe2-1.L": [
			-5.2359878210949904e-8,
			-2.617993755116288e-8,
			4.363323036216089e-8,
			0.9999999999999973
		],
		"finger1-2.L": [
			0.12053357974195325,
			0.01742444147796096,
			0.056434803783796214,
			0.9909506334402619
		],
		"pelvis.L": [
			-3.4906584289728906e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999994
		],
		"metacarpal4.R": [
			1.7453293033042833e-8,
			8.726646960610651e-9,
			-5.2359879987304315e-8,
			0.9999999999999987
		],
		"tongue04": [
			-7.853981998095985e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"toe3-2.L": [
			8.726646072432215e-9,
			-4.440892098500626e-16,
			6.108652437680207e-8,
			0.9999999999999982
		],
		"levator03.R": [
			8.726645628343017e-9,
			1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"upperleg02.R": [
			6.108652428338206e-8,
			-2.617994165898807e-8,
			3.4906582513371855e-8,
			0.9999999999999969
		],
		"upperleg02.L": [
			5.235987998730683e-8,
			8.726646627543744e-9,
			-8.726645628343008e-9,
			0.9999999999999987
		],
		"levator03.L": [
			-4.363322680944721e-8,
			4.3633227031492083e-8,
			-2.6179941770010135e-8,
			0.999999999999998
		],
		"toe3-2.R": [
			-2.617994177001034e-8,
			-2.6179941770010373e-8,
			-5.235987998730672e-8,
			0.999999999999998
		],
		"metacarpal3.L": [
			-1.2184696001195143e-15,
			3.4906584178706623e-8,
			3.4906584289728846e-8,
			0.9999999999999988
		],
		"tongue01": [
			0,
			0,
			0,
			1
		],
		"breast.L": [
			-5.2359878210950016e-8,
			-8.726645717160864e-8,
			1.7453296585756085e-8,
			0.9999999999999944
		],
		"temporalis02.R": [
			5.2359881763664e-8,
			-1.396263374919826e-7,
			1.745328503943907e-8,
			0.9999999999999886
		],
		"tongue02": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris04.R": [
			3.490658961879958e-8,
			-3.490658950777714e-8,
			1.3962633715889066e-7,
			0.999999999999989
		],
		"oris04.L": [
			1.7453292144864453e-8,
			2.6179939993653534e-8,
			8.726646516521464e-9,
			0.9999999999999997
		],
		"temporalis02.L": [
			1.134463936125464e-7,
			2.6179931000847034e-8,
			7.853982353365631e-8,
			0.9999999999999899
		],
		"breast.R": [
			-5.235988709273409e-8,
			1.2217304856676492e-7,
			5.235987288187946e-8,
			0.9999999999999899
		],
		"oris03.R": [
			5.940039618219929e-15,
			1.1344639727628447e-7,
			-5.235987998730654e-8,
			0.9999999999999922
		],
		"oris06.L": [
			-6.981316857945728e-8,
			2.9976021664879227e-15,
			4.363322855816734e-8,
			0.9999999999999967
		],
		"orbicularis04.R": [
			-8.726646072432225e-9,
			-2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"toe1-2.R": [
			8.726645628343025e-9,
			8.726645517320719e-9,
			2.6179939993653497e-8,
			0.9999999999999994
		],
		"toe1-2.L": [
			2.6179939993653497e-8,
			-8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"orbicularis04.L": [
			8.726645717160759e-8,
			2.617993943854202e-8,
			8.72664829287866e-9,
			0.9999999999999959
		],
		"metacarpal3.R": [
			-3.49065718552316e-8,
			7.853981309757785e-8,
			-1.6580627004710779e-7,
			0.9999999999999822
		],
		"oris06.R": [
			-6.981316857945706e-8,
			2.6179942769211095e-8,
			4.363322680944984e-8,
			0.9999999999999962
		],
		"levator04.L": [
			7.853981998095937e-8,
			-1.1344639705423987e-7,
			-8.831922556259788e-15,
			0.9999999999999905
		],
		"tongue06.L": [
			-1.745329303304289e-8,
			-2.617994077080965e-8,
			-3.4906584289728476e-8,
			0.9999999999999987
		],
		"toe2-2.L": [
			1.5230870001493993e-16,
			8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"toe2-2.R": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"tongue06.R": [
			1.745329303304279e-8,
			8.726647404699861e-9,
			-8.726645717160776e-8,
			0.999999999999996
		],
		"levator04.R": [
			1.7453293921221044e-8,
			1.570796399619212e-7,
			-8.726643407897075e-9,
			0.9999999999999877
		],
		"toe4-1.L": [
			-3.490658428972883e-8,
			8.726647515722163e-9,
			3.490658428972884e-8,
			0.9999999999999987
		],
		"upperleg01.R": [
			6.981316857945731e-8,
			2.6179940104675836e-8,
			1.7679558070943898e-15,
			0.9999999999999971
		],
		"metacarpal1.R": [
			1.2217304856676082e-7,
			8.726655842394848e-9,
			-7.853981998080424e-8,
			0.9999999999999893
		],
		"levator02.R": [
			1.7453278822188343e-8,
			-1.7453291445423957e-7,
			-7.853982353367169e-8,
			0.9999999999999816
		],
		"toe3-1.L": [
			-1.7453292144864453e-8,
			-2.6179939993653534e-8,
			8.726646516521464e-9,
			0.9999999999999997
		],
		"toe3-1.R": [
			-2.617993910547503e-8,
			-2.6179939216497417e-8,
			3.490658428972883e-8,
			0.9999999999999989
		],
		"levator02.L": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"finger5-1.R": [
			-0.04741890912381537,
			0.09821336049468288,
			0.16380620858468076,
			0.9804453625301929
		],
		"metacarpal1.L": [
			-3.490658606608563e-8,
			-6.981316869048015e-8,
			-2.6179937329118136e-8,
			0.9999999999999966
		],
		"toe4-1.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"upperleg01.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"head": [
			0,
			0,
			0,
			1
		],
		"toe5-1.R": [
			-3.490657540794398e-8,
			4.363322159139926e-8,
			-2.007128614422873e-7,
			0.9999999999999782
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			3.4906582513372053e-8,
			-7.85398198699383e-8,
			-1.745329480939791e-8,
			0.9999999999999961
		],
		"special04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal2.L": [
			-2.4434609713350654e-7,
			3.490659838956134e-8,
			6.10865171779226e-8,
			0.9999999999999677
		],
		"metacarpal2.R": [
			-1.745329036850763e-8,
			6.108652417236016e-8,
			-2.6179940881831788e-8,
			0.9999999999999974
		],
		"temporalis01.R": [
			-8.726643407896923e-9,
			7.85398198699383e-8,
			-3.490658428972874e-8,
			0.9999999999999962
		],
		"toe5-1.L": [
			8.726644740164582e-9,
			-2.6179939993653534e-8,
			-4.363322858580427e-8,
			0.9999999999999988
		],
		"risorius02.R": [
			-5.23598799873068e-8,
			3.4906584733818136e-8,
			-8.726647848788919e-9,
			0.9999999999999982
		],
		"special05.L": [
			8.726646072432198e-9,
			8.726645672751943e-8,
			8.16224901721429e-16,
			0.9999999999999961
		],
		"finger2-2.L": [
			0.048091495853094086,
			-0.03133790599041386,
			-0.029491696933879274,
			0.997915519213279
		],
		"foot.L": [
			8.726646072432215e-9,
			-4.440892098500626e-16,
			6.108652437680207e-8,
			0.9999999999999982
		],
		"toe3-3.R": [
			-8.726646516521423e-9,
			-8.726646294476836e-9,
			-5.235987998730662e-8,
			0.9999999999999984
		],
		"levator06.R": [
			8.726646072432212e-9,
			6.661338147750939e-16,
			-4.363322873131176e-8,
			0.9999999999999994
		],
		"orbicularis03.R": [
			-8.726645628343061e-9,
			8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"levator06.L": [
			4.363322858580414e-8,
			1.7453293810199e-8,
			-4.3633228585804126e-8,
			0.9999999999999982
		],
		"orbicularis03.L": [
			1.745329303304289e-8,
			-2.6179940104675836e-8,
			1.745329125668605e-8,
			0.9999999999999996
		],
		"foot.R": [
			4.363323036216091e-8,
			-2.6179941881032676e-8,
			4.363322680944725e-8,
			0.9999999999999978
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			7.853981642824635e-8,
			2.61799294465348e-8,
			1.3089969286281315e-7,
			0.9999999999999882
		],
		"risorius02.L": [
			8.72664651652143e-9,
			-3.490658451177353e-8,
			1.745329214486445e-8,
			0.9999999999999992
		],
		"special05.R": [
			-8.72664562834299e-9,
			-6.981316835741325e-8,
			8.726646516521431e-9,
			0.9999999999999971
		],
		"lowerleg02.L": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"tongue05.L": [
			-3.490658428972886e-8,
			-4.440892098500626e-16,
			-1.7453292072804558e-8,
			0.9999999999999993
		],
		"finger5-1.L": [
			0.06657915646613774,
			-0.0717748228122862,
			-0.2379118312284291,
			0.9663402875261166
		],
		"toe4-3.R": [
			1.745329214486445e-8,
			1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"wrist.R": [
			0.1300094450964138,
			-0.03302983545381433,
			-0.011384576963621494,
			0.9908970509406998
		],
		"toe4-3.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"finger3-3.L": [
			0.05294297277569233,
			-0.041126076788211896,
			-0.06167723377313597,
			0.9958421593183209
		],
		"tongue05.R": [
			-3.490658428972884e-8,
			-8.726645517320719e-9,
			1.7453292144864436e-8,
			0.9999999999999991
		],
		"lowerleg02.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"shoulder01.R": [
			-0.0015296201266894083,
			0.0005393533646340654,
			0.02675703545871724,
			0.9996406506408575
		],
		"finger3-1.L": [
			0.05971172659062661,
			-0.0426004192115661,
			-0.07534095542158728,
			0.9944563612480577
		],
		"special06.R": [
			-8.72664651652144e-9,
			-1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"finger4-3.L": [
			0.1349317182386293,
			-0.09131511782291124,
			-0.22652949722448884,
			0.9602808795125413
		],
		"finger3-2.L": [
			0.14830719864793576,
			-0.11841819116471264,
			-0.17016382921269702,
			0.9669676199636421
		],
		"upperarm01.R": [
			-0.000005148833728146426,
			-0.0000022141510939155395,
			0.2271831122910168,
			0.9738520593284972
		],
		"finger3-2.R": [
			-6.981316857945715e-8,
			-2.6179937440140577e-8,
			3.4906586066083515e-8,
			0.9999999999999967
		],
		"upperarm01.L": [
			-0.000004743897332721034,
			0.0000022284154077567564,
			-0.21437684864004336,
			0.9767510259731972
		],
		"special06.L": [
			-1.745329303304288e-8,
			1.7453293144065185e-8,
			3.490658428972881e-8,
			0.9999999999999989
		],
		"finger3-1.R": [
			0.05029205700394448,
			0.03587873559021426,
			0.06345669675413784,
			0.9960706164583981
		],
		"shoulder01.L": [
			-4.8913828459258096e-8,
			0.0006932761104666563,
			-0.014575133539131643,
			0.9998935367580635
		],
		"lowerarm01.R": [
			0.1757575635489627,
			-0.13642193261639324,
			0.008028949095744827,
			0.9749019802692772
		],
		"special03": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"upperarm02.L": [
			-8.726641187450837e-9,
			7.85398198699383e-8,
			-6.108652428338194e-8,
			0.999999999999995
		],
		"spine02": [
			-0.01365348735127807,
			-1.1102230246251565e-16,
			-4.930380657631324e-32,
			0.9999067867972236
		],
		"spine03": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"spine01": [
			-0.01010686399215855,
			0,
			0,
			0.9999489243457608
		],
		"upperarm02.R": [
			-8.726642075629366e-9,
			-1.483529815660134e-7,
			2.6179940881831583e-8,
			0.9999999999999888
		],
		"spine04": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"spine05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			0.17436876310356386,
			0.11613818147978228,
			-0.0014612630969630183,
			0.9778063826578673
		],
		"finger5-3.L": [
			0.08987405394819983,
			-0.10168060753533337,
			-0.3057516626331417,
			0.9423903805086465
		],
		"oris01": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"oris05": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"risorius03.R": [
			-1.7453291256686047e-8,
			3.4906584289728926e-8,
			-1.745329303304288e-8,
			0.999999999999999
		],
		"finger2-3.L": [
			-0.008259031841369006,
			0.005707868111971992,
			0.004798558723811813,
			0.9999380893179507
		],
		"oris06": [
			0,
			0,
			0,
			1
		],
		"finger3-3.R": [
			4.363322858580419e-8,
			-2.6179939660586626e-8,
			8.7266447401649e-9,
			0.9999999999999984
		],
		"finger2-3.R": [
			0.08735127196175631,
			0.06036580936867164,
			0.05075103775367347,
			0.9930508831438868
		],
		"toe3-3.L": [
			0,
			0,
			-6.981316857945735e-8,
			0.9999999999999976
		],
		"risorius03.L": [
			-5.235987998730676e-8,
			1.7453290479529926e-8,
			-2.6179940881831593e-8,
			0.9999999999999982
		]
	},
	"standing03": {
		"toe1-1.L": [
			1.745329214486445e-8,
			1.7453292366909068e-8,
			-8.726645628343025e-9,
			0.9999999999999999
		],
		"finger5-2.R": [
			0.036188674921094385,
			0.04387858936015099,
			0.12022915957879521,
			0.9911155323120489
		],
		"finger4-2.R": [
			0.05815549132770065,
			0.04450095097568196,
			0.09312178915677795,
			0.9929581746352331
		],
		"toe5-2.R": [
			-4.3633228585804305e-8,
			-8.726642075629343e-9,
			8.726645717159766e-8,
			0.9999999999999951
		],
		"toe4-2.R": [
			2.6179939993653527e-8,
			8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"clavicle.R": [
			-0.0021221146332568845,
			-0.0618705784606125,
			0.03421322692134622,
			0.9974953550037519
		],
		"neck03": [
			0,
			0,
			0,
			1
		],
		"neck02": [
			0.02026816864450511,
			-2.220446049250313e-16,
			-3.944304526105059e-31,
			0.9997945795711224
		],
		"neck01": [
			0.04642494335138631,
			0.0011656554896644078,
			-0.010270275049750671,
			0.9988683032975383
		],
		"clavicle.L": [
			-0.003560656675289487,
			0.06684457882156447,
			-0.05307297503003078,
			0.9963445103615867
		],
		"toe5-2.L": [
			-2.617993555276154e-8,
			4.3633224922068337e-8,
			-1.0471975997460876e-7,
			0.9999999999999932
		],
		"toe4-2.L": [
			-5.2359879987306664e-8,
			-2.6179942214099583e-8,
			-2.6179938217290193e-8,
			0.9999999999999982
		],
		"finger5-2.L": [
			0.05284969301459374,
			-0.06408246105756676,
			-0.17558122362600392,
			0.980954424039702
		],
		"finger1-3.L": [
			-1.7453291434320922e-7,
			1.7453292144864463e-8,
			-3.038100716026548e-15,
			0.9999999999999847
		],
		"toe1-1.R": [
			-3.490658428972892e-8,
			-8.726643851986182e-9,
			6.981316857945966e-8,
			0.9999999999999969
		],
		"oculi02.L": [
			-1.0471975642189716e-7,
			4.363321837175249e-8,
			-9.599311212582244e-8,
			0.9999999999999891
		],
		"oculi01.L": [
			-1.1344639005983205e-7,
			1.3962633038655525e-7,
			-5.235989597451681e-8,
			0.9999999999999825
		],
		"jaw": [
			4.3633228585804185e-8,
			4.440892098500626e-16,
			-8.72664605333848e-9,
			0.999999999999999
		],
		"finger1-3.R": [
			-6.981316857945679e-8,
			6.108652439440476e-8,
			-1.745329658575782e-8,
			0.9999999999999958
		],
		"oculi01.R": [
			-3.490659672422714e-8,
			6.981317557386291e-8,
			1.6580627004711769e-7,
			0.9999999999999832
		],
		"oculi02.R": [
			4.363322858580409e-8,
			8.726649070034398e-9,
			-6.981316857945727e-8,
			0.9999999999999963
		],
		"wrist.R": [
			0.13001157503950356,
			-0.03302986281032161,
			-0.011384716313359175,
			0.9908967689688686
		],
		"finger1-1.L": [
			-0.06419735291844,
			-0.028312644362130546,
			0.24933486166341776,
			0.9658722590522895
		],
		"tongue07.R": [
			-8.726649625145942e-9,
			-2.617994077080965e-8,
			-1.3962633715892153e-7,
			0.9999999999999896
		],
		"eye.R": [
			-4.363323036216098e-8,
			2.617994254716649e-8,
			6.108652428338111e-8,
			0.999999999999997
		],
		"finger2-1.R": [
			0.08148229813850388,
			-0.08019712974657145,
			-0.046506769212392086,
			0.9923538561863431
		],
		"finger4-3.R": [
			0.02453147051300016,
			0.016600711539097368,
			0.041185438383127514,
			0.9987123624928529
		],
		"finger2-1.L": [
			-5.235988176366369e-8,
			-6.981316869048015e-8,
			-1.7453288592150754e-8,
			0.9999999999999962
		],
		"eye.L": [
			8.726645628343007e-9,
			-8.726645517320719e-9,
			-5.235987998730687e-8,
			0.9999999999999987
		],
		"tongue07.L": [
			6.108652428338226e-8,
			-2.6179941547965768e-8,
			2.6179938217296582e-8,
			0.9999999999999972
		],
		"wrist.L": [
			0.07315668123399884,
			0.05015435600954876,
			0.012646392205461578,
			0.995978267497981
		],
		"finger5-3.R": [
			-4.363323746758792e-8,
			-7.853982364469658e-8,
			-1.0471975642189932e-7,
			0.9999999999999902
		],
		"lowerleg01.R": [
			-0.005499447916396351,
			-0.06017172354940681,
			-0.0022125626467808654,
			0.9981704385145067
		],
		"lowerarm02.L": [
			-5.235987998730684e-8,
			1.7453292144864463e-8,
			-9.583612278589327e-16,
			0.9999999999999983
		],
		"oris07.L": [
			-5.2359871105522824e-8,
			5.235987121654517e-8,
			-1.658062700470163e-7,
			0.9999999999999833
		],
		"oris07.R": [
			1.2217304856676037e-7,
			-1.1344639716526217e-7,
			-8.726659839211736e-9,
			0.999999999999986
		],
		"tongue00": [
			1.483529814549862e-7,
			1.1102230246251565e-16,
			0,
			0.9999999999999891
		],
		"lowerarm02.R": [
			4.363322858580383e-8,
			5.88418203051333e-15,
			-1.308996928761215e-7,
			0.9999999999999905
		],
		"lowerleg01.L": [
			0.10237231185380417,
			0.08851077831605025,
			0.012393995677759752,
			0.9907230393801966
		],
		"tongue03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			-1.0471975997461224e-7,
			-5.235987798890562e-8,
			1.7453297473960726e-8,
			0.9999999999999931
		],
		"metacarpal4.L": [
			6.981318989573818e-8,
			1.9198622436267243e-7,
			-1.0471974576374662e-7,
			0.9999999999999737
		],
		"finger1-2.R": [
			-0.027608083918184746,
			-0.09452738859281307,
			-0.029779277940921365,
			0.9946937021583615
		],
		"pelvis.R": [
			6.108652428338212e-8,
			-8.726645739365324e-9,
			-8.72664651652142e-9,
			0.9999999999999983
		],
		"toe2-1.R": [
			-6.981316857945772e-8,
			1.745329070157453e-8,
			-8.726647404699831e-9,
			0.9999999999999971
		],
		"toe2-3.L": [
			-4.569261529843786e-16,
			1.745329203384216e-8,
			2.6179939993653514e-8,
			0.9999999999999997
		],
		"toe5-3.L": [
			-1.745329036850753e-8,
			-1.745329059055223e-8,
			9.599310857310997e-8,
			0.9999999999999953
		],
		"levator05.L": [
			-8.726644740164582e-9,
			2.6179939993653534e-8,
			-4.363322858580427e-8,
			0.9999999999999988
		],
		"finger4-1.L": [
			0.07391639466979148,
			-0.04718557188899408,
			-0.13193953011608056,
			0.987371180862231
		],
		"finger4-1.R": [
			-0.001581545278260128,
			0.059886981422010765,
			0.09320803154951457,
			0.9938426993369507
		],
		"levator05.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe5-3.R": [
			-5.235987998730685e-8,
			8.881784197001252e-16,
			1.745329218919785e-8,
			0.9999999999999984
		],
		"toe2-3.R": [
			8.726645184253737e-9,
			-8.72664507323151e-9,
			-1.1344639716525972e-7,
			0.9999999999999937
		],
		"finger4-2.L": [
			0.14458080978508164,
			-0.11063935485677323,
			-0.2315093236986596,
			0.9556457270554586
		],
		"toe2-1.L": [
			-6.108652428338213e-8,
			-1.7453290368507623e-8,
			2.617994088183308e-8,
			0.9999999999999974
		],
		"finger1-2.L": [
			0.12053542473960271,
			0.017424293237637167,
			0.05643567184680806,
			0.9909503621933906
		],
		"pelvis.L": [
			-5.235987998730684e-8,
			-8.881784197001252e-16,
			-1.7453292120936186e-8,
			0.9999999999999983
		],
		"metacarpal4.R": [
			-2.6179940881831854e-8,
			6.981316869048015e-8,
			8.726644296075452e-9,
			0.9999999999999973
		],
		"tongue04": [
			-7.853981998095985e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"toe3-2.L": [
			3.490658428972882e-8,
			-1.2212453270876722e-15,
			4.3633228605944895e-8,
			0.9999999999999986
		],
		"levator03.R": [
			2.6179942658188842e-8,
			4.363323036216116e-8,
			-5.235987821094656e-8,
			0.9999999999999974
		],
		"upperleg02.R": [
			-0.05616308037018928,
			0.004821278266712747,
			0.06447283655728044,
			0.9963261097780509
		],
		"upperleg02.L": [
			0.04974826268264215,
			0.011703838274786937,
			-0.003833889308908129,
			0.9986858524192996
		],
		"levator03.L": [
			-8.726645717160763e-8,
			8.72664507323151e-9,
			-8.726646960610795e-9,
			0.9999999999999961
		],
		"toe3-2.R": [
			-1.7453293033042833e-8,
			-1.745329292202058e-8,
			-5.235987998730684e-8,
			0.9999999999999982
		],
		"metacarpal3.L": [
			7.853981998095974e-8,
			5.235987998730707e-8,
			4.161946496452462e-15,
			0.9999999999999953
		],
		"tongue01": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"breast.L": [
			-8.72664385198621e-9,
			-8.726645750467554e-8,
			2.6179940881831848e-8,
			0.999999999999996
		],
		"temporalis02.R": [
			4.36332339148753e-8,
			-1.7453291467628418e-7,
			2.6179932000049398e-8,
			0.9999999999999835
		],
		"tongue02": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"oris04.R": [
			6.108653138880855e-8,
			-4.363323580225398e-8,
			1.2217304856675862e-7,
			0.9999999999999898
		],
		"oris04.L": [
			3.490658428972886e-8,
			-4.440892098500626e-16,
			1.745329202975935e-8,
			0.9999999999999992
		],
		"temporalis02.L": [
			8.726645717160684e-8,
			-2.6179945544768657e-8,
			6.108652073066889e-8,
			0.9999999999999942
		],
		"breast.R": [
			-2.617994265818882e-8,
			8.726645706058633e-8,
			2.6179937329118314e-8,
			0.9999999999999954
		],
		"oris03.R": [
			-1.745328859215059e-8,
			1.2217304834472031e-7,
			-2.6179941770010175e-8,
			0.9999999999999921
		],
		"oris06.L": [
			-9.90006603036649e-16,
			8.726645961409929e-9,
			1.1344639716525992e-7,
			0.9999999999999937
		],
		"orbicularis04.R": [
			-4.363322858580418e-8,
			-1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"toe1-2.R": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"toe1-2.L": [
			1.7453292144864417e-8,
			1.1102230246251565e-15,
			-6.108652435993826e-8,
			0.9999999999999982
		],
		"orbicularis04.L": [
			6.108652428338216e-8,
			8.726644407097695e-9,
			2.6179940881832314e-8,
			0.9999999999999977
		],
		"metacarpal3.R": [
			-4.363321259859318e-8,
			1.5707963296751615e-7,
			-1.0471976708003597e-7,
			0.9999999999999813
		],
		"oris06.R": [
			-3.807717500373487e-16,
			8.726645961409929e-9,
			4.3633228585804185e-8,
			0.999999999999999
		],
		"levator04.L": [
			6.108652073066846e-8,
			-1.0471975975256953e-7,
			-2.617994621089772e-8,
			0.9999999999999919
		],
		"tongue06.L": [
			-1.745329392122131e-8,
			-2.617994065978735e-8,
			-6.1086524283384e-8,
			0.9999999999999973
		],
		"toe2-2.L": [
			-1.7453291256686037e-8,
			1.7453291034641438e-8,
			-3.4906584289728807e-8,
			0.999999999999999
		],
		"toe2-2.R": [
			8.726646072432225e-9,
			-3.3306690738754696e-16,
			3.490658409227928e-8,
			0.9999999999999994
		],
		"tongue06.R": [
			2.6179939993653385e-8,
			2.4424906541753444e-15,
			-9.599310857181386e-8,
			0.999999999999995
		],
		"levator04.R": [
			2.617994265818852e-8,
			1.1344639705423987e-7,
			-2.617993732911805e-8,
			0.9999999999999926
		],
		"toe4-1.L": [
			-3.4906584289728793e-8,
			1.7453292366909068e-8,
			-8.7266465165216e-9,
			0.9999999999999996
		],
		"upperleg01.R": [
			0.13130308525442225,
			0.025267811893431857,
			0.05880241057439828,
			0.9892741349067145
		],
		"metacarpal1.R": [
			6.981316857945718e-8,
			1.745329425428821e-8,
			-2.617993910547415e-8,
			0.9999999999999974
		],
		"levator02.R": [
			1.1344637940169565e-7,
			-3.3161254053837297e-7,
			-5.235991729078451e-8,
			0.9999999999999374
		],
		"toe3-1.L": [
			-4.3633228585804086e-8,
			-2.617993932751972e-8,
			1.7453293033042373e-8,
			0.9999999999999989
		],
		"toe3-1.R": [
			-6.108652073066833e-8,
			-2.617993488662762e-8,
			8.726645717160445e-8,
			0.9999999999999941
		],
		"levator02.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"finger5-1.R": [
			-0.07709994747629248,
			0.061706254371687086,
			0.07609128609869972,
			0.9921985952673059
		],
		"metacarpal1.L": [
			-3.4906582513372014e-8,
			2.617993888343051e-8,
			-3.490658606608567e-8,
			0.9999999999999983
		],
		"toe4-1.R": [
			-8.726645717160827e-8,
			1.7453290479529926e-8,
			-1.7453293921221223e-8,
			0.9999999999999961
		],
		"upperleg01.L": [
			-0.1780917185131367,
			-0.06136622228210864,
			-0.10991232221574304,
			0.9759286900101883
		],
		"head": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe5-1.R": [
			-9.599310502039588e-8,
			3.4906572077275655e-8,
			-1.221730485667574e-7,
			0.9999999999999871
		],
		"special01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			8.726647404699853e-9,
			-6.981316857945785e-8,
			1.745329125668601e-8,
			0.9999999999999976
		],
		"special04": [
			5.235987998730684e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999987
		],
		"metacarpal2.L": [
			-2.443460971335078e-7,
			-1.7453286038637827e-8,
			2.6179944434498003e-8,
			0.9999999999999695
		],
		"metacarpal2.R": [
			-2.6179943546367226e-8,
			4.363323047318346e-8,
			8.726645717161087e-8,
			0.9999999999999944
		],
		"temporalis01.R": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"toe5-1.L": [
			-1.745329303304289e-8,
			-3.490658440075123e-8,
			-2.617993910547502e-8,
			0.9999999999999988
		],
		"risorius02.R": [
			-2.6179938217296655e-8,
			-2.6179938328318997e-8,
			5.2359879987306704e-8,
			0.999999999999998
		],
		"special05.L": [
			8.376979030217172e-16,
			9.599310846208908e-8,
			-8.726646072432192e-9,
			0.9999999999999953
		],
		"finger2-2.L": [
			0.04809230458538344,
			-0.03133785881689455,
			-0.029492165709111194,
			0.9979154678660042
		],
		"foot.L": [
			0.038836558812633745,
			-0.0793774233514305,
			0.10623626442739396,
			0.9904063824926584
		],
		"toe3-3.R": [
			-1.7453291256686047e-8,
			-3.4906584289728926e-8,
			1.745329303304288e-8,
			0.999999999999999
		],
		"levator06.R": [
			-2.831068712794149e-15,
			-5.235987998730707e-8,
			-5.235987998730679e-8,
			0.9999999999999973
		],
		"orbicularis03.R": [
			-5.235987998730672e-8,
			2.6179938550363602e-8,
			-2.617994177001015e-8,
			0.9999999999999981
		],
		"levator06.L": [
			4.36332285858041e-8,
			8.72664829287828e-9,
			-5.235987998730687e-8,
			0.9999999999999976
		],
		"orbicularis03.L": [
			-1.7453291256686003e-8,
			-5.235987976526246e-8,
			8.726646960611257e-9,
			0.9999999999999984
		],
		"foot.R": [
			-0.08806158880513025,
			-0.023275220199938218,
			-0.11021181927317868,
			0.9897256062132863
		],
		"root": [
			0.005100607492815333,
			0.000047098685043489574,
			-0.009235132485445129,
			0.9999443454077301
		],
		"finger2-2.R": [
			2.0943951284378548e-7,
			8.726643940804024e-8,
			8.72664749351744e-8,
			0.9999999999999705
		],
		"risorius02.L": [
			-5.23598799873067e-8,
			-6.108652450542706e-8,
			3.384421543835748e-15,
			0.999999999999997
		],
		"special05.R": [
			-3.4906578960658666e-8,
			-8.726645372991726e-8,
			5.2359883540022255e-8,
			0.9999999999999942
		],
		"lowerleg02.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"tongue05.L": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"finger5-1.L": [
			0.06657982657369163,
			-0.071773988514225,
			-0.23791489778381444,
			0.9663395483362431
		],
		"toe4-3.R": [
			1.7453292144864446e-8,
			1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"oris03.L": [
			-1.7453296585756555e-8,
			-5.235988187468621e-8,
			-7.853981998095855e-8,
			0.9999999999999953
		],
		"toe4-3.L": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger3-3.L": [
			0.052943766288761414,
			-0.041126045864011584,
			-0.06167823887189581,
			0.9958420561577088
		],
		"tongue05.R": [
			-1.745329214486445e-8,
			-1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"lowerleg02.R": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"shoulder01.R": [
			3.490658428972879e-8,
			3.490658451177353e-8,
			1.745329303304293e-8,
			0.9999999999999987
		],
		"finger3-1.L": [
			0.05971256343159407,
			-0.0426004090703862,
			-0.07534210476626615,
			0.9944562243582432
		],
		"special06.R": [
			-8.726646516521448e-9,
			-8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"finger4-3.L": [
			0.13493340794396358,
			-0.09131377593203394,
			-0.226532372070392,
			0.9602800915096718
		],
		"finger3-2.L": [
			0.1483089728218164,
			-0.11841747590122254,
			-0.1701664225677635,
			0.9669669790702318
		],
		"upperarm01.R": [
			0.004287311784897426,
			-0.000373953789518211,
			0.15809263231355214,
			0.9874149070802987
		],
		"finger3-2.R": [
			0.0233833682913541,
			0.018670199022689626,
			0.026830419866425773,
			0.9991920587782889
		],
		"upperarm01.L": [
			0.0001254576976089777,
			-0.0039661435996181105,
			-0.12879903220959524,
			0.9916627769898314
		],
		"special06.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"finger3-1.R": [
			0.040134667970505376,
			0.028631897481148694,
			0.05064054989876471,
			0.9974993521699536
		],
		"shoulder01.L": [
			1.1344639716525987e-7,
			2.6179941881032676e-8,
			-1.7453289480329958e-8,
			0.9999999999999931
		],
		"lowerarm01.R": [
			0.17576018478934424,
			-0.13642239637261544,
			0.008028441282294877,
			0.9749014469890511
		],
		"special03": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"upperarm02.L": [
			-1.7453291256686e-8,
			8.726644518119997e-9,
			-6.981316857945704e-8,
			0.9999999999999974
		],
		"spine02": [
			-0.03697669074936667,
			-0.0034628759769375073,
			0.03314359935944181,
			0.9987603489589957
		],
		"spine03": [
			-0.03351356966214698,
			0.00032334522282317923,
			0.04074970091683792,
			0.9986071289408841
		],
		"spine01": [
			0.017511551635540697,
			0.002917857601094198,
			-0.019053879649992306,
			0.999660833151234
		],
		"upperarm02.R": [
			-2.617994798725951e-8,
			-7.853982364469658e-8,
			-1.0471975642189552e-7,
			0.9999999999999911
		],
		"spine04": [
			3.454145168148883e-8,
			0.0020016050606387337,
			-0.008495889986294053,
			0.9999619059896838
		],
		"spine05": [
			-7.021807794617627e-9,
			-0.025264763886458597,
			-0.05225109144198663,
			0.9983143368443038
		],
		"lowerarm01.L": [
			0.1743713078143462,
			0.11613859474714727,
			-0.0014607802294091161,
			0.9778058805010296
		],
		"finger5-3.L": [
			0.08987505425611078,
			-0.10167881756119179,
			-0.3057549838497615,
			0.9423894006899968
		],
		"oris01": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			7.853981998095985e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"oris05": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"risorius03.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"finger2-3.L": [
			-0.008259284902162843,
			0.005707878575130332,
			0.004798610079521991,
			0.9999380869215759
		],
		"oris06": [
			0,
			0,
			0,
			1
		],
		"finger3-3.R": [
			6.981316857945727e-8,
			-8.726648403900583e-9,
			3.490658428972855e-8,
			0.9999999999999969
		],
		"finger2-3.R": [
			0.08735259573549614,
			0.06036571210136443,
			0.050751855697848035,
			0.9930507308108643
		],
		"toe3-3.L": [
			-1.745329214486448e-8,
			8.72664507323151e-9,
			-4.36332285858036e-8,
			0.9999999999999989
		],
		"risorius03.L": [
			-1.3962633715891144e-7,
			-6.328271240363392e-15,
			-4.3633228590372446e-8,
			0.9999999999999892
		]
	},
	"standing01": {
		"toe1-1.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"finger5-2.R": [
			0.030899808494936138,
			0.0380658768618487,
			0.10360847635337625,
			0.9934090167103615
		],
		"finger1-3.R": [
			-1.483529743495583e-7,
			-7.853981243144403e-8,
			5.2359892421806756e-8,
			0.9999999999999845
		],
		"toe5-2.R": [
			-4.363322680944719e-8,
			2.6179938550363602e-8,
			-3.4906586066085474e-8,
			0.9999999999999981
		],
		"toe4-2.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"clavicle.R": [
			0.0013364484152596425,
			0.005143550568339705,
			0.04292458641703618,
			0.9990641809584158
		],
		"neck03": [
			-0.00016592844925022453,
			-0.000001045439677049842,
			0.000010594322416027242,
			0.9999999861772084
		],
		"neck02": [
			-0.012375202292394624,
			0.02434863821633937,
			-0.0010046344270071938,
			0.9996264246681857
		],
		"neck01": [
			0.028365441488906806,
			-0.08125376494693792,
			0.010383179934847636,
			0.9962356232265175
		],
		"clavicle.L": [
			0.004642807489156238,
			-0.043253053515849293,
			-0.056129444006922234,
			0.9974753647161655
		],
		"toe5-2.L": [
			-5.235988176366347e-8,
			-1.7453294809399722e-8,
			-5.2359878210949805e-8,
			0.9999999999999972
		],
		"toe4-2.L": [
			-8.726649625145837e-9,
			-3.490658440075123e-8,
			-9.599310857311068e-8,
			0.9999999999999948
		],
		"finger5-2.L": [
			0.004431381798732694,
			-0.0059716482370335555,
			-0.015759557006888105,
			0.9998481577897884
		],
		"finger1-3.L": [
			-1.308996928628367e-7,
			4.363322381184531e-8,
			-3.4906589618800476e-8,
			0.9999999999999905
		],
		"toe1-1.R": [
			3.490658428972878e-8,
			-1.7453292810998278e-8,
			3.4906584289728793e-8,
			0.9999999999999987
		],
		"oculi02.L": [
			-8.726644296075311e-8,
			1.7453290757085682e-7,
			-7.853983419181213e-8,
			0.9999999999999781
		],
		"oculi01.L": [
			-1.3962633715891112e-7,
			8.726657063640175e-9,
			7.853981998093215e-8,
			0.9999999999999871
		],
		"jaw": [
			2.6179939993653507e-8,
			4.440892098500626e-16,
			-1.745329219192525e-8,
			0.9999999999999997
		],
		"finger4-2.R": [
			0.03042693073915627,
			0.02818646393724833,
			0.056675827451951766,
			0.9975307392352102
		],
		"oculi01.R": [
			1.7453290368507637e-8,
			5.235988020935167e-8,
			3.490658606608566e-8,
			0.9999999999999979
		],
		"oculi02.R": [
			-7.853981998095921e-8,
			-6.108652395031555e-8,
			1.7453296585758527e-8,
			0.9999999999999947
		],
		"oris03.L": [
			2.617993466458322e-8,
			-6.981316513776648e-8,
			-7.85398235336732e-8,
			0.9999999999999939
		],
		"finger1-1.L": [
			0.19383101059351107,
			0.13223703502035267,
			-0.19000507859492818,
			0.9533315142223397
		],
		"tongue07.R": [
			-2.741556812027136e-15,
			-3.490658440075123e-8,
			-7.853981998096012e-8,
			0.9999999999999963
		],
		"eye.R": [
			5.235988176366353e-8,
			-2.6179941881032676e-8,
			3.49065825133716e-8,
			0.9999999999999977
		],
		"finger2-1.R": [
			-3.490658606608569e-8,
			5.235987998730707e-8,
			1.7453290368507845e-8,
			0.9999999999999979
		],
		"finger4-3.R": [
			0.016207731241858085,
			0.0157589395122536,
			0.03580194795319432,
			0.9991031907646964
		],
		"finger2-1.L": [
			0.10137101289149374,
			-0.11694643258016313,
			-0.09966429978547582,
			0.9829112253913862
		],
		"eye.L": [
			8.72664607243223e-9,
			1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"tongue07.L": [
			5.2359881763663464e-8,
			-3.4906586066085765e-8,
			2.617993821729546e-8,
			0.9999999999999978
		],
		"wrist.L": [
			0.08530757042310609,
			0.004298034488229074,
			-0.01366528358045436,
			0.9962516777163847
		],
		"finger5-3.R": [
			0.03833421829492074,
			0.042953752073719764,
			0.1286988207892382,
			0.9900111496432584
		],
		"lowerleg01.R": [
			1.745329214486444e-8,
			4.440892098500626e-16,
			-1.7453292016352737e-8,
			0.9999999999999994
		],
		"lowerarm02.L": [
			0.047327918804456755,
			-0.04808534422334254,
			0.06293774761048265,
			0.995734255561332
		],
		"oris07.L": [
			-1.745329392122126e-8,
			7.853982053607211e-8,
			1.7453290368507604e-8,
			0.9999999999999972
		],
		"oris07.R": [
			8.726644740164637e-9,
			6.981316869048015e-8,
			1.7453293033042856e-8,
			0.9999999999999973
		],
		"tongue00": [
			1.0471975997461224e-7,
			-2.6179939660586626e-8,
			-8.726648736968678e-9,
			0.9999999999999946
		],
		"lowerarm02.R": [
			0.047327885234650216,
			0.048085346005217855,
			-0.06293782166355276,
			0.9957342523901748
		],
		"lowerleg01.L": [
			0.18267209429729658,
			0.016733296788396412,
			-0.001076769904772114,
			0.9830308964168941
		],
		"tongue03": [
			-2.6179939993653507e-8,
			-4.440892098500626e-16,
			-1.745329219192525e-8,
			0.9999999999999997
		],
		"finger1-1.R": [
			0.19383093404324103,
			-0.13223702798979742,
			0.19000501628257674,
			0.9533315431809692
		],
		"metacarpal4.L": [
			5.235988886909173e-8,
			1.2217305589423688e-7,
			-7.853981287553083e-8,
			0.9999999999999883
		],
		"finger1-2.R": [
			-0.05228218565385612,
			-0.06828965895932826,
			-0.04986307614265355,
			0.9950461140972645
		],
		"pelvis.R": [
			1.078420144080877e-7,
			-5.122005586333245e-8,
			-0.08502065652545712,
			0.9963791888452739
		],
		"toe2-1.R": [
			-3.490658428972882e-8,
			8.726645850387627e-9,
			-1.7453292144864483e-8,
			0.9999999999999989
		],
		"toe2-3.L": [
			-8.726644740164572e-9,
			4.363322858580432e-8,
			-3.4906584289728966e-8,
			0.9999999999999982
		],
		"toe5-3.L": [
			-2.6179941770010237e-8,
			-6.981316891252476e-8,
			-2.6179938217296602e-8,
			0.9999999999999973
		],
		"levator05.L": [
			-3.4906584289728807e-8,
			8.726644851186904e-9,
			-3.49065842897288e-8,
			0.9999999999999984
		],
		"finger4-1.L": [
			0.030899165454971796,
			-0.025015095156444067,
			-0.06184622279098659,
			0.9972936033661239
		],
		"finger4-1.R": [
			0.11071976553306234,
			0.0761622180041096,
			0.20306201598614895,
			0.969900132865564
		],
		"levator05.R": [
			1.7453291256685845e-8,
			-1.483529816770357e-7,
			-8.726648736967626e-9,
			0.999999999999989
		],
		"toe5-3.R": [
			-4.3633228585804066e-8,
			-1.7453290479529926e-8,
			3.490658428972878e-8,
			0.9999999999999984
		],
		"toe2-3.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"finger4-2.L": [
			0.0304269084340095,
			-0.028186414610548716,
			-0.056675790575551985,
			0.9975307434045263
		],
		"toe2-1.L": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"finger1-2.L": [
			-0.05228221555210821,
			0.0682895829885728,
			0.0498630766092475,
			0.9950461177167974
		],
		"pelvis.L": [
			-8.090525373261067e-8,
			-4.80507783562345e-8,
			-0.05715409735971718,
			0.9983653685675337
		],
		"metacarpal4.R": [
			-2.617993821729672e-8,
			-5.235987843299483e-8,
			3.490658606608563e-8,
			0.999999999999998
		],
		"tongue04": [
			8.726645717160759e-8,
			-8.726646294476836e-9,
			-7.456576877019395e-16,
			0.9999999999999962
		],
		"toe3-2.L": [
			-8.72664651652145e-9,
			8.726646627543744e-9,
			2.6179939993653484e-8,
			0.9999999999999996
		],
		"levator03.R": [
			-1.745329214486445e-8,
			-1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"upperleg02.R": [
			0.0003733625804871215,
			0.0007014879696777276,
			0.03140417580377144,
			0.9995064513334057
		],
		"upperleg02.L": [
			0.0007294082559735764,
			-0.0013705140694401097,
			-0.06134818768688055,
			0.9981152185606214
		],
		"levator03.L": [
			-8.726645717160764e-8,
			1.7453286704771642e-8,
			-6.108652428337993e-8,
			0.9999999999999943
		],
		"toe3-2.R": [
			8.726645184253838e-9,
			-1.7453291034641438e-8,
			-5.235987998730675e-8,
			0.9999999999999989
		],
		"metacarpal3.L": [
			5.235987998730669e-8,
			-8.726647959811373e-9,
			3.4906584289728886e-8,
			0.9999999999999979
		],
		"tongue01": [
			0.0000013788101114147818,
			-3.490657229932026e-8,
			-8.726694032855145e-9,
			0.9999999999990491
		],
		"breast.L": [
			-3.490658251337196e-8,
			-2.6179938106274392e-8,
			4.3633230362161005e-8,
			0.999999999999998
		],
		"temporalis02.R": [
			8.726651845592067e-9,
			-1.3089969297386261e-7,
			4.3633226809447e-8,
			0.9999999999999906
		],
		"tongue02": [
			-5.235987998730684e-8,
			1.7453292144864463e-8,
			-9.583612278589327e-16,
			0.9999999999999983
		],
		"oris04.R": [
			5.2359878210949924e-8,
			2.6179936440939855e-8,
			6.981316857945873e-8,
			0.9999999999999958
		],
		"oris04.L": [
			4.36332285858041e-8,
			-8.726644740164602e-9,
			-3.490658428972879e-8,
			0.9999999999999982
		],
		"temporalis02.L": [
			4.363323213851767e-8,
			5.2359882096730814e-8,
			-5.235987821095056e-8,
			0.9999999999999963
		],
		"breast.R": [
			-1.7453291256686053e-8,
			3.4906584178706623e-8,
			-2.6179940881831874e-8,
			0.9999999999999988
		],
		"oris03.R": [
			6.108651717795459e-8,
			5.2359871327567475e-8,
			1.3962633715887624e-7,
			0.999999999999987
		],
		"oris06.L": [
			-2.6179939993653507e-8,
			8.726645739365324e-9,
			-1.7453292144864397e-8,
			0.9999999999999994
		],
		"orbicularis04.R": [
			4.363322858580418e-8,
			1.7453292144864463e-8,
			7.615435000746977e-16,
			0.9999999999999989
		],
		"toe1-2.R": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"toe1-2.L": [
			5.2359878210949785e-8,
			1.745328970237381e-8,
			5.235988176366349e-8,
			0.9999999999999972
		],
		"orbicularis04.L": [
			8.726645717160763e-8,
			8.72664507323151e-9,
			8.726646960610795e-9,
			0.9999999999999961
		],
		"metacarpal3.R": [
			-1.7453278822188343e-8,
			7.853981609518002e-8,
			-1.745329143431767e-7,
			0.9999999999999818
		],
		"oris06.R": [
			7.853981998095982e-8,
			-2.617994065978735e-8,
			8.726643851984822e-9,
			0.9999999999999962
		],
		"levator04.L": [
			1.7453297473935272e-8,
			-1.570796401839658e-7,
			3.490658073701469e-8,
			0.9999999999999871
		],
		"tongue06.L": [
			-8.726646516521448e-9,
			-8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"toe2-2.L": [
			1.7453293033042846e-8,
			-8.726647071632954e-9,
			5.235987998730684e-8,
			0.9999999999999984
		],
		"toe2-2.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"tongue06.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"levator04.R": [
			5.235988709273409e-8,
			1.2217304856676492e-7,
			-5.235987288187946e-8,
			0.9999999999999899
		],
		"toe4-1.L": [
			3.490658251337205e-8,
			4.363322680944748e-8,
			3.49065860660859e-8,
			0.9999999999999978
		],
		"upperleg01.R": [
			0.0007932753638957078,
			-0.013394871720656454,
			0.13540230350332172,
			0.9906998356373028
		],
		"metacarpal1.R": [
			5.2359879987306704e-8,
			3.4906584733818136e-8,
			-8.726644296075637e-9,
			0.9999999999999982
		],
		"levator02.R": [
			7.853981642824552e-8,
			-7.853981653926922e-8,
			-6.10865313888095e-8,
			0.9999999999999922
		],
		"toe3-1.L": [
			8.726647404699818e-9,
			-3.490658451177353e-8,
			4.363322858580417e-8,
			0.9999999999999984
		],
		"toe3-1.R": [
			-7.853981998095946e-8,
			-8.72664329687467e-9,
			3.4906584289735775e-8,
			0.9999999999999963
		],
		"levator02.L": [
			5.235987998730667e-8,
			4.440892098500626e-15,
			-8.726645717319424e-8,
			0.999999999999995
		],
		"finger5-1.R": [
			0.06612191555558079,
			0.07127710933273157,
			0.2362683751712416,
			0.9668116263587091
		],
		"metacarpal1.L": [
			4.3633225033090315e-8,
			-5.235987876606174e-8,
			-5.235988176366364e-8,
			0.9999999999999968
		],
		"toe4-1.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"upperleg01.L": [
			-0.16940393375034676,
			0.01576121704016542,
			-0.01012566739808149,
			0.9853686427561336
		],
		"head": [
			1.7453292144864446e-8,
			1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"toe5-1.R": [
			-3.490658251337199e-8,
			2.6179938217296694e-8,
			-5.2359881763663814e-8,
			0.9999999999999973
		],
		"special01": [
			-2.6179939993653527e-8,
			8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"temporalis01.L": [
			-3.4906582513372014e-8,
			2.617993888343051e-8,
			-3.490658606608567e-8,
			0.9999999999999983
		],
		"special04": [
			1.7453292144864453e-8,
			-2.6179939993653534e-8,
			-8.726646516521464e-9,
			0.9999999999999997
		],
		"metacarpal2.L": [
			-1.3089969286283653e-7,
			-9.992007221626409e-15,
			-7.853982000838312e-8,
			0.9999999999999881
		],
		"metacarpal2.R": [
			-1.2217304856676233e-7,
			2.6179929113467892e-8,
			-8.726646072436365e-8,
			0.9999999999999885
		],
		"temporalis01.R": [
			-1.7453293033042694e-8,
			-8.72664873696749e-9,
			-1.4835298145498374e-7,
			0.9999999999999888
		],
		"toe5-1.L": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"risorius02.R": [
			-7.853981998095915e-8,
			6.981316891252476e-8,
			8.726640743366316e-9,
			0.9999999999999947
		],
		"special05.L": [
			1.7453291256686047e-8,
			1.7453291478730648e-8,
			2.6179939993653507e-8,
			0.9999999999999994
		],
		"finger2-2.L": [
			0.0627743804428927,
			-0.07445876587662015,
			-0.07171623491412196,
			0.9926590809506978
		],
		"foot.L": [
			0.0032548558854700468,
			-0.041331887574766246,
			0.08046763511589185,
			0.9958945931580948
		],
		"toe3-3.R": [
			8.726646072432217e-9,
			4.440892098500626e-16,
			-6.981316867925081e-8,
			0.9999999999999976
		],
		"levator06.R": [
			2.6179939105475078e-8,
			-1.7453291034641438e-8,
			-3.490658428972863e-8,
			0.9999999999999987
		],
		"orbicularis03.R": [
			6.981316857945734e-8,
			-1.7453290812596833e-8,
			-2.6179940881830544e-8,
			0.9999999999999971
		],
		"levator06.L": [
			8.72664696061061e-9,
			9.59931090172006e-8,
			-8.726645184253729e-9,
			0.999999999999996
		],
		"orbicularis03.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"foot.R": [
			0.002576498400344788,
			0.03271672333759157,
			-0.06369500097343996,
			0.9974296589339207
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			8.726646072432215e-9,
			-4.440892098500626e-16,
			6.108652437680207e-8,
			0.9999999999999982
		],
		"risorius02.L": [
			-4.363322858580413e-8,
			-3.490658440075123e-8,
			1.6405861018266948e-15,
			0.9999999999999987
		],
		"special05.R": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"lowerleg02.L": [
			-0.015001315069428752,
			0.16415316825779558,
			0.006035264541243805,
			0.9863023235697221
		],
		"tongue05.L": [
			-4.3633230362160886e-8,
			5.235988198570851e-8,
			4.363322680944722e-8,
			0.9999999999999967
		],
		"finger5-1.L": [
			-4.363322858580394e-8,
			1.0471976030768104e-7,
			-4.5897214017174974e-15,
			0.9999999999999939
		],
		"toe4-3.R": [
			2.617994088183183e-8,
			-1.7453294032243605e-8,
			6.98131685794569e-8,
			0.9999999999999971
		],
		"wrist.R": [
			0.06958441120627987,
			-0.028825588946430836,
			0.04840522261865417,
			0.9959839504541251
		],
		"toe4-3.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"finger3-3.L": [
			0.03338546340203577,
			-0.030598675278893595,
			-0.04679951522277168,
			0.9978772155328138
		],
		"tongue05.R": [
			-1.745329214486445e-8,
			8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"lowerleg02.R": [
			-8.726645628343007e-9,
			1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"shoulder01.R": [
			-0.0009481394531087745,
			0.0003342754481470145,
			0.016585091354633222,
			0.9998619524895727
		],
		"finger3-1.L": [
			0.08625105730052662,
			-0.07375785890982922,
			-0.12446323059876183,
			0.9857126546780751
		],
		"special06.R": [
			-2.6179939993653527e-8,
			-4.3633228474782015e-8,
			-8.7266447401645e-9,
			0.9999999999999987
		],
		"finger4-3.L": [
			0.016207756890834653,
			-0.015758974935568992,
			-0.03580192377560013,
			0.9991031906562575
		],
		"finger3-2.L": [
			0.04403099380028894,
			-0.04097627405388515,
			-0.058937786297508774,
			0.9964479684840394
		],
		"upperarm01.R": [
			-0.00759291602886526,
			0.0024783817583315937,
			0.1304586987526545,
			0.9914215718703129
		],
		"finger3-2.R": [
			0.044030982558398886,
			0.04097626725740722,
			0.05893778271058691,
			0.9964479694724412
		],
		"upperarm01.L": [
			-0.014483235647055637,
			-0.004727417074235407,
			-0.24884201411783885,
			0.9684242559037725
		],
		"special06.L": [
			-1.7453292144864446e-8,
			1.7453292366909068e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"finger3-1.R": [
			0.08625110398164537,
			0.07375790975142094,
			0.12446322626496306,
			0.9857126473363144
		],
		"shoulder01.L": [
			0.003060627325086791,
			0.001078983955757229,
			0.053536410440752115,
			0.9985606246548675
		],
		"lowerarm01.R": [
			-0.1899821393525905,
			0.20635524645281966,
			0.0003709211951393075,
			0.9598563233140035
		],
		"special03": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"upperarm02.L": [
			-0.13006155184899168,
			0.14656064729596396,
			-0.002406213583508523,
			0.9806111255390749
		],
		"spine02": [
			-0.024777414480179238,
			-0.001965131163890632,
			-0.02916201369763971,
			0.9992656278228954
		],
		"spine03": [
			1.1305956675271007e-8,
			2.79321375584729e-7,
			-0.009237809088198315,
			0.9999573305312439
		],
		"spine01": [
			-4.4241535623038096e-8,
			-0.00416169438734848,
			0.03076796461680833,
			0.9995178901116096
		],
		"upperarm02.R": [
			3.49065860660857e-8,
			-4.363323047318346e-8,
			2.6179938217296602e-8,
			0.999999999999998
		],
		"spine04": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"spine05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			0.1807049419952574,
			0.11649672487495877,
			-0.012440234568704212,
			0.9765344221253927
		],
		"finger5-3.L": [
			0.011286046235334728,
			-0.012419417199208582,
			-0.03672960682684526,
			0.9991843269483118
		],
		"oris01": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"oris02": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"oris05": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"risorius03.R": [
			1.5992415089755425e-15,
			-6.108652450542706e-8,
			2.6179939993653454e-8,
			0.9999999999999977
		],
		"finger2-3.L": [
			0.05646622834127268,
			-0.058824184051631256,
			-0.056739959158290706,
			0.9950536957683674
		],
		"oris06": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"finger3-3.R": [
			0.033385413125653414,
			0.03059864181561045,
			0.04679958400265899,
			0.997877215015278
		],
		"finger2-3.R": [
			4.363323036216091e-8,
			-3.490658628813037e-8,
			5.235987821094999e-8,
			0.9999999999999974
		],
		"toe3-3.L": [
			-8.72664696061064e-9,
			-8.726647071632954e-9,
			-7.853981998095982e-8,
			0.9999999999999969
		],
		"risorius03.L": [
			-2.967059629099436e-7,
			3.4906566193093624e-8,
			-6.108653494094835e-8,
			0.9999999999999536
		]
	},
	"standing06": {
		"toe1-1.L": [
			3.490658251337197e-8,
			-3.4906582846438994e-8,
			-2.6179940881831884e-8,
			0.9999999999999984
		],
		"finger5-2.R": [
			0.036188287794827814,
			0.04387864109000661,
			0.12022719531764225,
			0.9911157824334283
		],
		"finger1-3.R": [
			-2.094395270546385e-7,
			1.047197671910638e-7,
			3.490656297365645e-8,
			0.9999999999999718
		],
		"toe5-2.R": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"toe4-2.R": [
			1.1423153030516055e-15,
			-4.363322858580432e-8,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"clavicle.R": [
			-0.002983784078132612,
			0.0046049811486491565,
			0.028568192758856057,
			0.9995767852164681
		],
		"neck03": [
			-0.033947786142511656,
			0.08716711029569302,
			0.0004239992373707206,
			0.9956150174255948
		],
		"neck02": [
			-0.01989243927310842,
			-0.02706789157923395,
			0.01855151859501467,
			0.9992634593854812
		],
		"neck01": [
			0.047339178579299555,
			0.12282414181615997,
			0.003614859423635437,
			0.991292169418234
		],
		"clavicle.L": [
			-0.019042997072631258,
			0.15815562285035956,
			-0.06331490402007783,
			0.9851981456297181
		],
		"toe5-2.L": [
			-8.726646516521441e-9,
			-8.726646516521441e-9,
			-3.490658428972886e-8,
			0.9999999999999994
		],
		"toe4-2.L": [
			-8.726646072432225e-9,
			-6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"finger5-2.L": [
			0.052849172158083005,
			-0.06408288712674781,
			-0.17557869997389194,
			0.98095487597299
		],
		"finger1-3.L": [
			-2.4434609713350787e-7,
			-8.726652067636564e-9,
			-2.6179938217283936e-8,
			0.9999999999999697
		],
		"toe1-1.R": [
			1.7453292144864446e-8,
			1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"oculi02.L": [
			-3.490657718430158e-8,
			8.726645372991726e-8,
			-7.853982353367374e-8,
			0.9999999999999926
		],
		"oculi01.L": [
			-9.599310857310988e-8,
			2.6179934997649923e-8,
			-5.235988176366031e-8,
			0.9999999999999939
		],
		"jaw": [
			1.7453292144864433e-8,
			2.617994021569814e-8,
			4.927555263958927e-16,
			0.9999999999999996
		],
		"finger4-2.R": [
			0.05815466748744189,
			0.04450110574824717,
			0.09312025949804979,
			0.9929583594026613
		],
		"oculi01.R": [
			8.726639855187211e-9,
			7.8539819758916e-8,
			7.853981998095917e-8,
			0.9999999999999933
		],
		"oculi02.R": [
			6.981316857945728e-8,
			8.726644740164602e-9,
			2.617994088183179e-8,
			0.9999999999999974
		],
		"oris03.L": [
			-2.6179941770010337e-8,
			-5.235988020935167e-8,
			-2.6179938217296668e-8,
			0.999999999999998
		],
		"finger1-1.L": [
			-0.16310383172376436,
			0.08755992299516868,
			0.15419487641152418,
			0.9705433220884788
		],
		"tongue07.R": [
			-8.726649625145859e-9,
			-4.363322858580432e-8,
			-7.85398199809603e-8,
			0.999999999999996
		],
		"eye.R": [
			-4.36332268094474e-8,
			-8.726645706058633e-8,
			1.745329569757789e-8,
			0.999999999999995
		],
		"finger2-1.R": [
			0.08148104994020207,
			-0.08019723976101834,
			-0.046505947014983985,
			0.9923539883164654
		],
		"finger4-3.R": [
			0.024531096599742504,
			0.016600743725516565,
			0.041184813443459506,
			0.9987123969136465
		],
		"finger2-1.L": [
			-7.853981287553213e-8,
			-5.2359871327567475e-8,
			1.0471976352732428e-7,
			0.9999999999999901
		],
		"eye.L": [
			3.4906589618799636e-8,
			6.108652794711844e-8,
			-7.853981642824183e-8,
			0.9999999999999946
		],
		"tongue07.L": [
			6.981316857945724e-8,
			4.3633228918871225e-8,
			3.0766209756393155e-15,
			0.9999999999999969
		],
		"wrist.L": [
			0.0021135344601429444,
			0.14734943129394928,
			-0.018683421065844155,
			0.988905762874659
		],
		"finger5-3.R": [
			-1.7453292144864443e-8,
			-2.6179940104675836e-8,
			-8.726645628343028e-9,
			0.9999999999999997
		],
		"lowerleg01.R": [
			0.6973107183647338,
			-0.06356487412909151,
			-0.004449155104500841,
			0.7139310007623058
		],
		"lowerarm02.L": [
			-1.7453291434320983e-7,
			7.853982730843256e-8,
			4.3633214375019456e-8,
			0.9999999999999807
		],
		"oris07.L": [
			-8.726645361889297e-8,
			6.108651751102201e-8,
			-6.108653138887229e-8,
			0.9999999999999923
		],
		"oris07.R": [
			2.6179938217296665e-8,
			-7.85398198699383e-8,
			-2.617994177001038e-8,
			0.9999999999999958
		],
		"tongue00": [
			1.3089969286283695e-7,
			-4.363323446998635e-8,
			3.490657896067318e-8,
			0.9999999999999905
		],
		"lowerarm02.R": [
			0.07745879601855829,
			0.07869814860123903,
			-0.10300732493599309,
			0.9885323602875239
		],
		"lowerleg01.L": [
			0.0540839020472027,
			0.004930215535515314,
			0.0003452146034457672,
			0.9985241636239951
		],
		"tongue03": [
			-2.617993910547506e-8,
			4.3633228918871225e-8,
			-1.745329303304283e-8,
			0.9999999999999987
		],
		"finger1-1.R": [
			-7.853981642824544e-8,
			-8.726645372991726e-8,
			2.6179947099079058e-8,
			0.9999999999999927
		],
		"metacarpal4.L": [
			-0.08260600576766478,
			0.02472717074119546,
			0.1406627864788613,
			0.986295490884071
		],
		"finger1-2.R": [
			-0.02760765814649784,
			-0.09452724881663377,
			-0.029778725948817645,
			0.9946937437843313
		],
		"pelvis.R": [
			-0.002308971752254623,
			0.006841219990893932,
			0.021466272917933488,
			0.999743499846584
		],
		"toe2-1.R": [
			3.4906584289728793e-8,
			1.7453292366909068e-8,
			-8.72664562834318e-9,
			0.9999999999999996
		],
		"toe2-3.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"toe5-3.L": [
			-2.6179940881831887e-8,
			-8.726647515722163e-9,
			-5.235987998730685e-8,
			0.9999999999999982
		],
		"levator05.L": [
			9.13852305968756e-16,
			2.6179939993653534e-8,
			-3.4906584289728846e-8,
			0.9999999999999991
		],
		"finger4-1.L": [
			0.07391530706379516,
			-0.04718583936301979,
			-0.13193753781894213,
			0.9873715157221964
		],
		"finger4-1.R": [
			-0.001581427020270122,
			0.059887001591228284,
			0.09320651768249892,
			0.9938428402873837
		],
		"levator05.R": [
			-8.72664740469983e-9,
			-3.490658406768432e-8,
			-3.4906584289728846e-8,
			0.9999999999999984
		],
		"toe5-3.R": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"toe2-3.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"finger4-2.L": [
			0.1445792428872969,
			-0.11064070351122346,
			-0.23150631876382166,
			0.9556465359248165
		],
		"toe2-1.L": [
			0,
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0.9999999999999992
		],
		"finger1-2.L": [
			0.12053351512429364,
			0.017424483907527377,
			0.056434778130547154,
			0.9909506420148753
		],
		"pelvis.L": [
			0.00282434556362032,
			0.008368069547742829,
			0.0262572027391596,
			0.999616205245041
		],
		"metacarpal4.R": [
			-3.4906584289728906e-8,
			8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"tongue04": [
			-8.726645717160764e-8,
			-1.7453293588154395e-8,
			-8.726644740163937e-9,
			0.9999999999999962
		],
		"toe3-2.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"levator03.R": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"upperleg02.R": [
			-0.16500232168737464,
			-0.14183215704491725,
			0.016062527949905047,
			0.9759097644053063
		],
		"upperleg02.L": [
			-0.004376604894427891,
			0.04989724088386194,
			-0.03117547416199821,
			0.9982580831090474
		],
		"levator03.L": [
			-2.6179939993653534e-8,
			4.3633228474782015e-8,
			-8.726647404699778e-9,
			0.9999999999999987
		],
		"toe3-2.R": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"metacarpal3.L": [
			-0.10815989824078272,
			0.05933258425884891,
			0.10955609439322923,
			0.9862953629816033
		],
		"tongue01": [
			-1.7453292144864453e-8,
			2.6179939993653534e-8,
			-8.726646516521464e-9,
			0.9999999999999997
		],
		"breast.L": [
			-8.726645628343025e-9,
			-8.726645517320719e-9,
			2.6179939993653497e-8,
			0.9999999999999994
		],
		"temporalis02.R": [
			3.490658251337171e-8,
			-1.396263370478934e-7,
			-8.726650957413986e-9,
			0.9999999999999895
		],
		"tongue02": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"oris04.R": [
			5.235988354002077e-8,
			-3.4906591506178586e-8,
			1.2217304856674922e-7,
			0.9999999999999907
		],
		"oris04.L": [
			1.7453292144864443e-8,
			-2.220446049250313e-16,
			2.6179940054284205e-8,
			0.9999999999999996
		],
		"temporalis02.L": [
			1.3962633715891176e-7,
			-3.490658939675484e-8,
			4.3633223256717494e-8,
			0.9999999999999886
		],
		"breast.R": [
			-1.2184696001195153e-15,
			6.981316846843555e-8,
			1.745329214486441e-8,
			0.9999999999999974
		],
		"oris03.R": [
			-2.617993555276118e-8,
			1.3089969308488492e-7,
			-3.490658784244214e-8,
			0.9999999999999907
		],
		"oris06.L": [
			-2.6179939993653494e-8,
			-1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"orbicularis04.R": [
			-4.363322858580412e-8,
			-3.4906584178706623e-8,
			8.726647404700103e-9,
			0.9999999999999984
		],
		"toe1-2.R": [
			3.4906584289728827e-8,
			-2.617994121489886e-8,
			2.61799391054727e-8,
			0.9999999999999991
		],
		"toe1-2.L": [
			-1.7453291256686043e-8,
			-1.745329114566374e-8,
			4.363322858580395e-8,
			0.9999999999999986
		],
		"orbicularis04.L": [
			1.1344639716525997e-7,
			1.1102230246251565e-16,
			0,
			0.9999999999999936
		],
		"metacarpal3.R": [
			-6.981315081588933e-8,
			9.599309458430128e-8,
			-1.919862242515674e-7,
			0.9999999999999745
		],
		"oris06.R": [
			-5.235987998730666e-8,
			2.617993932751972e-8,
			-8.726647404699014e-9,
			0.9999999999999984
		],
		"levator04.L": [
			6.108652073066898e-8,
			-1.6580626993611958e-7,
			-1.7453301914824148e-8,
			0.9999999999999841
		],
		"tongue06.L": [
			-3.0461740002987937e-16,
			-8.726646183454534e-9,
			-3.490658428972886e-8,
			0.9999999999999994
		],
		"toe2-2.L": [
			-1.5230870001493986e-16,
			1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"toe2-2.R": [
			-1.7453293033042856e-8,
			2.6179940992854256e-8,
			4.3633228585804166e-8,
			0.9999999999999986
		],
		"tongue06.R": [
			8.72665451012708e-9,
			7.85398199809606e-8,
			-1.0471975997461302e-7,
			0.9999999999999912
		],
		"levator04.R": [
			3.4906584289728886e-8,
			4.363322880784892e-8,
			-1.7453290368507557e-8,
			0.9999999999999981
		],
		"toe4-1.L": [
			2.6179939993653494e-8,
			6.661338147750939e-16,
			-2.6179940052507944e-8,
			0.9999999999999993
		],
		"upperleg01.R": [
			-0.5243366834521962,
			-0.09021765885696142,
			-0.260320285187356,
			0.805707866125616
		],
		"metacarpal1.R": [
			1.0471975642189813e-7,
			-1.3089969297386261e-7,
			-1.745330546754038e-8,
			0.9999999999999859
		],
		"levator02.R": [
			1.1344638295440527e-7,
			-1.8325956618880923e-7,
			-7.853984129723938e-8,
			0.9999999999999739
		],
		"toe3-1.L": [
			2.617993910547506e-8,
			-4.3633228918871225e-8,
			-1.745329303304283e-8,
			0.9999999999999987
		],
		"toe3-1.R": [
			-2.2846307649218933e-16,
			-2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"levator02.L": [
			5.2359883540020376e-8,
			6.108652783609614e-8,
			-4.3633225033090335e-8,
			0.999999999999996
		],
		"finger5-1.R": [
			-0.07709874275557724,
			0.06170603943801356,
			0.07609014444514996,
			0.9921987898000579
		],
		"metacarpal1.L": [
			-0.12844658099363498,
			0.08300629239744384,
			0.061912277118482795,
			0.9862952403796138
		],
		"toe4-1.R": [
			1.745329214486444e-8,
			8.726646627543744e-9,
			-1.7453292144864436e-8,
			0.9999999999999996
		],
		"upperleg01.L": [
			0.0028265357278175005,
			-0.022013979096570546,
			-0.06974373134742093,
			0.9973180071360658
		],
		"head": [
			5.691620020337746e-8,
			0.1985095127110218,
			-0.007807371919543378,
			0.9800678641333666
		],
		"toe5-1.R": [
			2.6179940881831953e-8,
			3.490658639915267e-8,
			-3.490658251337214e-8,
			0.9999999999999987
		],
		"special01": [
			-2.7755575615628914e-17,
			8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"temporalis01.L": [
			6.108651717795423e-8,
			-1.1344639361254849e-7,
			-6.108653138880847e-8,
			0.9999999999999901
		],
		"special04": [
			-6.108652428338209e-8,
			-3.490658229132748e-8,
			1.7453293921221273e-8,
			0.9999999999999972
		],
		"metacarpal2.L": [
			-0.10684836551994693,
			0.0580609000540937,
			0.11150727436785653,
			0.9862953342856674
		],
		"metacarpal2.R": [
			-7.853982353367302e-8,
			6.981317257626074e-8,
			4.363322325672324e-8,
			0.9999999999999937
		],
		"temporalis01.R": [
			6.39696603590209e-15,
			1.2217304834472031e-7,
			-5.235987998730646e-8,
			0.9999999999999909
		],
		"toe5-1.L": [
			2.6179937329118308e-8,
			-2.6179937218095972e-8,
			-8.72664571716049e-8,
			0.9999999999999958
		],
		"risorius02.R": [
			1.1423153030516055e-15,
			-4.363322858580432e-8,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"special05.L": [
			1.7453292144864288e-8,
			1.396263369368711e-7,
			2.4655085297586555e-15,
			0.9999999999999902
		],
		"finger2-2.L": [
			0.0480915552102757,
			-0.031337921804811764,
			-0.029491647519471295,
			0.9979155173164713
		],
		"foot.L": [
			-0.0017015871853770864,
			-0.001876792687510731,
			0.055926254021392764,
			0.9984316883800278
		],
		"toe3-3.R": [
			-8.726646516521423e-9,
			-8.726646294476836e-9,
			-5.235987998730662e-8,
			0.9999999999999984
		],
		"levator06.R": [
			1.7453293033042883e-8,
			1.745329292202058e-8,
			-3.4906584289728793e-8,
			0.9999999999999988
		],
		"orbicularis03.R": [
			-8.726646960610676e-9,
			-5.235988043139628e-8,
			-1.745329125668601e-8,
			0.9999999999999988
		],
		"levator06.L": [
			4.363323036216108e-8,
			2.617994343534491e-8,
			-7.853981998095083e-8,
			0.9999999999999956
		],
		"orbicularis03.L": [
			2.617993999365346e-8,
			3.4906584733818136e-8,
			1.0095481158786604e-15,
			0.9999999999999991
		],
		"foot.R": [
			0.09820592353259745,
			-0.046379665612890864,
			0.044707829314797456,
			0.9930789158967709
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			1.2217304146133288e-7,
			9.599309802599265e-8,
			7.853983063909507e-8,
			0.9999999999999851
		],
		"risorius02.L": [
			8.726646072432225e-9,
			-2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"special05.R": [
			-8.726644296075419e-9,
			-6.981316857945785e-8,
			2.6179940881831808e-8,
			0.9999999999999972
		],
		"lowerleg02.L": [
			-0.013127786322222985,
			0.14364177907675346,
			0.005281716143426395,
			0.9895285766487613
		],
		"tongue05.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"finger5-1.L": [
			0.06657915674226138,
			-0.07177477861825621,
			-0.23791172163194713,
			0.9663403177721154
		],
		"toe4-3.R": [
			-2.6179940881831907e-8,
			3.490658451177353e-8,
			1.7453291256686053e-8,
			0.9999999999999991
		],
		"wrist.R": [
			0.13000952439594268,
			-0.03302978838327297,
			-0.01138453844548942,
			0.9908970425478522
		],
		"toe4-3.L": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"finger3-3.L": [
			0.05294296697474373,
			-0.041126032033441784,
			-0.06167725228896651,
			0.9958421603282217
		],
		"tongue05.R": [
			4.569261529843785e-16,
			-2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"lowerleg02.R": [
			-0.01518355576306962,
			-0.16613838202106224,
			-0.006109132877792282,
			0.9859666202003465
		],
		"shoulder01.R": [
			2.617993999365347e-8,
			-2.6179940437742744e-8,
			8.726645184253845e-9,
			0.9999999999999996
		],
		"finger3-1.L": [
			0.05971174308360721,
			-0.04260043152007553,
			-0.07534094787967222,
			0.9944563603018552
		],
		"special06.R": [
			-3.8077175003734897e-16,
			-4.363322869682662e-8,
			-8.726646072432225e-9,
			0.9999999999999991
		],
		"finger4-3.L": [
			0.13493174613427206,
			-0.09131507102874648,
			-0.22652944530455196,
			0.9602808922904708
		],
		"finger3-2.L": [
			0.14830718001502924,
			-0.11841819032243783,
			-0.17016385646263552,
			0.966967618129228
		],
		"upperarm01.R": [
			-0.014118973518765222,
			0.1035555625738026,
			0.022608232087583856,
			0.9942664471300807
		],
		"finger3-2.R": [
			0.023383101745577797,
			0.01867019881081966,
			0.02682995059171522,
			0.9991920776208977
		],
		"upperarm01.L": [
			0.15507622354833422,
			0.04155625484072534,
			0.03379911483634276,
			0.9864492193771963
		],
		"special06.L": [
			8.726645628343025e-9,
			8.726645850387627e-9,
			3.4906584289728807e-8,
			0.9999999999999993
		],
		"finger3-1.R": [
			0.04013405667798251,
			0.02863192028960515,
			0.05063971231026009,
			0.9974994186325284
		],
		"shoulder01.L": [
			3.490658251337185e-8,
			1.7453289591351506e-8,
			7.853981998095986e-8,
			0.9999999999999964
		],
		"lowerarm01.R": [
			0.1328697191552849,
			0.20850121143339273,
			0.038459556980438854,
			0.9681909651712679
		],
		"special03": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"upperarm02.L": [
			0.22170322010537208,
			-0.23824479521962927,
			0.004463202356489909,
			0.9455512569767919
		],
		"spine02": [
			-7.948388470308792e-10,
			-0.0009151943955045816,
			-0.012202407019268214,
			0.9999251290382467
		],
		"spine03": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"spine01": [
			0.00019393356219594616,
			0.02195012143414221,
			-0.006396394423009878,
			0.9997385861799999
		],
		"upperarm02.R": [
			-0.15954004745181058,
			-0.17977203033112255,
			0.003399768065091981,
			0.9706788510866013
		],
		"spine04": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"spine05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			-0.2114909351432767,
			-0.3179792429949517,
			0.008648699739544677,
			0.9241677257778456
		],
		"finger5-3.L": [
			0.08987396972204145,
			-0.10168063072146172,
			-0.3057516245688519,
			0.9423903983891151
		],
		"oris01": [
			1.745329214486444e-8,
			3.490658451177353e-8,
			4.799202690040438e-16,
			0.9999999999999992
		],
		"oris02": [
			-1.7453292144864446e-8,
			1.7453292366909068e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"oris05": [
			-4.3633226809447267e-8,
			5.2359878099927926e-8,
			-2.6179942658188647e-8,
			0.9999999999999973
		],
		"risorius03.R": [
			-1.827704611937508e-15,
			5.235987998730707e-8,
			3.490658428972882e-8,
			0.9999999999999981
		],
		"finger2-3.L": [
			-0.008259065833483402,
			0.005707858799286147,
			0.004798471180254013,
			0.999938089510455
		],
		"oris06": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"finger3-3.R": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"finger2-3.R": [
			0.08735119313709938,
			0.06036579100296513,
			0.050751091590368426,
			0.9930508884425295
		],
		"toe3-3.L": [
			4.569261529843785e-16,
			2.617993988263123e-8,
			-1.745329214486445e-8,
			0.9999999999999996
		],
		"risorius03.L": [
			-1.570796399619154e-7,
			8.726640854384016e-9,
			-3.4906586066039e-8,
			0.9999999999999872
		]
	},
	"standing04": {
		"toe1-1.L": [
			5.2359878210949805e-8,
			-3.490658262439439e-8,
			-2.61799417700093e-8,
			0.9999999999999978
		],
		"finger5-2.R": [
			0.036188634902656856,
			0.04387862362814354,
			0.12022909490236065,
			0.9911155401018293
		],
		"finger4-2.R": [
			0.05815551528757926,
			0.04450102180364901,
			0.09312176311209328,
			0.9929581725002128
		],
		"toe5-2.R": [
			-1.7453291256686043e-8,
			-1.7453291256686043e-8,
			6.981316857945835e-8,
			0.9999999999999972
		],
		"toe4-2.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"clavicle.R": [
			-0.002122105927330871,
			-0.06187060617315698,
			0.03421321197576806,
			0.9974953538159965
		],
		"neck03": [
			-0.03407809175532573,
			8.7215771271687e-9,
			-2.973874584673527e-10,
			0.9994191731512437
		],
		"neck02": [
			-0.02039971229076095,
			0.0012055538182523806,
			0.017615829826382597,
			0.9996359742015959
		],
		"neck01": [
			0.04530748651760654,
			-0.08824788762524527,
			-0.02037565876025873,
			0.9948589721790846
		],
		"clavicle.L": [
			-0.019043223222085116,
			0.158155531481744,
			-0.0633157905225582,
			0.9851980989534763
		],
		"toe5-2.L": [
			3.4906586066085666e-8,
			2.617994077080965e-8,
			-3.4906582513372e-8,
			0.9999999999999986
		],
		"toe4-2.L": [
			7.615435000746974e-16,
			1.7453292255886765e-8,
			-4.363322858580417e-8,
			0.999999999999999
		],
		"finger5-2.L": [
			0.05284975475648943,
			-0.06408240969808388,
			-0.17558125633860516,
			0.980954418213213
		],
		"finger1-3.L": [
			-1.3089969286283475e-7,
			6.981316136300819e-8,
			-4.363323746756771e-8,
			0.9999999999999878
		],
		"toe1-1.R": [
			8.726647848789033e-9,
			-5.235987998730707e-8,
			3.4906584289728846e-8,
			0.9999999999999983
		],
		"oculi02.L": [
			-3.490658073701521e-8,
			4.363322680944748e-8,
			-6.981316857946001e-8,
			0.999999999999996
		],
		"oculi01.L": [
			-1.1344639005983066e-7,
			5.23598678858761e-8,
			-1.047197670800369e-7,
			0.9999999999999868
		],
		"jaw": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"finger1-3.R": [
			-8.726638522915545e-9,
			6.108652428338246e-8,
			-1.221730485667637e-7,
			0.9999999999999908
		],
		"oculi01.R": [
			-1.7453295697578307e-8,
			2.6179942658188793e-8,
			1.3089969286282385e-7,
			0.9999999999999908
		],
		"oculi02.R": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"wrist.R": [
			0.130011582432297,
			-0.03302977666109419,
			-0.011384802473432912,
			0.9908967698806013
		],
		"finger1-1.L": [
			-0.1631066772747728,
			0.08756057419867636,
			0.15419662453418229,
			0.9705425073929765
		],
		"tongue07.R": [
			-8.726648736967431e-9,
			-2.6179940992854256e-8,
			-1.0471975997461325e-7,
			0.9999999999999942
		],
		"eye.R": [
			-2.617993999365349e-8,
			8.881784197001252e-16,
			3.490658424245935e-8,
			0.9999999999999989
		],
		"finger2-1.R": [
			0.08148230543107134,
			-0.08019711485989589,
			-0.046506795032362755,
			0.9923538555805602
		],
		"finger4-3.R": [
			0.024531519796551354,
			0.01660074464133654,
			0.04118547480325242,
			0.9987123592301512
		],
		"finger2-1.L": [
			-5.23598746582363e-8,
			-6.108652061964648e-8,
			8.726646072432263e-8,
			0.9999999999999925
		],
		"eye.L": [
			1.7453293921221365e-8,
			3.490658628813037e-8,
			-5.2359879987306525e-8,
			0.9999999999999981
		],
		"tongue07.L": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"wrist.L": [
			0.0021136902537522975,
			0.14734950272742553,
			-0.018683627485223595,
			0.9889057479980007
		],
		"finger5-3.R": [
			-8.72664429607533e-9,
			-1.0471975975256953e-7,
			1.7453293033042724e-8,
			0.9999999999999944
		],
		"lowerleg01.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"lowerarm02.L": [
			-5.2359883540020707e-8,
			2.617994609988017e-8,
			1.2217304856681564e-7,
			0.9999999999999907
		],
		"oris07.L": [
			-5.2359860447382416e-8,
			1.047197495385177e-7,
			-1.9198622425154528e-7,
			0.9999999999999751
		],
		"oris07.R": [
			1.7453292144864407e-8,
			-6.108652472747167e-8,
			-1.0183439690065433e-15,
			0.9999999999999984
		],
		"tongue00": [
			7.853981998095993e-8,
			-8.726645850387627e-9,
			-6.85389203006783e-16,
			0.9999999999999968
		],
		"lowerarm02.R": [
			0.07746008027603721,
			0.0786982690489022,
			-0.10300876503807625,
			0.9885321000036708
		],
		"lowerleg01.L": [
			0.05408475302431404,
			0.004930171452193766,
			0.0003452252040627998,
			0.9985241177454397
		],
		"tongue03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			-1.0471975642189773e-7,
			-8.726645406298417e-8,
			3.4906593171554376e-8,
			0.9999999999999903
		],
		"metacarpal4.L": [
			-0.0826075450237676,
			0.02472746986735641,
			0.14066488552190257,
			0.9862950551027899
		],
		"finger1-2.R": [
			-0.027608116637864766,
			-0.09452737393053967,
			-0.029779275108528087,
			0.9946937027283911
		],
		"pelvis.R": [
			-0.0023090007278607464,
			0.006841239237662333,
			0.02146661031206359,
			0.9997434924034467
		],
		"toe2-1.R": [
			-8.726645628342998e-9,
			-6.108652406133785e-8,
			8.726646516521382e-9,
			0.9999999999999979
		],
		"toe2-3.L": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"toe5-3.L": [
			-1.745329214486445e-8,
			3.3306690738754696e-16,
			4.3633228449276404e-8,
			0.9999999999999991
		],
		"levator05.L": [
			-8.726642519718672e-9,
			1.0471976008563644e-7,
			-3.490658606608545e-8,
			0.999999999999994
		],
		"finger4-1.L": [
			0.07391631236498016,
			-0.04718556962484899,
			-0.13193956656159625,
			0.9873711822618071
		],
		"finger4-1.R": [
			-0.0015814984324895953,
			0.059886933088246774,
			0.09320805006565178,
			0.9938427005874471
		],
		"levator05.R": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"toe5-3.R": [
			-2.617994354636722e-8,
			-4.3633230251138855e-8,
			-7.85398199809651e-8,
			0.9999999999999954
		],
		"toe2-3.R": [
			1.066161005983695e-15,
			1.7453292144864463e-8,
			-6.108652428338229e-8,
			0.9999999999999979
		],
		"finger4-2.L": [
			0.14458082450694315,
			-0.11063929908873082,
			-0.23150936442666586,
			0.9556457214181461
		],
		"toe2-1.L": [
			-3.4906584289728793e-8,
			-1.7453292366909068e-8,
			-8.72664562834318e-9,
			0.9999999999999996
		],
		"finger1-2.L": [
			0.12053536738554704,
			0.01742420584123927,
			0.05643568546925316,
			0.9909503699306278
		],
		"pelvis.L": [
			0.0028243763653875487,
			0.008368092997218524,
			0.026257603159950068,
			0.9996161944436632
		],
		"metacarpal4.R": [
			-7.853981998095933e-8,
			3.490658839755412e-8,
			4.363322503309232e-8,
			0.9999999999999953
		],
		"tongue04": [
			-6.108652428338213e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"toe3-2.L": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"levator03.R": [
			1.745329214486445e-8,
			1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"upperleg02.R": [
			-0.03879039648896895,
			-0.040196672727342286,
			-0.00014094006939359427,
			0.998438537306016
		],
		"upperleg02.L": [
			-0.011446004231859612,
			0.12540102329237557,
			-0.03274335603676388,
			0.9914995940391499
		],
		"levator03.L": [
			-4.363322858580401e-8,
			-4.3633228918871225e-8,
			1.745329392122144e-8,
			0.9999999999999984
		],
		"toe3-2.R": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"metacarpal3.L": [
			-0.1081618458274162,
			0.059333024809098855,
			0.10955763408389835,
			0.986294951871978
		],
		"tongue01": [
			-5.235987998730684e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999987
		],
		"breast.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"temporalis02.R": [
			2.6179947099080924e-8,
			-1.2217304856676492e-7,
			6.108652073066738e-8,
			0.9999999999999906
		],
		"tongue02": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris04.R": [
			4.3633228585804e-8,
			-4.3298697960381105e-15,
			9.599310849651147e-8,
			0.9999999999999942
		],
		"oris04.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis02.L": [
			6.98131685794569e-8,
			-8.72665051332433e-9,
			6.10865242833813e-8,
			0.9999999999999958
		],
		"breast.R": [
			-3.8077175003734897e-16,
			4.363322858580432e-8,
			8.726646072432225e-9,
			0.999999999999999
		],
		"oris03.R": [
			3.883872220957831e-15,
			1.483529812329465e-7,
			-2.6179939993653216e-8,
			0.9999999999999885
		],
		"oris06.L": [
			-5.235987998730683e-8,
			1.7763568394002505e-15,
			3.49065843627162e-8,
			0.999999999999998
		],
		"orbicularis04.R": [
			-4.3633228585804106e-8,
			-3.4906584289728926e-8,
			-8.726644740164946e-9,
			0.9999999999999984
		],
		"toe1-2.R": [
			-1.745329303304285e-8,
			4.3633228918871225e-8,
			2.6179939105475048e-8,
			0.9999999999999986
		],
		"toe1-2.L": [
			8.726646072432222e-9,
			2.220446049250313e-16,
			-3.490658426895706e-8,
			0.9999999999999992
		],
		"orbicularis04.L": [
			7.853981998095989e-8,
			1.7453290368507623e-8,
			1.745329392122154e-8,
			0.9999999999999964
		],
		"metacarpal3.R": [
			-5.2359874658236344e-8,
			9.599310535346461e-8,
			-5.2359885316377506e-8,
			0.9999999999999929
		],
		"oris06.R": [
			8.726645628343018e-9,
			8.726645628343022e-9,
			5.235987998730709e-8,
			0.9999999999999986
		],
		"levator04.L": [
			5.2359883540021123e-8,
			-1.6580627004714188e-7,
			1.7453283263083634e-8,
			0.9999999999999848
		],
		"tongue06.L": [
			8.726644740164572e-9,
			-3.4906584178706623e-8,
			-4.363322858580417e-8,
			0.9999999999999984
		],
		"toe2-2.L": [
			5.2359878210949805e-8,
			-3.4906582957461296e-8,
			-4.3633230362161104e-8,
			0.9999999999999972
		],
		"toe2-2.R": [
			-2.617993910547503e-8,
			-2.6179939216497417e-8,
			3.490658428972883e-8,
			0.9999999999999989
		],
		"tongue06.R": [
			4.363322858580404e-8,
			3.6637359812630166e-15,
			-9.599310842883793e-8,
			0.9999999999999942
		],
		"levator04.R": [
			5.2359883540020554e-8,
			7.853982375571888e-8,
			-3.490658073701498e-8,
			0.9999999999999951
		],
		"toe4-1.L": [
			-2.6179939993653487e-8,
			8.726645295276114e-9,
			-3.4906584289728926e-8,
			0.9999999999999988
		],
		"upperleg01.R": [
			-0.0022604166465206585,
			-0.017604311224100555,
			-0.05577402163348794,
			0.9982856491274104
		],
		"metacarpal1.R": [
			7.8539823533673e-8,
			-6.108652794711844e-8,
			5.2359874658238065e-8,
			0.9999999999999937
		],
		"levator02.R": [
			1.4835294592785073e-7,
			-2.792526598849321e-7,
			-1.221730911993286e-7,
			0.9999999999999424
		],
		"toe3-1.L": [
			-2.6179939993653487e-8,
			7.771561172376096e-16,
			2.6179939958862843e-8,
			0.9999999999999994
		],
		"toe3-1.R": [
			8.726646960610635e-9,
			-4.363322858580432e-8,
			1.7453292144864436e-8,
			0.9999999999999989
		],
		"levator02.L": [
			-2.617993999365346e-8,
			-3.4906584733818136e-8,
			1.0095481158786604e-15,
			0.9999999999999991
		],
		"finger5-1.R": [
			-0.07709988797350133,
			0.06170618343868384,
			0.07609138849048458,
			0.9921985964500728
		],
		"metacarpal1.L": [
			-0.12844869068922213,
			0.08300664494206744,
			0.06191312707320314,
			0.9862948826044391
		],
		"toe4-1.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"upperleg01.L": [
			0.0028266207092014295,
			-0.022014009605423213,
			-0.06974481208574164,
			0.9973179306437756
		],
		"head": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"toe5-1.R": [
			-8.726645628343032e-9,
			8.726645295276114e-9,
			-3.490658428972877e-8,
			0.9999999999999992
		],
		"special01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			-8.726641631540034e-9,
			-8.726645717160864e-8,
			5.2359879987306644e-8,
			0.9999999999999949
		],
		"special04": [
			-4.363322858580417e-8,
			-8.726646516521441e-9,
			4.068768463957589e-16,
			0.999999999999999
		],
		"metacarpal2.L": [
			-0.10685021728960652,
			0.05806130992939673,
			0.11150890209597486,
			0.9862949255206565
		],
		"metacarpal2.R": [
			-4.363323746758882e-8,
			6.98131753518183e-8,
			1.22173048566755e-7,
			0.9999999999999892
		],
		"temporalis01.R": [
			-2.617993555276144e-8,
			5.235987832197253e-8,
			-7.853981998097532e-8,
			0.9999999999999951
		],
		"toe5-1.L": [
			-3.4906584289728793e-8,
			-8.726647293677559e-9,
			-2.61799399936534e-8,
			0.999999999999999
		],
		"risorius02.R": [
			-2.6179939993653497e-8,
			-8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"special05.L": [
			2.6179943546367017e-8,
			1.2217304845574262e-7,
			-2.6179936440939676e-8,
			0.9999999999999919
		],
		"finger2-2.L": [
			0.04809231196895298,
			-0.03133786624417034,
			-0.02949217402407451,
			0.9979154670311895
		],
		"foot.L": [
			-0.001701659612210425,
			-0.0018767088794913178,
			0.055927097486671164,
			0.9984316411678181
		],
		"toe3-3.R": [
			-8.726646516521416e-9,
			6.108652428338246e-8,
			8.726645628342962e-9,
			0.9999999999999981
		],
		"levator06.R": [
			-3.49065860660856e-8,
			-6.108652439440476e-8,
			-2.6179938217296585e-8,
			0.999999999999997
		],
		"orbicularis03.R": [
			8.726645628343061e-9,
			-8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"levator06.L": [
			1.7453293921221365e-8,
			3.490658628813037e-8,
			-5.2359879987306525e-8,
			0.9999999999999981
		],
		"orbicularis03.L": [
			-1.745329214486445e-8,
			3.3306690738754696e-16,
			3.490658449484121e-8,
			0.9999999999999994
		],
		"foot.R": [
			0.09820735601717014,
			-0.046379745943584294,
			0.04470837347302433,
			0.9930787459873067
		],
		"root": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger2-2.R": [
			1.396263371589077e-7,
			2.617992134190672e-8,
			1.3089969996826627e-7,
			0.9999999999999815
		],
		"risorius02.L": [
			-2.6179940881831907e-8,
			-3.490658451177353e-8,
			-1.7453291256686053e-8,
			0.9999999999999991
		],
		"special05.R": [
			-4.3633226809447214e-8,
			-5.2359878544017135e-8,
			3.4906586066085587e-8,
			0.9999999999999972
		],
		"lowerleg02.L": [
			-1.5230870001493986e-16,
			1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"tongue05.L": [
			-2.6179939993653504e-8,
			1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"finger5-1.L": [
			0.06657982319217386,
			-0.07177397502430971,
			-0.23791481337494902,
			0.9663395703528196
		],
		"toe4-3.R": [
			4.569261529843786e-16,
			-1.745329203384216e-8,
			2.6179939993653514e-8,
			0.9999999999999997
		],
		"oris03.L": [
			-3.490658606608563e-8,
			-6.981316869048015e-8,
			-2.6179937329118136e-8,
			0.9999999999999966
		],
		"toe4-3.L": [
			1.745329214486445e-8,
			-3.3306690738754696e-16,
			3.490658449484121e-8,
			0.9999999999999994
		],
		"finger3-3.L": [
			0.05294384757468958,
			-0.041126043803210055,
			-0.06167820891435777,
			0.9958420537767029
		],
		"tongue05.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"lowerleg02.R": [
			-0.015183865768615173,
			-0.16613823948819828,
			-0.006109348077941914,
			0.9859666381101067
		],
		"shoulder01.R": [
			7.853981998095983e-8,
			-1.9984014443252818e-15,
			2.6179940010394776e-8,
			0.9999999999999966
		],
		"finger3-1.L": [
			0.059712538803214255,
			-0.04260040793651465,
			-0.07534223215941831,
			0.9944562162340548
		],
		"special06.R": [
			0,
			0,
			0,
			1
		],
		"finger4-3.L": [
			0.13493340134369106,
			-0.09131389260939626,
			-0.22653229737781722,
			0.9602800989623135
		],
		"finger3-2.L": [
			0.14830898313084978,
			-0.11841747613778097,
			-0.17016642243789348,
			0.9669669774829648
		],
		"upperarm01.R": [
			-0.002659599424680385,
			0.00022802480790040658,
			0.2693457777793393,
			0.9630398364180116
		],
		"finger3-2.R": [
			0.023383500410406478,
			0.018670185913203574,
			0.0268304383852186,
			0.9991920554340791
		],
		"upperarm01.L": [
			0.15507854756479755,
			0.04155630120766263,
			0.03379987173763999,
			0.9864488261362828
		],
		"special06.L": [
			-4.363322858580408e-8,
			8.726646849588349e-9,
			1.745329214486511e-8,
			0.9999999999999989
		],
		"finger3-1.R": [
			0.0401346549457169,
			0.02863194222099541,
			0.05064051652876492,
			0.9974993531039213
		],
		"shoulder01.L": [
			9.599311567853655e-8,
			-6.981317579590751e-8,
			8.726645006617887e-8,
			0.9999999999999892
		],
		"lowerarm01.R": [
			0.17576017771644392,
			-0.13642240377081294,
			0.008028388122723057,
			0.9749014476667002
		],
		"special03": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"upperarm02.L": [
			0.22170609465686353,
			-0.2382455965923732,
			0.004462125380982173,
			0.9455503861420766
		],
		"spine02": [
			-1.0849459239533944e-9,
			-0.0009152031250424519,
			-0.012202607179069451,
			0.9999251265876227
		],
		"spine03": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"spine01": [
			0.0012265896732559457,
			0.13217408422393417,
			0.008591561791590636,
			0.9911885249554292
		],
		"upperarm02.R": [
			0.029997892784745534,
			0.03380136599403627,
			-0.0006394987886141485,
			0.998978070393295
		],
		"spine04": [
			0,
			0,
			0,
			1
		],
		"spine05": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			-0.21149394329355842,
			-0.3179798130320456,
			0.008649789173606592,
			0.924166831043778
		],
		"finger5-3.L": [
			0.08987505374536132,
			-0.10167885614947725,
			-0.30575505415210374,
			0.9423893737658793
		],
		"oris01": [
			7.853981998095986e-8,
			-1.745329203384216e-8,
			-1.365371901799131e-15,
			0.9999999999999968
		],
		"oris02": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"oris05": [
			-6.108652428338213e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"risorius03.R": [
			4.363322858580417e-8,
			8.726645628343022e-9,
			8.726646516520993e-9,
			0.999999999999999
		],
		"finger2-3.L": [
			-0.008259206684322826,
			0.005707852037885819,
			0.0047986366270049725,
			0.9999380875917177
		],
		"oris06": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-3.R": [
			8.726645361889305e-8,
			4.36332233677561e-8,
			6.98131721321718e-8,
			0.9999999999999929
		],
		"finger2-3.R": [
			0.08735254437955495,
			0.06036574774275616,
			0.050751822333013355,
			0.9930507348669325
		],
		"toe3-3.L": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"risorius03.L": [
			-1.4835298145498593e-7,
			1.745328337410257e-8,
			-6.108652783610168e-8,
			0.999999999999987
		]
	},
	"standing05": {
		"toe1-1.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger5-2.R": [
			0.039659150368709935,
			0.04808702405674681,
			0.1317576759035336,
			0.9893203246420736
		],
		"finger1-3.R": [
			-6.108652428338208e-8,
			-1.7453290035440716e-8,
			3.490658606608564e-8,
			0.9999999999999972
		],
		"toe5-2.R": [
			-1.1344640071797366e-7,
			5.2359883428998444e-8,
			3.49065789606629e-8,
			0.9999999999999915
		],
		"toe4-2.R": [
			-8.726646960610626e-9,
			3.4906584178706623e-8,
			2.6179939993653494e-8,
			0.999999999999999
		],
		"clavicle.R": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"neck03": [
			-0.01863359212102255,
			3.506313228651692e-8,
			8.074695862133525e-9,
			0.999826379550303
		],
		"neck02": [
			0.0003555671892801915,
			-1.7453291478730648e-8,
			-6.205817701719805e-12,
			0.9999999367859849
		],
		"neck01": [
			-0.05042080167642783,
			0.002153766357647302,
			-0.010108940578619593,
			0.998674578313257
		],
		"clavicle.L": [
			0.010050127970524398,
			-0.006965966176879834,
			0.09790964607342145,
			0.9951201793998428
		],
		"toe5-2.L": [
			-4.363322503309097e-8,
			1.7453285150459408e-8,
			-1.5707963996183346e-7,
			0.9999999999999865
		],
		"toe4-2.L": [
			-2.6179941770010476e-8,
			-4.363323080625037e-8,
			-3.490658251337224e-8,
			0.9999999999999982
		],
		"finger5-2.L": [
			0.0528483044718925,
			-0.06408292745679811,
			-0.17557491750538723,
			0.980955597091932
		],
		"finger1-3.L": [
			-2.530727556404358e-7,
			-2.6179966305939217e-8,
			-1.0471975286952817e-7,
			0.9999999999999616
		],
		"toe1-1.R": [
			2.6179940881831877e-8,
			-2.6179940992854256e-8,
			3.4906584289728846e-8,
			0.9999999999999988
		],
		"oculi02.L": [
			-8.726644651346552e-8,
			9.599310135666173e-8,
			-9.599311567853795e-8,
			0.999999999999987
		],
		"oculi01.L": [
			-7.853981287553208e-8,
			6.10865172889774e-8,
			-9.599311212582806e-8,
			0.9999999999999908
		],
		"jaw": [
			8.726645717160768e-8,
			8.726646960610651e-9,
			-8.72664518425463e-9,
			0.9999999999999961
		],
		"finger4-2.R": [
			0.038309011516654896,
			0.0293146217086957,
			0.06134208185457207,
			0.9969504609480051
		],
		"oculi01.R": [
			4.363323213851802e-8,
			-6.108652783609614e-8,
			5.235987643459333e-8,
			0.9999999999999957
		],
		"oculi02.R": [
			3.4906584289728866e-8,
			-5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"oris03.L": [
			-2.6179933776404626e-8,
			-6.108652061964648e-8,
			9.599310857310833e-8,
			0.999999999999993
		],
		"finger1-1.L": [
			-0.06419577942434074,
			-0.028317198860325243,
			0.2493302135931897,
			0.9658734299805442
		],
		"tongue07.R": [
			-3.490659139515611e-8,
			-7.853982375571888e-8,
			-8.7266453618893e-8,
			0.9999999999999926
		],
		"eye.R": [
			-5.2359879987306644e-8,
			1.7453294476332815e-8,
			3.490658251337203e-8,
			0.9999999999999982
		],
		"finger2-1.R": [
			-8.726646072432225e-9,
			-6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"finger4-3.R": [
			-1.7453293921221365e-8,
			-3.490658628813037e-8,
			-5.2359879987306525e-8,
			0.9999999999999981
		],
		"finger2-1.L": [
			-1.1344639716525959e-7,
			-2.6179932777203874e-8,
			6.108652783609847e-8,
			0.9999999999999913
		],
		"eye.L": [
			1.745329214486445e-8,
			-8.726645406298417e-9,
			-2.6179939993653613e-8,
			0.9999999999999994
		],
		"tongue07.L": [
			6.108652428338174e-8,
			-3.490658073701525e-8,
			-4.363323036216002e-8,
			0.9999999999999967
		],
		"wrist.L": [
			0.1468082953374252,
			-0.03295213938333086,
			-0.08331474144082505,
			0.9850990482123254
		],
		"finger5-3.R": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"lowerleg01.R": [
			-0.005499306799691972,
			-0.06017174761395783,
			-0.0022123960958114687,
			0.9981704382104895
		],
		"lowerarm02.L": [
			-1.2217306277761564e-7,
			1.0471977784920483e-7,
			1.3962632294805223e-7,
			0.999999999999977
		],
		"oris07.L": [
			-1.745326994040321e-8,
			1.570796398508989e-7,
			-1.396263371589106e-7,
			0.9999999999999776
		],
		"oris07.R": [
			6.108652428338107e-8,
			-1.832595732942366e-7,
			-1.1199600285648662e-14,
			0.9999999999999817
		],
		"tongue00": [
			2.967059629099429e-7,
			-1.745328981339611e-8,
			-8.726651401502389e-9,
			0.9999999999999563
		],
		"lowerarm02.R": [
			0.2059120236914318,
			0.209207089739745,
			-0.27383352943574596,
			0.9158863631797821
		],
		"lowerleg01.L": [
			0.10237123628741616,
			0.08851077762053727,
			0.012393359736632636,
			0.990723158536446
		],
		"tongue03": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			-7.853982353367284e-8,
			-7.853982375571888e-8,
			-2.6179933776402736e-8,
			0.9999999999999936
		],
		"metacarpal4.L": [
			5.235988886909161e-8,
			2.1816615014547125e-7,
			-4.363321792766348e-8,
			0.9999999999999739
		],
		"finger1-2.R": [
			-6.092348000597493e-15,
			8.726645717160864e-8,
			6.981316857945703e-8,
			0.9999999999999938
		],
		"pelvis.R": [
			0.009809001968744825,
			-0.029062559053805392,
			-0.09119036408510729,
			0.9953609740388895
		],
		"toe2-1.R": [
			6.092348000597549e-16,
			8.726646183454534e-9,
			-6.98131685794573e-8,
			0.9999999999999977
		],
		"toe2-3.L": [
			4.569261529843772e-16,
			8.726646072432231e-9,
			-5.235987998730683e-8,
			0.9999999999999986
		],
		"toe5-3.L": [
			-2.617993910547503e-8,
			-2.6179939216497417e-8,
			3.490658428972883e-8,
			0.9999999999999989
		],
		"levator05.L": [
			1.0966227248108331e-14,
			7.85398199809606e-8,
			-1.3962633715891282e-7,
			0.999999999999987
		],
		"finger4-1.L": [
			0.07391389536746311,
			-0.047186181881657796,
			-0.13193514501036985,
			0.9873719247690459
		],
		"finger4-1.R": [
			0.08820628349720505,
			0.056306346030930654,
			0.1574460992345181,
			0.9819673990434156
		],
		"levator05.R": [
			-2.6179939993653527e-8,
			8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"toe5-3.R": [
			-2.6179939993653444e-8,
			1.9984014443252818e-15,
			6.981316854088414e-8,
			0.9999999999999976
		],
		"toe2-3.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger4-2.L": [
			0.14457715644924732,
			-0.1106416294287097,
			-0.23150162022492068,
			0.955647882592562
		],
		"toe2-1.L": [
			-3.490658251337205e-8,
			-4.363322680944748e-8,
			3.49065860660859e-8,
			0.9999999999999978
		],
		"finger1-2.L": [
			0.12053344745853938,
			0.017424125255767198,
			0.056434801625704266,
			0.9909506552136178
		],
		"pelvis.L": [
			-6.108652428338212e-8,
			-8.726645739365324e-9,
			8.72664651652142e-9,
			0.9999999999999983
		],
		"metacarpal4.R": [
			-5.2359879987306756e-8,
			2.617994121489886e-8,
			1.7453290368507855e-8,
			0.9999999999999986
		],
		"tongue04": [
			-1.4835298145498612e-7,
			-8.72664374096388e-9,
			1.7453293033042704e-8,
			0.9999999999999893
		],
		"toe3-2.L": [
			1.7453293921221206e-8,
			-1.7453293699176697e-8,
			9.599310857311026e-8,
			0.9999999999999953
		],
		"levator03.R": [
			-2.6179939993653487e-8,
			8.726647182655256e-9,
			2.617993999365346e-8,
			0.9999999999999989
		],
		"upperleg02.R": [
			-0.05564269826183582,
			0.007370710144557258,
			0.09650796459639699,
			0.9937483461780288
		],
		"upperleg02.L": [
			0.04964417955687947,
			0.01348965344107178,
			-0.06995285893857608,
			0.9962229078938523
		],
		"levator03.L": [
			8.726646960610684e-9,
			1.7453293255087488e-8,
			-6.108652428338172e-8,
			0.999999999999998
		],
		"toe3-2.R": [
			-2.617993555276164e-8,
			3.4906580625992945e-8,
			-1.221730485667452e-7,
			0.9999999999999915
		],
		"metacarpal3.L": [
			1.7453293921221375e-8,
			-2.6179941547965768e-8,
			7.853981998095793e-8,
			0.9999999999999967
		],
		"tongue01": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"breast.L": [
			0.01534426469121993,
			-0.013636578625923157,
			0.09800656764007816,
			0.9949740247684234
		],
		"temporalis02.R": [
			5.2359883540019807e-8,
			-1.570796402949881e-7,
			1.7453284151258633e-8,
			0.9999999999999867
		],
		"tongue02": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"oris04.R": [
			9.599310857310847e-8,
			8.72662841988614e-9,
			1.8325957285013372e-7,
			0.9999999999999786
		],
		"oris04.L": [
			6.981316857945723e-8,
			5.2359878099927926e-8,
			2.617994354622119e-8,
			0.9999999999999959
		],
		"temporalis02.L": [
			1.2217304146133248e-7,
			4.363321592926184e-8,
			1.0471976708003543e-7,
			0.9999999999999858
		],
		"breast.R": [
			0.005790109740281087,
			-0.06709930894930283,
			-0.018955337654009106,
			0.9975494236087471
		],
		"oris03.R": [
			2.6179948875437363e-8,
			1.396263371589157e-7,
			-6.108652073066807e-8,
			0.9999999999999882
		],
		"oris06.L": [
			-1.047197599746124e-7,
			-8.726643629941577e-9,
			2.6179940881831232e-8,
			0.9999999999999944
		],
		"orbicularis04.R": [
			-8.726646516521428e-9,
			-5.235987998730707e-8,
			-8.726645628342985e-9,
			0.9999999999999987
		],
		"toe1-2.R": [
			-9.138523059687567e-16,
			3.4906584178706623e-8,
			2.6179939993653468e-8,
			0.9999999999999989
		],
		"toe1-2.L": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"orbicularis04.L": [
			1.396263371589116e-7,
			8.726646072432231e-9,
			1.2184696001194844e-15,
			0.9999999999999901
		],
		"metacarpal3.R": [
			-9.599310857311017e-8,
			8.726640410294806e-9,
			-6.108652428337318e-8,
			0.9999999999999932
		],
		"oris06.R": [
			-7.853981998095994e-8,
			-8.72664196460704e-9,
			5.235987998730381e-8,
			0.9999999999999954
		],
		"levator04.L": [
			6.108652428338092e-8,
			-1.9198621781235659e-7,
			-8.726657618751059e-9,
			0.9999999999999799
		],
		"tongue06.L": [
			-3.490658428972884e-8,
			-2.6179941325921163e-8,
			-1.7453291256685967e-8,
			0.999999999999999
		],
		"toe2-2.L": [
			-1.7453293033042856e-8,
			2.6179940992854256e-8,
			4.3633228585804166e-8,
			0.9999999999999986
		],
		"toe2-2.R": [
			1.745329214486445e-8,
			-3.3306690738754696e-16,
			4.3633228449276404e-8,
			0.9999999999999991
		],
		"tongue06.R": [
			-8.72664607243214e-9,
			-1.1102230246251565e-15,
			-1.4835298142645773e-7,
			0.9999999999999889
		],
		"levator04.R": [
			6.108653138880908e-8,
			1.2217304845574262e-7,
			-4.363322148037669e-8,
			0.9999999999999898
		],
		"toe4-1.L": [
			8.726645628343018e-9,
			8.726645628343022e-9,
			5.235987998730709e-8,
			0.9999999999999986
		],
		"upperleg01.R": [
			0.13343199649676546,
			0.034268814706267636,
			0.10946136287743262,
			0.9843981718220172
		],
		"metacarpal1.R": [
			-2.6179939993653484e-8,
			-2.6179940104675836e-8,
			8.045503725131716e-16,
			0.9999999999999991
		],
		"levator02.R": [
			7.853979866467992e-8,
			-2.967059627989599e-7,
			-6.981319344845159e-8,
			0.9999999999999505
		],
		"toe3-1.L": [
			8.726647404699853e-9,
			-6.981316857945785e-8,
			1.745329125668601e-8,
			0.9999999999999976
		],
		"toe3-1.R": [
			-2.617993821729665e-8,
			-5.235987998730707e-8,
			2.6179941770010347e-8,
			0.9999999999999979
		],
		"levator02.L": [
			2.6179941770010294e-8,
			6.108652428338246e-8,
			-3.490658251337185e-8,
			0.9999999999999971
		],
		"finger5-1.R": [
			0.052733103517383036,
			0.05684374679941717,
			0.18842744825513497,
			0.9790215038431417
		],
		"metacarpal1.L": [
			8.726646516521416e-9,
			-6.108652428338246e-8,
			8.726645628342962e-9,
			0.9999999999999981
		],
		"toe4-1.R": [
			-4.363322680944721e-8,
			4.3633227031492083e-8,
			-2.6179941770010135e-8,
			0.999999999999998
		],
		"upperleg01.L": [
			-0.18200664005098327,
			-0.029073882765341286,
			-0.04954668677368103,
			0.9816177556197984
		],
		"head": [
			-0.023016521102528227,
			-1.7448669176189924e-8,
			4.01714055724129e-10,
			0.9997350847881339
		],
		"toe5-1.R": [
			-5.2359872881880147e-8,
			3.490657352056559e-8,
			-2.1816615003455604e-7,
			0.9999999999999742
		],
		"special01": [
			8.726646072432225e-9,
			1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"temporalis01.L": [
			8.726645361889341e-8,
			-3.490657740634617e-8,
			-7.853982353367286e-8,
			0.9999999999999927
		],
		"special04": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"metacarpal2.L": [
			-3.054326214168704e-7,
			-2.61799159018139e-8,
			7.853982708586685e-8,
			0.9999999999999498
		],
		"metacarpal2.R": [
			-1.134463971652599e-7,
			-5.2359881430597e-8,
			-1.7453285927620584e-8,
			0.9999999999999919
		],
		"temporalis01.R": [
			1.745330457936244e-8,
			1.396263373809603e-7,
			-8.726645361889329e-8,
			0.9999999999999863
		],
		"toe5-1.L": [
			5.235987821095e-8,
			-2.6179935663783738e-8,
			-8.726645717161295e-8,
			0.9999999999999942
		],
		"risorius02.R": [
			-5.235987465823624e-8,
			9.59931049093754e-8,
			-6.10865278360955e-8,
			0.999999999999992
		],
		"special05.L": [
			4.363322858580375e-8,
			1.396263371589157e-7,
			6.180369913805331e-15,
			0.999999999999989
		],
		"finger2-2.L": [
			0.04809125761641109,
			-0.031337951748181436,
			-0.029490928635614186,
			0.9979155519628451
		],
		"foot.L": [
			0.026408132434226125,
			-0.08210066983404074,
			0.10368048708287553,
			0.990864494849016
		],
		"toe3-3.R": [
			-2.617994177001034e-8,
			-2.6179941770010373e-8,
			-5.235987998730672e-8,
			0.999999999999998
		],
		"levator06.R": [
			1.745329036850754e-8,
			-4.363322858580432e-8,
			-4.363322858580477e-8,
			0.9999999999999981
		],
		"orbicularis03.R": [
			8.72664651652144e-9,
			1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"levator06.L": [
			4.3633228585804066e-8,
			-8.726642963807762e-9,
			-6.981316857946062e-8,
			0.9999999999999968
		],
		"orbicularis03.L": [
			8.726647404699846e-9,
			-4.363322880784892e-8,
			2.617993999365346e-8,
			0.9999999999999984
		],
		"foot.R": [
			-0.09170631112598135,
			-0.03609665712718735,
			-0.07822750984360675,
			0.9920521360027283
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			-8.726645717160729e-8,
			4.3633230695228065e-8,
			2.6179936440943686e-8,
			0.9999999999999951
		],
		"risorius02.L": [
			-6.108652428338214e-8,
			-4.363322869682662e-8,
			8.726648736966921e-9,
			0.9999999999999972
		],
		"special05.R": [
			-3.4906584289728754e-8,
			-7.85398196478937e-8,
			-8.726643407896827e-9,
			0.9999999999999961
		],
		"lowerleg02.L": [
			-8.726645184253792e-9,
			1.745329203384216e-8,
			-4.363322858580425e-8,
			0.9999999999999988
		],
		"tongue05.L": [
			-2.617993999365348e-8,
			1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		],
		"finger5-1.L": [
			0.06657701086489434,
			-0.0717751573268205,
			-0.23790752010128405,
			0.9663414718898609
		],
		"toe4-3.R": [
			4.363322858580403e-8,
			-3.4416913763379853e-15,
			8.726645736010788e-8,
			0.9999999999999954
		],
		"wrist.R": [
			-0.05177268299546452,
			0.014249755934000241,
			0.1045392272308466,
			0.9930700296158625
		],
		"toe4-3.L": [
			-1.7453291256686053e-8,
			3.4906584178706623e-8,
			-2.6179940881831874e-8,
			0.9999999999999988
		],
		"finger3-3.L": [
			0.05294284357521706,
			-0.0411261341421697,
			-0.061675838130572265,
			0.9958422502563256
		],
		"tongue05.R": [
			-2.6179939993653534e-8,
			-4.3633228474782015e-8,
			8.726647404699778e-9,
			0.9999999999999987
		],
		"lowerleg02.R": [
			-8.72664651652144e-9,
			-1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"shoulder01.R": [
			1.066161005983695e-15,
			-1.745329203384216e-8,
			6.108652428338231e-8,
			0.999999999999998
		],
		"finger3-1.L": [
			0.059710919660071124,
			-0.04260068178739884,
			-0.0753395686505817,
			0.9944565035134225
		],
		"special06.R": [
			-8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"finger4-3.L": [
			0.1349308437966619,
			-0.09131576773348438,
			-0.2265248639785908,
			0.9602820335479809
		],
		"finger3-2.L": [
			0.1483059260553159,
			-0.11841878187791988,
			-0.17016006972403183,
			0.9669684043788281
		],
		"upperarm01.R": [
			-0.009791042727277348,
			0.0031957757592627756,
			0.16822389712174038,
			0.9856950050278153
		],
		"finger3-2.R": [
			-4.363322858580409e-8,
			8.726647404699861e-9,
			2.6179939993652998e-8,
			0.9999999999999986
		],
		"upperarm01.L": [
			-0.06284471545687949,
			0.054899078516012056,
			0.2635589856368849,
			0.9610272077351885
		],
		"special06.L": [
			-6.092348000597589e-16,
			3.4906584178706623e-8,
			1.745329214486445e-8,
			0.9999999999999991
		],
		"finger3-1.R": [
			0.07753142788627308,
			0.055311886809811917,
			0.09782619873210972,
			0.9906359107709957
		],
		"shoulder01.L": [
			3.490658784244258e-8,
			-6.981316846843555e-8,
			4.363322680944667e-8,
			0.9999999999999959
		],
		"lowerarm01.R": [
			0.04470639758821078,
			-0.039613314709533554,
			0.003354069882351865,
			0.9982088326235311
		],
		"special03": [
			-3.490658428972883e-8,
			2.6179939993653534e-8,
			-1.0341496537059884e-15,
			0.9999999999999992
		],
		"upperarm02.L": [
			-0.3591981366437075,
			0.40474224586325214,
			-0.007654134416035478,
			0.8408934696331043
		],
		"spine02": [
			-0.036684517261576816,
			-0.00829378066959019,
			-0.009919925674289176,
			0.9992432408928803
		],
		"spine03": [
			-0.033351913273445964,
			0.000840872865838227,
			0.10603854144537868,
			0.9938021787770244
		],
		"spine01": [
			0.08428429394333549,
			-0.10645809550852559,
			0.017228932101975965,
			0.9905887116224356
		],
		"upperarm02.R": [
			-1.7453291256686043e-8,
			-1.7453291256686043e-8,
			6.981316857945835e-8,
			0.9999999999999972
		],
		"spine04": [
			3.413310431662024e-8,
			0.00200163114370433,
			-0.008495575254991849,
			0.9999619086114484
		],
		"spine05": [
			2.824023236411035e-8,
			-0.03727904229945622,
			-0.07709593381715042,
			0.9963264976874279
		],
		"lowerarm01.L": [
			0.10335578564811415,
			0.052080523672079826,
			0.001076978851041535,
			0.9932794373909375
		],
		"finger5-3.L": [
			0.08987264908869325,
			-0.10168154783879135,
			-0.3057461585792811,
			0.9423921987627554
		],
		"oris01": [
			4.363322858580418e-8,
			-1.7453291367708346e-8,
			-1.745329303304287e-8,
			0.999999999999999
		],
		"oris02": [
			1.7453292144864443e-8,
			-1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"oris05": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"risorius03.R": [
			-1.1423153030516055e-15,
			4.363322858580432e-8,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"finger2-3.L": [
			-0.008259039297434248,
			0.005707866951392027,
			0.0047984017974439805,
			0.9999380900160463
		],
		"oris06": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"finger3-3.R": [
			4.363322858580419e-8,
			2.6179939660586626e-8,
			-8.7266447401649e-9,
			0.9999999999999984
		],
		"finger2-3.R": [
			3.490658606608565e-8,
			-2.6179941881032676e-8,
			4.363322680944736e-8,
			0.999999999999998
		],
		"toe3-3.L": [
			2.132322011967378e-15,
			1.7453292144864463e-8,
			-1.2217304856676391e-7,
			0.9999999999999923
		],
		"risorius03.L": [
			-1.6580627004713296e-7,
			4.363321659539565e-8,
			-7.853982708648242e-8,
			0.9999999999999825
		]
	},
	"Snorkel_Diver_01": {
		"toe1-1.L": [
			6.10865242833821e-8,
			-8.72664829287828e-9,
			3.490658428972797e-8,
			0.9999999999999976
		],
		"finger5-2.R": [
			1.5230870001493993e-16,
			-8.726645961409929e-9,
			1.7453292144864466e-8,
			0.9999999999999999
		],
		"finger4-2.R": [
			-8.726645628343017e-9,
			-2.6179939993653534e-8,
			1.7453292144864436e-8,
			0.9999999999999996
		],
		"toe5-2.R": [
			4.363322858580419e-8,
			4.440892098500626e-16,
			-1.7453292253300258e-8,
			0.9999999999999987
		],
		"toe4-2.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"clavicle.R": [
			3.4906584289728906e-8,
			-8.72664829287828e-9,
			6.108652428337678e-8,
			0.9999999999999973
		],
		"neck03": [
			-0.21165068790469355,
			1.1457031534600759e-7,
			-6.95311334899128e-9,
			0.9773453771873364
		],
		"neck02": [
			-0.10374918713652496,
			-0.007670020760214724,
			-0.024319340878937657,
			0.9942765443322411
		],
		"neck01": [
			-0.097659046813381,
			-0.018881665656950042,
			-0.012469362950094823,
			0.9949626667695318
		],
		"clavicle.L": [
			-0.013649458015570357,
			0.03476153458031894,
			0.13305835032386062,
			0.9904043635902435
		],
		"toe5-2.L": [
			-1.7453293033042876e-8,
			2.6179940881831953e-8,
			3.4906584289728807e-8,
			0.9999999999999989
		],
		"toe4-2.L": [
			-2.6179939993653484e-8,
			-2.6179940104675836e-8,
			8.045503725131716e-16,
			0.9999999999999991
		],
		"finger5-2.L": [
			0.16149253636591965,
			-0.19581452077443207,
			-0.5365280949061293,
			0.8048070809382718
		],
		"finger1-3.L": [
			-1.7453292144864446e-8,
			1.7453292366909068e-8,
			-1.745329214486445e-8,
			0.9999999999999997
		],
		"toe1-1.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"oculi02.L": [
			-5.235987998730686e-8,
			2.617994110387656e-8,
			8.726644740164896e-9,
			0.9999999999999984
		],
		"oculi01.L": [
			-8.726646516521438e-9,
			3.490658440075123e-8,
			8.726645628343022e-9,
			0.9999999999999994
		],
		"jaw": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"finger1-3.R": [
			1.7453292144864453e-8,
			-2.6179939993653534e-8,
			-8.726646516521464e-9,
			0.9999999999999997
		],
		"oculi01.R": [
			6.981317213217101e-8,
			-2.617994698805859e-8,
			9.599310502039032e-8,
			0.9999999999999928
		],
		"oculi02.R": [
			5.235987998730684e-8,
			-8.726645739365324e-9,
			-8.72664651652204e-9,
			0.9999999999999988
		],
		"wrist.R": [
			-8.726646072432225e-9,
			-2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"finger1-1.L": [
			-1.745329125668605e-8,
			2.617993899445281e-8,
			-4.3633228585803e-8,
			0.9999999999999988
		],
		"tongue07.R": [
			2.7755575615628914e-16,
			1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"eye.R": [
			-8.726648736967438e-9,
			5.235987998730707e-8,
			5.2359879987306776e-8,
			0.9999999999999973
		],
		"finger2-1.R": [
			-2.617993999365346e-8,
			3.4906584733818136e-8,
			-1.0095481158786604e-15,
			0.9999999999999991
		],
		"finger4-3.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"finger2-1.L": [
			-0.05741261127379542,
			0.011676169030757855,
			0.039917606757837815,
			0.9974838564178449
		],
		"eye.L": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"tongue07.L": [
			-4.3633228585804047e-8,
			4.3633228918871225e-8,
			-8.726647848789339e-9,
			0.9999999999999984
		],
		"wrist.L": [
			-0.1112947342202261,
			0.15681896658297545,
			0.11455897895936779,
			0.9746268692143083
		],
		"finger5-3.R": [
			2.6179939993653497e-8,
			8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"lowerleg01.R": [
			0.18738555695752826,
			-0.061040327980183995,
			-0.03581746386954327,
			0.9797335559659791
		],
		"lowerarm02.L": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"oris07.L": [
			-7.853981998095983e-8,
			8.726647293677559e-9,
			1.745329125668274e-8,
			0.9999999999999964
		],
		"oris07.R": [
			2.6179939105475088e-8,
			6.108652428338246e-8,
			1.7453293921221196e-8,
			0.9999999999999977
		],
		"tongue00": [
			1.0471975997461245e-7,
			8.726647071632954e-9,
			-8.726645184263907e-9,
			0.9999999999999946
		],
		"lowerarm02.R": [
			8.726646516521435e-9,
			3.490658395666202e-8,
			-1.745329214486445e-8,
			0.9999999999999989
		],
		"lowerleg01.L": [
			0.1276786778495069,
			-2.7418797121647742e-8,
			-1.9710016026946332e-7,
			0.9918155852892021
		],
		"tongue03": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger1-1.R": [
			0,
			0,
			-3.490658428972887e-8,
			0.9999999999999996
		],
		"metacarpal4.L": [
			-2.617993377640426e-8,
			1.396263374919826e-7,
			-4.3633232138517547e-8,
			0.9999999999999892
		],
		"finger1-2.R": [
			-7.615435000746974e-16,
			-1.7453292255886765e-8,
			-4.363322858580417e-8,
			0.999999999999999
		],
		"pelvis.R": [
			-2.6179939993653497e-8,
			8.726646516521441e-9,
			8.726645628343002e-9,
			0.9999999999999996
		],
		"toe2-1.R": [
			4.363322858580422e-8,
			8.726646516521441e-9,
			-8.726645628343238e-9,
			0.999999999999999
		],
		"toe2-3.L": [
			-7.853981998095987e-8,
			1.3322676295501878e-15,
			1.7453292146485912e-8,
			0.9999999999999969
		],
		"toe5-3.L": [
			8.726645628342989e-9,
			8.726645628343022e-9,
			6.981316857945736e-8,
			0.9999999999999974
		],
		"levator05.L": [
			4.3633228585804185e-8,
			7.771561172376096e-16,
			-2.6179939951169008e-8,
			0.9999999999999984
		],
		"finger4-1.L": [
			0.25721940257896997,
			-0.16419781918346998,
			-0.45913967684963997,
			0.8343069053140566
		],
		"finger4-1.R": [
			-8.726645184253789e-9,
			3.4906584178706623e-8,
			-2.617993999365348e-8,
			0.999999999999999
		],
		"levator05.R": [
			8.726646072432044e-8,
			6.981317235421614e-8,
			-2.6179933776400735e-8,
			0.9999999999999937
		],
		"toe5-3.R": [
			6.981316857945736e-8,
			-8.726645628343022e-9,
			-8.726646516520718e-9,
			0.9999999999999974
		],
		"toe2-3.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger4-2.L": [
			0.2947330119766014,
			-0.2255368706273353,
			-0.47194770905174427,
			0.7997067784879907
		],
		"toe2-1.L": [
			-6.108652428338202e-8,
			3.3306690738754696e-15,
			5.235988009708042e-8,
			0.999999999999997
		],
		"finger1-2.L": [
			1.745329125668605e-8,
			-2.617993899445281e-8,
			-4.3633228585803e-8,
			0.9999999999999988
		],
		"pelvis.L": [
			-7.853981998095983e-8,
			-1.2212453270876722e-15,
			-1.7453292151567028e-8,
			0.9999999999999968
		],
		"metacarpal4.R": [
			-2.617993999365349e-8,
			8.881784197001252e-16,
			3.490658424245935e-8,
			0.9999999999999989
		],
		"tongue04": [
			-4.363322858580417e-8,
			8.726646516521441e-9,
			-4.068768463957589e-16,
			0.999999999999999
		],
		"toe3-2.L": [
			1.5230870001493993e-16,
			8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"levator03.R": [
			9.599310857311011e-8,
			4.363322869682662e-8,
			-8.726642075628535e-9,
			0.9999999999999944
		],
		"upperleg02.R": [
			0.05033033898771495,
			-0.013555552307857988,
			0.02244465422363647,
			0.9983883720655963
		],
		"upperleg02.L": [
			-0.20742311243580744,
			3.5933111819375085e-8,
			2.9568333620694893e-7,
			0.9782513237544602
		],
		"levator03.L": [
			-1.745329480939979e-8,
			8.726645706058633e-8,
			3.49065825133716e-8,
			0.9999999999999952
		],
		"toe3-2.R": [
			4.3633228585804086e-8,
			1.7453292144864463e-8,
			8.726646960611766e-9,
			0.9999999999999989
		],
		"metacarpal3.L": [
			-5.2359878210949963e-8,
			5.235987832197253e-8,
			-3.49065878424416e-8,
			0.9999999999999968
		],
		"tongue01": [
			-1.0471975997461235e-7,
			-8.726646516521441e-9,
			9.147568014590599e-16,
			0.9999999999999946
		],
		"breast.L": [
			-1.7453292144864446e-8,
			1.7453292366909068e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"temporalis02.R": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"tongue02": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"oris04.R": [
			2.6179939105475045e-8,
			-1.745329114566374e-8,
			-4.363322858580426e-8,
			0.9999999999999988
		],
		"oris04.L": [
			2.6179939993653504e-8,
			-1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"temporalis02.L": [
			3.490658428972884e-8,
			8.726646405499139e-9,
			-8.726645628342989e-9,
			0.9999999999999991
		],
		"breast.R": [
			-2.6179939993653434e-8,
			6.108652450542706e-8,
			-1.5739905687674017e-15,
			0.999999999999998
		],
		"oris03.R": [
			-1.7453301026648743e-8,
			6.981317213217153e-8,
			1.3089969286283385e-7,
			0.999999999999989
		],
		"oris06.L": [
			-2.6179939105475068e-8,
			-3.4906584289728926e-8,
			1.7453293033042906e-8,
			0.999999999999999
		],
		"orbicularis04.R": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"toe1-2.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"toe1-2.L": [
			-3.490658428972884e-8,
			-8.726645517320719e-9,
			1.7453292144864436e-8,
			0.9999999999999991
		],
		"orbicularis04.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"metacarpal3.R": [
			-4.363322680944723e-8,
			5.235987998730707e-8,
			-1.7453294809399954e-8,
			0.9999999999999974
		],
		"oris06.R": [
			1.7453293921221316e-8,
			6.108652406133785e-8,
			-2.6179939105475e-8,
			0.9999999999999974
		],
		"levator04.L": [
			3.490658428972883e-8,
			-8.726647515722163e-9,
			3.490658428972884e-8,
			0.9999999999999987
		],
		"tongue06.L": [
			-3.49065842897288e-8,
			-1.7453293477132092e-8,
			-1.7453291256685666e-8,
			0.9999999999999992
		],
		"toe2-2.L": [
			-8.726646072432225e-9,
			-6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"toe2-2.R": [
			0,
			0,
			0,
			1
		],
		"tongue06.R": [
			-8.726645628343012e-9,
			1.745329203384216e-8,
			-3.4906584289728866e-8,
			0.9999999999999993
		],
		"levator04.R": [
			8.726645717160673e-8,
			-7.85398200919829e-8,
			-1.745329925029425e-8,
			0.999999999999993
		],
		"toe4-1.L": [
			1.1423153030516057e-15,
			2.617993988263123e-8,
			-4.3633228585804225e-8,
			0.9999999999999984
		],
		"upperleg01.R": [
			1.158709796280855e-7,
			-0.005418639275799664,
			-0.0361487929951549,
			0.9993317282631323
		],
		"metacarpal1.R": [
			-5.235987998730681e-8,
			-1.7453291478730648e-8,
			8.726646960610605e-9,
			0.9999999999999986
		],
		"levator02.R": [
			1.0471975997461267e-7,
			-9.599310857311139e-8,
			-8.72665628648547e-9,
			0.9999999999999898
		],
		"toe3-1.L": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"toe3-1.R": [
			-4.3633228585804185e-8,
			3.3306690738754696e-16,
			8.726646077118623e-9,
			0.9999999999999991
		],
		"levator02.L": [
			2.6179946210902697e-8,
			-8.726646050227771e-8,
			6.981316502674334e-8,
			0.9999999999999931
		],
		"finger5-1.R": [
			-3.4906584289728793e-8,
			1.7453291478730648e-8,
			-2.617994088183205e-8,
			0.9999999999999991
		],
		"metacarpal1.L": [
			-4.363322858580412e-8,
			3.4906584178706623e-8,
			-8.726647404700103e-9,
			0.9999999999999984
		],
		"toe4-1.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"upperleg01.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"head": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"toe5-1.R": [
			3.4906584289728866e-8,
			-5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"special01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			-3.490658428972886e-8,
			-1.1102230246251565e-16,
			-8.726646072432225e-9,
			0.9999999999999993
		],
		"special04": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"metacarpal2.L": [
			8.72665095741345e-9,
			7.85398199809606e-8,
			-6.108652428338193e-8,
			0.9999999999999948
		],
		"metacarpal2.R": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-2.6179939993653613e-8,
			0.9999999999999994
		],
		"temporalis01.R": [
			-8.726646516521436e-9,
			1.7453292366909068e-8,
			2.6179939993653527e-8,
			0.9999999999999996
		],
		"toe5-1.L": [
			8.726645628343007e-9,
			-1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"risorius02.R": [
			-2.6179939105475104e-8,
			6.981316891252476e-8,
			-1.7453293921221593e-8,
			0.9999999999999972
		],
		"special05.L": [
			1.7453292144864433e-8,
			2.617994021569814e-8,
			4.927555263958927e-16,
			0.9999999999999996
		],
		"finger2-2.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"foot.L": [
			0.39030858805816526,
			0.03557839124671336,
			0.00249175747590161,
			0.919993030032847
		],
		"toe3-3.R": [
			-3.4906584289728906e-8,
			-8.726645739365324e-9,
			8.726646516521435e-9,
			0.9999999999999994
		],
		"levator06.R": [
			-8.72664562834302e-9,
			-3.4906584289728926e-8,
			8.726646516521445e-9,
			0.9999999999999994
		],
		"orbicularis03.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator06.L": [
			1.5230870001493931e-15,
			8.726645717160864e-8,
			-1.7453292144864383e-8,
			0.9999999999999962
		],
		"orbicularis03.L": [
			2.284630764921893e-16,
			-8.726645961409929e-9,
			2.61799399936535e-8,
			0.9999999999999996
		],
		"foot.R": [
			0.30241696396364687,
			0.031801920942795436,
			-0.03137808433725972,
			0.9521281602571593
		],
		"root": [
			0.7577080796193822,
			4.3533863958167274e-8,
			-2.9430631486795763e-9,
			0.6525936454483032
		],
		"finger2-2.R": [
			6.981316857945712e-8,
			-4.363323047318346e-8,
			3.490658073702643e-8,
			0.999999999999996
		],
		"risorius02.L": [
			-1.3707785118926907e-15,
			2.6179939993653534e-8,
			5.235987998730687e-8,
			0.9999999999999984
		],
		"special05.R": [
			-1.7453292144864427e-8,
			-8.881784197001252e-16,
			-5.235988012452949e-8,
			0.9999999999999986
		],
		"lowerleg02.L": [
			8.726646516521438e-9,
			-3.490658440075123e-8,
			8.726645628343022e-9,
			0.9999999999999994
		],
		"tongue05.L": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"finger5-1.L": [
			0.13893441281362817,
			-0.14976903805996067,
			-0.49645691204855397,
			0.8436806259799622
		],
		"toe4-3.R": [
			0,
			0,
			0,
			1
		],
		"oris03.L": [
			-3.490658606608592e-8,
			-1.745329647473426e-8,
			-1.3089969286289749e-7,
			0.9999999999999906
		],
		"toe4-3.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-3.L": [
			0.3555103692421994,
			-0.2761592589479769,
			-0.41419002126019083,
			0.791072099967545
		],
		"tongue05.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"lowerleg02.R": [
			5.2359879987306704e-8,
			1.745329336610979e-8,
			-8.726645184253104e-9,
			0.9999999999999986
		],
		"shoulder01.R": [
			1.0471975997461261e-7,
			-5.2359883428998444e-8,
			2.617993466458787e-8,
			0.9999999999999926
		],
		"finger3-1.L": [
			0.30267497950852124,
			-0.21593371400070305,
			-0.3819125440577222,
			0.8461106881659973
		],
		"special06.R": [
			-8.72664696061062e-9,
			-2.6179939993653534e-8,
			-3.490658428972884e-8,
			0.9999999999999991
		],
		"finger4-3.L": [
			0.3233955840537047,
			-0.21884678483632292,
			-0.5429530884807099,
			0.7434536466321392
		],
		"finger3-2.L": [
			0.34837279566816776,
			-0.2781575041725437,
			-0.39973190750708876,
			0.800923966573351
		],
		"upperarm01.R": [
			-0.0976126923913818,
			-0.20574988236084601,
			0.1748712218313746,
			0.9578928979629224
		],
		"finger3-2.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"upperarm01.L": [
			-0.08484664751362371,
			-0.08189169894918713,
			0.5236920870071378,
			0.84370693611883
		],
		"special06.L": [
			-2.6179939993653487e-8,
			8.726647071632954e-9,
			3.490658428972886e-8,
			0.9999999999999988
		],
		"finger3-1.R": [
			-2.6179939993653494e-8,
			-6.661338147750939e-16,
			-2.6179940052507944e-8,
			0.9999999999999993
		],
		"shoulder01.L": [
			2.6179939105475078e-8,
			-1.7453291034641438e-8,
			-3.490658428972863e-8,
			0.9999999999999987
		],
		"lowerarm01.R": [
			1.2184696001195153e-15,
			-1.745329203384216e-8,
			6.981316857945761e-8,
			0.9999999999999974
		],
		"special03": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"upperarm02.L": [
			-0.2929130703016428,
			0.20654547695914593,
			-0.01306886855580516,
			0.933472069142326
		],
		"spine02": [
			-0.07441319477826981,
			0.014305326927936624,
			0.0075450127811763,
			0.9970963377961571
		],
		"spine03": [
			-0.037016259855105454,
			1.1102230246251565e-16,
			0,
			0.9993146634100489
		],
		"spine01": [
			-0.08057138222549462,
			0.008488043063654471,
			-0.0007711994810358576,
			0.9967124012184178
		],
		"upperarm02.R": [
			-0.11869832148697528,
			-0.13374956872790866,
			0.0025305856159237353,
			0.9838777146971637
		],
		"spine04": [
			-0.08294474784287259,
			0,
			0,
			0.9965541474527526
		],
		"spine05": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"lowerarm01.L": [
			0.02195759886413944,
			0.04081359421651365,
			0.06841945306013797,
			0.9965795968321863
		],
		"finger5-3.L": [
			0.17106869579365433,
			-0.19352569357785643,
			-0.5819743412621895,
			0.7710960856839492
		],
		"oris01": [
			7.853981998095985e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"oris02": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"oris05": [
			-1.0471975997461235e-7,
			8.726646516521441e-9,
			-9.147568014590599e-16,
			0.9999999999999946
		],
		"risorius03.R": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"finger2-3.L": [
			5.235987998730683e-8,
			-8.726646294476836e-9,
			-4.4331856927593173e-16,
			0.9999999999999987
		],
		"oris06": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger3-3.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger2-3.R": [
			2.6179939993653504e-8,
			3.4906584733818136e-8,
			-8.726645184253808e-9,
			0.9999999999999991
		],
		"toe3-3.L": [
			-5.235987821095e-8,
			-2.617993533071683e-8,
			8.726645717161273e-8,
			0.9999999999999942
		],
		"risorius03.L": [
			-1.047197599746124e-7,
			3.4906581070082154e-8,
			-2.6179943546368675e-8,
			0.9999999999999939
		]
	},
	"Harvey_SittingFashion2": {
		"toe1-1.L": [
			-0.19477093297675607,
			-0.017894744722668388,
			0.01349462327202045,
			0.9805926559593543
		],
		"finger5-2.R": [
			5.235987998730684e-8,
			-1.7453292144864463e-8,
			-9.583612278589327e-16,
			0.9999999999999983
		],
		"finger1-3.R": [
			-4.3633228585804086e-8,
			-2.617993932751972e-8,
			1.7453293033042373e-8,
			0.9999999999999989
		],
		"toe5-2.R": [
			-3.4906584289728906e-8,
			8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"toe4-2.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"clavicle.R": [
			1.7453292144864446e-8,
			5.551115123125783e-16,
			-3.490658429686185e-8,
			0.9999999999999992
		],
		"neck03": [
			4.169795475774536e-8,
			-0.09232116027527237,
			-0.03710709646938845,
			0.9950376207747307
		],
		"neck02": [
			0.09898103885290478,
			-0.09546168301633573,
			-0.02628024905797052,
			0.9901510841951039
		],
		"neck01": [
			-0.09947011691017076,
			-1.1102230246251565e-16,
			1.232595164407831e-32,
			0.9950405498480337
		],
		"clavicle.L": [
			1.745329214486445e-8,
			-3.3306690738754696e-16,
			3.490658449484121e-8,
			0.9999999999999994
		],
		"toe5-2.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"toe4-2.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"finger5-2.L": [
			-8.726646072432225e-9,
			-6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"finger1-3.L": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"toe1-1.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"oculi02.L": [
			-8.726646072432228e-9,
			0,
			2.6179939875677524e-8,
			1
		],
		"oculi01.L": [
			-2.6179939993653487e-8,
			7.771561172376096e-16,
			2.6179939958862843e-8,
			0.9999999999999994
		],
		"jaw": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"oculi01.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"oculi02.R": [
			2.2846307649218933e-16,
			2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"wrist.R": [
			-0.2451089895364866,
			-0.2450433055423813,
			-0.47561279560336683,
			0.808497266733547
		],
		"finger1-1.L": [
			-0.04496871286632635,
			0.1861798547428679,
			0.04211111071193015,
			0.9805822407660043
		],
		"tongue07.R": [
			-4.363322858580419e-8,
			2.6179939660586626e-8,
			8.7266447401649e-9,
			0.9999999999999984
		],
		"eye.R": [
			-1.7453292144864443e-8,
			-1.7453292255886765e-8,
			8.726646516521435e-9,
			0.9999999999999997
		],
		"finger2-1.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"finger4-3.R": [
			3.0461740002987947e-16,
			-8.726645961409929e-9,
			3.490658428972888e-8,
			0.9999999999999993
		],
		"finger2-1.L": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"eye.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"tongue07.L": [
			3.4906584289728866e-8,
			-8.726645961409929e-9,
			-1.7169609607764797e-16,
			0.9999999999999993
		],
		"wrist.L": [
			-0.27510679354581224,
			0.29011157777045615,
			0.41641038657123247,
			0.8165500073749771
		],
		"finger5-3.R": [
			-8.726645628343025e-9,
			-8.726645850387627e-9,
			3.4906584289728807e-8,
			0.9999999999999993
		],
		"lowerleg01.R": [
			0.5714669761560752,
			-0.045606019245387985,
			0.012136701025468485,
			0.8192669202768039
		],
		"lowerarm02.L": [
			2.6179939993653464e-8,
			-8.726645295276114e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"oris07.L": [
			2.6179939993653497e-8,
			8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"oris07.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue00": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"lowerarm02.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"lowerleg01.L": [
			0.8590457221740829,
			0.06855562472079324,
			-0.018228847241985747,
			0.5069598432438002
		],
		"tongue03": [
			-4.569261529843785e-16,
			2.6179939993653534e-8,
			1.745329214486445e-8,
			0.9999999999999997
		],
		"finger1-1.R": [
			-0.04496868615201387,
			-0.1861798480570901,
			-0.04211111605341781,
			0.980582243031117
		],
		"metacarpal4.L": [
			-1.7453291256685997e-8,
			1.745329114566374e-8,
			-5.235987998730706e-8,
			0.9999999999999983
		],
		"finger1-2.R": [
			-7.853981998095983e-8,
			-2.617993899445281e-8,
			8.726648292877301e-9,
			0.9999999999999961
		],
		"pelvis.R": [
			-0.36802260748683685,
			-0.04365855231188198,
			-0.022911604236283203,
			0.9285086696310062
		],
		"toe2-1.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"toe2-3.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"toe5-3.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"levator05.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"finger4-1.L": [
			2.6179939993653494e-8,
			8.726646960610651e-9,
			-3.490658428972892e-8,
			0.9999999999999989
		],
		"finger4-1.R": [
			-1.7453291256685997e-8,
			-8.72664507323151e-9,
			6.108652428338223e-8,
			0.999999999999998
		],
		"levator05.R": [
			-1.7453291256686083e-8,
			-2.617993899445281e-8,
			2.6179940881832245e-8,
			0.9999999999999991
		],
		"toe5-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe2-3.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger4-2.L": [
			-1.7453292144864443e-8,
			-6.661338147750939e-16,
			-2.6179940059872455e-8,
			0.9999999999999999
		],
		"toe2-1.L": [
			-0.19431516294757628,
			-0.0182588912262045,
			0.018609028840254525,
			0.9805926444683694
		],
		"finger1-2.L": [
			-3.490658428972882e-8,
			2.6179939993653534e-8,
			8.726645184253818e-9,
			0.9999999999999988
		],
		"pelvis.L": [
			-0.284727830971177,
			0.03378022255405333,
			0.017724715469315682,
			0.9578490451507375
		],
		"metacarpal4.R": [
			-1.7453290368507643e-8,
			-3.490658262439439e-8,
			5.2359879987306684e-8,
			0.999999999999998
		],
		"tongue04": [
			-1.5230870001493986e-16,
			1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"toe3-2.L": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"levator03.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"upperleg02.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"upperleg02.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"levator03.L": [
			8.726646960610704e-9,
			-2.6179939993653534e-8,
			2.6179939993653468e-8,
			0.9999999999999992
		],
		"toe3-2.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"metacarpal3.L": [
			-1.7453291256686047e-8,
			-1.7453291478730648e-8,
			2.6179939993653507e-8,
			0.9999999999999994
		],
		"tongue01": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"breast.L": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"temporalis02.R": [
			-8.726646072432225e-9,
			2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"tongue02": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris04.R": [
			8.72664562834299e-9,
			6.981316835741325e-8,
			8.726646516521431e-9,
			0.9999999999999971
		],
		"oris04.L": [
			0,
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0.9999999999999991
		],
		"temporalis02.L": [
			-8.726646072432231e-9,
			1.7453292366909068e-8,
			-8.726646072432231e-9,
			0.9999999999999998
		],
		"breast.R": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"oris03.R": [
			-1.745329303304287e-8,
			-3.490658440075123e-8,
			-1.7453291256686037e-8,
			0.999999999999999
		],
		"oris06.L": [
			-8.72664829287831e-9,
			7.85398202030052e-8,
			2.617993910547502e-8,
			0.9999999999999967
		],
		"orbicularis04.R": [
			8.726646516521441e-9,
			-2.6179940104675836e-8,
			8.726645628343022e-9,
			0.9999999999999998
		],
		"toe1-2.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe1-2.L": [
			1.7453292144864456e-8,
			8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"orbicularis04.L": [
			3.490658428972878e-8,
			-2.6179939549564324e-8,
			-1.7453293033042585e-8,
			0.9999999999999991
		],
		"metacarpal3.R": [
			-8.726645628343017e-9,
			-1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"oris06.R": [
			-5.235987998730684e-8,
			3.3306690738754696e-16,
			8.726646049588092e-9,
			0.9999999999999987
		],
		"levator04.L": [
			0,
			0,
			2.617993999365351e-8,
			0.9999999999999998
		],
		"tongue06.L": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"toe2-2.L": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe2-2.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"tongue06.R": [
			1.745329214486445e-8,
			1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"levator04.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"toe4-1.L": [
			-0.09721789655329924,
			-0.012687093842219332,
			0.01679722594858436,
			0.9950404873370848
		],
		"upperleg01.R": [
			-0.2828669043469692,
			0.05989810812495866,
			0.08520771437389284,
			0.9534873761510375
		],
		"metacarpal1.R": [
			8.726646960610704e-9,
			-2.6179939993653534e-8,
			2.6179939993653468e-8,
			0.9999999999999992
		],
		"levator02.R": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"toe3-1.L": [
			-0.19259860471259282,
			-0.020028408444414003,
			0.030704986893645522,
			0.9805925984310752
		],
		"toe3-1.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"levator02.L": [
			2.6179939105475058e-8,
			2.617993943854202e-8,
			2.6179940881831917e-8,
			0.9999999999999991
		],
		"finger5-1.R": [
			8.726646516521443e-9,
			1.7453291811797556e-8,
			-2.6179939993653554e-8,
			0.9999999999999993
		],
		"metacarpal1.L": [
			-8.726646516521435e-9,
			1.7453292366909068e-8,
			3.49065842897289e-8,
			0.9999999999999992
		],
		"toe4-1.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperleg01.L": [
			-0.5668596097053384,
			-0.08671952356614954,
			-0.06656038716771934,
			0.8165290086563086
		],
		"head": [
			-0.09850002179786733,
			-0.09324684995630528,
			0.10352293350252242,
			0.985335360635189
		],
		"toe5-1.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"special01": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"temporalis01.L": [
			8.726646960610678e-9,
			1.7453293255087488e-8,
			-5.2359879987306756e-8,
			0.9999999999999989
		],
		"special04": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"metacarpal2.L": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"metacarpal2.R": [
			2.6179939993653464e-8,
			-1.1102230246251565e-15,
			5.235988002172713e-8,
			0.9999999999999984
		],
		"temporalis01.R": [
			1.7453291256686e-8,
			4.363322836375971e-8,
			2.617994088183192e-8,
			0.9999999999999984
		],
		"toe5-1.L": [
			-0.0985102638667868,
			-0.010291584631484052,
			0.009174964560101976,
			0.9950405173780559
		],
		"risorius02.R": [
			-1.7453292144864443e-8,
			2.6179940104675836e-8,
			8.726645628343028e-9,
			0.9999999999999997
		],
		"special05.L": [
			0,
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0.9999999999999991
		],
		"finger2-2.L": [
			2.6179939105475068e-8,
			-3.4906584289728926e-8,
			-1.7453293033042906e-8,
			0.999999999999999
		],
		"foot.L": [
			0.37004765793979993,
			0.029536407784904406,
			-0.007856167005055934,
			0.9285098879971185
		],
		"oris06": [
			8.726646072432215e-9,
			5.235988020935167e-8,
			4.624224031074066e-16,
			0.9999999999999982
		],
		"levator06.R": [
			2.2846307649218933e-16,
			2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"orbicularis03.R": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator06.L": [
			1.7453293033042893e-8,
			6.108652428338246e-8,
			-8.72664518425366e-9,
			0.9999999999999979
		],
		"orbicularis03.L": [
			1.745329214486444e-8,
			-3.490658451177353e-8,
			-4.799202690040438e-16,
			0.9999999999999992
		],
		"foot.R": [
			0.44561863184143247,
			-0.03556570649708324,
			0.009461916007530054,
			0.894466090817645
		],
		"root": [
			-0.3713112455965303,
			0,
			0,
			0.9285084592471698
		],
		"finger2-2.R": [
			2.6179939993653494e-8,
			-8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"risorius02.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"special05.R": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"lowerleg02.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"tongue05.L": [
			-8.72664651652143e-9,
			4.363322880784892e-8,
			8.726645628342965e-9,
			0.9999999999999992
		],
		"finger5-1.L": [
			8.726646516521436e-9,
			-1.7453292366909068e-8,
			2.6179939993653527e-8,
			0.9999999999999996
		],
		"toe4-3.R": [
			-7.853981998095987e-8,
			-6.661338147750939e-16,
			-8.726646064066113e-9,
			0.999999999999997
		],
		"oris03.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"toe4-3.L": [
			-5.235987998730683e-8,
			8.726646627543744e-9,
			8.726645628343008e-9,
			0.9999999999999987
		],
		"finger3-3.L": [
			0,
			0,
			2.617993999365351e-8,
			0.9999999999999998
		],
		"tongue05.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"lowerleg02.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"shoulder01.R": [
			0.09087254836643018,
			-0.1737618620235276,
			0.002022204943558372,
			0.9805839617017372
		],
		"finger3-1.L": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"special06.R": [
			3.046174000298792e-16,
			3.490658440075123e-8,
			-8.726646072432198e-9,
			0.9999999999999992
		],
		"finger4-3.L": [
			-2.6179939993653494e-8,
			-1.745329158975295e-8,
			1.745329303304287e-8,
			0.9999999999999994
		],
		"finger3-2.L": [
			3.807717500373487e-16,
			8.726646183454534e-9,
			-4.36332285858042e-8,
			0.999999999999999
		],
		"upperarm01.R": [
			0.4410053519066275,
			0.07330254106448897,
			0.008376341446908568,
			0.8944667986947115
		],
		"finger3-2.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"upperarm01.L": [
			0.4856055079913079,
			-0.1332458382441155,
			-0.009397524159694522,
			0.8639123356792602
		],
		"special06.L": [
			-2.2846307649218933e-16,
			2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"finger3-1.R": [
			-1.7453292144864456e-8,
			8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"shoulder01.L": [
			0.09087254836643018,
			0.1737618620235276,
			-0.002022204943558372,
			0.9805839617017372
		],
		"lowerarm01.R": [
			0.21397759852833204,
			-0.1916740298471291,
			0.0032808648248347392,
			0.9578433533392663
		],
		"special03": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"upperarm02.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"spine02": [
			-0.09947012417709522,
			-1.1102230246251565e-16,
			0,
			0.9950405491215889
		],
		"spine03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"spine01": [
			-0.19605579706334517,
			1.1102230246251565e-16,
			-1.9721522630525295e-31,
			0.9805927413752646
		],
		"upperarm02.R": [
			-8.726646072432222e-9,
			-2.220446049250313e-16,
			-3.490658426895706e-8,
			0.9999999999999992
		],
		"spine04": [
			0.09946979995889645,
			-1.1102230246251565e-16,
			0,
			0.9950405815322999
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			0.27656927235971424,
			0.2477285456887981,
			-0.004244312451367182,
			0.9285052455689988
		],
		"finger5-3.L": [
			-3.4906584289728906e-8,
			8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"oris01": [
			-6.108652428338218e-8,
			2.617994065978735e-8,
			1.7453290368509142e-8,
			0.9999999999999977
		],
		"oris02": [
			-4.363322858580417e-8,
			-8.726646516521441e-9,
			4.068768463957589e-16,
			0.999999999999999
		],
		"oris05": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"risorius03.R": [
			-8.726645184253789e-9,
			-3.490658440075123e-8,
			2.6179939993653494e-8,
			0.999999999999999
		],
		"finger2-3.L": [
			-2.617993999365348e-8,
			-8.726646738566046e-9,
			-2.6179939993653468e-8,
			0.9999999999999991
		],
		"toe3-3.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"finger3-3.R": [
			6.981316857945734e-8,
			8.726646627543744e-9,
			-8.72664562834299e-9,
			0.9999999999999977
		],
		"finger2-3.R": [
			8.726646516521445e-9,
			-8.726646405499139e-9,
			3.490658428972881e-8,
			0.9999999999999996
		],
		"toe3-3.L": [
			1.7453292144864453e-8,
			-8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"risorius03.L": [
			7.615435000746988e-16,
			4.363322858580432e-8,
			-1.7453292144864436e-8,
			0.9999999999999989
		]
	},
	"Harvey_StandingFashion2": {
		"toe1-1.L": [
			2.617993999365346e-8,
			5.235987998730707e-8,
			1.361416935280011e-15,
			0.9999999999999983
		],
		"finger5-2.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"finger1-3.R": [
			1.745329303304289e-8,
			-2.6179940104675836e-8,
			1.745329125668605e-8,
			0.9999999999999996
		],
		"toe5-2.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe4-2.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"clavicle.R": [
			0.026519303829748597,
			0.09584509884127579,
			-0.003301743419716341,
			0.9950374576079444
		],
		"neck03": [
			1.2673447779378008e-8,
			0.018629062991703527,
			-0.046316568119267154,
			0.9987530893717949
		],
		"neck02": [
			-8.429587546541338e-10,
			0.013258552989972916,
			-0.048128570206776015,
			0.9987531484318152
		],
		"neck01": [
			-1.6845095417832065e-8,
			0.0883009236135972,
			0.04585422285406301,
			0.9950378571368202
		],
		"clavicle.L": [
			-8.72664607243222e-9,
			2.220446049250313e-16,
			4.3633228492591465e-8,
			0.999999999999999
		],
		"toe5-2.L": [
			8.726645628343007e-9,
			-1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"toe4-2.L": [
			-8.726646072432223e-9,
			-3.490658451177353e-8,
			3.180207328966892e-16,
			0.9999999999999998
		],
		"finger5-2.L": [
			0.027131535657061015,
			-0.02826578131499269,
			-0.09143242344248376,
			0.9950402189474441
		],
		"finger1-3.L": [
			-8.726646072432223e-9,
			3.490658451177353e-8,
			-3.180207328966892e-16,
			0.9999999999999998
		],
		"toe1-1.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"oculi02.L": [
			-4.36332285858042e-8,
			-8.726645184253812e-9,
			1.7453292144864443e-8,
			0.9999999999999989
		],
		"oculi01.L": [
			-4.3633228585804245e-8,
			1.7453293255087488e-8,
			1.745329125668602e-8,
			0.999999999999999
		],
		"jaw": [
			1.7453292144864446e-8,
			3.490658440075123e-8,
			-8.726645628343005e-9,
			0.9999999999999993
		],
		"finger4-2.R": [
			3.490658428972884e-8,
			8.726645517320719e-9,
			1.7453292144864436e-8,
			0.9999999999999991
		],
		"oculi01.R": [
			1.7453292144864446e-8,
			-4.440892098500626e-16,
			1.7453292108381275e-8,
			0.9999999999999999
		],
		"oculi02.R": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"wrist.R": [
			0.1362956253989389,
			0.16461491780054915,
			0.04394549398512758,
			0.9759068730637338
		],
		"finger1-1.L": [
			1.7453290368507637e-8,
			-5.235988020935167e-8,
			-3.490658606608566e-8,
			0.9999999999999979
		],
		"tongue07.R": [
			4.3633228585804245e-8,
			-1.7453293255087488e-8,
			1.745329125668602e-8,
			0.999999999999999
		],
		"eye.R": [
			0,
			0,
			0,
			1
		],
		"finger2-1.R": [
			-2.6179938217296714e-8,
			-3.490658262439439e-8,
			6.108652428337613e-8,
			0.9999999999999971
		],
		"finger4-3.R": [
			-1.1102230246251565e-16,
			-8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"finger2-1.L": [
			0.3290153967316793,
			-0.20674465820472165,
			-0.22125538548853732,
			0.8944560187117235
		],
		"eye.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"tongue07.L": [
			3.4906584289728754e-8,
			-4.363322880784892e-8,
			-8.726647404700152e-9,
			0.9999999999999986
		],
		"wrist.L": [
			-0.07739409278865442,
			-0.06199631490648472,
			-0.007958005857571832,
			0.995039336650671
		],
		"finger5-3.R": [
			-8.726645628343032e-9,
			-2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"lowerleg01.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"lowerarm02.L": [
			-8.726646072432222e-9,
			-2.220446049250313e-16,
			-3.490658426895706e-8,
			0.9999999999999992
		],
		"oris07.L": [
			3.490658428972884e-8,
			-8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"oris07.R": [
			4.569261529843771e-16,
			5.235988009832937e-8,
			-8.726646072432165e-9,
			0.9999999999999987
		],
		"tongue00": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"lowerarm02.R": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"lowerleg01.L": [
			0.022545554305726596,
			-0.28614611799422174,
			-0.013435482861257389,
			0.9578264899960587
		],
		"tongue03": [
			1.7453291256686003e-8,
			5.235987976526246e-8,
			1.7453293033042863e-8,
			0.9999999999999982
		],
		"finger1-1.R": [
			-0.022815795026878954,
			-0.09446273543572004,
			-0.021365828599281562,
			0.99503755330116
		],
		"metacarpal4.L": [
			8.72664474016463e-9,
			-2.617993888343051e-8,
			-5.235987998730668e-8,
			0.9999999999999984
		],
		"finger1-2.R": [
			-1.7453292144864446e-8,
			1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"pelvis.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe2-1.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-3.L": [
			1.745329303304287e-8,
			-3.490658440075123e-8,
			1.7453291256686037e-8,
			0.999999999999999
		],
		"toe5-3.L": [
			3.4906584289728866e-8,
			-8.726645961409929e-9,
			-1.7169609607764797e-16,
			0.9999999999999993
		],
		"levator05.L": [
			1.745329214486445e-8,
			-8.726646294476836e-9,
			1.745329214486445e-8,
			0.9999999999999998
		],
		"finger4-1.L": [
			0.2100979874259464,
			-0.1176802827332688,
			-0.37677885235660163,
			0.8944539580952322
		],
		"finger4-1.R": [
			8.726647404699846e-9,
			-4.363322880784892e-8,
			2.617993999365346e-8,
			0.9999999999999984
		],
		"levator05.R": [
			-2.220446049250313e-16,
			1.745329203384216e-8,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe5-3.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe2-3.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger4-2.L": [
			0.21941437868023406,
			-0.14772523670822235,
			-0.3605438446752431,
			0.8944510724095874
		],
		"toe2-1.L": [
			2.617993999365347e-8,
			2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"finger1-2.L": [
			0.06182842985014558,
			0.09975856204810207,
			0.07633931935267199,
			0.9901503839726222
		],
		"pelvis.L": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"metacarpal4.R": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"tongue04": [
			6.108652428338209e-8,
			-1.7453292144864463e-8,
			-1.0899510809257394e-15,
			0.999999999999998
		],
		"toe3-2.L": [
			-1.7453292144864446e-8,
			3.490658440075123e-8,
			8.726645628343005e-9,
			0.9999999999999993
		],
		"levator03.R": [
			2.617993999365347e-8,
			2.6179940437742744e-8,
			-8.726645184253845e-9,
			0.9999999999999996
		],
		"upperleg02.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"upperleg02.L": [
			1.745329214486445e-8,
			8.726646627543744e-9,
			-2.6179939993653573e-8,
			0.9999999999999997
		],
		"levator03.L": [
			1.745329214486443e-8,
			-5.235987998730707e-8,
			-8.662785736608193e-16,
			0.999999999999998
		],
		"toe3-2.R": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"metacarpal3.L": [
			-4.569261529843771e-16,
			-5.235988009832937e-8,
			-8.726646072432165e-9,
			0.9999999999999987
		],
		"tongue01": [
			2.617993999365348e-8,
			4.363322869682662e-8,
			1.035761105051169e-15,
			0.9999999999999987
		],
		"breast.L": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"temporalis02.R": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"tongue02": [
			0,
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0.9999999999999992
		],
		"oris04.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"oris04.L": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"temporalis02.L": [
			-1.745329303304284e-8,
			5.235988009832937e-8,
			8.726645184253813e-9,
			0.9999999999999986
		],
		"breast.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oris03.R": [
			-8.726645184253792e-9,
			1.745329203384216e-8,
			-4.363322858580425e-8,
			0.9999999999999988
		],
		"oris06.L": [
			2.6179939105475058e-8,
			2.617993943854202e-8,
			2.6179940881831917e-8,
			0.9999999999999991
		],
		"orbicularis04.R": [
			2.6179939993653484e-8,
			2.6179940104675836e-8,
			8.045503725131716e-16,
			0.9999999999999991
		],
		"toe1-2.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"toe1-2.L": [
			-1.7453292144864473e-8,
			4.363322880784892e-8,
			-8.726646960610506e-9,
			0.9999999999999988
		],
		"orbicularis04.L": [
			2.6179939993653464e-8,
			-8.726645295276114e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"metacarpal3.R": [
			-8.726645184253789e-9,
			-3.490658440075123e-8,
			2.6179939993653494e-8,
			0.999999999999999
		],
		"oris06.R": [
			-3.046174000298792e-16,
			-3.490658440075123e-8,
			-8.726646072432198e-9,
			0.9999999999999992
		],
		"levator04.L": [
			8.726645628343012e-9,
			4.3633228474782015e-8,
			8.726646516521458e-9,
			0.9999999999999989
		],
		"tongue06.L": [
			8.726645628343017e-9,
			2.6179939993653534e-8,
			1.7453292144864436e-8,
			0.9999999999999996
		],
		"toe2-2.L": [
			-8.726646516521438e-9,
			-3.490658440075123e-8,
			-8.726645628343022e-9,
			0.9999999999999994
		],
		"toe2-2.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"tongue06.R": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"levator04.R": [
			0,
			0,
			1.745329214486446e-8,
			1
		],
		"toe4-1.L": [
			1.7453292144864407e-8,
			6.108652472747167e-8,
			1.0183439690065433e-15,
			0.9999999999999984
		],
		"upperleg01.R": [
			0.0007085242571998434,
			0.015130138202503751,
			0.04756873870209532,
			0.9987531186482685
		],
		"metacarpal1.R": [
			2.617993999365353e-8,
			-1.745329336610979e-8,
			1.7453291256686023e-8,
			0.9999999999999997
		],
		"levator02.R": [
			2.6179940881831897e-8,
			2.6179940992854256e-8,
			-2.6179939105475064e-8,
			0.9999999999999988
		],
		"toe3-1.L": [
			0,
			6.981316857945734e-8,
			-2.220446049250313e-16,
			0.9999999999999974
		],
		"toe3-1.R": [
			0,
			0,
			0,
			1
		],
		"levator02.L": [
			-1.5230870001493993e-16,
			-8.726646183454534e-9,
			-1.7453292144864466e-8,
			0.9999999999999999
		],
		"finger5-1.R": [
			-8.726646072432225e-9,
			-2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"metacarpal1.L": [
			3.490658428972884e-8,
			-8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"toe4-1.R": [
			3.4906584289728793e-8,
			-1.7453292366909068e-8,
			-8.7266465165216e-9,
			0.9999999999999996
		],
		"upperleg01.L": [
			-0.17295655547697827,
			0.2813240507582244,
			0.007024911504323941,
			0.943871526745499
		],
		"head": [
			0.09744073591201777,
			0.19212325151530263,
			-0.0588567730495467,
			0.974746038452225
		],
		"toe5-1.R": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"special01": [
			0,
			2.6179939993653504e-8,
			1.1102230246251565e-16,
			0.9999999999999998
		],
		"temporalis01.L": [
			1.3707785118926925e-15,
			5.235988009832937e-8,
			-2.617993999365348e-8,
			0.9999999999999982
		],
		"special04": [
			-2.6179939993653504e-8,
			1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"metacarpal2.L": [
			-1.7453293921221352e-8,
			-2.6179941881032676e-8,
			-7.853981998095827e-8,
			0.9999999999999964
		],
		"metacarpal2.R": [
			-1.7453293033042797e-8,
			1.7453293144065185e-8,
			6.981316857945734e-8,
			0.9999999999999972
		],
		"temporalis01.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"toe5-1.L": [
			2.6179939993653504e-8,
			3.4906584733818136e-8,
			-8.726645184253808e-9,
			0.9999999999999991
		],
		"risorius02.R": [
			-2.6179939993653504e-8,
			1.7453292144864463e-8,
			-4.776313300554488e-16,
			0.9999999999999993
		],
		"special05.L": [
			0,
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0.9999999999999991
		],
		"finger2-2.L": [
			0.3311544594059638,
			-0.2085202743869332,
			-0.2163422243089678,
			0.8944562936030972
		],
		"foot.L": [
			0.06587654629537244,
			0.3423500556764799,
			-0.03546603430051175,
			0.9365889602368268
		],
		"oris06": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"levator06.R": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"orbicularis03.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"levator06.L": [
			1.745329214486444e-8,
			4.440892098500626e-16,
			-1.7453292016352737e-8,
			0.9999999999999994
		],
		"orbicularis03.L": [
			3.046174000298796e-16,
			-3.4906584178706623e-8,
			8.726646072432218e-9,
			0.9999999999999994
		],
		"foot.R": [
			-0.09913256284882312,
			0.00791498369865351,
			-0.002103861465546554,
			0.9950405327337212
		],
		"root": [
			0.09946978542504491,
			-1.1102230246251565e-16,
			0,
			0.9950405829851845
		],
		"finger2-2.R": [
			-8.726646516521436e-9,
			1.7453292366909068e-8,
			2.6179939993653527e-8,
			0.9999999999999996
		],
		"risorius02.L": [
			-2.617993999365346e-8,
			-3.4906584733818136e-8,
			1.0095481158786604e-15,
			0.9999999999999991
		],
		"special05.R": [
			-1.745329214486445e-8,
			-1.7453291922819858e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"lowerleg02.L": [
			0,
			0,
			0,
			1
		],
		"tongue05.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"finger5-1.L": [
			-0.09209988358144425,
			-0.033378379802469604,
			-0.017275042867755573,
			0.9950402344126416
		],
		"toe4-3.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris03.L": [
			-2.6179939993653474e-8,
			8.726646627543744e-9,
			1.7453292144864476e-8,
			0.9999999999999994
		],
		"toe4-3.L": [
			-4.3633228585804027e-8,
			4.3633228918871225e-8,
			1.745329036850777e-8,
			0.9999999999999984
		],
		"finger3-3.L": [
			0.25900167548487096,
			-0.18840750624158242,
			-0.3120586676017559,
			0.8944496249999069
		],
		"tongue05.R": [
			1.745329214486445e-8,
			1.7453291922819858e-8,
			-1.745329214486445e-8,
			0.9999999999999993
		],
		"lowerleg02.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"shoulder01.R": [
			0.0009138537104710897,
			-0.0006807052698341032,
			-0.09946342431120198,
			0.9950405663770809
		],
		"finger3-1.L": [
			0.2533564373639661,
			-0.16811730629081212,
			-0.3278790827314148,
			0.8944508896965593
		],
		"special06.R": [
			3.046174000298792e-16,
			3.490658440075123e-8,
			-8.726646072432198e-9,
			0.9999999999999992
		],
		"finger4-3.L": [
			0.21689794187232256,
			-0.13088071347611652,
			-0.36848312094352353,
			0.8944527439900075
		],
		"finger3-2.L": [
			0.2592439054145594,
			-0.19318926985779494,
			-0.30891904667117837,
			0.8944492865003526
		],
		"upperarm01.R": [
			0.18864793916275174,
			0.20128536488929694,
			0.23703933101357424,
			0.9315087291505469
		],
		"finger3-2.R": [
			2.617994088183188e-8,
			-5.2359880320373975e-8,
			8.7266447401646e-9,
			0.9999999999999986
		],
		"upperarm01.L": [
			-0.18737098251375128,
			-0.393470178000108,
			-0.40082957003529596,
			0.8058591624606093
		],
		"special06.L": [
			-8.72664651652143e-9,
			2.617994021569814e-8,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"finger3-1.R": [
			8.726645628343017e-9,
			1.7453292144864463e-8,
			1.7453292144864456e-8,
			0.9999999999999994
		],
		"shoulder01.L": [
			0.001800967393006309,
			0.0013419121301981862,
			0.19604237850970516,
			0.9805928521137316
		],
		"lowerarm01.R": [
			2.6179939993653497e-8,
			8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"special03": [
			0,
			5.235987998730684e-8,
			1.1102230246251565e-16,
			0.9999999999999987
		],
		"upperarm02.L": [
			-1.7453292144864433e-8,
			2.617994021569814e-8,
			-4.927555263958927e-16,
			0.9999999999999996
		],
		"spine02": [
			1.2661307725225092e-7,
			-0.09964083535636203,
			0.09835290639219825,
			0.9901507005166831
		],
		"spine03": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"spine01": [
			-9.508634854428684e-8,
			0.009774396222866799,
			0.09898895723755693,
			0.9950405255684265
		],
		"upperarm02.R": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"spine04": [
			-0.09947008784247237,
			-8.683367025419386e-9,
			8.680401843634942e-10,
			0.9950405527538114
		],
		"spine05": [
			4.51524408044939e-8,
			0.03079151281710457,
			-0.1365555586451547,
			0.9901537568183749
		],
		"lowerarm01.L": [
			-0.6620053531367032,
			-0.4735193377988919,
			-0.06449521457637153,
			0.5773809110505774
		],
		"finger5-3.L": [
			0.0773978719121952,
			-0.07440648737889288,
			-0.2664663617779022,
			0.957845980364404
		],
		"oris01": [
			-1.7453292144864446e-8,
			-3.490658440075123e-8,
			-8.726645628343005e-9,
			0.9999999999999993
		],
		"oris02": [
			-2.6179939993653527e-8,
			8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"oris05": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"risorius03.R": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"finger2-3.L": [
			0.32964018186311045,
			-0.22253117467697314,
			-0.2043666691087311,
			0.8944559750795704
		],
		"toe3-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger3-3.R": [
			1.7453293033042916e-8,
			2.617994110387656e-8,
			-2.6179939105475286e-8,
			0.9999999999999992
		],
		"finger2-3.R": [
			9.13852305968756e-16,
			-2.6179939993653534e-8,
			3.4906584289728846e-8,
			0.9999999999999991
		],
		"toe3-3.L": [
			-2.6179940881831874e-8,
			-4.363322880784892e-8,
			-1.7453291256686013e-8,
			0.9999999999999986
		],
		"risorius03.L": [
			2.6179939993653504e-8,
			1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		]
	},
	"gym01": {
		"toe1-1.L": [
			0.2170465349113011,
			0.021738528840732463,
			-0.01648314345853315,
			0.9757799670153938
		],
		"finger5-2.R": [
			-0.036413017387469715,
			-0.044150392350860046,
			-0.12097405769023285,
			0.991004597560458
		],
		"finger1-3.R": [
			-0.3842293840720182,
			0.06518663504286792,
			0.14930647865190944,
			0.9087497226739563
		],
		"toe5-2.R": [
			0.25937301058376716,
			-0.01569185909699522,
			-0.03364251316501255,
			0.9650635151360426
		],
		"toe4-2.R": [
			0.2417484349584718,
			-0.02044870235109353,
			-0.02469443093069126,
			0.9698091203161041
		],
		"clavicle.R": [
			-0.06629181759869067,
			0.009215963475255107,
			-0.2272226305667887,
			0.971540188100829
		],
		"neck03": [
			-0.14707826699586257,
			-8.795368788838687e-8,
			-5.75024404410739e-8,
			0.9891248573246367
		],
		"neck02": [
			-0.14314962582654495,
			-8.772467330331324e-8,
			-5.785122087733774e-8,
			0.989701058211877
		],
		"neck01": [
			-0.09533999878436522,
			-5.628136157120878e-8,
			-3.844247868923187e-8,
			0.9954447672431616
		],
		"clavicle.L": [
			-0.06629185917365961,
			-0.009215952846069242,
			0.22722264947498502,
			0.9715401809426141
		],
		"toe5-2.L": [
			0.25937301915587396,
			0.015691848217163296,
			0.03364224946539145,
			0.9650635222017275
		],
		"toe4-2.L": [
			0.2417484421323891,
			0.020448630580120586,
			0.024694357334795754,
			0.969809121915123
		],
		"finger5-2.L": [
			-0.04385189800311493,
			0.1399810644212619,
			0.2539941422057351,
			0.9560174100769231
		],
		"finger1-3.L": [
			-0.38422944019965366,
			-0.06518666333438505,
			-0.14930651948542623,
			0.9087496902042597
		],
		"toe1-1.R": [
			0.2170465866664305,
			-0.02173852727472969,
			0.01648317967274273,
			0.9757799549264442
		],
		"oculi02.L": [
			2.617994177001044e-8,
			3.490658639915267e-8,
			-5.2359878210949374e-8,
			0.9999999999999979
		],
		"oculi01.L": [
			-8.726645628343007e-9,
			1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		],
		"jaw": [
			7.853981998095985e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999969
		],
		"finger4-2.R": [
			-0.05620973408100811,
			-0.04301212647684294,
			-0.0900066189867575,
			0.9934229871052187
		],
		"oculi01.R": [
			-1.7453292144864433e-8,
			2.617994021569814e-8,
			-4.927555263958927e-16,
			0.9999999999999996
		],
		"oculi02.R": [
			-6.108652428338193e-8,
			3.490658440075123e-8,
			8.726643851989352e-9,
			0.9999999999999974
		],
		"oris03.L": [
			3.490658251337199e-8,
			-5.235987821095023e-8,
			-2.6179941770010284e-8,
			0.9999999999999977
		],
		"finger1-1.L": [
			0.010288046357032758,
			0.06896106276039371,
			0.08925161606933044,
			0.9935656379696944
		],
		"tongue07.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"eye.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"finger2-1.R": [
			-2.6179939993653494e-8,
			1.745329158975295e-8,
			-1.745329303304287e-8,
			0.9999999999999994
		],
		"finger4-3.R": [
			-0.07054264375862353,
			-0.047737033554909325,
			-0.11843339034309162,
			0.9893019979211418
		],
		"finger2-1.L": [
			-6.981316857945728e-8,
			-8.726644740164602e-9,
			2.617994088183179e-8,
			0.9999999999999974
		],
		"eye.L": [
			-8.726645628343032e-9,
			8.726645295276114e-9,
			-3.490658428972877e-8,
			0.9999999999999992
		],
		"tongue07.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"wrist.L": [
			-0.11190048489211982,
			0.12950888751349343,
			0.12302881116946458,
			0.9775324246070581
		],
		"finger5-3.R": [
			-0.03018835608033691,
			-0.03415093101813349,
			-0.10269956116974598,
			0.9936675385677564
		],
		"lowerleg01.R": [
			5.2359879987306836e-8,
			5.551115123125783e-16,
			-8.726646040608206e-9,
			0.9999999999999987
		],
		"lowerarm02.L": [
			-3.490658428972881e-8,
			8.726646738566046e-9,
			2.617993999365343e-8,
			0.9999999999999992
		],
		"oris07.L": [
			-1.7453292144864443e-8,
			2.220446049250313e-16,
			2.6179940054284205e-8,
			0.9999999999999996
		],
		"oris07.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"tongue00": [
			1.221730485667622e-7,
			1.1102230246251565e-16,
			0,
			0.9999999999999927
		],
		"lowerarm02.R": [
			-2.6179941770010333e-8,
			-2.617994165898807e-8,
			-6.108652428338132e-8,
			0.9999999999999972
		],
		"lowerleg01.L": [
			0.08359184408870164,
			-0.007767692652587255,
			-0.001183174643080434,
			0.9964690996967593
		],
		"tongue03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			0.008754389782450741,
			-0.05004230790150144,
			-0.07799526005934623,
			0.9956585094738577
		],
		"metacarpal4.L": [
			-0.1523022533721337,
			0.0455881571779847,
			0.25934563626914076,
			0.9526098805340203
		],
		"finger1-2.R": [
			-3.1984830179510645e-15,
			6.108652450542706e-8,
			5.2359879987306737e-8,
			0.9999999999999968
		],
		"pelvis.R": [
			8.726646072432233e-9,
			8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"toe2-1.R": [
			0.0939124482002168,
			-0.009370729362296992,
			0.006986146717008939,
			0.9955118458653863
		],
		"toe2-3.L": [
			0.29636595853244874,
			0.026480318965789507,
			-0.009318131766153379,
			0.9546618164308247
		],
		"toe5-3.L": [
			0.02901190894624732,
			0.0027484636448438238,
			-0.0008470246939317155,
			0.9995749284751273
		],
		"levator05.L": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"finger4-1.L": [
			-0.03768286410149116,
			0.02405414281287732,
			0.06726346602727674,
			0.9967331769860195
		],
		"finger4-1.R": [
			-0.03768294578400056,
			-0.024054219738627536,
			-0.06726348605584388,
			0.9967331706898398
		],
		"levator05.R": [
			4.3633228585804086e-8,
			-1.7453292144864463e-8,
			-8.726646960611766e-9,
			0.9999999999999989
		],
		"toe5-3.R": [
			0.029011951699968258,
			-0.002748444774610004,
			0.0008469727232042092,
			0.9995749273301557
		],
		"toe2-3.R": [
			0.2963660724148011,
			-0.026480422841166806,
			0.009318024001720934,
			0.9546617792476462
		],
		"finger4-2.L": [
			-0.05620973792997263,
			0.043012124446033195,
			0.09000657137386377,
			0.9934229912892112
		],
		"toe2-1.L": [
			0.09391245550386362,
			0.009370726549843944,
			-0.006986120719583229,
			0.9955118453853044
		],
		"finger1-2.L": [
			-3.4906584289728754e-8,
			4.363322880784892e-8,
			-8.726647404700152e-9,
			0.9999999999999986
		],
		"pelvis.L": [
			-4.363322858580417e-8,
			8.726646516521441e-9,
			-4.068768463957589e-16,
			0.999999999999999
		],
		"metacarpal4.R": [
			-0.15230219724017713,
			-0.04558812667595313,
			-0.25934571716607585,
			0.9526098689440525
		],
		"tongue04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			0.29552474883738666,
			0.027584828334026867,
			-0.004742467422866823,
			0.9549249756253758
		],
		"levator03.R": [
			8.726646072432225e-9,
			6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"upperleg02.R": [
			0.0009161701964136525,
			0.0017214372580739434,
			0.0770737869282492,
			0.9970234845049931
		],
		"upperleg02.L": [
			0.039704439502899036,
			0.0036625158906116173,
			-0.07612923283839072,
			0.9963003981573779
		],
		"levator03.L": [
			1.7453292144864387e-8,
			-1.5543122344752192e-15,
			8.726645715545856e-8,
			0.9999999999999961
		],
		"toe3-2.R": [
			0.29552484353467656,
			-0.027584823422101667,
			0.004742449046157227,
			0.9549249465521473
		],
		"metacarpal3.L": [
			-0.19941700893566633,
			0.10939153902379695,
			0.20199315513117014,
			0.9526096330697648
		],
		"tongue01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"breast.L": [
			2.7755575615628914e-17,
			-8.726645961409929e-9,
			8.726646072432226e-9,
			1
		],
		"temporalis02.R": [
			4.363322858580413e-8,
			-2.617993943854202e-8,
			-2.6179940881831894e-8,
			0.9999999999999987
		],
		"tongue02": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris04.R": [
			4.363322858580417e-8,
			-1.7453292255886765e-8,
			8.726645184253984e-9,
			0.9999999999999989
		],
		"oris04.L": [
			8.726645717160763e-8,
			8.72664507323151e-9,
			8.726646960610795e-9,
			0.9999999999999961
		],
		"temporalis02.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"breast.R": [
			-8.726645628343061e-9,
			8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"oris03.R": [
			-1.2184696001195143e-15,
			3.4906584178706623e-8,
			3.4906584289728846e-8,
			0.9999999999999988
		],
		"oris06.L": [
			2.6179939993653484e-8,
			-2.6179940104675836e-8,
			-8.045503725131716e-16,
			0.9999999999999991
		],
		"orbicularis04.R": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"toe1-2.R": [
			0.19817373833436291,
			-0.017749929789853902,
			0.029442491089341133,
			0.9795638055509671
		],
		"toe1-2.L": [
			0.19817377087326066,
			0.01774994924581408,
			-0.029442493794511818,
			0.9795637985342269
		],
		"orbicularis04.L": [
			8.726645717160768e-8,
			-8.726646960610651e-9,
			8.72664518425463e-9,
			0.9999999999999961
		],
		"metacarpal3.R": [
			-0.20972596038118205,
			-0.07365488146755439,
			-0.10223458032150469,
			0.9696071733257114
		],
		"oris06.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"levator04.L": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"tongue06.L": [
			0,
			0,
			0,
			1
		],
		"toe2-2.L": [
			0.28618676470018445,
			0.02584317364953559,
			-0.015154944258178614,
			0.957705379409917
		],
		"toe2-2.R": [
			0.2861867965149878,
			-0.025843140388580266,
			0.015154979953888651,
			0.9577053702355134
		],
		"tongue06.R": [
			-3.0461740002987937e-16,
			-8.726646183454534e-9,
			-3.490658428972886e-8,
			0.9999999999999994
		],
		"levator04.R": [
			1.3707785118926925e-15,
			5.235988009832937e-8,
			-2.617993999365348e-8,
			0.9999999999999982
		],
		"toe4-1.L": [
			0.1659921035561435,
			0.016932592612242336,
			-0.023570047175281477,
			0.9856999349399337
		],
		"upperleg01.R": [
			2.6179939993653494e-8,
			-8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"metacarpal1.R": [
			-0.2368207626832259,
			-0.15303932008283938,
			-0.11415044157222232,
			0.9526093478229072
		],
		"levator02.R": [
			-1.7453289480329204e-8,
			4.3633226698425176e-8,
			-5.23598799873068e-8,
			0.9999999999999973
		],
		"toe3-1.L": [
			0.10913678422998693,
			0.011135133504154071,
			-0.008045831411231047,
			0.9939318063764153
		],
		"toe3-1.R": [
			0.10913684205332524,
			-0.011135143253732771,
			0.008045839093656297,
			0.9939317998558178
		],
		"levator02.L": [
			2.617994088183188e-8,
			5.2359880320373975e-8,
			-8.7266447401646e-9,
			0.9999999999999986
		],
		"finger5-1.R": [
			0.17544631271936778,
			-0.06233827057018548,
			0.23990779261450307,
			0.9527732061820028
		],
		"metacarpal1.L": [
			-0.23682073084169775,
			0.1530392235131498,
			0.11415051241119242,
			0.9526093627643802
		],
		"toe4-1.R": [
			0.16599212968097968,
			-0.016932489088841374,
			0.023570003052892488,
			0.9856999333739026
		],
		"upperleg01.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"head": [
			0,
			0,
			0,
			1
		],
		"toe5-1.R": [
			0.06724599408858715,
			-0.006415049968211739,
			0.0022475758339133216,
			0.9977132713439336
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			3.4906584289728793e-8,
			-1.7453292366909068e-8,
			-8.7266465165216e-9,
			0.9999999999999996
		],
		"special04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal2.L": [
			-0.19699856898658946,
			0.10704668419120256,
			0.20559069274626238,
			0.9526095938405285
		],
		"metacarpal2.R": [
			-0.20555484253416717,
			-0.07922115955791731,
			-0.1282983191487618,
			0.9669595420143776
		],
		"temporalis01.R": [
			8.72664651652144e-9,
			1.7453291811797556e-8,
			-1.7453292144864453e-8,
			0.9999999999999993
		],
		"toe5-1.L": [
			0.06724592776144855,
			0.006415066557032834,
			-0.002247706576722639,
			0.9977132754131901
		],
		"risorius02.R": [
			1.745329303304288e-8,
			-1.7453293144065185e-8,
			3.490658428972881e-8,
			0.9999999999999989
		],
		"special05.L": [
			-2.220446049250313e-16,
			1.745329203384216e-8,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"finger2-2.L": [
			-0.11563156262256569,
			0.07534744125747284,
			0.07091376203384735,
			0.9878883252552499
		],
		"foot.L": [
			0.338973984163705,
			0.030899090889597525,
			0.0021636391878292046,
			0.9402857028094415
		],
		"toe3-3.R": [
			0.020976196885372035,
			-0.0019099903788041273,
			-0.0005392346986176985,
			0.9997780055226856
		],
		"levator06.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"orbicularis03.R": [
			-8.726646072432225e-9,
			-6.661338147750939e-16,
			-2.6179940047656725e-8,
			1
		],
		"levator06.L": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"orbicularis03.L": [
			2.6179939993653497e-8,
			-5.551115123125783e-16,
			1.745329205570242e-8,
			0.9999999999999993
		],
		"foot.R": [
			0.33897393453952707,
			-0.030899033256252983,
			-0.002163561165309192,
			0.9402857227724484
		],
		"root": [
			-0.9854478063348815,
			-0.00710724454702677,
			0.0012245541317995527,
			0.16982522937389788
		],
		"finger2-2.R": [
			-0.115631573349174,
			-0.07534747314021306,
			-0.07091373605155804,
			0.9878883234330641
		],
		"risorius02.L": [
			-7.853981998095985e-8,
			-8.726643851986182e-9,
			2.6179940881831987e-8,
			0.9999999999999967
		],
		"special05.R": [
			8.726644740164589e-9,
			-4.363322858580432e-8,
			-2.617993999365346e-8,
			0.9999999999999987
		],
		"lowerleg02.L": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"tongue05.L": [
			2.6179939993653497e-8,
			8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"finger5-1.L": [
			0.17544646148547927,
			0.06233829148539893,
			-0.2399077864317216,
			0.9527731789761597
		],
		"toe4-3.R": [
			0.006990908633910443,
			-0.0006739140675149358,
			0.0005942130889444651,
			0.9999751596650325
		],
		"wrist.R": [
			-0.11190042936285581,
			-0.12950886234964132,
			-0.1230288811648734,
			0.9775324254880907
		],
		"toe4-3.L": [
			0.006990899787551661,
			0.0006739051323629841,
			-0.0005941869821318044,
			0.9999751597484127
		],
		"finger3-3.L": [
			-0.03869890995826436,
			0.030060952899641058,
			0.04508563515484194,
			0.9977805465038355
		],
		"tongue05.R": [
			1.7453292144864436e-8,
			8.726646072432231e-9,
			1.7453292144864443e-8,
			0.9999999999999999
		],
		"lowerleg02.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"shoulder01.R": [
			-0.06764257214651435,
			0.26896741094103893,
			0.09951270954724302,
			0.9556035971696862
		],
		"finger3-1.L": [
			-0.06583849807267539,
			0.04696931630818901,
			0.08307354830256812,
			0.9932562413946849
		],
		"special06.R": [
			1.7453292144864443e-8,
			-2.6179940104675836e-8,
			8.726645628343028e-9,
			0.9999999999999997
		],
		"finger4-3.L": [
			-0.07054271666507393,
			0.04773705037668374,
			0.11843336816620335,
			0.9893019945656901
		],
		"finger3-2.L": [
			-0.06607012184291335,
			0.05275291965696749,
			0.07580994335887382,
			0.9935314393391145
		],
		"upperarm01.R": [
			-0.2520741220576424,
			0.27995653857545244,
			-0.3841614958602232,
			0.8429133517723845
		],
		"finger3-2.R": [
			-0.0660701189911843,
			-0.05275291506994395,
			-0.075809739710266,
			0.9935314553113938
		],
		"upperarm01.L": [
			-0.25207405613189604,
			-0.2799566921675054,
			0.38416158097264413,
			0.8429132816846823
		],
		"special06.L": [
			2.6179939993653477e-8,
			2.6179940548765046e-8,
			8.726646960610674e-9,
			0.9999999999999996
		],
		"finger3-1.R": [
			-0.06583858302025376,
			-0.04696934404670139,
			-0.08307353674124052,
			0.9932562354191434
		],
		"shoulder01.L": [
			-0.06764257319163404,
			-0.2689674622153776,
			-0.09951273659192092,
			0.9556035798475333
		],
		"lowerarm01.R": [
			0.13947719061690794,
			-0.2455044180494591,
			-0.04095563425584442,
			0.9584343118015507
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"upperarm02.L": [
			-0.2747345840883527,
			0.3095695297295157,
			-0.0058543285435734265,
			0.9103039829673103
		],
		"spine02": [
			-0.20159920676674403,
			-1.2192180121051166e-7,
			-7.291076566175165e-8,
			0.979468100466268
		],
		"spine03": [
			-0.12308705454195779,
			-7.572712312775565e-8,
			-4.336863115524661e-8,
			0.9923958771600059
		],
		"spine01": [
			-0.17687528620339463,
			-1.099148883021428e-7,
			-6.891174226499068e-8,
			0.9842332717046554
		],
		"upperarm02.R": [
			-0.27473458404471846,
			-0.309569529680349,
			0.005854342107230066,
			0.9103039829099696
		],
		"spine04": [
			-0.20921624777421932,
			-1.24311326010762e-7,
			-8.049317537858846e-8,
			0.9778693990852023
		],
		"spine05": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			0.158113777019088,
			0.21426787984809847,
			-0.02659115767320993,
			0.9635259308995047
		],
		"finger5-3.L": [
			-0.030188339258491556,
			0.034150932041455695,
			0.10269959334905766,
			0.9936675357177832
		],
		"oris01": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"oris02": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris05": [
			0,
			0,
			0,
			1
		],
		"risorius03.R": [
			-5.2359879987306756e-8,
			-2.617994121489886e-8,
			-1.7453290368507855e-8,
			0.9999999999999986
		],
		"finger2-3.L": [
			-0.11230757264923692,
			0.07761258144769645,
			0.06525394534957957,
			0.9884863271401254
		],
		"oris06": [
			0,
			0,
			0,
			1
		],
		"finger3-3.R": [
			-0.03869893397732361,
			-0.030061024450121376,
			-0.04508563997609482,
			0.9977805431987411
		],
		"finger2-3.R": [
			-0.11230751614354388,
			-0.07761251127234003,
			-0.06525387868865808,
			0.9884863434705382
		],
		"toe3-3.L": [
			0.020976187583504082,
			0.0019099738445195191,
			0.000539190655032082,
			0.9997780057731877
		],
		"risorius03.L": [
			-9.599310857311005e-8,
			-1.7453293921221302e-8,
			-1.745329036845209e-8,
			0.999999999999995
		]
	},
	"akimbo01": {
		"toe1-1.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger5-2.R": [
			-0.007098474613368085,
			-0.0010136393303131763,
			0.054511212156468515,
			0.9984874120101385
		],
		"finger1-3.R": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe5-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe4-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"clavicle.R": [
			0.03219157686353345,
			-0.1197167758579123,
			-0.0607462239230738,
			0.9904249048950223
		],
		"neck03": [
			0,
			0,
			0,
			1
		],
		"neck02": [
			0,
			0,
			0,
			1
		],
		"neck01": [
			0,
			0,
			0,
			1
		],
		"clavicle.L": [
			0.032190351362835185,
			0.11971883544506623,
			0.06074276773277671,
			0.9904249077476677
		],
		"toe5-2.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe4-2.L": [
			0,
			0,
			0,
			1
		],
		"finger5-2.L": [
			-0.007098603540197664,
			0.0010136758537272472,
			-0.05451121950006681,
			0.9984874106555663
		],
		"finger1-3.L": [
			-2.2846307649218933e-16,
			-2.6179939993653534e-8,
			-8.726646072432225e-9,
			0.9999999999999996
		],
		"toe1-1.R": [
			0,
			0,
			0,
			1
		],
		"oculi02.L": [
			8.726646072432225e-9,
			2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"oculi01.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"jaw": [
			0,
			0,
			0,
			1
		],
		"finger4-2.R": [
			0.02481472767529215,
			0.005219395915233349,
			0.0607791192938899,
			0.9978290864945463
		],
		"oculi01.R": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"oculi02.R": [
			8.726646072432225e-9,
			-2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"wrist.R": [
			-0.1509185851416901,
			-0.16693060216050726,
			-0.05112418534528539,
			0.9730077452898008
		],
		"finger1-1.L": [
			0.01822103719758957,
			-0.1427045335884809,
			-0.03977512730296772,
			0.9887979314019477
		],
		"tongue07.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"eye.R": [
			0,
			0,
			0,
			1
		],
		"finger2-1.R": [
			0.017758402199636734,
			-0.009658275784549808,
			-0.05559794961139315,
			0.9982485786912972
		],
		"finger4-3.R": [
			0.027844123080724967,
			0.0031707238941178773,
			0.05959678745635931,
			0.997829080677014
		],
		"finger2-1.L": [
			0.017758403123153674,
			0.009658259473892206,
			0.055597942218322156,
			0.998248579244438
		],
		"eye.L": [
			0,
			0,
			0,
			1
		],
		"tongue07.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"wrist.L": [
			-0.15091856220020278,
			0.1669306513897172,
			0.051124233132320535,
			0.9730077378914623
		],
		"finger5-3.R": [
			-0.0037395560732337747,
			-0.005430009374760791,
			0.05458433071404346,
			0.9984873967953045
		],
		"lowerleg01.R": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.L": [
			0.02340591714666124,
			-0.024785591333830514,
			0.028984006153491,
			0.9989983808255398
		],
		"oris07.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"oris07.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"tongue00": [
			0,
			0,
			0,
			1
		],
		"lowerarm02.R": [
			0.023405969291810887,
			0.02478559317802609,
			-0.028984004265933748,
			0.9989983796128183
		],
		"lowerleg01.L": [
			0,
			0,
			0,
			1
		],
		"tongue03": [
			0,
			0,
			0,
			1
		],
		"finger1-1.R": [
			0.018221096456704812,
			0.1427045053307351,
			0.03977508229666455,
			0.9887979361985535
		],
		"metacarpal4.L": [
			-0.043779761193587584,
			0.03223983759986759,
			0.05121152319092049,
			0.9972067515183765
		],
		"finger1-2.R": [
			0.025916868038319316,
			0.1450343469725851,
			0.06245023882366982,
			0.9871136316656692
		],
		"pelvis.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"toe2-1.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"toe2-3.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-3.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"levator05.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"finger4-1.L": [
			-0.03398880180062499,
			0.02808274487258433,
			0.01454705025731596,
			0.9989216706636166
		],
		"finger4-1.R": [
			-0.03398880633971303,
			-0.028082580166663096,
			-0.014547404759401162,
			0.9989216699769559
		],
		"levator05.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			8.72664607243223e-9,
			0.9999999999999996
		],
		"toe5-3.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-3.R": [
			0,
			0,
			0,
			1
		],
		"finger4-2.L": [
			0.024814727731108387,
			-0.005219405540986433,
			-0.06077908056274595,
			0.9978290888019736
		],
		"toe2-1.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-2.L": [
			0.02591687332480505,
			-0.14503437522320095,
			-0.06245023854094705,
			0.9871136273939595
		],
		"pelvis.L": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"metacarpal4.R": [
			-0.04377976492625843,
			-0.03223977790938648,
			-0.05121152694699835,
			0.9972067530914099
		],
		"tongue04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"levator03.R": [
			-8.726646072432228e-9,
			-8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"upperleg02.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"upperleg02.L": [
			0,
			0,
			0,
			1
		],
		"levator03.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"toe3-2.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"metacarpal3.L": [
			-0.043779871130968984,
			0.032239419034935546,
			0.051212890137869865,
			0.9972066900235738
		],
		"tongue01": [
			0,
			0,
			0,
			1
		],
		"breast.L": [
			-8.726646072432225e-9,
			-8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"temporalis02.R": [
			0,
			2.6179939993653504e-8,
			1.1102230246251565e-16,
			0.9999999999999998
		],
		"tongue02": [
			0,
			0,
			0,
			1
		],
		"oris04.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oris04.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"temporalis02.L": [
			0,
			-2.6179939993653504e-8,
			-1.1102230246251565e-16,
			0.9999999999999998
		],
		"breast.R": [
			0,
			0,
			0,
			1
		],
		"oris03.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"oris06.L": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"orbicularis04.R": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe1-2.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"toe1-2.L": [
			8.726646072432231e-9,
			-8.726646294476836e-9,
			-8.72664607243223e-9,
			0.9999999999999999
		],
		"orbicularis04.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal3.R": [
			-0.04377975104384826,
			-0.03223934199930589,
			-0.05121286083974925,
			0.9972066992908735
		],
		"oris06.R": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"levator04.L": [
			-8.726646072432231e-9,
			8.726646294476836e-9,
			8.72664607243223e-9,
			0.9999999999999999
		],
		"tongue06.L": [
			0,
			0,
			0,
			1
		],
		"toe2-2.L": [
			0,
			-8.726646072432231e-9,
			2.220446049250313e-16,
			0.9999999999999999
		],
		"toe2-2.R": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"tongue06.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"levator04.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"toe4-1.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperleg01.R": [
			0,
			0,
			0,
			1
		],
		"metacarpal1.R": [
			-0.02829244625494918,
			-0.05618945725549107,
			-0.05433625820277425,
			0.9965389372336463
		],
		"levator02.R": [
			-8.726646516521445e-9,
			8.726646405499139e-9,
			3.490658428972881e-8,
			0.9999999999999996
		],
		"toe3-1.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-1.R": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"levator02.L": [
			-8.726646516521441e-9,
			-8.726646516521441e-9,
			-3.490658428972886e-8,
			0.9999999999999994
		],
		"finger5-1.R": [
			-0.06583863875280681,
			-0.030003421611988768,
			-0.023241654114399726,
			0.9971082658632294
		],
		"metacarpal1.L": [
			-0.028292496341818494,
			0.05618949207225998,
			0.05433634485106178,
			0.9965389291240134
		],
		"toe4-1.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"upperleg01.L": [
			0,
			0,
			0,
			1
		],
		"head": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-1.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"special01": [
			0,
			0,
			0,
			1
		],
		"temporalis01.L": [
			1.745329214486445e-8,
			1.7453292366909068e-8,
			-8.726645628343025e-9,
			0.9999999999999999
		],
		"special04": [
			0,
			0,
			0,
			1
		],
		"metacarpal2.L": [
			-0.04377993134153404,
			0.032239430745807596,
			0.051213091303717616,
			0.9972066766704052
		],
		"metacarpal2.R": [
			-0.04377988303973841,
			-0.03223941969821076,
			-0.051213085852012515,
			0.9972066794281235
		],
		"temporalis01.R": [
			1.745329214486445e-8,
			-1.7453292366909068e-8,
			8.726645628343025e-9,
			0.9999999999999999
		],
		"toe5-1.L": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"risorius02.R": [
			-8.726646072432225e-9,
			2.6179939993653534e-8,
			-1.8621685332420096e-16,
			0.9999999999999998
		],
		"special05.L": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"finger2-2.L": [
			0.13766523377172918,
			-0.07053618014353225,
			-0.058024554227729105,
			0.9862586282552908
		],
		"foot.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris06": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.R": [
			-8.726645628343012e-9,
			4.3633228474782015e-8,
			-8.726646516521458e-9,
			0.9999999999999989
		],
		"orbicularis03.R": [
			0,
			0,
			0,
			1
		],
		"levator06.L": [
			1.523087000149398e-16,
			1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"orbicularis03.L": [
			0,
			0,
			0,
			1
		],
		"foot.R": [
			0,
			0,
			0,
			1
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			0.13766531209547725,
			0.07053621673788824,
			0.058024636204348355,
			0.9862586098824759
		],
		"risorius02.L": [
			-8.726646072432225e-9,
			-2.6179939993653534e-8,
			1.8621685332420096e-16,
			0.9999999999999998
		],
		"special05.R": [
			0,
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0.9999999999999997
		],
		"lowerleg02.L": [
			0,
			0,
			0,
			1
		],
		"tongue05.L": [
			-8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger5-1.L": [
			-0.06583861459053672,
			0.03000342160304359,
			0.02324168224982545,
			0.9971082668031124
		],
		"toe4-3.R": [
			0,
			0,
			0,
			1
		],
		"oris03.L": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"toe4-3.L": [
			0,
			0,
			0,
			1
		],
		"finger3-3.L": [
			0.10254494630939268,
			-0.06344261392363904,
			-0.10790083186425589,
			0.986821655218379
		],
		"tongue05.R": [
			0,
			0,
			0,
			1
		],
		"lowerleg02.R": [
			0,
			0,
			0,
			1
		],
		"shoulder01.R": [
			0.10953851298984887,
			0.048173141661036256,
			-0.10332112807419244,
			0.9874236208881955
		],
		"finger3-1.L": [
			0.020226993494089636,
			-0.001216805997500403,
			-0.015006702320330382,
			0.99968204295307
		],
		"special06.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"finger4-3.L": [
			0.02784411934944653,
			-0.003170775917341384,
			-0.059596789301417354,
			0.9978290805056237
		],
		"finger3-2.L": [
			0.015150336038310877,
			-0.006706749459545525,
			-0.011051717936191816,
			0.999801653509471
		],
		"upperarm01.R": [
			0.12486469071124591,
			0.2913526574774825,
			0.0007952377823609824,
			0.9484312339812853
		],
		"finger3-2.R": [
			0.015150353721602002,
			0.00670673129978705,
			0.011051769612591075,
			0.9998016527920992
		],
		"upperarm01.L": [
			0.12486350611163635,
			-0.2913513489999404,
			-0.0013106520315405911,
			0.9484312196826276
		],
		"special06.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"finger3-1.R": [
			0.020226897995923927,
			0.0012168083219550319,
			0.015006657680035234,
			0.9996820455526069
		],
		"shoulder01.L": [
			0.10953948831165414,
			-0.04817152071345909,
			0.10332092417452021,
			0.987423613106501
		],
		"lowerarm01.R": [
			-0.3429991561814005,
			0.3087408101403061,
			-0.01308750977678555,
			0.8870509613886887
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"upperarm02.L": [
			0.2011695188342199,
			-0.22337872244575152,
			0.0050914279433678,
			0.9537331117309548
		],
		"spine02": [
			0,
			0,
			0,
			1
		],
		"spine03": [
			0,
			0,
			0,
			1
		],
		"spine01": [
			0,
			0,
			0,
			1
		],
		"upperarm02.R": [
			0.2011731192905893,
			0.22337949534756163,
			-0.0049097819856569885,
			0.9537331236640657
		],
		"spine04": [
			0,
			0,
			0,
			1
		],
		"spine05": [
			0,
			0,
			0,
			1
		],
		"lowerarm01.L": [
			-0.3430047074664263,
			-0.3087342733849695,
			0.01309741630585518,
			0.8870509437340319
		],
		"finger5-3.L": [
			-0.003739665902322626,
			0.005429907716012039,
			-0.05458435475670761,
			0.9984873956224626
		],
		"oris01": [
			0,
			0,
			0,
			1
		],
		"oris02": [
			0,
			0,
			0,
			1
		],
		"oris05": [
			0,
			0,
			0,
			1
		],
		"risorius03.R": [
			-3.490658428972884e-8,
			8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"finger2-3.L": [
			0.020711574256038326,
			-0.004972867526232272,
			0.011511036476900355,
			0.9997068556930225
		],
		"toe3-3.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger3-3.R": [
			0.10254488764056392,
			0.06344260432023807,
			0.1079008909227922,
			0.9868216554747455
		],
		"finger2-3.R": [
			0.02071152125712039,
			0.004972820728396221,
			-0.011510915901293344,
			0.999706858412171
		],
		"toe3-3.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"risorius03.L": [
			-3.490658428972884e-8,
			-8.726646405499139e-9,
			-8.726645628342989e-9,
			0.9999999999999991
		]
	},
	"genuflect01": {
		"toe1-1.L": [
			-0.2949977688559316,
			-0.031722294328357825,
			0.017979378505399827,
			0.9548019450970591
		],
		"finger5-2.R": [
			0.0399399693665061,
			0.05435726131343277,
			0.07228642605431443,
			0.9951003766443863
		],
		"finger1-3.R": [
			0.08713282224647013,
			0.04826671906402802,
			0.05844624601326871,
			0.993308729169897
		],
		"toe5-2.R": [
			4.363322858580418e-8,
			-1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"toe4-2.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"clavicle.R": [
			-0.21593393589444254,
			0.08137512089295185,
			-0.12744587553852652,
			0.9646285159775293
		],
		"neck03": [
			0.022997922702844745,
			-0.020349958316658645,
			0.03673340795135076,
			0.9988531581209238
		],
		"neck02": [
			0.055998224720152166,
			-0.018849405485422577,
			0.053869047165628445,
			0.996798387086629
		],
		"neck01": [
			0.10989136525768578,
			-0.006767361460783938,
			0.013665849708711679,
			0.9938266122480317
		],
		"clavicle.L": [
			-0.2644888108945501,
			-0.005185285111361404,
			-0.1133325436730879,
			0.9576922868408667
		],
		"toe5-2.L": [
			-0.03706742997908238,
			-0.003134322239311982,
			0.0005620219438020584,
			0.9993076932507726
		],
		"toe4-2.L": [
			-0.1143179152315243,
			-0.009666375275776629,
			0.0017332774009194084,
			0.9933956770570314
		],
		"finger5-2.L": [
			0.2214415490870635,
			-0.11425040210485726,
			-0.4338720914418728,
			0.8658322552461623
		],
		"finger1-3.L": [
			0.07851023674909893,
			0.0028523437600173063,
			0.07941862198862623,
			0.9937407556008272
		],
		"toe1-1.R": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"oculi02.L": [
			2.6179940881831907e-8,
			3.490658451177353e-8,
			-1.7453291256686053e-8,
			0.9999999999999991
		],
		"oculi01.L": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"jaw": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"finger4-2.R": [
			0.05224145312963716,
			0.060478647897654225,
			0.07575171131594406,
			0.9939189312796497
		],
		"oculi01.R": [
			-2.220446049250313e-16,
			1.745329203384216e-8,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"oculi02.R": [
			2.617993999365348e-8,
			1.1102230246251565e-15,
			-4.363322861862043e-8,
			0.9999999999999989
		],
		"wrist.R": [
			0.139963665049904,
			0.14799483432374694,
			-0.09592968543915524,
			0.9743229428330372
		],
		"finger1-1.L": [
			0.008872094914223888,
			0.07378977034525092,
			0.14534955841549266,
			0.9865849489996537
		],
		"tongue07.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"eye.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"finger2-1.R": [
			0.08713291599528095,
			0.048266806095131454,
			0.05844625982161047,
			0.9933087159047783
		],
		"finger4-3.R": [
			0.03250062752271576,
			0.06018060163300576,
			0.08821777434057708,
			0.9937502848744821
		],
		"finger2-1.L": [
			0.33167447060279076,
			-0.20977850546664767,
			-0.30195890569328465,
			0.868795628135324
		],
		"eye.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"tongue07.L": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			1.745329214262813e-8,
			0.9999999999999999
		],
		"wrist.L": [
			0.12278386496515674,
			0.016024517204742295,
			0.12009109036504105,
			0.9850103894718617
		],
		"finger5-3.R": [
			0.028845493188267877,
			0.05682287998274094,
			0.07522279699580628,
			0.9951284483147494
		],
		"lowerleg01.R": [
			0.7531814459017919,
			-0.06987972201803794,
			-0.0033640027147365907,
			0.6540819654184813
		],
		"lowerarm02.L": [
			0.08147982765102622,
			-0.08299277058578514,
			0.1090140247106258,
			0.9872128342626251
		],
		"oris07.L": [
			3.4906584289728906e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999994
		],
		"oris07.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"tongue00": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"lowerarm02.R": [
			0.19829706261431024,
			0.09538076447608768,
			-0.09618576973215937,
			0.9707363609278913
		],
		"lowerleg01.L": [
			0.8430609385852952,
			0.09049317129464018,
			0.0045681847954097046,
			0.5301305230491782
		],
		"tongue03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			0.1966013529081958,
			0.02473674101722756,
			0.044029456695271446,
			0.9791820099560824
		],
		"metacarpal4.L": [
			-0.056480724867443446,
			-0.04741142142986521,
			-0.0007205936351160056,
			0.997277075632074
		],
		"finger1-2.R": [
			0.07528454636237979,
			0.0001857600929529024,
			0.03841030382007979,
			0.9964220246123869
		],
		"pelvis.R": [
			0.006429656127765942,
			0.06690473972940669,
			-0.017343819302770846,
			0.9975878945014379
		],
		"toe2-1.R": [
			0,
			0,
			0,
			1
		],
		"toe2-3.L": [
			-0.11599787563160187,
			-0.012473664270424067,
			0.00706977955303972,
			0.9931459705228105
		],
		"toe5-3.L": [
			-0.08292849082771798,
			-0.007012172346577361,
			0.0012573521364200382,
			0.996530036633931
		],
		"levator05.L": [
			-1.7453292144864436e-8,
			-8.881784197001252e-16,
			-4.3633228475580265e-8,
			0.9999999999999988
		],
		"finger4-1.L": [
			0.24642961597444754,
			-0.1768384039114661,
			-0.3979126019505176,
			0.8658326538550631
		],
		"finger4-1.R": [
			0.021968881547337532,
			0.07960629778244499,
			0.0872937270952545,
			0.9927537513435805
		],
		"levator05.R": [
			-6.853892559463472e-16,
			2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"toe5-3.R": [
			6.108652428338212e-8,
			-8.726646405499139e-9,
			-4.661919405738096e-16,
			0.9999999999999984
		],
		"toe2-3.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"finger4-2.L": [
			0.246429606417286,
			-0.17683874377244335,
			-0.3979126606322946,
			0.8658325601930975
		],
		"toe2-1.L": [
			-0.2949978083746944,
			-0.03172230633684703,
			0.017979365092588667,
			0.9548019327408516
		],
		"finger1-2.L": [
			0.10338995829869413,
			0.007212790616139886,
			0.0910710137813222,
			0.9904365515384432
		],
		"pelvis.L": [
			-0.0002018965060217111,
			0.06428704052671552,
			-0.044359046317720044,
			0.9969450389404122
		],
		"metacarpal4.R": [
			0.008668748456203322,
			0.10604056324341304,
			0.06821134289280463,
			0.9919815847322888
		],
		"tongue04": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"toe3-2.L": [
			-0.11599786123406355,
			-0.012473665728764183,
			0.007069770860199065,
			0.9931459722479841
		],
		"levator03.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"upperleg02.R": [
			-0.23069242149161254,
			0.0003762553670310087,
			0.0023144108610382574,
			0.973023899295696
		],
		"upperleg02.L": [
			-0.22841121051413252,
			-0.06904701824021575,
			-0.03958842265256627,
			0.9703059233950316
		],
		"levator03.L": [
			8.726645184253878e-9,
			2.617993988263123e-8,
			2.6179939993653474e-8,
			0.9999999999999991
		],
		"toe3-2.R": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"metacarpal3.L": [
			-0.027468481570919967,
			-0.032414245670215114,
			-0.0026100258485523197,
			0.9990935826852705
		],
		"tongue01": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"breast.L": [
			-2.6179939993653477e-8,
			-8.726645517320719e-9,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"temporalis02.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"tongue02": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris04.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"oris04.L": [
			8.726646516521448e-9,
			8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"temporalis02.L": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"breast.R": [
			-5.235987998730666e-8,
			2.617993932751972e-8,
			-8.726647404699014e-9,
			0.9999999999999984
		],
		"oris03.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"oris06.L": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"orbicularis04.R": [
			3.4906584289728866e-8,
			8.726645961409929e-9,
			1.7169609607764797e-16,
			0.9999999999999993
		],
		"toe1-2.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"toe1-2.L": [
			-0.1159979152508569,
			-0.012473664723742561,
			0.007069771386237191,
			0.9931459659477859
		],
		"orbicularis04.L": [
			3.4906584289728866e-8,
			-8.726645961409929e-9,
			-1.7169609607764797e-16,
			0.9999999999999993
		],
		"metacarpal3.R": [
			0.03102973360922849,
			0.10643541005682955,
			0.0712034326294693,
			0.9912813577889756
		],
		"oris06.R": [
			2.6179939993653477e-8,
			8.726645517320719e-9,
			1.745329214486445e-8,
			0.9999999999999993
		],
		"levator04.L": [
			-8.726646516521441e-9,
			2.6179940104675836e-8,
			8.726645628343022e-9,
			0.9999999999999998
		],
		"tongue06.L": [
			0,
			0,
			0,
			1
		],
		"toe2-2.L": [
			-0.11599786845795539,
			-0.01247364697012543,
			0.007069777664528096,
			0.9931459715914119
		],
		"toe2-2.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue06.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"levator04.R": [
			2.2846307649218933e-16,
			-2.6179939993653534e-8,
			8.726646072432225e-9,
			0.9999999999999996
		],
		"toe4-1.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"upperleg01.R": [
			-0.5847606056096734,
			1.6134323321814747e-8,
			-2.2388104461535003e-8,
			0.8112059135182678
		],
		"metacarpal1.R": [
			0.08713288331280969,
			0.04826671863996668,
			0.05844628820174115,
			0.9933087213514065
		],
		"levator02.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe3-1.L": [
			-0.22198913644337162,
			-0.026555643242823668,
			0.016323072707099356,
			0.9745507572263666
		],
		"toe3-1.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"levator02.L": [
			1.1423153030516055e-15,
			-4.363322858580432e-8,
			2.617993999365348e-8,
			0.9999999999999988
		],
		"finger5-1.R": [
			-0.040976626457202354,
			0.08577148507000198,
			0.08969942480721017,
			0.9914223023627867
		],
		"metacarpal1.L": [
			0.028193612697570612,
			0.03657870617838477,
			0.006301557925001615,
			0.9989131137516878
		],
		"toe4-1.R": [
			8.726646072432228e-9,
			0,
			-1.7453292144864456e-8,
			0.9999999999999998
		],
		"upperleg01.L": [
			0.1384097101926524,
			-0.002372443655489942,
			0.030836410883378605,
			0.9898920342134889
		],
		"head": [
			0.08866220588771434,
			-0.00658972448971662,
			-0.00027663246548664165,
			0.9960399149897325
		],
		"toe5-1.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"special01": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			1.1102230246251565e-16,
			8.726646072432231e-9,
			-8.726646072432235e-9,
			0.9999999999999999
		],
		"special04": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"metacarpal2.L": [
			-0.006897281444472792,
			-0.007613895870518639,
			-0.0008476567713886871,
			0.9999468673766353
		],
		"metacarpal2.R": [
			0.057229307571865014,
			0.07735267419550218,
			0.06595093086966185,
			0.9931726158463462
		],
		"temporalis01.R": [
			8.726646072432225e-9,
			-3.3306690738754696e-16,
			3.490658409227928e-8,
			0.9999999999999994
		],
		"toe5-1.L": [
			-3.490658428972886e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"risorius02.R": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"special05.L": [
			0,
			0,
			0,
			1
		],
		"finger2-2.L": [
			0.30670829338617217,
			-0.25776104171266856,
			-0.29970535053832503,
			0.8658325305750771
		],
		"foot.L": [
			-0.012740426681226677,
			-0.0011961310421582105,
			-0.000020157709029206184,
			0.9999181218440721
		],
		"oris06": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"levator06.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"orbicularis03.R": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"levator06.L": [
			-8.72664651652145e-9,
			8.726646627543744e-9,
			2.6179939993653484e-8,
			0.9999999999999996
		],
		"orbicularis03.L": [
			-2.6179939993653494e-8,
			-8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"foot.R": [
			0.000903341299162239,
			0.009946740070129412,
			-0.01930554532796289,
			0.9997637432193995
		],
		"root": [
			0,
			0,
			0,
			1
		],
		"finger2-2.R": [
			0.08713281458694987,
			0.048266739324860586,
			0.05844628472246168,
			0.9933087265796284
		],
		"risorius02.L": [
			1.7453292144864446e-8,
			-1.7453292255886765e-8,
			-4.946992079080189e-16,
			0.9999999999999999
		],
		"special05.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"lowerleg02.L": [
			0.04342874452992599,
			0.0040772506859585445,
			0.00006872417009944984,
			0.9990482047691125
		],
		"tongue05.L": [
			-1.7453292144864463e-8,
			-8.726645850387627e-9,
			-8.726646072432226e-9,
			0.9999999999999996
		],
		"finger5-1.L": [
			0.18988999707297632,
			-0.1487012161900113,
			-0.4312742607812581,
			0.8693861336039448
		],
		"toe4-3.R": [
			-3.4906584289728866e-8,
			5.551115123125783e-16,
			8.726646079670163e-9,
			0.9999999999999994
		],
		"oris03.L": [
			-1.7453292144864436e-8,
			-8.726646072432231e-9,
			1.7453292144864443e-8,
			0.9999999999999999
		],
		"toe4-3.L": [
			-0.06784598734615783,
			-0.005736854393064816,
			0.0010286727768460554,
			0.9976787821413341
		],
		"finger3-3.L": [
			0.25120013702467275,
			-0.21037390171683124,
			-0.38052140832204123,
			0.8647801861998418
		],
		"tongue05.R": [
			-8.726646072432233e-9,
			-8.726645739365324e-9,
			-8.72664607243223e-9,
			0.9999999999999996
		],
		"lowerleg02.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"shoulder01.R": [
			-0.29804886972997624,
			0.01049078581385321,
			0.05176147744417187,
			0.953088434573879
		],
		"finger3-1.L": [
			0.2867485229619001,
			-0.19259962219890447,
			-0.36145318713228897,
			0.8660440309937588
		],
		"special06.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger4-3.L": [
			0.19970612207702063,
			-0.1644809878088236,
			-0.43094476133916776,
			0.864494119198459
		],
		"finger3-2.L": [
			0.2710882692748991,
			-0.21470051184780958,
			-0.3615920215017669,
			0.8658325764604233
		],
		"upperarm01.R": [
			0.045518153990053725,
			-0.011302472027812205,
			0.23063462049451258,
			0.9719094729514423
		],
		"finger3-2.R": [
			0.09153856526852533,
			0.04639791870713228,
			0.055790619044972393,
			0.9931542332562477
		],
		"upperarm01.L": [
			0.11320728215349915,
			-0.21586381328240967,
			-0.16981168980983835,
			0.9548564894194952
		],
		"special06.L": [
			-2.6179939993653504e-8,
			-1.7453292144864463e-8,
			4.776313300554488e-16,
			0.9999999999999993
		],
		"finger3-1.R": [
			0.02786448830107702,
			0.07896026534500644,
			0.09018368643977134,
			0.9923989870452798
		],
		"shoulder01.L": [
			-0.07789332140191176,
			-0.02022689405350908,
			0.022221586230733625,
			0.9965087577855581
		],
		"lowerarm01.R": [
			-0.1720275227262531,
			0.20838180064762657,
			-0.20842110032136624,
			0.9399703194911806
		],
		"special03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"upperarm02.L": [
			0.09270809228737871,
			-0.1573881069719275,
			-0.04466912010051988,
			0.9821603041854593
		],
		"spine02": [
			0.15868034633003764,
			-2.220446049250313e-16,
			5.551115123125783e-17,
			0.9873300095148427
		],
		"spine03": [
			0.1484825640980604,
			8.629911563140524e-9,
			1.29575476857894e-9,
			0.9889150257523978
		],
		"spine01": [
			0.10309245771719092,
			-1.8259948331156295e-8,
			6.880845823673356e-9,
			0.9946717776039633
		],
		"upperarm02.R": [
			0.30248210887430305,
			0.42718668524111614,
			0.09313725086410038,
			0.8469601893035699
		],
		"spine04": [
			0.023139579285456003,
			8.724309608076908e-9,
			2.0193091697199234e-10,
			0.9997322440886321
		],
		"spine05": [
			-0.03392436008765215,
			0.10636682540725906,
			0.003631168812065981,
			0.9937414406466518
		],
		"lowerarm01.L": [
			0.2739169323062453,
			0.09525483003134672,
			0.04756751209538231,
			0.9558417041250556
		],
		"finger5-3.L": [
			0.22144159699846075,
			-0.11425030088545385,
			-0.43387207250701293,
			0.8658322658372253
		],
		"oris01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"oris05": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			-1.7453292144864443e-8,
			-6.661338147750939e-16,
			-2.6179940059872455e-8,
			0.9999999999999999
		],
		"finger2-3.L": [
			0.3291751481520273,
			-0.25836548818897687,
			-0.26362928651149115,
			0.8691320933237967
		],
		"toe3-3.R": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger3-3.R": [
			0.04832751409447203,
			0.059045813485851584,
			0.0852112144356445,
			0.9934370096919309
		],
		"finger2-3.R": [
			0.08713288337879498,
			0.04826675602575414,
			0.058446247242846444,
			0.9933087219389931
		],
		"toe3-3.L": [
			0.04290467966793778,
			-0.003412754511565863,
			-0.0013472101709264355,
			0.999072433106825
		],
		"risorius03.L": [
			-1.745329214486443e-8,
			-5.235987998730707e-8,
			8.662785736608193e-16,
			0.999999999999998
		]
	},
	"fly02": {
		"toe1-1.L": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger5-2.R": [
			0.16149536913973128,
			0.1958143020853058,
			0.5365328706721632,
			0.8048033819098641
		],
		"finger1-3.R": [
			0.44119465027563526,
			-0.07485084595502733,
			-0.1714394463388918,
			0.8776976402309576
		],
		"toe5-2.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe4-2.R": [
			-4.363322858580418e-8,
			1.7453292144864463e-8,
			-7.615435000746977e-16,
			0.9999999999999989
		],
		"clavicle.R": [
			-0.011073306696043157,
			-0.04261186650146187,
			-0.3556428714334566,
			0.9335843607894486
		],
		"neck03": [
			-0.21164821103129924,
			1.2309928831832906e-7,
			-8.799803801732553e-9,
			0.9773459135675736
		],
		"neck02": [
			-0.1068850546348813,
			5.980383466219763e-8,
			-1.5205890666102758e-8,
			0.9942713840273661
		],
		"neck01": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"clavicle.L": [
			-0.01107329111907355,
			0.042611850083084546,
			0.35564293079784504,
			0.9335843391091178
		],
		"toe5-2.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe4-2.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"finger5-2.L": [
			0.16149532453058058,
			-0.19581445515726648,
			-0.5365326923543382,
			0.8048034724957581
		],
		"finger1-3.L": [
			0.441194707102631,
			0.07485078350410368,
			0.17143952142697078,
			0.8776976023245915
		],
		"toe1-1.R": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oculi02.L": [
			3.49065860660857e-8,
			-4.363323047318346e-8,
			2.6179938217296602e-8,
			0.999999999999998
		],
		"oculi01.L": [
			-1.523087000149398e-16,
			-1.7453292144864463e-8,
			-8.726646072432222e-9,
			0.9999999999999997
		],
		"jaw": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger4-2.R": [
			0.2947375279219385,
			0.2255362656575245,
			0.4719524336422625,
			0.7997024964865798
		],
		"oculi01.R": [
			3.490658428972883e-8,
			-8.726647515722163e-9,
			3.490658428972884e-8,
			0.9999999999999987
		],
		"oculi02.R": [
			-3.490658428972884e-8,
			8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"oris03.L": [
			1.745329303304289e-8,
			-1.7453293144065185e-8,
			2.6179939993653494e-8,
			0.9999999999999993
		],
		"finger1-1.L": [
			0.18919229569314291,
			0.009503842129843787,
			0.1989455374085896,
			0.9615282759130577
		],
		"tongue07.R": [
			8.726645628343061e-9,
			-8.726645406298417e-9,
			-2.6179939993653514e-8,
			0.9999999999999997
		],
		"eye.R": [
			2.6179939993653494e-8,
			8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"finger2-1.R": [
			0.4478678587658469,
			0.29051645070895504,
			0.2836993116494643,
			0.796573457705934
		],
		"finger4-3.R": [
			0.3233991392396569,
			0.2188468569790485,
			0.5429558682875719,
			0.7434500487736412
		],
		"finger2-1.L": [
			0.44786783395254626,
			-0.29051645520501623,
			-0.2836992611645572,
			0.7965734879974671
		],
		"eye.L": [
			0,
			0,
			0,
			1
		],
		"tongue07.L": [
			8.726646072432225e-9,
			-8.726646294476836e-9,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"wrist.L": [
			-6.981316857945735e-8,
			1.7453289591351506e-8,
			-4.3633230362158894e-8,
			0.9999999999999964
		],
		"finger5-3.R": [
			0.1710710973286539,
			0.19352488014394875,
			0.5819783352794361,
			0.7710927425993683
		],
		"lowerleg01.R": [
			-0.05565694216640542,
			0.013816914202162467,
			-0.00262695332912716,
			0.9983508886092219
		],
		"lowerarm02.L": [
			-0.24139999762420453,
			0.24526021107084084,
			-0.3210175080444658,
			0.8823385005435512
		],
		"oris07.L": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"oris07.R": [
			2.6179939993653527e-8,
			-8.726645739365324e-9,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"tongue00": [
			4.3633228585804185e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999991
		],
		"lowerarm02.R": [
			-0.24139994845662502,
			-0.24526016189430355,
			0.3210175509704126,
			0.8823385120472056
		],
		"lowerleg01.L": [
			-0.04041100666428339,
			-0.011726032203489667,
			0.0024850862931137226,
			0.9991112425827551
		],
		"tongue03": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-1.R": [
			0.18919223386349418,
			-0.009503814555472667,
			-0.19894557453669984,
			0.9615282806693198
		],
		"metacarpal4.L": [
			2.6179940881831864e-8,
			2.617994077080965e-8,
			-3.490658428972883e-8,
			0.9999999999999988
		],
		"finger1-2.R": [
			0.03184086741096788,
			-0.004603336861669249,
			-0.014908053117355007,
			0.9993711614833127
		],
		"pelvis.R": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"toe2-1.R": [
			-3.490658428972886e-8,
			-1.1102230246251565e-16,
			-8.726646072432225e-9,
			0.9999999999999993
		],
		"toe2-3.L": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe5-3.L": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"levator05.L": [
			-2.6179939993653494e-8,
			1.745329158975295e-8,
			-1.745329303304287e-8,
			0.9999999999999994
		],
		"finger4-1.L": [
			0.25722476063681715,
			-0.16419813952594575,
			-0.45914485279533107,
			0.8343023418660074
		],
		"finger4-1.R": [
			0.2572248164085497,
			0.16419795080155886,
			0.4591448857485007,
			0.8343023436783291
		],
		"levator05.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"toe5-3.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-3.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"finger4-2.L": [
			0.2947374566443655,
			-0.22553641854518292,
			-0.4719523643257617,
			0.7997025205462002
		],
		"toe2-1.L": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"finger1-2.L": [
			0.031840848803580686,
			0.004603396485956868,
			0.014908090369412765,
			0.9993711612458094
		],
		"pelvis.L": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"metacarpal4.R": [
			2.6179939993653494e-8,
			8.726646405499139e-9,
			2.6506363249292466e-16,
			0.9999999999999997
		],
		"tongue04": [
			-2.6179939993653507e-8,
			-1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"toe3-2.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"levator03.R": [
			-1.7453291256686047e-8,
			3.4906584289728926e-8,
			-1.745329303304288e-8,
			0.999999999999999
		],
		"upperleg02.R": [
			0.0008239119092129214,
			0.0015474656326706082,
			0.06929219342405116,
			0.99759486689225
		],
		"upperleg02.L": [
			0.0008239026320767684,
			-0.0015474749097748042,
			-0.06929219342358414,
			0.997594866885553
		],
		"levator03.L": [
			-3.4906584289728807e-8,
			-3.490658451177353e-8,
			1.4362437249803944e-15,
			0.9999999999999988
		],
		"toe3-2.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"metacarpal3.L": [
			9.138523059687561e-16,
			3.4906584289728926e-8,
			-2.6179939993653487e-8,
			0.999999999999999
		],
		"tongue01": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"breast.L": [
			-0.06287932418484363,
			0.006216936210679425,
			-0.00046626935888454985,
			0.9980016647717046
		],
		"temporalis02.R": [
			0,
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0.9999999999999997
		],
		"tongue02": [
			0,
			0,
			0,
			1
		],
		"oris04.R": [
			3.490658428972881e-8,
			-8.726646738566046e-9,
			1.7453292144864403e-8,
			0.9999999999999988
		],
		"oris04.L": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"temporalis02.L": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"breast.R": [
			-0.06287927252060536,
			0.006216999213584762,
			-0.0004662467706062283,
			0.9980016676449027
		],
		"oris03.R": [
			-6.853892559463472e-16,
			2.6179939993653534e-8,
			2.6179939993653514e-8,
			0.9999999999999994
		],
		"oris06.L": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"orbicularis04.R": [
			1.745329214486445e-8,
			-4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"toe1-2.R": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe1-2.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"orbicularis04.L": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"metacarpal3.R": [
			3.0461740002987937e-16,
			8.726646183454534e-9,
			-3.490658428972886e-8,
			0.9999999999999994
		],
		"oris06.R": [
			2.617993999365348e-8,
			-1.745329247793137e-8,
			-8.726646516521431e-9,
			0.9999999999999996
		],
		"levator04.L": [
			-1.7453292144864456e-8,
			-8.726646183454534e-9,
			1.5230870001493993e-16,
			1
		],
		"tongue06.L": [
			0,
			0,
			-1.745329214486446e-8,
			1
		],
		"toe2-2.L": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"toe2-2.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"tongue06.R": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"levator04.R": [
			-8.726645628343012e-9,
			4.3633228474782015e-8,
			-8.726646516521458e-9,
			0.9999999999999989
		],
		"toe4-1.L": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"upperleg01.R": [
			0,
			0,
			0,
			1
		],
		"metacarpal1.R": [
			5.235987998730672e-8,
			-2.6179938550363602e-8,
			-2.617994177001015e-8,
			0.9999999999999981
		],
		"levator02.R": [
			-8.726646516521448e-9,
			-8.726646405499139e-9,
			-2.6179939993653477e-8,
			0.9999999999999996
		],
		"toe3-1.L": [
			-3.490658428972884e-8,
			8.726646405499139e-9,
			8.726645628342989e-9,
			0.9999999999999991
		],
		"toe3-1.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"levator02.L": [
			-1.7453292144864443e-8,
			1.7453292255886765e-8,
			-8.726646516521435e-9,
			0.9999999999999997
		],
		"finger5-1.R": [
			0.13893866866353616,
			0.14976955158637517,
			0.4964626598249684,
			0.8436764517083176
		],
		"metacarpal1.L": [
			1.745329214486445e-8,
			-8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"toe4-1.R": [
			-2.6179939993653507e-8,
			-4.440892098500626e-16,
			-1.745329219192525e-8,
			0.9999999999999997
		],
		"upperleg01.L": [
			0.0007301798693039033,
			-0.005686881798041554,
			-0.018017623181249557,
			0.9998212297544358
		],
		"head": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe5-1.R": [
			-2.6179939993653507e-8,
			1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"special01": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			3.490658428972882e-8,
			-8.726645850387627e-9,
			-1.7453292144864483e-8,
			0.9999999999999989
		],
		"special04": [
			-1.7453292144864456e-8,
			2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"metacarpal2.L": [
			-2.617993999365348e-8,
			-8.726646738566046e-9,
			-2.6179939993653468e-8,
			0.9999999999999991
		],
		"metacarpal2.R": [
			4.569261529843784e-16,
			1.7453292255886765e-8,
			-2.6179939993653494e-8,
			0.9999999999999994
		],
		"temporalis01.R": [
			1.745329214486445e-8,
			8.726646627543744e-9,
			-2.6179939993653573e-8,
			0.9999999999999997
		],
		"toe5-1.L": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"risorius02.R": [
			-8.726645184253789e-9,
			-3.490658440075123e-8,
			2.6179939993653494e-8,
			0.999999999999999
		],
		"special05.L": [
			8.726646516521438e-9,
			3.490658440075123e-8,
			-8.726645628343022e-9,
			0.9999999999999994
		],
		"finger2-2.L": [
			0.3355111908923531,
			-0.2186241328650067,
			-0.2057606375330736,
			0.8929156115540827
		],
		"foot.L": [
			0.4215109878252823,
			0.03842461666417851,
			0.002689069141736184,
			0.9060048591944284
		],
		"toe3-3.R": [
			8.726646072432231e-9,
			0,
			-8.72664594740284e-9,
			0.9999999999999998
		],
		"levator06.R": [
			0,
			2.6179939993653504e-8,
			1.1102230246251565e-16,
			0.9999999999999998
		],
		"orbicularis03.R": [
			8.726646072432228e-9,
			-1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"levator06.L": [
			2.7755575615628914e-16,
			1.7453292144864463e-8,
			-1.7453292144864453e-8,
			0.9999999999999997
		],
		"orbicularis03.L": [
			1.7453292144864456e-8,
			-8.726646183454534e-9,
			-1.5230870001493993e-16,
			1
		],
		"foot.R": [
			0.42151087359320133,
			-0.03842461304665834,
			-0.0026890733317647985,
			0.9060049124809028
		],
		"root": [
			0.6909823063560021,
			3.1262938904319526e-8,
			1.7811586844805503e-8,
			0.7228716707016114
		],
		"finger2-2.R": [
			0.33551120403167645,
			0.21862411265420745,
			0.20576075664037308,
			0.8929155841187657
		],
		"risorius02.L": [
			1.7453292144864463e-8,
			8.726645850387627e-9,
			8.726646072432226e-9,
			0.9999999999999996
		],
		"special05.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			-4.402746914158785e-17,
			1.0000000000000002
		],
		"lowerleg02.L": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"tongue05.L": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			8.726646072432231e-9,
			0.9999999999999994
		],
		"finger5-1.L": [
			0.13893859078412435,
			-0.14976963307176294,
			-0.4964626003888687,
			0.8436764850436415
		],
		"toe4-3.R": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"wrist.R": [
			6.092348000597549e-16,
			-8.726645961409929e-9,
			6.98131685794573e-8,
			0.9999999999999977
		],
		"toe4-3.L": [
			2.6179939993653507e-8,
			2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"finger3-3.L": [
			0.35551401188670445,
			-0.2761602765083432,
			-0.4141916011402878,
			0.7910692805158724
		],
		"tongue05.R": [
			0,
			0,
			0,
			1
		],
		"lowerleg02.R": [
			0,
			0,
			0,
			1
		],
		"shoulder01.R": [
			8.726645628343018e-9,
			8.726645628343022e-9,
			5.235987998730709e-8,
			0.9999999999999986
		],
		"finger3-1.L": [
			0.3026799077254229,
			-0.21593342084331424,
			-0.38191672063918286,
			0.8461071148019296
		],
		"special06.R": [
			0,
			0,
			0,
			1
		],
		"finger4-3.L": [
			0.32339906154326997,
			-0.21884693831088242,
			-0.5429558725879924,
			0.7434500554893358
		],
		"finger3-2.L": [
			0.34837744421374967,
			-0.2781571466009113,
			-0.3997347724459731,
			0.8009206389246695
		],
		"upperarm01.R": [
			-0.10334153049989658,
			0.0711548328202779,
			-0.5691106814306802,
			0.8126318662972573
		],
		"finger3-2.R": [
			0.3483774220540156,
			0.2781571337722911,
			0.3997348039791019,
			0.8009206372808552
		],
		"upperarm01.L": [
			-0.10334158948190472,
			-0.0711548113582815,
			0.569110579391037,
			0.8126319321372494
		],
		"special06.L": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"finger3-1.R": [
			0.3026799597493977,
			0.21593336436035815,
			0.3819167332809034,
			0.8461071048999427
		],
		"shoulder01.L": [
			-1.8277046119375055e-15,
			-3.490658440075123e-8,
			-5.235987998730683e-8,
			0.9999999999999979
		],
		"lowerarm01.R": [
			0.15894014823734864,
			-0.14083052135669938,
			0.011925143861030734,
			0.9771195343849101
		],
		"special03": [
			0,
			0,
			0,
			1
		],
		"upperarm02.L": [
			-0.29959012114916067,
			0.20184943797363597,
			-0.0036648061973533165,
			0.9324640115817314
		],
		"spine02": [
			0,
			0,
			0,
			1
		],
		"spine03": [
			-0.03701541641547019,
			0,
			0,
			0.9993146946520847
		],
		"spine01": [
			-0.08468313221543462,
			-1.1102230246251565e-16,
			0,
			0.996407932083132
		],
		"upperarm02.R": [
			-0.29959010426037347,
			-0.20184950697254322,
			0.003664832314927331,
			0.9324640019691396
		],
		"spine04": [
			-0.0829432391053487,
			0,
			0,
			0.9965542730261674
		],
		"spine05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"lowerarm01.L": [
			0.1589402053310419,
			0.14083047985315977,
			-0.011925134042070776,
			0.9771195311996038
		],
		"finger5-3.L": [
			0.17107090306965067,
			-0.19352508938932456,
			-0.5819783067045767,
			0.7710927547481308
		],
		"oris01": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"oris02": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"oris05": [
			1.7453292144864456e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999997
		],
		"risorius03.R": [
			3.490658428972886e-8,
			4.440892098500626e-16,
			-1.7453292072804558e-8,
			0.9999999999999993
		],
		"finger2-3.L": [
			0.45682959772149884,
			-0.3157029517164561,
			-0.26543280113289874,
			0.7881521382359332
		],
		"oris06": [
			2.6179939993653507e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999998
		],
		"finger3-3.R": [
			0.35551413604042875,
			0.2761601179979719,
			0.4141916114361031,
			0.7910692746648286
		],
		"finger2-3.R": [
			0.456829639608369,
			0.31570293507933767,
			0.265432825823665,
			0.7881521123062749
		],
		"toe3-3.L": [
			-8.726646072432228e-9,
			1.1102230246251565e-16,
			8.726646034088026e-9,
			0.9999999999999999
		],
		"risorius03.L": [
			8.726645628343007e-9,
			-1.745329203384216e-8,
			-1.7453292144864443e-8,
			0.9999999999999998
		]
	},
	"fly01": {
		"toe1-1.L": [
			8.726645717160759e-8,
			-8.726648403900583e-9,
			2.617993910547254e-8,
			0.999999999999996
		],
		"finger5-2.R": [
			0.16149422833190544,
			0.19581267743405828,
			0.5365302677526302,
			0.8048057413791722
		],
		"finger4-2.R": [
			0.2947346334742742,
			0.2255351343564529,
			0.47194981585053924,
			0.7997054272169501
		],
		"toe5-2.R": [
			3.490658428972878e-8,
			-1.7453290923619136e-8,
			-3.490658428972879e-8,
			0.9999999999999988
		],
		"toe4-2.R": [
			7.853981998095993e-8,
			-8.726645850387627e-9,
			-6.85389203006783e-16,
			0.9999999999999968
		],
		"clavicle.R": [
			1.7453292144864413e-8,
			-9.992007221626409e-16,
			6.108652440744466e-8,
			0.999999999999998
		],
		"neck03": [
			-0.21165149665612587,
			1.1457030524297807e-7,
			-6.953209531503521e-9,
			0.9773452020464464
		],
		"neck02": [
			-0.10416987955229061,
			0.007792359753213796,
			-0.04261141246464277,
			0.9936157118581137
		],
		"neck01": [
			-0.052429843365014786,
			0.004403683894132593,
			-0.06880151177674253,
			0.9962419741559354
		],
		"clavicle.L": [
			-0.013649695886105867,
			0.03476133919709001,
			0.1330594551407554,
			0.9904042187395448
		],
		"toe5-2.L": [
			-8.72664740469983e-9,
			3.490658451177353e-8,
			3.490658428972884e-8,
			0.9999999999999986
		],
		"toe4-2.L": [
			-1.7453292144864446e-8,
			-1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"finger5-2.L": [
			0.1614940938504726,
			-0.19581265808571247,
			-0.5365300853423949,
			0.804805894677285
		],
		"finger1-3.L": [
			0.4411942997770242,
			0.07485128506678784,
			0.1714375599361324,
			0.8776981474352422
		],
		"toe1-1.R": [
			-8.72664607243223e-9,
			-1.7453291811797556e-8,
			-8.726646072432228e-9,
			0.9999999999999996
		],
		"oculi02.L": [
			-6.10865242833821e-8,
			1.7453293144065185e-8,
			1.7453291256684746e-8,
			0.9999999999999979
		],
		"oculi01.L": [
			-5.235988176366352e-8,
			4.363323036216116e-8,
			2.6179937329117888e-8,
			0.9999999999999971
		],
		"jaw": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"finger1-3.R": [
			0.44119427110998233,
			-0.07485126012073617,
			-0.17143738587512328,
			0.8776981979714739
		],
		"oculi01.R": [
			3.4906587842442525e-8,
			-3.4906587620398e-8,
			7.853981998095919e-8,
			0.9999999999999958
		],
		"oculi02.R": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"wrist.R": [
			-0.10677244532793849,
			0.18864179864785424,
			0.2550483087355296,
			0.942318564463601
		],
		"finger1-1.L": [
			0.1891930734971226,
			0.009500571116515033,
			0.19894765144650428,
			0.9615277177872162
		],
		"tongue07.R": [
			1.745329303304289e-8,
			2.6179940104675836e-8,
			-1.745329125668605e-8,
			0.9999999999999996
		],
		"eye.R": [
			-2.132322011967385e-15,
			3.4906584178706623e-8,
			6.108652428338222e-8,
			0.9999999999999976
		],
		"finger2-1.R": [
			0.4478647215317095,
			0.2905167382121183,
			0.28369867852374353,
			0.7965753422180463
		],
		"finger4-3.R": [
			0.3233970033247304,
			0.2188454896865708,
			0.5429546428061713,
			0.7434522753611372
		],
		"finger2-1.L": [
			0.4478646010590105,
			-0.29051729588450015,
			-0.28369843469743206,
			0.7965752934032277
		],
		"eye.L": [
			-8.726646516521438e-9,
			1.7453292366909068e-8,
			1.7453292144864456e-8,
			0.9999999999999996
		],
		"tongue07.L": [
			-2.6179939993653507e-8,
			8.726645739365324e-9,
			-1.7453292144864397e-8,
			0.9999999999999994
		],
		"wrist.L": [
			5.235987998730683e-8,
			8.726646627543744e-9,
			-8.726645628343008e-9,
			0.9999999999999987
		],
		"finger5-3.R": [
			0.1710700701446609,
			0.19352393098538234,
			0.5819759341469393,
			0.7710950209348152
		],
		"lowerleg01.R": [
			0.1322511101484822,
			-0.01205570917684362,
			-0.0008441056465934179,
			0.991142568567406
		],
		"lowerarm02.L": [
			-0.2414053322915984,
			0.24525611707523154,
			-0.3210221799380334,
			0.8823364792221821
		],
		"oris07.L": [
			-6.10865242833821e-8,
			2.1094237467877974e-15,
			3.4906584459454344e-8,
			0.9999999999999973
		],
		"oris07.R": [
			8.726645628343032e-9,
			2.617993988263123e-8,
			8.726646516521458e-9,
			0.9999999999999997
		],
		"tongue00": [
			1.0471975997461245e-7,
			8.726647071632954e-9,
			-8.726645184263907e-9,
			0.9999999999999946
		],
		"lowerarm02.R": [
			-0.1473653278859534,
			-0.14972036275353162,
			0.19596874634091418,
			0.9578431623035089
		],
		"lowerleg01.L": [
			0.9076691457698592,
			0.08274304821815448,
			0.005793696322547515,
			0.41140824356337863
		],
		"tongue03": [
			-1.7453292144864453e-8,
			8.726646294476836e-9,
			-8.726646072432231e-9,
			0.9999999999999994
		],
		"finger1-1.R": [
			0.18919277113616711,
			-0.009500851981639191,
			-0.19894778513380101,
			0.9615277468444663
		],
		"metacarpal4.L": [
			8.910059850846267e-15,
			1.1344639716526217e-7,
			-7.853981998095936e-8,
			0.9999999999999905
		],
		"finger1-2.R": [
			0.03184138113172976,
			-0.004603268145510819,
			-0.014908316381702386,
			0.9993711415048302
		],
		"pelvis.R": [
			-8.726646072432235e-9,
			2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"toe2-1.R": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			-1.7453292144864463e-8,
			0.9999999999999996
		],
		"toe2-3.L": [
			-2.6179939993653474e-8,
			8.726646627543744e-9,
			1.7453292144864476e-8,
			0.9999999999999994
		],
		"toe5-3.L": [
			8.726645184253797e-9,
			8.726645295276114e-9,
			7.853981998095983e-8,
			0.999999999999997
		],
		"levator05.L": [
			-8.726646072432225e-9,
			-1.7453292366909068e-8,
			1.4736068246078264e-16,
			1
		],
		"finger4-1.L": [
			0.2572219095218385,
			-0.16419638321177332,
			-0.4591415643866603,
			0.8343053762590064
		],
		"finger4-1.R": [
			0.25722223730447674,
			0.1641964899110504,
			0.45914145888782004,
			0.834305312261245
		],
		"levator05.R": [
			1.745329125668597e-8,
			6.981316835741325e-8,
			1.7453293033042816e-8,
			0.9999999999999971
		],
		"toe5-3.R": [
			-4.363322858580412e-8,
			2.6179940992854256e-8,
			2.617993910547514e-8,
			0.9999999999999986
		],
		"toe2-3.R": [
			2.6179939105475045e-8,
			-1.745329158975295e-8,
			-2.6179940881831907e-8,
			0.9999999999999996
		],
		"finger4-2.L": [
			0.2947345551088863,
			-0.22553544614416876,
			-0.4719497775697558,
			0.7997053907591074
		],
		"toe2-1.L": [
			1.745329214486445e-8,
			-3.3306690738754696e-16,
			4.3633228449276404e-8,
			0.9999999999999991
		],
		"finger1-2.L": [
			0.03184143316380762,
			0.0046032145696852655,
			0.014908323346635142,
			0.99937113998989
		],
		"pelvis.L": [
			-6.108652428338212e-8,
			8.726645739365324e-9,
			-8.72664651652142e-9,
			0.9999999999999983
		],
		"metacarpal4.R": [
			5.2359879987306584e-8,
			9.599310868413369e-8,
			4.937374586558452e-15,
			0.9999999999999938
		],
		"tongue04": [
			-2.6179939993653494e-8,
			8.726646405499139e-9,
			-2.6506363249292466e-16,
			0.9999999999999997
		],
		"toe3-2.L": [
			-1.745329214486445e-8,
			8.726645406298417e-9,
			-1.745329214486445e-8,
			0.9999999999999998
		],
		"levator03.R": [
			6.108652428338213e-8,
			1.7453291256686043e-8,
			8.726646960610654e-9,
			0.9999999999999981
		],
		"upperleg02.R": [
			0.0015457553287311506,
			0.0029042312260646463,
			0.13003677769072156,
			0.9915037128166807
		],
		"upperleg02.L": [
			-0.04691792274133048,
			-0.006081831675601945,
			-0.005508024994751632,
			0.9988650466953809
		],
		"levator03.L": [
			0,
			7.853981998095985e-8,
			1.1102230246251565e-16,
			0.9999999999999969
		],
		"toe3-2.R": [
			-1.2217304856676214e-7,
			8.72664285278546e-9,
			-2.617994088182809e-8,
			0.9999999999999921
		],
		"metacarpal3.L": [
			9.138523059687561e-16,
			3.4906584289728926e-8,
			-2.6179939993653487e-8,
			0.999999999999999
		],
		"tongue01": [
			-6.108652428338212e-8,
			-8.726646405499139e-9,
			4.661919405738096e-16,
			0.9999999999999984
		],
		"breast.L": [
			-2.6179939993653507e-8,
			8.726645739365324e-9,
			-1.7453292144864397e-8,
			0.9999999999999994
		],
		"temporalis02.R": [
			8.726645628343032e-9,
			-2.617993988263123e-8,
			-8.726646516521458e-9,
			0.9999999999999997
		],
		"tongue02": [
			0,
			8.726646072432231e-9,
			-2.220446049250313e-16,
			0.9999999999999999
		],
		"oris04.R": [
			2.6179939993653468e-8,
			1.3322676295501878e-15,
			-5.235987999662734e-8,
			0.9999999999999984
		],
		"oris04.L": [
			2.6179939993653507e-8,
			-1.1102230246251565e-16,
			8.72664607243223e-9,
			0.9999999999999997
		],
		"temporalis02.L": [
			2.617993999365348e-8,
			8.726646738566046e-9,
			-2.6179939993653468e-8,
			0.9999999999999991
		],
		"breast.R": [
			-1.7453294809399755e-8,
			6.981316846843555e-8,
			3.490658251337197e-8,
			0.9999999999999964
		],
		"oris03.R": [
			-6.853892030067779e-15,
			5.235987998730707e-8,
			1.308996928628385e-7,
			0.9999999999999902
		],
		"oris06.L": [
			-8.726645184253878e-9,
			-2.617993988263123e-8,
			2.6179939993653474e-8,
			0.9999999999999991
		],
		"orbicularis04.R": [
			3.490658428972886e-8,
			-2.220446049250313e-16,
			0,
			0.9999999999999992
		],
		"toe1-2.R": [
			-1.7453292144864453e-8,
			-2.6179939993653534e-8,
			8.726646516521464e-9,
			0.9999999999999997
		],
		"toe1-2.L": [
			-3.490658428972881e-8,
			8.726646738566046e-9,
			1.7453292144864403e-8,
			0.9999999999999988
		],
		"orbicularis04.L": [
			1.7453292144864463e-8,
			-1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"metacarpal3.R": [
			-2.617993732911801e-8,
			1.3089969330692952e-7,
			-1.7453295697578076e-8,
			0.9999999999999913
		],
		"oris06.R": [
			2.617993999365346e-8,
			3.4906584733818136e-8,
			1.0095481158786604e-15,
			0.9999999999999991
		],
		"levator04.L": [
			1.5230870001493986e-16,
			-1.745329203384216e-8,
			8.726646072432222e-9,
			0.9999999999999999
		],
		"tongue06.L": [
			-2.617993999365353e-8,
			-1.745329336610979e-8,
			-1.7453291256686023e-8,
			0.9999999999999997
		],
		"toe2-2.L": [
			0,
			0,
			-2.617993999365351e-8,
			0.9999999999999998
		],
		"toe2-2.R": [
			7.853981998095993e-8,
			-8.726645850387627e-9,
			-6.85389203006783e-16,
			0.9999999999999968
		],
		"tongue06.R": [
			-8.726645628343012e-9,
			1.745329203384216e-8,
			-3.4906584289728866e-8,
			0.9999999999999993
		],
		"levator04.R": [
			8.726644296075419e-9,
			-6.981316857945785e-8,
			-2.6179940881831808e-8,
			0.9999999999999972
		],
		"toe4-1.L": [
			2.6179940881831887e-8,
			1.7453292810998278e-8,
			-4.363322858580428e-8,
			0.9999999999999982
		],
		"upperleg01.R": [
			1.1344639716525997e-7,
			1.887379141862766e-15,
			-1.7453292146252373e-8,
			0.9999999999999934
		],
		"metacarpal1.R": [
			5.235988531637738e-8,
			9.599311223684737e-8,
			-5.235987465823627e-8,
			0.9999999999999928
		],
		"levator02.R": [
			8.726645717160723e-8,
			-9.599310846208908e-8,
			-8.726654510127331e-9,
			0.9999999999999915
		],
		"toe3-1.L": [
			5.235987998730684e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999987
		],
		"toe3-1.R": [
			6.108652428338216e-8,
			8.726644407097695e-9,
			2.6179940881832314e-8,
			0.9999999999999977
		],
		"levator02.L": [
			5.2359885316377354e-8,
			-8.726646083534462e-8,
			5.2359874658236344e-8,
			0.9999999999999934
		],
		"finger5-1.R": [
			0.13893686545010425,
			0.14976774281572292,
			0.4964589978686238,
			0.8436792246263178
		],
		"metacarpal1.L": [
			-8.726644740164625e-9,
			5.235987998730707e-8,
			-2.617994088183188e-8,
			0.9999999999999984
		],
		"toe4-1.R": [
			-8.726646516521435e-9,
			1.7453292366909068e-8,
			3.49065842897289e-8,
			0.9999999999999992
		],
		"upperleg01.L": [
			-0.6101627844038626,
			-0.053262569992066244,
			-0.021066702555312494,
			0.7902029291326449
		],
		"head": [
			-3.490658428972884e-8,
			-8.726646405499139e-9,
			-8.726645628342989e-9,
			0.9999999999999991
		],
		"toe5-1.R": [
			1.745329303304289e-8,
			2.6179940104675836e-8,
			-1.745329125668605e-8,
			0.9999999999999996
		],
		"special01": [
			8.726646072432235e-9,
			-2.220446049250313e-16,
			0,
			0.9999999999999999
		],
		"temporalis01.L": [
			-1.7453292144864463e-8,
			1.1102230246251565e-16,
			-8.726646072432228e-9,
			0.9999999999999998
		],
		"special04": [
			-2.6179939993653507e-8,
			-2.220446049250313e-16,
			-8.726646120913181e-9,
			0.9999999999999994
		],
		"metacarpal2.L": [
			-1.7453290368507587e-8,
			5.235988020935167e-8,
			-2.617994088183192e-8,
			0.9999999999999982
		],
		"metacarpal2.R": [
			6.108652428338173e-8,
			6.108652428338246e-8,
			2.617994354636745e-8,
			0.9999999999999961
		],
		"temporalis01.R": [
			1.7453291256686083e-8,
			2.617993899445281e-8,
			2.6179940881832245e-8,
			0.9999999999999991
		],
		"toe5-1.L": [
			4.3633228585804066e-8,
			-1.7453290479529926e-8,
			-3.4906584289728754e-8,
			0.9999999999999983
		],
		"risorius02.R": [
			0,
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0.9999999999999982
		],
		"special05.L": [
			3.490658428972882e-8,
			2.6179939993653534e-8,
			-8.726645184253818e-9,
			0.9999999999999988
		],
		"finger2-2.L": [
			0.33551157429870404,
			-0.21862301135799567,
			-0.20576031632208847,
			0.8929158161010484
		],
		"foot.L": [
			0.39030963953651154,
			0.03557890019136278,
			0.0024915039691912,
			0.9199925649449692
		],
		"toe3-3.R": [
			6.108652428338213e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999982
		],
		"levator06.R": [
			0,
			-4.3633228585804185e-8,
			-1.1102230246251565e-16,
			0.9999999999999991
		],
		"orbicularis03.R": [
			8.726646072432225e-9,
			8.726646294476836e-9,
			4.402746914158785e-17,
			1.0000000000000002
		],
		"levator06.L": [
			8.726647404699846e-9,
			4.363322825273741e-8,
			-2.6179939993653474e-8,
			0.9999999999999982
		],
		"orbicularis03.L": [
			-1.7453292144864443e-8,
			-8.726645850387627e-9,
			2.6179939993653534e-8,
			0.9999999999999996
		],
		"foot.R": [
			0.42151256097168505,
			-0.03842315754998349,
			-0.0026906639039947266,
			0.9060041844465931
		],
		"root": [
			0.5505948030469506,
			4.107368156702762e-8,
			-1.472452320563754e-8,
			0.8347726414166238
		],
		"finger2-2.R": [
			0.3355116825319617,
			0.21862284292371825,
			0.20576056339579085,
			0.8929157597374853
		],
		"risorius02.L": [
			-1.3707785118926907e-15,
			2.6179939993653534e-8,
			5.235987998730687e-8,
			0.9999999999999984
		],
		"special05.R": [
			-3.4906584289728793e-8,
			1.7453291478730648e-8,
			-2.617994088183205e-8,
			0.9999999999999991
		],
		"lowerleg02.L": [
			8.726646072432231e-9,
			-1.7453292366909068e-8,
			8.726646072432231e-9,
			0.9999999999999998
		],
		"tongue05.L": [
			2.6179939993653497e-8,
			8.726646516521441e-9,
			-8.726645628343002e-9,
			0.9999999999999996
		],
		"finger5-1.L": [
			0.13893649507193345,
			-0.1497674546267861,
			-0.496459226694198,
			0.8436792021271703
		],
		"toe4-3.R": [
			-1.745329303304289e-8,
			3.490658440075123e-8,
			2.617993910547502e-8,
			0.9999999999999988
		],
		"oris03.L": [
			-5.235987998730707e-8,
			-8.726651068435842e-9,
			-9.59931085731274e-8,
			0.9999999999999939
		],
		"toe4-3.L": [
			1.7453292144864446e-8,
			1.7453292255886765e-8,
			4.946992079080189e-16,
			0.9999999999999999
		],
		"finger3-3.L": [
			0.35551211174939845,
			-0.2761578183085811,
			-0.4141920197591046,
			0.7910707734168932
		],
		"tongue05.R": [
			-8.726646072432225e-9,
			1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"lowerleg02.R": [
			-8.726646072432225e-9,
			8.726646294476836e-9,
			1.7453292144864453e-8,
			0.9999999999999997
		],
		"shoulder01.R": [
			5.235987998730684e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999987
		],
		"finger3-1.L": [
			0.3026774482107774,
			-0.21593229026256444,
			-0.3819143542485009,
			0.8461093513166767
		],
		"special06.R": [
			8.726646072432225e-9,
			-1.7453292366909068e-8,
			-1.4736068246078264e-16,
			1
		],
		"finger4-3.L": [
			0.3233967788976022,
			-0.21884572581598893,
			-0.5429546554870621,
			0.7434522942164168
		],
		"finger3-2.L": [
			0.3483746365875754,
			-0.2781561791338504,
			-0.3997338745111656,
			0.8009226443049438
		],
		"upperarm01.R": [
			-0.0976125610258238,
			-0.2057493173324496,
			0.17487202902806115,
			0.9578928853534823
		],
		"finger3-2.R": [
			0.3483746747428549,
			0.2781561174666214,
			0.39973376450685216,
			0.8009227040276017
		],
		"upperarm01.L": [
			-0.09713173424685675,
			-0.08947748273388312,
			0.5513096875419525,
			0.8237820310665925
		],
		"special06.L": [
			8.726646072432228e-9,
			8.726645850387627e-9,
			1.7453292144864463e-8,
			0.9999999999999996
		],
		"finger3-1.R": [
			0.302677628302055,
			0.21593237456824943,
			0.3819143168246552,
			0.8461092822698008
		],
		"shoulder01.L": [
			0.0004695337135363538,
			-0.004931191364138887,
			0.10492748671421753,
			0.9944675386465155
		],
		"lowerarm01.R": [
			-2.617994177001034e-8,
			2.6179941881032676e-8,
			6.108652428338127e-8,
			0.9999999999999972
		],
		"special03": [
			-1.745329214486445e-8,
			4.440892098500626e-16,
			8.726646160864038e-9,
			0.9999999999999999
		],
		"upperarm02.L": [
			-0.299593259068849,
			0.20185089821267987,
			-0.0036673895392238236,
			0.932462677143277
		],
		"spine02": [
			-0.07497340409018087,
			0.007380659468401163,
			0.04883729345022435,
			0.9959615621666321
		],
		"spine03": [
			-0.037016267280176075,
			1.1102230246251565e-16,
			0,
			0.999314663135012
		],
		"spine01": [
			-0.003488816806629014,
			-0.004293404666667611,
			0.0647940575704885,
			0.9978833223063754
		],
		"upperarm02.R": [
			-0.11869894823755854,
			-0.13374955717231163,
			0.0025302274498037788,
			0.9838776415756992
		],
		"spine04": [
			-0.08294492849857886,
			-1.1102230246251565e-16,
			0,
			0.9965541324164813
		],
		"spine05": [
			8.726645717160763e-8,
			1.1102230246251565e-16,
			0,
			0.9999999999999962
		],
		"lowerarm01.L": [
			0.15894200069156508,
			0.1408310039755586,
			-0.011923679585717013,
			0.977119181369671
		],
		"finger5-3.L": [
			0.17106990006488448,
			-0.19352400618834453,
			-0.5819758869187116,
			0.7710950754386797
		],
		"oris01": [
			0,
			0,
			0,
			1
		],
		"oris02": [
			0,
			0,
			8.726646072432231e-9,
			1
		],
		"oris05": [
			-6.108652428338212e-8,
			8.726646405499139e-9,
			-4.661919405738096e-16,
			0.9999999999999984
		],
		"risorius03.R": [
			8.726645717160759e-8,
			2.617994021569814e-8,
			2.2073853230039648e-15,
			0.9999999999999961
		],
		"finger2-3.L": [
			0.4568275532986892,
			-0.3156980785076505,
			-0.2654352151638768,
			0.7881544622246438
		],
		"oris06": [
			0,
			0,
			-8.726646072432231e-9,
			1
		],
		"finger3-3.R": [
			0.3555122747511458,
			0.2761574777665229,
			0.4141919497020587,
			0.7910708557246342
		],
		"finger2-3.R": [
			0.4568276621147382,
			0.3156977836714028,
			0.26543525215312797,
			0.7881545047934141
		],
		"toe3-3.L": [
			8.726648292878315e-9,
			-2.6179940881831953e-8,
			8.72664571716036e-8,
			0.9999999999999958
		],
		"risorius03.L": [
			-6.981316857945734e-8,
			1.7453290812596833e-8,
			-2.6179940881830544e-8,
			0.9999999999999971
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/makehuman-data/src/json/poses/poses.json
// module id = 149
// module chunks = 0